import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** nullを返す型で何も返す必要がない時に使う */
  Void: any;
};

/** ホテルのブックマークを追加するinput */
export type AddBookmarkHotelInput = {
  /** こころからホテルID */
  cocolocalaHotelId: Scalars['Int'];
};

export type AddBookmarkHotelPayload = {
  __typename?: 'AddBookmarkHotelPayload';
  ok: Scalars['Boolean'];
};

export type AddDpCarToCartsForOrderPurchaseDpCarInput = {
  /** 出発営業所ID */
  pickUpVendorId: Scalars['String'];
  /** 出発営業所名 */
  pickUpVendorName: Scalars['String'];
  /** 出発地コード */
  pickUpLocationCode: Scalars['String'];
  /** 出発日 */
  pickUpDate: Scalars['String'];
  /** 出発時間 */
  pickUpTime: Scalars['String'];
  /** 返却地営業所ID */
  returnVendorId: Scalars['String'];
  /** 返却地営業所名 */
  returnVendorName: Scalars['String'];
  /** 返却地コード */
  returnLocationCode: Scalars['String'];
  /** 返却日 */
  returnDate: Scalars['String'];
  /** 返却時間 */
  returnTime: Scalars['String'];
  /** レンタカーサムネイル */
  carThumbnailUrl: Scalars['String'];
  /** レンタカー名 */
  carName: Scalars['String'];
  /** 予約情報 */
  reference: DpCarReferenceInput;
  /** carTrawler合計料金 */
  provisionalPrice: Scalars['Int'];
  /** carTrawler手数料 */
  provisionalCarTrawlerTransactionFee: Scalars['Int'];
  /** carTrawler税 */
  provisionalTax: Scalars['Int'];
};

/** カートへDP(ホテル+レンタカー)を追加するmutationのinput */
export type AddDpCarToCartsForOrderPurchaseInput = {
  dPCar: AddDpCarToCartsForOrderPurchaseDpCarInput;
  hotel: AddHotelToCartHotelInput;
};

export type AddFlightToCartInput = {
  occupancy: OccupancyInput;
  /** 行きの乗り継ぎ情報 */
  goingFlightSectors: Array<CartFlightSectorInput>;
  /** 帰りの乗り継ぎ情報 */
  returningFlightSectors: Array<CartFlightSectorInput>;
  /** 行きの機内持ち込み */
  goingFreeBaggageAllowance?: Maybe<Scalars['String']>;
  /** 帰りの機内持ち込み */
  returningFreeBaggageAllowance?: Maybe<Scalars['String']>;
  /** 料金情報 */
  priceInfo: CartFlightPriceInfo;
  /** 出発場所の出発日時(UTC) ex. 2022-04-16T15:00:00Z */
  goingDeparturePointDateUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーンオフセット ex. +09:00 */
  goingDeparturePointDateTimeZoneOffset: Scalars['String'];
  /** 行きのフライトのvalidatingCarrierIATA */
  goingValidatingCarrierIATA: Scalars['String'];
  /** 目的地からの出発日時(UTC) ex. 2022-04-18T15:00:00Z */
  returningDeparturePointDateUtcDateTime: Scalars['String'];
  /** 目的地のタイムゾーンオフセット ex. -10:00 */
  returningDeparturePointDateTimeZoneOffset: Scalars['String'];
  /** 帰りのフライトのvalidatingCarrierIATA */
  returningValidatingCarrierIATA: Scalars['String'];
  /** INFINIで後から空室検索や予約の詳細を取得するために必要な情報 */
  additionalFlightInfo?: Maybe<AdditionalFlightInfoForAddFlightToCartInput>;
  /** 海外DPか否かのフラグ */
  isDP?: Maybe<Scalars['Boolean']>;
};

export type AddHotelToCartHotelForOrderConfirmInput = {
  /** こころからホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ExpediaホテルID */
  expediaHotelId: Scalars['String'];
  /** ExpediaホテルのルームID */
  roomId: Scalars['String'];
  /** ExpediaホテルのルームのレートID */
  rateId: Scalars['String'];
  /** ExpediaホテルのルームのレートのベッドグループID */
  bedGroupId: Scalars['String'];
  /** Expediaのホテル情報 */
  expediaHotelInfo?: Maybe<ExpediaHotelInfoInput>;
  /** Didaのホテル情報 */
  didaHotelInfo?: Maybe<DidaHotelInfoInput>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
};

export type AddHotelToCartHotelInput = {
  /** こころからホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ExpediaホテルID */
  expediaHotelId: Scalars['String'];
  /** ExpediaホテルのルームID */
  roomId: Scalars['String'];
  /** ExpediaホテルのルームのレートID */
  rateId: Scalars['String'];
  /** ExpediaホテルのルームのレートのベッドグループID */
  bedGroupId: Scalars['String'];
  /** ホテルのチェックイン日 */
  checkInDate: Scalars['String'];
  /** ホテルのチェックアウト日 */
  checkOutDate: Scalars['String'];
  /** 大人の人数 */
  numberOfAdults: Scalars['Int'];
  /** 子供の年齢 */
  childAges: Array<Scalars['Int']>;
  /** Expediaのホテル情報 */
  expediaHotelInfo?: Maybe<ExpediaHotelInfoInput>;
  /** Didaのホテル情報 */
  didaHotelInfo?: Maybe<DidaHotelInfoInput>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
  /** こころからで扱っている商材の種類 */
  productType?: Maybe<ProductType>;
  /** 仕入れ価格の税・サービス料抜き */
  provisionalExclusivePrice?: Maybe<Scalars['Int']>;
  /** 割引前の仕入れ価格の税・サービス料抜き */
  provisionalExclusiveStrikethroughPrice?: Maybe<Scalars['Int']>;
  /** 仕入れ価格の税・サービス料 */
  provisionalTaxAndServiceCharge?: Maybe<Scalars['Int']>;
};

export type AddHotelToCartInput = {
  hotel: AddHotelToCartHotelInput;
  channel?: Maybe<Channel>;
  /** テーマID */
  themeId?: Maybe<Scalars['Int']>;
  schedule?: Maybe<AddHotelToCartInputSchedule>;
};

export type AddHotelToCartInputSchedule = {
  goingDate: Scalars['String'];
  returningDate: Scalars['String'];
};

export type AddHotelToCartsForOrderPurchaseInput = {
  hotel: AddHotelToCartHotelInput;
  channel?: Maybe<Channel>;
  /** テーマID */
  themeId?: Maybe<Scalars['Int']>;
  schedule?: Maybe<AddHotelToCartsForOrderPurchaseInputSchedule>;
};

export type AddHotelToCartsForOrderPurchaseInputSchedule = {
  goingDate: Scalars['String'];
  returningDate: Scalars['String'];
};

export type AddSelectedCancelForAnyReasonInput = {
  /** キャンセル保証を追加するかどうか */
  hasCancelForAnyReason: Scalars['Boolean'];
};

export type AddSelectedCancelForAnyReasonPayload = {
  __typename?: 'AddSelectedCancelForAnyReasonPayload';
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

export type AddToCartPayload = {
  __typename?: 'AddToCartPayload';
  ok: Scalars['Boolean'];
  cartSnapshotId?: Maybe<Scalars['String']>;
};

export type AdditionalFlightInfo = {
  __typename?: 'AdditionalFlightInfo';
  /** 航空券ID INFINIの outwardId, returnIdが入る */
  externalFlightId: Scalars['String'];
  /** 行きの航空券に対する帰りの航空券の一覧(INFINIのみ) */
  recommendedReturningFlights: Array<Flight>;
};

export type AdditionalFlightInfoForAddFlightToCartInput = {
  routingId: Scalars['String'];
  outwardId: Scalars['String'];
  returnId: Scalars['String'];
  isPassportRequired: Scalars['Boolean'];
  /** AdditionalFlightInfoの有効期限 ex. 2022-04-16T15:00:00Z */
  expireDateTime: Scalars['String'];
  /** 予約時に購入可能な受託手荷物オプション */
  baggageOptionInfo?: Maybe<BaggageOptionInfoInput>;
};

export type AdditionalFlightInfoForChangeFlightInput = {
  routingId: Scalars['String'];
  outwardId: Scalars['String'];
  returnId: Scalars['String'];
  isPassportRequired: Scalars['Boolean'];
  /** AdditionalFlightInfoの有効期限 ex. 2022-04-16T15:00:00Z */
  expireDateTime: Scalars['String'];
  /** 予約時に購入可能な受託手荷物オプション */
  baggageOptionInfo?: Maybe<BaggageOptionInfoInput>;
};

export type AdditionalOptionsInfo = {
  __typename?: 'AdditionalOptionsInfo';
  /** 空港送迎 */
  isAvailableAirportTransfer: Scalars['Boolean'];
  /** 現地アクティビティ */
  localActivities: Array<LocalActivity>;
};

export type AdminAirportInfo = Node & {
  __typename?: 'AdminAirportInfo';
  /** ID */
  id: Scalars['ID'];
  /** IATAの空港コード */
  airportIATACode: Scalars['String'];
  /** 空港名 */
  airportName: Scalars['String'];
  /** 空港の所在する国/都市名 ex. ハワイ/アメリカ */
  countryAndCityName: Scalars['String'];
};

export type AdminBaggageOption = {
  __typename?: 'AdminBaggageOption';
  /** 許容量 */
  allowance: Scalars['String'];
  /** 料金 */
  price: Scalars['String'];
};

export type AdminBirthdayOrPassportExpiry = {
  __typename?: 'AdminBirthdayOrPassportExpiry';
  year: Scalars['String'];
  month: Scalars['String'];
  day: Scalars['String'];
};

export type AdminBookExpediaHotelInput = {
  travelId: Scalars['ID'];
  bookingUrl: Scalars['String'];
  requests: Array<RoomRequest>;
};

export type AdminBookExpediaHotelPayload = {
  __typename?: 'AdminBookExpediaHotelPayload';
  bookingId: Scalars['ID'];
};

export type AdminCancelForAnyReasonInfo = {
  __typename?: 'AdminCancelForAnyReasonInfo';
  /** キャンセル保証のステータス ex: 追加済み or 追加なし */
  statusText: Scalars['String'];
  /** キャンセル保証の税込み価格 */
  inclusivePrice: Scalars['String'];
};

export type AdminCarInfo = {
  __typename?: 'AdminCarInfo';
  /** 営業所 */
  vendorName: Scalars['String'];
  /** 車名 */
  carName: Scalars['String'];
  /** ピックアップ時間 */
  pickUpDatetime: Scalars['String'];
  /** 返却時間 */
  returnDatetime: Scalars['String'];
  /** 料金 */
  amount: Scalars['String'];
  /** 予約番号 */
  reservationNumber?: Maybe<Scalars['String']>;
  /** キャンセルポリシー */
  cancelPolicy?: Maybe<Scalars['String']>;
  /** 予約キャンセルのための情報 */
  cancelReservedInfo: CancelReservedInfo;
};

export type AdminCarrier = Node & {
  __typename?: 'AdminCarrier';
  /** ID */
  id: Scalars['ID'];
  /** IATAの航空会社コード */
  carrierIATACode: Scalars['String'];
  /** 航空会社名 */
  name: Scalars['String'];
};

export type AdminCheckPriceBy = {
  __typename?: 'AdminCheckPriceBy';
  status: PriceCheckStatus;
  bookingUrl?: Maybe<Scalars['String']>;
  currentPrice?: Maybe<Scalars['Int']>;
  reservationPrice?: Maybe<Scalars['Int']>;
};

export type AdminCheckPriceByInput = {
  hotelId: Scalars['String'];
  roomId: Scalars['String'];
  rateId: Scalars['String'];
  bedGroupId: Scalars['String'];
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  childAges: Array<Scalars['Int']>;
  isMember: Scalars['Boolean'];
  salesChannel: Scalars['String'];
  reservationPrice: Scalars['Int'];
};

export type AdminDpFlightTheme = {
  __typename?: 'AdminDPFlightTheme';
  /** テーマID */
  themeId: Scalars['Int'];
  /** 地域ID */
  zoneId: Scalars['Int'];
  /** タイトル */
  title: Scalars['String'];
  /** 説明 */
  description: Scalars['String'];
  /** 画像 */
  imageUrls: Array<Scalars['String']>;
  /** スタッフのコメント */
  staffComment: Scalars['String'];
  /** 目的地の空港 */
  arrivalCityOrAirportIata: Scalars['String'];
  /** おすすめ日数 */
  recommendedDays: ThemeRecommendedDays;
  /** 最低料金 */
  minimumPrice?: Maybe<Scalars['Int']>;
  /** 公開ステータス */
  publishStatus: DpFlightThemePublishStatus;
  /** おすすめのホテル */
  recommendedHotels: Array<DpFlightThemeRecommendedHotel>;
  /** 並び順 */
  sortOrder: Scalars['Int'];
  /** バージョン番号 */
  versionNo: Scalars['Int'];
};

export type AdminDpFlightThemeInput = {
  /** テーマID */
  themeId: Scalars['Int'];
};

export type AdminDpFlightThemeZone = Node & {
  __typename?: 'AdminDPFlightThemeZone';
  id: Scalars['ID'];
  dPFlightThemeZoneId: Scalars['Int'];
  zoneName: Scalars['String'];
  zoneNameKana: Scalars['String'];
  zonePath: Scalars['String'];
  versionNo: Scalars['Int'];
};

export type AdminDpFlightThemes = {
  __typename?: 'AdminDPFlightThemes';
  /** 旅行テーマ */
  dPFlightThemes: Array<DpFlightThemeSummary>;
  /** ページネーション結果 */
  pagination: Pagination;
};

export type AdminDpFlightThemesInput = {
  /** ページネーション指定 */
  pagination: PaginationInput;
};

export type AdminDeleteFlightPassengerAndPassportInput = {
  flightPassengerId: Scalars['Int'];
  deleteTarget: DeleteFlightPassengerAndPassportTarget;
};

export type AdminDeleteFlightPassengerAndPassportPayload = {
  __typename?: 'AdminDeleteFlightPassengerAndPassportPayload';
  ok: Scalars['Boolean'];
};

export type AdminDetailProductsInfo = {
  __typename?: 'AdminDetailProductsInfo';
  staysInfo: Array<AdminStayInfo>;
  carsInfo: Array<AdminCarInfo>;
  flightsInfo: Array<AdminFlightInfo>;
  supportPlanInfo?: Maybe<AdminSupportPlanInfo>;
  cancelForAnyReasonInfo?: Maybe<AdminCancelForAnyReasonInfo>;
};

export type AdminFincodeOrderIdInfo = {
  __typename?: 'AdminFincodeOrderIdInfo';
  cardOrderId?: Maybe<Scalars['String']>;
  virtualAccountOrderId?: Maybe<Scalars['String']>;
};

export type AdminFlightClass = Node & {
  __typename?: 'AdminFlightClass';
  /** ID */
  id: Scalars['ID'];
  /** 搭乗クラス名 ex. エコノミー */
  name: Scalars['String'];
  /** 搭乗クラスコード */
  code: Scalars['String'];
};

export type AdminFlightInfo = {
  __typename?: 'AdminFlightInfo';
  /** 出発日 ex. 2021/04/02 */
  goingDeparturePointDate: Scalars['String'];
  /** 現地出発日 ex. 2021/04/16 */
  returningDeparturePointDate: Scalars['String'];
  /** 料金 */
  amount: Scalars['String'];
  /** Vendorの予約番号 ex.5D4KHX */
  reservationNumber: Scalars['String'];
  vendor: Scalars['String'];
  /** 行きのフライトの区間情報一覧 */
  goingFlightSectors: Array<AdminFlightSector>;
  /** 帰りのフライトの区間情報一覧 */
  returningFlightSectors: Array<AdminFlightSector>;
  /** 人数 */
  numberOfPeople: Scalars['String'];
  /** キャンセルポリシー */
  flightCarrierCancelPoliciesList: Array<Scalars['String']>;
  /** 搭乗者情報 */
  passengers: Array<AdminFlightPassenger>;
  /** 全旅客の受託手荷物オプション */
  selectedBaggageOption?: Maybe<AdminSelectedBaggageOptionInfo>;
};

export type AdminFlightPassenger = {
  __typename?: 'AdminFlightPassenger';
  flightPassengerId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: AdminBirthdayOrPassportExpiry;
  nationality: Scalars['String'];
  isRepresentative: Scalars['Boolean'];
  passport?: Maybe<AdminFlightPassengerPassport>;
  /** 旅客単位の受託手荷物オプション */
  selectedBaggageOption?: Maybe<AdminSelectedBaggageOptionInfo>;
};

export type AdminFlightPassengerPassport = {
  __typename?: 'AdminFlightPassengerPassport';
  passportNumber: Scalars['String'];
  passportExpiry: AdminBirthdayOrPassportExpiry;
  passportIssuingCountry: Scalars['String'];
};

export type AdminFlightSector = {
  __typename?: 'AdminFlightSector';
  /** 乗り継ぎの順序 */
  flightIndex: Scalars['Int'];
  /** 航空会社の情報 */
  carrier: AdminCarrier;
  /** 航空機の便名 ex. 221 */
  flightNumber: Scalars['String'];
  /** 搭乗クラス ex. エコノミークラス */
  flightClass: Array<AdminFlightClass>;
  /** 運賃クラスコード ex. W */
  fareClassCode: Scalars['String'];
  /** 出発日 ex. 4/16(木) */
  departureDate: Scalars['String'];
  /** 出発時間 ex. 15:00 */
  departureTime: Scalars['String'];
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーンオフセット ex. +09:00 */
  departureTimeZoneOffset: Scalars['String'];
  /** 出発する空港 */
  departureAirport: AdminAirportInfo;
  /** 到着日　ex. 4/20(木) */
  arrivalDate: Scalars['String'];
  /** 到着日時 ex. 18:00 */
  arrivalTime: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 到着日時のタイムゾーンオフセット ex. +09:00 */
  arrivalTimeZoneOffset: Scalars['String'];
  /** 到着する空港 */
  arrivalAirport: AdminAirportInfo;
  /** フライト時間 */
  flightTime: Scalars['String'];
  /** 乗り継ぎの空港待ち時間 */
  connectingTime?: Maybe<Scalars['String']>;
  /** コードシェア便 */
  codeShareAirlines: Array<Scalars['String']>;
  codeShareCarrierIATACodes: Array<Scalars['String']>;
  reservationNumber?: Maybe<Scalars['String']>;
  /** 航空会社の予約番号 */
  flightSectorFlightExternalReservation?: Maybe<AdminFlightSectorFlightExternalReservation>;
  flightTransits: Array<AdminFlightTransit>;
};

export type AdminFlightSectorFlightExternalReservation = {
  __typename?: 'AdminFlightSectorFlightExternalReservation';
  externalId: Scalars['String'];
};

export type AdminFlightTransit = {
  __typename?: 'AdminFlightTransit';
  /** 到着日　ex. 4/20(木) */
  arrivalDate: Scalars['String'];
  /** 到着日時 ex. 18:00 */
  arrivalTime: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 出発日 ex. 4/16(木) */
  departureDate: Scalars['String'];
  /** 出発時間 ex. 15:00 */
  departureTime: Scalars['String'];
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 到着日時のタイムゾーンオフセット ex. +09:00 */
  timeZoneOffset: Scalars['String'];
  /** 一時寄港する空港 */
  airport: AdminAirportInfo;
};

export type AdminFullRefundFincodePaymentInput = {
  paymentId: Scalars['Int'];
};

export type AdminFullRefundFincodePaymentPayload = {
  __typename?: 'AdminFullRefundFincodePaymentPayload';
  ok: Scalars['Boolean'];
};

export type AdminIdInfo = {
  __typename?: 'AdminIdInfo';
  orderId: Scalars['Int'];
  travelId: Scalars['Int'];
  userId: Scalars['Int'];
  paymentId: Scalars['Int'];
  fincodeOrderIdInfo?: Maybe<AdminFincodeOrderIdInfo>;
};

export type AdminOrder = {
  __typename?: 'AdminOrder';
  /** サマリー */
  summaryInfo: AdminSummaryInfo;
  /** 詳細 */
  detailProductsInfo: AdminDetailProductsInfo;
  /** 本予約以降にメールアドレスが更新されたかどうか */
  isUpdatedEmail: Scalars['Boolean'];
};

export type AdminOrderInput = {
  orderId: Scalars['Int'];
};

export type AdminPriceInfo = {
  __typename?: 'AdminPriceInfo';
  /** 合計料金 */
  totalAmount: Scalars['String'];
  /** 決済手数料 */
  paymentFee: Scalars['String'];
  /** 値引き額 */
  discountAmount: Scalars['String'];
  /** 取扱手数料の合計 */
  totalTransactionFee: Scalars['String'];
  /** 取扱手数料 */
  transactionFee: Scalars['String'];
  /** 取扱手数料の消費税 */
  transactionFeeTax: Scalars['String'];
  /** 発券手数料 */
  ticketIssuanceFee: Scalars['String'];
  /** 期間限定セール割引額 */
  limitedTimeSaleDiscountAmount: Scalars['String'];
  /** キャンペーン割引額 */
  campaignDiscountAmount: Scalars['String'];
  /** 受託手荷物オプション料金 */
  selectedBaggageOptionAmount: Scalars['String'];
};

export type AdminSelectedBaggageOptionInfo = {
  __typename?: 'AdminSelectedBaggageOptionInfo';
  round?: Maybe<AdminBaggageOption>;
  going?: Maybe<AdminBaggageOption>;
  returning?: Maybe<AdminBaggageOption>;
};

export type AdminSendReservedInput = {
  orderId: Scalars['Int'];
};

export type AdminSendReservedPayload = {
  __typename?: 'AdminSendReservedPayload';
  ok: Scalars['Boolean'];
};

export type AdminStayInfo = {
  __typename?: 'AdminStayInfo';
  stayId: Scalars['Int'];
  stayExpediaReservationId?: Maybe<Scalars['Int']>;
  stayDidaReservationId?: Maybe<Scalars['Int']>;
  /** 宿泊施設 */
  stayDescription: Scalars['String'];
  /** 予約番号 */
  reservationNumber?: Maybe<Scalars['String']>;
  /** チェックイン・アウト(日本時間) ex. 2022/07/06 00:00 / 2022/07/07 00:00 */
  checkinAndCheckoutJapanDatetime: Scalars['String'];
  /** チェックイン・アウト(現地時間) ex. 2022/07/06 00:00 / 2022/07/07 00:00 */
  checkinAndCheckoutLocalDatetime: Scalars['String'];
  /** 人数 */
  numberOfPeople: Scalars['String'];
  /** 料金 */
  costAndAmount: Scalars['String'];
  /** キャンセルペナルティー */
  cancelPenalty: Array<Scalars['String']>;
  /** 在庫確認・予約確定用の情報 */
  orderReserveInfo?: Maybe<OrderReserveInfo>;
  /** ホテル事業者 */
  provider: HotelProvider;
};

export type AdminSummaryInfo = {
  __typename?: 'AdminSummaryInfo';
  /** 予約内容 ex. ホテル単体／レンタカー＋ホテル */
  productTypeText: Scalars['String'];
  /** 予約ステータス */
  status: OrderStatus;
  /** Expediaの予約ステータス */
  expediaHotelReservationStatus?: Maybe<ExpediaHotelReservationStatus>;
  /** Didaの予約ステータス */
  didaHotelReservationStatus?: Maybe<DidaHotelReservationStatus>;
  /** 申し込み日時 ex. 2022/04/08 08:20 */
  reservationDateTime: Scalars['String'];
  /** 支払い方法 */
  paymentMethod: Scalars['String'];
  /** 支払いステータス */
  paymentStatus: PaymentStatusEnum;
  /** クーポン情報 */
  couponId?: Maybe<Scalars['String']>;
  /** 予約番号 */
  reservationNumber?: Maybe<Scalars['String']>;
  /** 各種ID一覧 */
  idInfo: AdminIdInfo;
  /** お名前 */
  userName: Scalars['String'];
  /** メールアドレス */
  email: Scalars['String'];
  /** 電話番号 */
  phoneNumber: Scalars['String'];
  /** 料金 */
  priceInfo: AdminPriceInfo;
  /** 内容(コメント) */
  description?: Maybe<Scalars['String']>;
  /** TravelFusion(INFINI)予約ステータス */
  travelFusionReservationStatus?: Maybe<AdminTravelFusionReservationStatus>;
  /** 空港送迎利用有無 */
  useAirportTransfer: Scalars['Boolean'];
};

export type AdminSupportPlanInfo = {
  __typename?: 'AdminSupportPlanInfo';
  /** プランのタイプ */
  planType: DpFlightSupportPlanType;
  /** プランのタイトル. ex: あんしんプラン */
  title: Scalars['String'];
  /** プランの税込み価格 */
  inclusivePrice: Scalars['String'];
};

export type AdminTemporarySuspendedFlightCarrier = {
  __typename?: 'AdminTemporarySuspendedFlightCarrier';
  carrierIATA: Scalars['String'];
  start: Scalars['String'];
  end: Scalars['String'];
};

export type AdminTemporarySuspendedFlightCarriers = {
  __typename?: 'AdminTemporarySuspendedFlightCarriers';
  carriers: Array<AdminTemporarySuspendedFlightCarrier>;
};

export enum AdminTravelFusionReservationStatus {
  /** 成功 */
  Succeeded = 'SUCCEEDED',
  /** 失敗（Failed, Duplicate, BookingNotLaunched） */
  Failed = 'FAILED',
  /** 処理中（BookingInProgress, Unconfirmed, UnconfirmedBySupplier） */
  InProgress = 'IN_PROGRESS',
  /** 取得失敗 */
  Unknown = 'UNKNOWN'
}

export type AdminUpdateContactInput = {
  orderId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
};

export type AdminUpdateContactPayload = {
  __typename?: 'AdminUpdateContactPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateFlightPassengerAndPassportPayload = {
  __typename?: 'AdminUpdateFlightPassengerAndPassportPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateFlightPassengerAndPassportsInput = {
  flightPassengers: Array<AdminUpdateFlightPassengerInput>;
};

export type AdminUpdateFlightPassengerInput = {
  flightPassengerId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: DpFlightBirthdayOrPassportExpiryInput;
  nationality: Scalars['String'];
  passport?: Maybe<AdminUpdateFlightPassengerPassportInput>;
};

export type AdminUpdateFlightPassengerPassportInput = {
  passportNumber: Scalars['String'];
  passportExpiry: DpFlightBirthdayOrPassportExpiryInput;
  passportIssuingCountry: Scalars['String'];
};

export type AdminUpdateFlightReservationInput = {
  orderId: Scalars['Int'];
  flight: AdminUpdateFlightsInput;
};

export type AdminUpdateFlightReservationPayload = {
  __typename?: 'AdminUpdateFlightReservationPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateFlightSectorFlightExternalReservation = {
  externalId: Scalars['String'];
};

export type AdminUpdateFlightSectorInput = {
  departureAirportIata: Scalars['String'];
  departureUtcDateTime: Scalars['String'];
  departureTimeZoneOffset: Scalars['String'];
  arrivalAirportIata: Scalars['String'];
  arrivalUtcDateTime: Scalars['String'];
  arrivalTimeZoneOffset: Scalars['String'];
  flightCarrierIata: Scalars['String'];
  flightCarrierName: Scalars['String'];
  flightNumber: Scalars['String'];
  fareClassCode: Scalars['String'];
  codeShareAirlines: Array<Scalars['String']>;
  flightSectorFlightExternalReservation?: Maybe<AdminUpdateFlightSectorFlightExternalReservation>;
  flightTransits: Array<AdminUpdateFlightTransitInput>;
};

export type AdminUpdateFlightTransitInput = {
  arrivalUtcDateTime: Scalars['String'];
  departureUtcDateTime: Scalars['String'];
  timeZoneOffset: Scalars['String'];
  airportIata: Scalars['String'];
};

export type AdminUpdateFlightsInput = {
  goingFlightSectors: Array<AdminUpdateFlightSectorInput>;
  returningFlightSectors: Array<AdminUpdateFlightSectorInput>;
};

export type AdminUpdateHotelPhotosByCountryCodeInput = {
  countryCode: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
};

export type AdminUpdateHotelPhotosByCountryCodePayload = {
  __typename?: 'AdminUpdateHotelPhotosByCountryCodePayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateOrderStatusReservedInput = {
  orderId: Scalars['Int'];
  stayId: Scalars['Int'];
  stayExpediaReservationId: Scalars['Int'];
  expediaReservationId: Scalars['String'];
};

export type AdminUpdateOrderStatusReservedPayload = {
  __typename?: 'AdminUpdateOrderStatusReservedPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdatePaymentStatusRefundedInput = {
  paymentId: Scalars['Int'];
};

export type AdminUpdatePaymentStatusRefundedPayload = {
  __typename?: 'AdminUpdatePaymentStatusRefundedPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateTemporarySuspendedFlightCarrier = {
  carrierIATA: Scalars['String'];
  start: Scalars['String'];
  end: Scalars['String'];
};

export type AdminUpdateTemporarySuspendedFlightCarriersInput = {
  carriers: Array<AdminUpdateTemporarySuspendedFlightCarrier>;
};

export type AdminUpdateTemporarySuspendedFlightCarriersPayload = {
  __typename?: 'AdminUpdateTemporarySuspendedFlightCarriersPayload';
  ok: Scalars['Boolean'];
};

export type AdminUpdateTravelDescriptionInput = {
  travelId: Scalars['Int'];
  description: Scalars['String'];
};

export type AdminUpdateTravelDescriptionPayload = {
  __typename?: 'AdminUpdateTravelDescriptionPayload';
  ok: Scalars['Boolean'];
};

export type Airport = Node & {
  __typename?: 'Airport';
  id: Scalars['ID'];
  cityName: Scalars['String'];
  iata: Scalars['String'];
  airportName: Scalars['String'];
  zonePath?: Maybe<Scalars['String']>;
};

export type AirportInput = {
  iataCode: Scalars['String'];
};

export type AirportSection = {
  __typename?: 'AirportSection';
  name: Scalars['String'];
  airports: Array<AirportWithChildren>;
};

export type AirportWithChildren = {
  __typename?: 'AirportWithChildren';
  airport: Airport;
  children?: Maybe<Array<Airport>>;
};

export type Airports = {
  __typename?: 'Airports';
  departureAirPorts: Array<AirportSection>;
  arrivalAirPorts: Array<AirportSection>;
};

export type AirportsForDpFlightThemes = {
  __typename?: 'AirportsForDPFlightThemes';
  /** ヘッダー画像 */
  imageUrl: Scalars['String'];
  /** 目的地のIATAコード ex. TYO */
  returningCityOrAirportIATACode: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** 出発地の空港リスト */
  departureAirports: Array<AirportSection>;
  /** 目的地の空港リスト */
  arrivalAirports: Array<AirportSection>;
};

export type AirportsForDpFlightThemesInput = {
  /** テーマID */
  themeId: Scalars['String'];
  /** 地域名 ex. hawaii */
  zoneNameEn: Scalars['String'];
};

/** アメニティ情報 */
export type Amenity = {
  __typename?: 'Amenity';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ApplyReservationCancelForAnyReasonPriceInfo = {
  __typename?: 'ApplyReservationCancelForAnyReasonPriceInfo';
  /** キャンセル保証が追加されているかどうか */
  hasCancelForAnyReason: Scalars['Boolean'];
  /** 税込のキャンセル保証料 */
  amount: Scalars['Int'];
  /** キャンセル保証料の消費税 */
  tax: Scalars['Int'];
};

export type ApplyReservationFlightInfo = {
  __typename?: 'ApplyReservationFlightInfo';
  flightReservationId: Scalars['String'];
};

export type ApplyReservationHotelInfo = {
  __typename?: 'ApplyReservationHotelInfo';
  cocolocalaHotelId: Scalars['String'];
  checkInDate: Scalars['Int'];
  checkOutDate: Scalars['Int'];
  nights: Scalars['Int'];
  numberOfPeople: Scalars['Int'];
  numberOfAdults: Scalars['Int'];
  numberOfChildren: Scalars['Int'];
  numberOfBabies: Scalars['Int'];
  hotelName: Scalars['String'];
  mealLabel: Scalars['String'];
};

export type ApplyReservationInput = {
  /** 決済手段問わず共通で使用するデータ */
  shared: ReservationSharedInput;
  /** 決済手段 */
  paymentMethod: PaymentMethod;
  /** クレジットカード(SBPS)選択時に使用するデータ */
  creditCard?: Maybe<ApplyReservationViaCreditCardInput>;
  /** ホテルの予約情報 */
  hotelReservationInfo?: Maybe<HotelReservationInput>;
  /** レンタカーの予約情報 */
  dPCarReservationInfo?: Maybe<DpCarReservationInput>;
  /** らくらくキャンセルの情報 */
  cancelForAnyReasonInfo?: Maybe<CancelForAnyReasonInput>;
  /** 海外DPあんしんサポートプラン */
  dPFlightSupportPlan?: Maybe<DpFlightSupportPlanType>;
  /** 空港送迎の有無 */
  useAirportTransfer?: Maybe<Scalars['Boolean']>;
  /** 外部サービスの予約情報 */
  flightExternalReservationInfo?: Maybe<FlightExternalReservationInput>;
};

export type ApplyReservationLogInfo = {
  __typename?: 'ApplyReservationLogInfo';
  email: Scalars['String'];
};

export type ApplyReservationPayload = Node & {
  __typename?: 'ApplyReservationPayload';
  id: Scalars['ID'];
  orderId: Scalars['String'];
  travelId: Scalars['String'];
  cocolocalaUserId: Scalars['String'];
  firebaseUserId: Scalars['String'];
  totalAmount: Scalars['Int'];
  hotelInfo?: Maybe<ApplyReservationHotelInfo>;
  flightInfo?: Maybe<ApplyReservationFlightInfo>;
  logInfo: ApplyReservationLogInfo;
};

export type ApplyReservationPriceInfo = {
  __typename?: 'ApplyReservationPriceInfo';
  /** 割引前の支払い合計金額(こころからの取扱手数料、手数料の消費税、支払手数料はなし) */
  amountBeforeDiscount: Scalars['Int'];
  /** こころからの取扱手数料の合計 */
  cocolocalaTransactionFee: Scalars['Int'];
  /** こころからの取扱手数料に対する消費税の合計 */
  cocolocalaTransactionFeeTax: Scalars['Int'];
  /** 通貨 */
  currency: Scalars['String'];
  /** 海外DPの税込のキャンセル保証料 */
  cancelForAnyReasonPriceInfo?: Maybe<ApplyReservationCancelForAnyReasonPriceInfo>;
};

export type ApplyReservationViaCreditCardInput = {
  /** SBPSのトークン */
  token: Scalars['String'];
  /** SBPSのトークンキー */
  tokenKey: Scalars['String'];
};

export type ApplyReservationViaFincodeInput = {
  orderId: Scalars['Int'];
  /** 3Dセキュア認証実行に使用する情報 */
  param: Scalars['String'];
};

export type ApplyReservationViaFincodeNeedChallenge = {
  __typename?: 'ApplyReservationViaFincodeNeedChallenge';
  challengeUrl: Scalars['String'];
};

export type ApplyReservationViaFincodePayload = {
  __typename?: 'ApplyReservationViaFincodePayload';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  /** チャレンジが必要なケースの情報 */
  needChallengeInfo?: Maybe<ApplyReservationViaFincodeNeedChallenge>;
  /** チャレンジが不要なケースの情報(決済済み) */
  withoutChallengeInfo?: Maybe<ApplyReservationPayload>;
};

export type ApplyReservationViaStripeInput = {
  /** 決済手段問わず共通で使用するデータ */
  shared: ReservationSharedInput;
  /** 決済手段 */
  paymentMethod: PaymentMethod;
  /** OrderのID */
  orderId: Scalars['Int'];
  /** Stripeで検証された決済に関するID */
  paymentIntentId: Scalars['String'];
  /** ホテルの予約情報 */
  hotelReservationInfo?: Maybe<HotelReservationInput>;
  /** レンタカーの予約情報 */
  dPCarReservationInfo?: Maybe<DpCarReservationInput>;
  /** 外部サービスの予約情報 */
  flightExternalReservationInfo?: Maybe<FlightExternalReservationInput>;
};

export type Area = {
  __typename?: 'Area';
  name: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  path: Scalars['String'];
  type: PathType;
  count: Scalars['Int'];
};

export type AroundVacantHotels = {
  __typename?: 'AroundVacantHotels';
  /** 空室のホテルの一覧 */
  result: Array<HotelListItemData>;
  /** ページネーション結果 */
  pagination: PaginationData;
};

export type AroundVacantHotelsInput = {
  /** 国のコード（2文字のJP等） */
  countryCode?: Maybe<Scalars['String']>;
  /** 地方の表示名 */
  regionName?: Maybe<Scalars['String']>;
  /** 都道府県の表示名 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 地域のパス */
  districtPath?: Maybe<Scalars['String']>;
  /** エリアのパス */
  areaPath?: Maybe<Scalars['String']>;
  /** 取得するページ */
  page: Scalars['Int'];
  /** 1ページでの件数 */
  limit: Scalars['Int'];
  /** チェックイン日 */
  checkinDate: Scalars['String'];
  /** チェックアウト日 */
  checkoutDate: Scalars['String'];
  /** 宿泊人数 */
  occupancies: Array<OccupancyInput>;
  /** こころからで扱っている商材の種類 */
  productType?: Maybe<ProductType>;
  /** 会員限定価格 */
  isAvailableMemberDiscount?: Maybe<Scalars['Boolean']>;
};

export type BaggageOption = {
  __typename?: 'BaggageOption';
  value: Scalars['Int'];
  /** 許容量 */
  allowance: Scalars['String'];
  /** 料金 */
  price: Scalars['Int'];
  /** こころからでの手数料も含まれた料金 */
  inclusivePrice?: Maybe<Scalars['Int']>;
  /** 最大個数 */
  maxQuantity: Scalars['Int'];
  /** 最大重量 */
  maxWeight?: Maybe<Scalars['Int']>;
};

export type BaggageOptionDetail = {
  __typename?: 'BaggageOptionDetail';
  /** 手荷物指定の単位（True: 旅客単位, False: 全旅客） */
  perPassenger: Scalars['Boolean'];
  /** 選択可能な受託手荷物の一覧 */
  baggageOptions: Array<BaggageOption>;
};

export type BaggageOptionDetailInput = {
  /** 手荷物指定の単位（True: 旅客単位, False: 全旅客） */
  perPassenger: Scalars['Boolean'];
  /** 選択可能な受託手荷物の一覧 */
  baggageOptions: Array<BaggageOptionInput>;
};

export type BaggageOptionInfo = {
  __typename?: 'BaggageOptionInfo';
  round?: Maybe<BaggageOptionDetail>;
  going?: Maybe<BaggageOptionDetail>;
  returning?: Maybe<BaggageOptionDetail>;
};

export type BaggageOptionInfoInput = {
  round?: Maybe<BaggageOptionDetailInput>;
  going?: Maybe<BaggageOptionDetailInput>;
  returning?: Maybe<BaggageOptionDetailInput>;
};

export type BaggageOptionInput = {
  value: Scalars['Int'];
  /** 許容量 */
  allowance: Scalars['String'];
  /** 料金 */
  price: Scalars['Int'];
  /** 最大個数 */
  maxQuantity: Scalars['Int'];
  /** 最大重量 */
  maxWeight?: Maybe<Scalars['Int']>;
};

export type BaggageOptionPriceInfo = {
  __typename?: 'BaggageOptionPriceInfo';
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
  /** 手数料込みの合計金額 */
  inclusiveTotalPrice?: Maybe<Scalars['Int']>;
};

export type BedGroupConfiguration = {
  __typename?: 'BedGroupConfiguration';
  /** ベッドの種類 */
  type?: Maybe<RoomBedType>;
  /** ベッドのサイズ */
  size?: Maybe<Scalars['String']>;
  /** 台数 */
  quantity?: Maybe<Scalars['Int']>;
};

export type BirthdayOrPassportExpiry = {
  __typename?: 'BirthdayOrPassportExpiry';
  year: Scalars['String'];
  month: Scalars['String'];
  day: Scalars['String'];
};

export type CampaignBanner = {
  __typename?: 'CampaignBanner';
  description: Scalars['String'];
  imageData: ImageData;
  linkUrl: Scalars['String'];
};

export type CampaignInfo = {
  __typename?: 'CampaignInfo';
  /** バナー */
  campaignImageBannerPath: Scalars['String'];
  /** 一人当たりのキャンペーンの割引額 */
  campaignDiscountAmountPerPerson: Scalars['Int'];
};

export type CancelForAnyReasonInput = {
  /** キャンセル保証が追加されているかどうか */
  hasCancelForAnyReason: Scalars['Boolean'];
  /** 税込のキャンセル保証料 */
  amount: Scalars['Int'];
  /** キャンセル保証料の消費税 */
  tax: Scalars['Int'];
};

export type CancelOrderAndRefundInput = {
  orderId: Scalars['Int'];
  notSendEmail: Scalars['Boolean'];
  cancelChargeAmount: Scalars['Int'];
};

export type CancelOrderAndRefundPayload = {
  __typename?: 'CancelOrderAndRefundPayload';
  ok: Scalars['Boolean'];
};

export type CancelPnrInput = {
  controlNumber: Scalars['String'];
};

export type CancelPnrPayload = {
  __typename?: 'CancelPNRPayload';
  ok: Scalars['Boolean'];
};

export type CancelPolicyDateTime = {
  __typename?: 'CancelPolicyDateTime';
  /** 日. ex. '12月28日' */
  date: Scalars['String'];
  /** 時間. ex. '17:00' */
  time: Scalars['String'];
};

export type CancelPolicySection = {
  __typename?: 'CancelPolicySection';
  /** セクションタイトル */
  title: Scalars['String'];
  /** キャンセルペナルティ */
  policies: Array<CancelPolicyTableItem>;
};

export type CancelPolicyTableItem = {
  __typename?: 'CancelPolicyTableItem';
  /** 開始日 */
  beginDate?: Maybe<CancelPolicyDateTime>;
  /** 終了日 */
  endDate?: Maybe<CancelPolicyDateTime>;
  /** キャンセルポリシーの値 */
  value: Scalars['String'];
};

export type CancelReservedCarInput = {
  pickupDateTime: Scalars['String'];
  returnDateTime: Scalars['String'];
  pickupLocationCode: Scalars['String'];
  returnLocationCode: Scalars['String'];
  reservationConfId: Scalars['String'];
  lastName: Scalars['String'];
  firstName: Scalars['String'];
};

export type CancelReservedCarPayload = {
  __typename?: 'CancelReservedCarPayload';
  ok: Scalars['Boolean'];
};

export type CancelReservedDidaHotelInput = {
  bookingId: Scalars['String'];
};

export type CancelReservedDidaHotelPayload = {
  __typename?: 'CancelReservedDidaHotelPayload';
  ok: Scalars['Boolean'];
};

export type CancelReservedHotelInput = {
  itineraryId: Scalars['String'];
  email: Scalars['String'];
};

export type CancelReservedHotelPayload = {
  __typename?: 'CancelReservedHotelPayload';
  ok: Scalars['Boolean'];
};

export type CancelReservedInfo = {
  __typename?: 'CancelReservedInfo';
  pickupDateTime: Scalars['String'];
  returnDateTime: Scalars['String'];
  pickupLocationCode: Scalars['String'];
  returnLocationCode: Scalars['String'];
  reservationConfId: Scalars['String'];
  lastName: Scalars['String'];
  firstName: Scalars['String'];
};

export enum CarrierType {
  FullCarrier = 'FULL_CARRIER',
  Lcc = 'LCC'
}

export type CartFlightPriceInfo = {
  /** 元値の税サ抜きの大人の合計料金 */
  originalExclusivePriceOfAdults: Scalars['Int'];
  /** 元値の税サ抜きの小児の合計料金 */
  originalExclusivePriceOfChildren: Scalars['Int'];
  /** 元値の税サ抜きの乳幼児の合計料金 */
  originalExclusivePriceOfInfants: Scalars['Int'];
  /** 元値の大人の税サ料金 */
  originalTaxOfAdults: Scalars['Int'];
  /** 元値の小児の税サ料金 */
  originalTaxOfChildren: Scalars['Int'];
  /** 元値の乳幼児の税サ料金 */
  originalTaxOfInfants: Scalars['Int'];
  /** 通貨コード */
  currencyCode: Scalars['String'];
};

export type CartFlightSectorInput = {
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーン ex. +09:00 */
  departureTimeZoneOffset: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 到着日時のタイムゾーン ex. +09:00 */
  arrivalTimeZoneOffset: Scalars['String'];
  /** 出発空港のIATAコード */
  departureAirportIATACode: Scalars['String'];
  /** 到着空港のIATAコード */
  arrivalAirportIATACode: Scalars['String'];
  /** フライト番号 */
  flightNumber: Scalars['String'];
  /** 航空会社のIATAコード */
  carrierIATACode: Scalars['String'];
  /** flightSectorのインデックス番号 */
  flightIndex: Scalars['Int'];
  /** 航空機のクラス */
  flightClassCode: Scalars['String'];
  /** 運賃クラス */
  fareClassCode: Scalars['String'];
  /** コードシェア便 */
  codeShareAirlines: Array<Scalars['String']>;
  flightTransits: Array<FlightTransitInput>;
};

export type ChangeDpFlightCancelForAnyReasonInput = {
  cartSnapshotId: Scalars['String'];
  hasCancelForAnyReason: Scalars['Boolean'];
};

export type ChangeDpFlightCancelForAnyReasonPayload = {
  __typename?: 'ChangeDPFlightCancelForAnyReasonPayload';
  cartSnapshotId: Scalars['String'];
  orderPriceInfo: OrderPriceInfoForOrderConfirm;
};

export type ChangeDpFlightOptionsInput = {
  cartSnapshotId: Scalars['String'];
  hasCancelForAnyReason?: Maybe<Scalars['Boolean']>;
  supportPlanType?: Maybe<DpFlightSupportPlanType>;
};

export type ChangeDpFlightOptionsPayload = {
  __typename?: 'ChangeDPFlightOptionsPayload';
  cartSnapshotId: Scalars['String'];
  orderPriceInfo: OrderPriceInfoForOrderConfirm;
};

export type ChangeDpFlightSupportPlanInput = {
  cartSnapshotId: Scalars['String'];
  supportPlanType: DpFlightSupportPlanType;
};

export type ChangeDpFlightSupportPlanPayload = {
  __typename?: 'ChangeDPFlightSupportPlanPayload';
  cartSnapshotId: Scalars['String'];
  orderPriceInfo: OrderPriceInfoForOrderConfirm;
};

export type ChangeFlightInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
  /** 人数 */
  occupancy: OccupancyInput;
  /** 行きの乗り継ぎ情報 */
  goingFlightSectors: Array<CartFlightSectorInput>;
  /** 帰りの乗り継ぎ情報 */
  returningFlightSectors: Array<CartFlightSectorInput>;
  /** 行きの機内持ち込み */
  goingFreeBaggageAllowance?: Maybe<Scalars['String']>;
  /** 帰りの機内持ち込み */
  returningFreeBaggageAllowance?: Maybe<Scalars['String']>;
  /** 料金情報 */
  priceInfo: CartFlightPriceInfo;
  /** 出発場所の出発日時(UTC) ex. 2022-04-16T15:00:00Z */
  goingDeparturePointDateUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーンオフセット ex. +09:00 */
  goingDeparturePointDateTimeZoneOffset: Scalars['String'];
  /** 行きのフライトのvalidatingCarrierIATA */
  goingValidatingCarrierIATA: Scalars['String'];
  /** 目的地からの出発日時(UTC) ex. 2022-04-18T15:00:00Z */
  returningDeparturePointDateUtcDateTime: Scalars['String'];
  /** 目的地のタイムゾーンオフセット ex. -10:00 */
  returningDeparturePointDateTimeZoneOffset: Scalars['String'];
  /** 帰りのフライトのvalidatingCarrierIATA */
  returningValidatingCarrierIATA: Scalars['String'];
  /** INFINIで後から空室検索や予約の詳細を取得するために必要な情報 */
  additionalFlightInfo?: Maybe<AdditionalFlightInfoForChangeFlightInput>;
};

export type ChangeFlightPayload = {
  __typename?: 'ChangeFlightPayload';
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

export type ChangeHotelRoomInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
  /** カートへ追加するホテル情報 */
  hotel: AddHotelToCartHotelForOrderConfirmInput;
};

export type ChangeHotelRoomPayload = {
  __typename?: 'ChangeHotelRoomPayload';
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

export type ChangeSelectedBaggageOptionInput = {
  cartSnapshotId: Scalars['String'];
  /** 旅客単位の受託手荷物オプション */
  perPassengers: Array<ChangeSelectedBaggageOptionPerPassengerInput>;
  /** 全旅客の受託手荷物オプション */
  perFlight?: Maybe<SelectedBaggageOptionInfoInput>;
};

export type ChangeSelectedBaggageOptionPayload = {
  __typename?: 'ChangeSelectedBaggageOptionPayload';
  cartSnapshotId: Scalars['String'];
  orderPriceInfo: OrderPriceInfoForOrderConfirm;
};

export type ChangeSelectedBaggageOptionPerPassengerInput = {
  selectedBaggageOption: SelectedBaggageOptionInfoInput;
};

export type ChangeUseAirportTransferInput = {
  cartSnapshotId: Scalars['String'];
  useAirportTransfer: Scalars['Boolean'];
};

export type ChangeUseAirportTransferPayload = {
  __typename?: 'ChangeUseAirportTransferPayload';
  cartSnapshotId: Scalars['String'];
};

export enum Channel {
  /** Google Hotel Ads */
  Gha = 'GHA',
  /** Google Ads */
  GoogleAds = 'GOOGLE_ADS'
}

export type Checkin = {
  __typename?: 'Checkin';
  twentyFourHour?: Maybe<Scalars['String']>;
  beginTime?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  minAge?: Maybe<Scalars['String']>;
};

export type Checkout = {
  __typename?: 'Checkout';
  time?: Maybe<Scalars['String']>;
};

export type Conditions = {
  __typename?: 'Conditions';
  /** 料金タイプ */
  priceRangeConditions: Array<HotelPriceRange>;
  /** ベッドタイプ */
  bedTypeConditions: Array<RoomBedType>;
  /** 禁煙/喫煙条件 */
  smokingConditions: Array<SmokingCondition>;
  /** WiFi利用 */
  wifiConditions: Array<HotelWifiCondition>;
  /** 日本語対応 */
  japaneseConditions: Array<HotelJapaneseCondition>;
};

export type ConfirmReservationViaFincodeInput = {
  orderId: Scalars['Int'];
};

export enum ContactType {
  DayOfTravel = 'DAY_OF_TRAVEL',
  DayOfAppointment = 'DAY_OF_APPOINTMENT',
  Etc = 'ETC'
}

export type ConvenienceStorePaymentDetail = {
  __typename?: 'ConvenienceStorePaymentDetail';
  /** コンビニの種類 */
  convenienceStoreType: ConvenienceStoreType;
  /** コンビニ払いの支払い期限 */
  convenienceStorePaymentDeadline: Scalars['String'];
  sevenEleven?: Maybe<SevenEleven>;
  lawson?: Maybe<Lawson>;
  miniStop?: Maybe<MiniStop>;
  familyMart?: Maybe<FamilyMart>;
  dailyYamazaki?: Maybe<DailyYamazaki>;
  seicoMart?: Maybe<SeicoMart>;
};

export enum ConvenienceStoreType {
  SevenEleven = 'SEVEN_ELEVEN',
  Lawson = 'LAWSON',
  FamilyMart = 'FAMILY_MART',
  SeicoMart = 'SEICO_MART',
  Ministop = 'MINISTOP',
  DailyYamazaki = 'DAILY_YAMAZAKI'
}

export type Coupon = Node & {
  __typename?: 'Coupon';
  id: Scalars['ID'];
  couponId: Scalars['Int'];
  /** ラベル */
  label: Scalars['String'];
  /** クーポンのタイトル */
  title: Scalars['String'];
  /** 詳細文 */
  description: Scalars['String'];
  /** 利用条件 */
  condition: Scalars['String'];
  discountType: DiscountType;
  discountAmount: Scalars['Int'];
  /** サムネイルURL */
  thumbnailUrl?: Maybe<Scalars['String']>;
  startTime: Scalars['Int'];
  expireTime: Scalars['Int'];
  /** 利用可能な旅行出発時間。この期間内の旅行に対して使える */
  departureStartTime: Scalars['Int'];
  /** 利用できなくなる旅行到着時間 */
  arrivalEndTime: Scalars['Int'];
  /** 使用済みかどうか。ユーザーIDが紐付いていない場合は常に true がかえる。 */
  isUsed: Scalars['Boolean'];
  /** クーポンが使える値引き前の最低料金 */
  minimumAvailableAmount: Scalars['Int'];
  /** 割引の単位 */
  discountUnit: DiscountUnit;
  /** 最大使用回数 */
  usageCountLimit: Scalars['Int'];
  /** 現在のクーポンの使用回数 */
  currentUsageCount: Scalars['Int'];
  /** 最大の値引き額 */
  maximumDiscountAmount: Scalars['Int'];
};

export type CouponCode = Node & {
  __typename?: 'CouponCode';
  id: Scalars['ID'];
  isAvailableDiscount: Scalars['Boolean'];
  isAvailableFifteenPercentDiscount: Scalars['Boolean'];
  couponCode: Scalars['String'];
  isAvailablePerPersonDiscount: Scalars['Boolean'];
  isDPFlight: Scalars['Boolean'];
};

export type CouponCodeInput = {
  couponCode: Scalars['String'];
};

export type Covid19Tag = {
  __typename?: 'Covid19Tag';
  /** マスクの用意あり */
  mask: Scalars['Boolean'];
  /** 無料消毒液の設置 */
  freeAntisepticSolution: Scalars['Boolean'];
  /** 清掃の強化 */
  cleaning: Scalars['Boolean'];
  /** 食事の個別包装 */
  individualPackagingForMeal: Scalars['Boolean'];
  /** 非対面式のチェックイン */
  noMeetCheckIn: Scalars['Boolean'];
  /** ルームサービスの個別包装 */
  individualPackagingForRoomService: Scalars['Boolean'];
};

export type CreateDpFlightThemeInput = {
  /** タイトル */
  title: Scalars['String'];
  /** 説明文 */
  description: Scalars['String'];
  /** 宿泊日数 */
  recommendedStayDays: Scalars['Int'];
  /** 合計日数 */
  recommendedTotalDays: Scalars['Int'];
  /** 1人当たりの目安の最低料金 */
  minimumPrice?: Maybe<Scalars['Int']>;
  /** 並び順 */
  sortOrder: Scalars['Int'];
  /** 地域のID */
  dPFlightThemeZoneId: Scalars['Int'];
  /** 到着空港のIATAコード ex. HNL */
  arrivalAirportIATACode: Scalars['String'];
  /** 画像URL */
  imageUrls: Array<Scalars['String']>;
  /** スタッフコメント */
  staffComment: Scalars['String'];
  /** ホテル */
  hotels: Array<DpFlightThemeHotel>;
};

export type CreateDpFlightThemePayload = {
  __typename?: 'CreateDPFlightThemePayload';
  dPFlightThemeId: Scalars['Int'];
};

export type CreateMyReviewInput = {
  cocolocalaHotelId: Scalars['Int'];
  stayedAt: Scalars['String'];
  numberOfPeople: Scalars['Int'];
  useScene: UseScene;
};

export type CreateMyReviewItemInput = {
  reviewId: Scalars['Int'];
  category: ReviewItemCategory;
  comment: Scalars['String'];
  sortOrder: Scalars['Int'];
  reviewVersionNo: Scalars['Int'];
  reviewItemImages: Array<ReviewItemImageInput>;
};

export type CreateMyReviewItemPayload = Node & IReviewItem & {
  __typename?: 'CreateMyReviewItemPayload';
  id: Scalars['ID'];
  reviewItemId: Scalars['Int'];
  reviewItemImages: Array<MyReviewItemImage>;
  category: ReviewItemCategoryWithLabel;
  comment: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type CreateMyReviewPayload = {
  __typename?: 'CreateMyReviewPayload';
  reviewId: Scalars['Int'];
};

export type CurrencyData = {
  __typename?: 'CurrencyData';
  value: Scalars['Int'];
  currency: Scalars['String'];
};

export type DpCar = IdpCar & {
  __typename?: 'DPCar';
  /** 車名 */
  name: Scalars['String'];
  /** 車の画像URL */
  thumbnailUrl: Scalars['String'];
  /** 車のオプション情報 */
  options: Array<DpCarOption>;
};

export type DpCarOption = {
  __typename?: 'DPCarOption';
  /** タイプ */
  type: DpCarOptionType;
  /** 表示名 */
  value: Scalars['String'];
};

export enum DpCarOptionType {
  /** 乗車人数 */
  Passengers = 'PASSENGERS',
  /** 荷台の数 */
  Baggage = 'BAGGAGE',
  /** カーナビ */
  CarNavigation = 'CAR_NAVIGATION',
  /** 禁煙 */
  NoSmoking = 'NO_SMOKING',
  /** ETC */
  Etc = 'ETC'
}

export type DpCarPriceInfo = IdpCarPriceInfo & {
  __typename?: 'DPCarPriceInfo';
  /** 総額 */
  price?: Maybe<Scalars['Int']>;
  /** 予約手数料 */
  transactionFee?: Maybe<Scalars['Int']>;
  /** 税 */
  tax?: Maybe<Scalars['Int']>;
  /** 通貨コード */
  currencyCode?: Maybe<Scalars['String']>;
  /** こころからの取扱手数料も含めた金額 */
  inclusivePrice?: Maybe<Scalars['Int']>;
  /** こころからの取扱手数料 */
  cocolocalaTransactionFee?: Maybe<Scalars['Int']>;
  /** こころからの取扱手数料に対する税額 */
  cocolocalaTransactionFeeTax?: Maybe<Scalars['Int']>;
};

export type DpCarPriceInfoWithPriceDiffFromLowestPrice = IdpCarPriceInfo & {
  __typename?: 'DPCarPriceInfoWithPriceDiffFromLowestPrice';
  /** 総額 */
  price: Scalars['Int'];
  /** 検索して最安価格の車との価格差 */
  priceDiffFromLowestPrice: Scalars['Int'];
  /** 予約手数料 */
  transactionFee: Scalars['Int'];
  /** 税 */
  tax: Scalars['Int'];
  /** 通貨コード */
  currencyCode: Scalars['String'];
  /** こころからの取扱手数料も含めた金額 */
  inclusivePrice: Scalars['Int'];
  /** こころからの取扱手数料 */
  cocolocalaTransactionFee: Scalars['Int'];
  /** こころからの取扱手数料に対する税額 */
  cocolocalaTransactionFeeTax: Scalars['Int'];
  /** こころからの取扱手数料を含めた金額での最安価格との価格差 */
  inclusivePriceDiffFromLowestPrice: Scalars['Int'];
};

export type DpCarReference = {
  __typename?: 'DPCarReference';
  type: Scalars['String'];
  id: Scalars['String'];
  idContext: Scalars['String'];
  dateTime: Scalars['String'];
  url: Scalars['String'];
};

export type DpCarReferenceInput = {
  type: Scalars['String'];
  id: Scalars['String'];
  idContext: Scalars['String'];
  dateTime: Scalars['String'];
  url: Scalars['String'];
};

export type DpCarReservationInfo = {
  __typename?: 'DPCarReservationInfo';
  /** リファレンス情報 */
  reference: DpCarReference;
  /** 出発日時 */
  departureDateTime: Scalars['String'];
  /** 返却日時 */
  returnDateTime: Scalars['String'];
  /** 借りるときのロケーションコード */
  pickupLocationCode: Scalars['String'];
  /** 返却するときののロケーションコード */
  returnLocationCode: Scalars['String'];
  /** 運転手以外の人数 */
  passengers: Scalars['Int'];
};

export type DpCarReservationInput = {
  /** リファレンス情報 */
  reference: DpCarReferenceInput;
  /** 出発日時 */
  departureDateTime: Scalars['String'];
  /** 返却日時 */
  returnDateTime: Scalars['String'];
  /** 借りるときのロケーションコード */
  pickupLocationCode: Scalars['String'];
  /** 返却するときののロケーションコード */
  returnLocationCode: Scalars['String'];
  /** 運転手以外の人数 */
  passengers: Scalars['Int'];
  /** 年齢 */
  age: Scalars['Int'];
  /** 国籍コード */
  countryCode: Scalars['String'];
  /** 郵便番号 */
  zipCode: Scalars['String'];
  /** 住所 */
  address: Scalars['String'];
};

export type DpCarVendor = Node & {
  __typename?: 'DPCarVendor';
  id: Scalars['ID'];
  /** 営業所の情報 */
  vendorInfo: DpCarVendorInfo;
  /** 営業所で利用可能な車 */
  cars: Array<DpCarWithReference>;
};

export type DpCarVendorInfo = Node & {
  __typename?: 'DPCarVendorInfo';
  id: Scalars['ID'];
  vendorId: Scalars['String'];
  /** 営業所名 */
  vendorName: Scalars['String'];
  /** 住所のテキスト */
  address?: Maybe<Scalars['String']>;
  /** 緯度 */
  latitude: Scalars['String'];
  /** 経度 */
  longitude: Scalars['String'];
  /** 営業所のロケーションコード */
  locationCode: Scalars['String'];
  /** ご利用日時情報 */
  reservedCarInfo: Array<DetailsTableItem>;
  /** 出発営業所 */
  pickupVendor: Array<DetailsTableItem>;
};

export type DpCarWithReference = IdpCar & Node & {
  __typename?: 'DPCarWithReference';
  id: Scalars['ID'];
  /** 車名 */
  name: Scalars['String'];
  /** 車の画像URL */
  thumbnailUrl: Scalars['String'];
  /** 車のオプション情報 */
  options: Array<DpCarOption>;
  /** 料金情報(最低価格との比較情報あり) */
  priceInfo: DpCarPriceInfoWithPriceDiffFromLowestPrice;
  /** 予約するために必要な情報 */
  reference: DpCarReference;
};

export type DpFlightBirthdayOrPassportExpiryInput = {
  year: Scalars['String'];
  month: Scalars['String'];
  day: Scalars['String'];
};

export type DpFlightCancelForAnyReason = {
  __typename?: 'DPFlightCancelForAnyReason';
  /** キャンセル保証付きの場合の料金情報 */
  cancelForAnyReasonPrice: DpFlightCancelForAnyReasonPrice;
  /** キャンセル保証を付けない場合の料金情報 */
  defaultPrice: DpFlightCancelForAnyReasonPrice;
  /** 宿泊人数 */
  numberOfPeople: Scalars['Int'];
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
  /** キャンセル保証期限 ex. 2024年5月15日 11:15 */
  limitDateTimeText: Scalars['String'];
};

export type DpFlightCancelForAnyReasonForOrderConfirm = {
  __typename?: 'DPFlightCancelForAnyReasonForOrderConfirm';
  /** キャンセル保証付きの場合の料金情報 */
  cancelForAnyReasonPrice: DpFlightCancelForAnyReasonPriceForOrderConfirm;
  /** キャンセル保証を付けない場合の料金情報 */
  defaultPrice: DpFlightCancelForAnyReasonPriceForOrderConfirm;
  /** 宿泊人数 */
  numberOfPeople: Scalars['Int'];
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
  /** キャンセル保証期限 ex. 2024年5月15日 11:15 */
  limitDateTimeText: Scalars['String'];
  /** キャンセル保証が追加されているかどうか */
  hasCancelForAnyReason: Scalars['Boolean'];
};

export type DpFlightCancelForAnyReasonForOrderConfirmInput = {
  cartSnapshotId: Scalars['String'];
};

export type DpFlightCancelForAnyReasonPrice = {
  __typename?: 'DPFlightCancelForAnyReasonPrice';
  /** キャンセル保証料の1人あたりの税込の料金 */
  inclusivePricePerPerson: Scalars['Int'];
  /** キャンセル保証料を加味した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金 */
  totalPrice: Scalars['Int'];
  /** キャンセル保証料を加味した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の1人あたりの合計料金 */
  totalPricePerPerson: Scalars['Int'];
};

export type DpFlightCancelForAnyReasonPriceForOrderConfirm = {
  __typename?: 'DPFlightCancelForAnyReasonPriceForOrderConfirm';
  /** キャンセル保証を追加するかどうかを切り替えた場合の差額 */
  priceDiff: Scalars['Int'];
  /** キャンセル保証料を加味した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金 */
  totalPrice: Scalars['Int'];
  /** キャンセル保証料を加味した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の1人あたりの合計料金 */
  totalPricePerPerson: Scalars['Int'];
};

export enum DpFlightGender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE'
}

export type DpFlightSupportPlan = {
  __typename?: 'DPFlightSupportPlan';
  /** プランのタイプ */
  planType: DpFlightSupportPlanType;
  /** プランのタイトル. ex: あんしん */
  title: Scalars['String'];
  /** プランの説明 */
  description: Scalars['String'];
  /** プランの税込み価格 */
  inclusivePrice: Scalars['Int'];
  /** アイコン画像のURL */
  iconUrl: Scalars['String'];
  /** おすすめのプランかどうか */
  isRecommend: Scalars['Boolean'];
  /** プランの内容 */
  contents: Array<DpFlightSupportPlanContent>;
  /** プランの色 */
  planColor: Scalars['String'];
  /** 旅行に必要な手続きのパス */
  zonePath?: Maybe<Scalars['String']>;
};

export type DpFlightSupportPlanContent = {
  __typename?: 'DPFlightSupportPlanContent';
  /** プラン内容のタイトル */
  title: Scalars['String'];
  /** プラン内容の説明 */
  description: Scalars['String'];
  /** アイコン画像のURL */
  iconUrl: Scalars['String'];
};

export type DpFlightSupportPlanForOrderConfirm = {
  __typename?: 'DPFlightSupportPlanForOrderConfirm';
  basicPlanPrice: DpFlightSupportPlanPriceForOrderConfirm;
  allPlanPrice: DpFlightSupportPlanPriceForOrderConfirm;
  overseasDPFlightPlans: Array<DpFlightSupportPlan>;
  numberOfPeople: Scalars['Int'];
  numberOfStays: Scalars['Int'];
  selectedPlanType: DpFlightSupportPlanType;
};

export type DpFlightSupportPlanForOrderConfirmInput = {
  cartSnapshotId: Scalars['String'];
};

export type DpFlightSupportPlanPriceForOrderConfirm = {
  __typename?: 'DPFlightSupportPlanPriceForOrderConfirm';
  /** プランのタイプ */
  planType: DpFlightSupportPlanType;
  /** 選択中のプランからの差額 */
  priceDiff: Scalars['Int'];
  /** planTypeのプランを選択した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金 */
  totalPrice: Scalars['Int'];
  /** planTypeのプランを選択した場合の、ホテル・航空券・海外あんしんサポートを合わせた税サ込の1人あたりの合計料金 */
  totalPricePerPerson: Scalars['Int'];
};

export enum DpFlightSupportPlanType {
  /** 無料プラン */
  Free = 'FREE',
  /** あんしんプラン */
  Reliable = 'RELIABLE',
  /** おまかせプラン */
  All = 'ALL'
}

export type DpFlightTheme = {
  __typename?: 'DPFlightTheme';
  /** ゾーン名 */
  zoneName: Scalars['String'];
  /** ゾーン名 ex. hawaii */
  zoneNameEn: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** 親のゾーン情報 パンクズ用 */
  parentZoneInfo?: Maybe<ZoneInfo>;
  /** スタッフのコメント */
  staffComment: Scalars['String'];
  /** 旅行テーマ */
  travelTheme: TravelTheme;
  /** スタッフ厳選ホテル */
  hotels: Array<TravelThemeHotelSummary>;
  /** 海外あんしんサポート */
  supportPlans: Array<DpFlightSupportPlan>;
  /** 出発地の空港リスト */
  departureAirports: Array<AirportSection>;
  /** 目的地のIATAコード (ex. HNL) */
  returningCityOrAirportIATACode: Scalars['String'];
  /** 到着地の空港名 ex. 関西国際空港 */
  arrivalAirportName: Scalars['String'];
  /** 到着地の空港の都市の名前 ex. パリ */
  arrivalAirportCityName: Scalars['String'];
  /** おすすめのテーマ */
  recommendedThemes: Array<TravelTheme>;
  /** 最安値旅行日程 */
  lowestPriceSchedule: FlightSchedule;
};

export type DpFlightThemeHotel = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** スタッフコメント */
  hotelDescription: Scalars['String'];
  /** 客室スタッフコメント */
  roomDescription: Scalars['String'];
};

export type DpFlightThemeInput = {
  /** テーマID */
  themeId: Scalars['String'];
};

export enum DpFlightThemePublishStatus {
  Published = 'PUBLISHED',
  Draft = 'DRAFT'
}

export type DpFlightThemeRecommendedHotel = {
  __typename?: 'DPFlightThemeRecommendedHotel';
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル説明 */
  hotelDescription: Scalars['String'];
  /** 客室説明 */
  roomDescription: Scalars['String'];
};

export type DpFlightThemeSummary = {
  __typename?: 'DPFlightThemeSummary';
  /** テーマID */
  themeId: Scalars['Int'];
  /** 地域名 ex. ハワイ */
  zoneNameKana: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** タイトル */
  title: Scalars['String'];
  /** 公開ステータス */
  publishStatus: DpFlightThemePublishStatus;
  /** 最終更新日時. ex. 2022年5月30日 12:00 */
  updatedAt: Scalars['String'];
};

export type DpFlightThemes = {
  __typename?: 'DPFlightThemes';
  /** ゾーン名 */
  zoneName: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** 子供の都市を返す 無ければ空配列 */
  cities: Array<TravelDestination>;
  /** 親のゾーン情報 パンクズ用 */
  parentZoneInfo?: Maybe<ZoneInfo>;
  /** 旅行テーマページのヘッダー画像URL */
  headerImageUrl: Scalars['String'];
  /** 旅行テーマ */
  travelThemes: Array<TravelTheme>;
  /** 旅行テーマフィルター */
  travelThemesFilter: DpFlightTravelThemesFilter;
  /** 現在の状況 */
  supportPlans: Array<DpFlightSupportPlan>;
  /** 人気の旅行先 */
  recommendedTravelDestinations: Array<TravelDestination>;
  /** 事前確認事項 */
  priorConfirmation?: Maybe<Scalars['String']>;
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
  /** キャンペーンに関する情報 */
  campaignInfo?: Maybe<CampaignInfo>;
};

export type DpFlightThemesInput = {
  /** 国や都市名 ex. hawaii */
  zoneNameEn: Scalars['String'];
  country: Scalars['String'];
};

export type DpFlightTravelThemesFilter = {
  __typename?: 'DPFlightTravelThemesFilter';
  conditions: Array<DpFlightTravelThemesFilterCondition>;
  results: Array<DpFlightTravelThemesFilterResult>;
};

export type DpFlightTravelThemesFilterCondition = {
  __typename?: 'DPFlightTravelThemesFilterCondition';
  title: Scalars['String'];
  summaryTitle: Scalars['String'];
  options: Array<DpFlightTravelThemesFilterConditionOption>;
};

export type DpFlightTravelThemesFilterConditionOption = {
  __typename?: 'DPFlightTravelThemesFilterConditionOption';
  id: Scalars['Int'];
  text: Scalars['String'];
};

export type DpFlightTravelThemesFilterResult = {
  __typename?: 'DPFlightTravelThemesFilterResult';
  filterConditionOptionIds: Array<Scalars['Int']>;
  themeIds: Array<Scalars['Int']>;
};

export type DailyYamazaki = {
  __typename?: 'DailyYamazaki';
  /** オンライン決済番号（11桁） */
  paymentCode: Scalars['String'];
};

/** 予約日当日のご連絡 */
export type DayOfAppointment = {
  /** 宿泊施設へのご事情のご連絡・ご相談済みか否か */
  isContacted: Scalars['Boolean'];
  /** ご対応頂いた担当者様のお名前 */
  contactedPersonName: Scalars['String'];
  /** ご相談内容 */
  consultation: Scalars['String'];
  /** 宿泊施設様からのご回答内容 */
  hotelAnswer: Scalars['String'];
};

/** 旅行日当日のご連絡 */
export type DayOfTravel = {
  /** 予約ステータス */
  reservationStatus: ReservationStatus;
  /** 現在のご状況 */
  currentStatus: Scalars['String'];
};

export type Deal = {
  __typename?: 'Deal';
  id: Scalars['String'];
  description: Scalars['String'];
};

export type DeleteDpFlightThemeInput = {
  dPFlightThemeId: Scalars['Int'];
};

export type DeleteDpFlightThemePayload = {
  __typename?: 'DeleteDPFlightThemePayload';
  ok: Scalars['Boolean'];
};

export enum DeleteFlightPassengerAndPassportTarget {
  Passenger = 'PASSENGER',
  Passport = 'PASSPORT'
}

export type DeleteMyReviewInput = {
  /** レビューのID */
  reviewId: Scalars['Int'];
  /** レビューのバージョン番号 */
  versionNo: Scalars['Int'];
};

export type DeleteMyReviewItemInput = {
  /** レビューのID */
  reviewId: Scalars['Int'];
  /** レビューアイテムのID */
  reviewItemId: Scalars['Int'];
  /** レビューのバージョン番号 */
  reviewVersionNo: Scalars['Int'];
};

export type DeleteMyReviewItemPayload = {
  __typename?: 'DeleteMyReviewItemPayload';
  /** レビューアイテムのID */
  reviewItemId: Scalars['Int'];
};

export type DeleteMyReviewPayload = {
  __typename?: 'DeleteMyReviewPayload';
  /** レビューのID */
  reviewId: Scalars['Int'];
};

export type DetailsTableItem = {
  __typename?: 'DetailsTableItem';
  title: Scalars['String'];
  content: Scalars['String'];
  contentLink?: Maybe<Scalars['String']>;
};

export type DidaHotelInfoInput = {
  didaHotelId: Scalars['String'];
  inclusiveStrikethrough: Scalars['Int'];
};

export enum DidaHotelReservationStatus {
  PreBook = 'PRE_BOOK',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  OnRequest = 'ON_REQUEST',
  Unknown = 'UNKNOWN'
}

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  /** 割引前の合計金額 */
  strikethroughAmount: Scalars['Int'];
  /** 割引額 */
  discountAmount: Scalars['Int'];
};

export type DiscountInfoForDpFlight = {
  __typename?: 'DiscountInfoForDPFlight';
  /** 1名あたりの割引前の料金 */
  strikethroughPerPerson: Scalars['Int'];
  /** 1名あたりのホテルセット割引額 */
  hotelDiscountAmountPerPerson?: Maybe<Scalars['Int']>;
  /** 1名あたりの期間限定セール割引額 */
  limitedTimeSaleDiscountAmountPerPerson?: Maybe<Scalars['Int']>;
  /** 1名あたりのキャンペーン割引額 */
  campaignDiscountAmountPerPerson?: Maybe<Scalars['Int']>;
};

export enum DiscountType {
  /** 金額引き */
  Absolute = 'ABSOLUTE',
  /** %引き */
  Relative = 'RELATIVE'
}

export enum DiscountUnit {
  /** 合計金額からの割引 */
  Whole = 'WHOLE',
  Nightly = 'NIGHTLY',
  /** 人数ごとの割引 */
  Person = 'PERSON',
  /** １泊１人ごとの割引 */
  NightlyPerson = 'NIGHTLY_PERSON'
}

export enum ElasticsearchFilterType {
  And = 'AND',
  Or = 'OR',
  Not = 'NOT',
  None = 'NONE'
}

export type ElasticsearchGeoLocationFilterInput = {
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  distanceMeters: Scalars['Int'];
};

export type ElasticsearchSort = {
  key: Scalars['String'];
  sortType: ElasticsearchSortType;
};

export enum ElasticsearchSortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum ErrorCode {
  /** 30x: リダイレクト */
  Redirect = 'REDIRECT',
  /** 400: 不正なリクエスト */
  BadRequest = 'BAD_REQUEST',
  /** 401: 未認証 */
  Unauthenticated = 'UNAUTHENTICATED',
  /** 403: 禁止 */
  Forbidden = 'FORBIDDEN',
  /** 404: リソースが見つからない */
  NotFound = 'NOT_FOUND',
  /** 409: コンフリクト */
  Conflict = 'CONFLICT',
  /** 500: 予期せぬエラー */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** 503: サーバ障害 */
  ServiceUnavailable = 'SERVICE_UNAVAILABLE'
}

/** その他のご連絡 */
export type Etc = {
  /** ご連絡頂く内容やご状況 */
  consultationOrCurrentStatus: Scalars['String'];
};

export type ExpandableContent = {
  __typename?: 'ExpandableContent';
  /** コンテンツのタイトル */
  title: Scalars['String'];
  /** アイコンがある場合の画像のURL */
  iconUrl?: Maybe<Scalars['String']>;
  /** ラベル情報 */
  label?: Maybe<ExpandableContentLabel>;
  /** 開いたきに表示されるコンテンツ */
  content: Scalars['String'];
  /** 旅行のしやすさでの現在のステータス */
  status?: Maybe<TravelStatus>;
};

export type ExpandableContentLabel = {
  __typename?: 'ExpandableContentLabel';
  /** テキスト */
  text: Scalars['String'];
  /** ラベルの色 */
  labelColor: ExpandedContentLabelColor;
};

/** セクションのタイトルといくつかのExpandableContentを持つ情報 */
export type ExpandableContentsSection = {
  __typename?: 'ExpandableContentsSection';
  /** セクションのタイトル */
  title: Scalars['String'];
  /** コンテンツ */
  contents: Array<ExpandableContent>;
};

export enum ExpandedContentLabelColor {
  Blue = 'BLUE',
  Yellow = 'YELLOW',
  Orange = 'ORANGE',
  Red = 'RED'
}

export type ExpediaGuestReview = {
  __typename?: 'ExpediaGuestReview';
  verificationSourceType?: Maybe<ExpediaGuestReviewVerificationSourceType>;
  title?: Maybe<Scalars['String']>;
  dateSubmitted: Scalars['String'];
  rating: Scalars['String'];
  reviewerName: Scalars['String'];
  text: Scalars['String'];
};

export enum ExpediaGuestReviewVerificationSourceType {
  Expedia = 'Expedia',
  HotelsCom = 'HotelsCom',
  Vrbo = 'Vrbo'
}

export type ExpediaHotelInfoInput = {
  /** 仕入れ価格の税・サービス料抜き */
  provisionalExclusivePrice: Scalars['Int'];
  /** 割引前の仕入れ価格の税・サービス料抜き */
  provisionalExclusiveStrikethroughPrice?: Maybe<Scalars['Int']>;
  /** 仕入れ価格の税・サービス料 */
  provisionalTaxAndServiceCharge: Scalars['Int'];
};

export enum ExpediaHotelReservationStatus {
  Pending = 'PENDING',
  Reserved = 'RESERVED',
  Canceled = 'CANCELED',
  Unknown = 'UNKNOWN'
}

export type FamilyMart = {
  __typename?: 'FamilyMart';
  /** お客様番号（11桁） */
  customerCode: Scalars['String'];
  /** 確認番号（6桁） */
  confirmationCode: Scalars['String'];
};

export type FilterAvailableDpCarVendorsInput = {
  /** 検索地域(district又はareaどちらか必須)のid */
  districtId?: Maybe<Scalars['String']>;
  areaId?: Maybe<Scalars['String']>;
  /** 出発日 (YYYY-MM-DD) */
  pickupDate: Scalars['String'];
  /** 出発時間 (hh:mm) */
  pickupTime: Scalars['String'];
  /** 返却日 (YYYY-MM-DD) */
  returnDate: Scalars['String'];
  /** 返却時間 (hh:mm) */
  returnTime: Scalars['String'];
  /** 運転手を除く乗車人数 */
  numberOfPassengers: Scalars['Int'];
};

export type Flight = {
  __typename?: 'Flight';
  /** 航空券カード */
  summary: FlightSummary;
  /** 航空券詳細モーダル */
  detail: FlightDetail;
  /** 航空券のベンダー */
  gdsVendor: GdsVendors;
  /** パスポート情報入力必要有無 */
  passportRequirement?: Maybe<PassportRequirement>;
  /** 航空券が、FullCarrierかLCCか(LCCが1つでもあれば、LCC優先) */
  carrierType?: Maybe<CarrierType>;
  /** 追加オプション情報 */
  additionalFlightInfo?: Maybe<AdditionalFlightInfo>;
};

export type FlightCancelPolicy = {
  __typename?: 'FlightCancelPolicy';
  /** こころからで定める発券手数料 */
  cocolocalaTicketingFeeText: Scalars['String'];
  /** こころからで定める1名あたりの発券手数料 */
  cocolocalaTicketingFeePerPersonText: Scalars['String'];
  /** こころからで定める取消手数料 */
  cocolocalaCancelFeeText: Scalars['String'];
  /** こころからで定める1名あたりの取消手数料 */
  cocolocalaCancelFeePerPersonText: Scalars['String'];
  /** 航空会社の定めるキャンセルポリシー */
  flightCarrierCancelPolicyTextList: Array<Scalars['String']>;
};

export type FlightClass = Node & {
  __typename?: 'FlightClass';
  /** ID */
  id: Scalars['ID'];
  /** 搭乗クラス名 ex. エコノミー */
  name: Scalars['String'];
  /** 搭乗クラスコード */
  code: FlightClassCode;
};

export enum FlightClassCode {
  /** ビジネスクラス */
  Business = 'BUSINESS',
  /** ファーストクラス */
  First = 'FIRST',
  /** エコノミークラス */
  Economy = 'ECONOMY',
  /** エコノミープレミアム */
  EconomyPremium = 'ECONOMY_PREMIUM'
}

export type FlightDetail = {
  __typename?: 'FlightDetail';
  /** 区間一覧 */
  flightSectors: Array<FlightSector>;
  /** 受託手荷物 */
  freeBaggageAllowance?: Maybe<Scalars['String']>;
  /** 行きの出発空港と帰りの到着空港が異なるか */
  showDifferentAirportsAlertForDeparture?: Maybe<Scalars['Boolean']>;
  /** 行きの到着空港と帰りの出発空港が異なるか */
  showDifferentAirportsAlertForArrival?: Maybe<Scalars['Boolean']>;
  /** 料金情報 */
  price?: Maybe<FlightTicketPriceInfo>;
};

export type FlightExternalReservationInfo = {
  __typename?: 'FlightExternalReservationInfo';
  /** 外部サービスの予約番号 */
  flightExternalReservationId: Scalars['String'];
  /** 支払額 */
  expectedPrice: Scalars['Int'];
};

export type FlightExternalReservationInput = {
  /** 外部サービスの予約番号 */
  flightExternalReservationId: Scalars['String'];
  /** 支払額 */
  expectedPrice: Scalars['Int'];
  /** 航空券のベンダー */
  gdsVendor: GdsVendors;
};

export type FlightOption = {
  __typename?: 'FlightOption';
  /** 受託手荷物 */
  freeBaggageAllowance: Scalars['String'];
  /** 運賃クラス */
  fareClassCodes: Array<Scalars['String']>;
};

export type FlightOptions = {
  __typename?: 'FlightOptions';
  goingFlight: FlightOption;
  returningFlight: FlightOption;
  /** パスポート必要有無 */
  isPassportRequired: Scalars['Boolean'];
  /** 予約時に購入可能な受託手荷物オプション */
  baggageOptionInfo?: Maybe<BaggageOptionInfo>;
};

export type FlightOptionsInput = {
  routingId: Scalars['String'];
  outwardId: Scalars['String'];
  returnId: Scalars['String'];
};

export type FlightPassenger = {
  __typename?: 'FlightPassenger';
  flightPassengerId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: BirthdayOrPassportExpiry;
  nationality: Scalars['String'];
  isRepresentative: Scalars['Boolean'];
  isNeedPassport: Scalars['Boolean'];
  passport?: Maybe<FlightPassengerPassport>;
  /** 旅客単位の受託手荷物オプション */
  selectedBaggageOption?: Maybe<SelectedBaggageOptionInfo>;
};

export type FlightPassengerInput = {
  flightPassengerId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: DpFlightBirthdayOrPassportExpiryInput;
  nationality: Scalars['String'];
  passport: FlightPassengerPassportInput;
  isRepresentative: Scalars['Boolean'];
  orderOfPassenger: Scalars['Int'];
};

export type FlightPassengerPassport = {
  __typename?: 'FlightPassengerPassport';
  passportNumber: Scalars['String'];
  passportExpiry: BirthdayOrPassportExpiry;
  passportIssuingCountry: Scalars['String'];
};

export type FlightPassengerPassportInput = {
  passportNumber: Scalars['String'];
  passportExpiry: DpFlightBirthdayOrPassportExpiryInput;
  passportIssuingCountry: Scalars['String'];
};

export type FlightReservationInfo = {
  __typename?: 'FlightReservationInfo';
  /** 代表者の名 */
  representativeFirstName: Scalars['String'];
  /** 代表者の姓 */
  representativeLastName: Scalars['String'];
  /** 代表者の電話番号 */
  representativePhoneNumber: Scalars['String'];
  /** 航空券のベンダー */
  gdsVendor: GdsVendors;
  /** 外部サービスの予約情報 */
  flightExternalReservationInfo?: Maybe<FlightExternalReservationInfo>;
};

export type FlightSchedule = {
  __typename?: 'FlightSchedule';
  /** 日程 ex. 2023-03-30 */
  goingDate: Scalars['String'];
  returningDate: Scalars['String'];
};

export type FlightSector = {
  __typename?: 'FlightSector';
  /** 乗り継ぎの順序 */
  flightIndex: Scalars['Int'];
  /** 航空会社の情報 */
  carrier: OrderCarrier;
  /** 航空機の便名 ex. 221 */
  flightNumber: Scalars['String'];
  /** 搭乗クラス ex. エコノミークラス */
  flightClass: Array<FlightClass>;
  /** 運賃クラスコード ex. W */
  fareClassCode: Scalars['String'];
  /** 出発日 ex. 4/16(木) */
  departureDate: Scalars['String'];
  /** 出発時間 ex. 15:00 */
  departureTime: Scalars['String'];
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーンオフセット ex. +09:00 */
  departureTimeZoneOffset: Scalars['String'];
  /** 出発する空港 */
  departureAirport: OrderAirportInfo;
  /** 到着日　ex. 4/20(木) */
  arrivalDate: Scalars['String'];
  /** 到着日時 ex. 18:00 */
  arrivalTime: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 到着日時のタイムゾーンオフセット ex. +09:00 */
  arrivalTimeZoneOffset: Scalars['String'];
  /** 到着する空港 */
  arrivalAirport: OrderAirportInfo;
  /** フライト時間 */
  flightTime: Scalars['String'];
  /** 乗り継ぎの空港待ち時間 */
  connectingTime?: Maybe<Scalars['String']>;
  /** コードシェア便 */
  codeShareAirlines: Array<Scalars['String']>;
  /** 異なる空港での乗り継ぎフラグ */
  isConnectingToAnotherAirport?: Maybe<Scalars['Boolean']>;
  codeShareCarrierIATACodes: Array<Scalars['String']>;
  /** トランジット情報 */
  flightTransits: Array<FlightTransit>;
};

export type FlightSectorInput = {
  /** 出発空港のIATAコード */
  departureAirportIATACode: Scalars['String'];
  /** 到着空港のIATAコード */
  arrivalAirportIATACode: Scalars['String'];
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 出発日時のタイムゾーンオフセット ex. +09:00 */
  departureTimeZoneOffset: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T15:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 到着日時のタイムゾーンオフセット ex. +09:00 */
  arrivalTimeZoneOffset: Scalars['String'];
  /** 航空機の便名 ex. 221 */
  flightNumber: Scalars['String'];
  /** IATAの航空会社コード */
  carrierIATACode: Scalars['String'];
};

export type FlightSummary = {
  __typename?: 'FlightSummary';
  /** 出発日 */
  departureDate: Scalars['String'];
  /** 出発時間 */
  departureTime: Scalars['String'];
  /** 到着日 */
  arrivalDate: Scalars['String'];
  /** 到着時間 */
  arrivalTime: Scalars['String'];
  /** 「出発時間 -> 到着時間」が日付をまたぐ場合の日数 */
  dayDiff: Scalars['Int'];
  /** 所要時間 */
  totalTime: Scalars['String'];
  /** 所要時間(分) */
  totalTimeInMinutes: Scalars['Int'];
  /** 出発から到着までの空港名 */
  connectionsAirportNames: Array<Scalars['String']>;
  /** 乗り継ぎ回数: 0の場合は直行便, 別空港(羽田)への移動はカウントしない */
  numberOfConnections: Scalars['Int'];
  /** validating carrier以外の航空会社の数 */
  numberOfConnectingCarriers?: Maybe<Scalars['Int']>;
  /** 料金差分（帰りのチケットのみ） */
  priceDiff?: Maybe<Scalars['Int']>;
  /** 航空会社のIATAコード */
  carrierIATA: Scalars['String'];
  /** 航空会社名 */
  carrierName: Scalars['String'];
  /** 座席クラス */
  flightClass: FlightClass;
  /** 合計料金 */
  totalAmount?: Maybe<Scalars['Int']>;
  /** 日またぎの航空券に関する補足事項 */
  arrivalNote?: Maybe<Scalars['String']>;
  /** 受託手荷物 */
  baggageAllowance?: Maybe<Scalars['String']>;
};

export type FlightTicketPriceInfo = {
  __typename?: 'FlightTicketPriceInfo';
  /** 元値の税サ抜きの大人の合計料金 */
  originalExclusivePriceOfAdults: Scalars['Int'];
  /** 元値の税サ抜きの小児の合計料金 */
  originalExclusivePriceOfChildren: Scalars['Int'];
  /** 元値の税サ抜きの乳幼児の合計料金 */
  originalExclusivePriceOfInfants: Scalars['Int'];
  /** 元値の税サ抜きの総額 */
  originalExclusivePrice: Scalars['Int'];
  /** 元値の税サ込の総額 */
  originalInclusivePrice: Scalars['Int'];
  /** 元値の大人の税サ料金 */
  originalTaxOfAdults: Scalars['Int'];
  /** 元値の小児の税サ料金 */
  originalTaxOfChildren: Scalars['Int'];
  /** 元値の乳幼児の税サ料金 */
  originalTaxOfInfants: Scalars['Int'];
  /** 元値の税サ料金の総額 */
  originalTax: Scalars['Int'];
  /** 通貨コード */
  currencyCode: Scalars['String'];
  /** こころからの取扱手数料も含めた金額 */
  inclusivePrice: Scalars['Int'];
  /** 1名あたりの料金 */
  inclusivePricePerPerson: Scalars['Int'];
};

export type FlightTicketStatus = {
  __typename?: 'FlightTicketStatus';
  /** 航空券の完売フラグ */
  status: FlightTicketStatusEnum;
  /** 完売の場合にリダイレクトするための情報 */
  redirectInfo?: Maybe<RedirectInfo>;
};

export enum FlightTicketStatusEnum {
  SoldOut = 'SOLD_OUT',
  PriceChanged = 'PRICE_CHANGED',
  Reservable = 'RESERVABLE'
}

export type FlightTicketStatusInput = {
  cartSnapshotId: Scalars['String'];
};

export type FlightTransit = {
  __typename?: 'FlightTransit';
  /** 到着日　ex. 4/20(木) */
  arrivalDate: Scalars['String'];
  /** 到着日時 ex. 18:00 */
  arrivalTime: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 出発日 ex. 4/16(木) */
  departureDate: Scalars['String'];
  /** 出発時間 ex. 15:00 */
  departureTime: Scalars['String'];
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** 空港のタイムゾーンオフセット ex. +09:00 */
  timeZoneOffset: Scalars['String'];
  /** 一時寄港する空港 */
  airport: OrderAirportInfo;
  /** フライト時間 */
  flightTime: Scalars['String'];
  /** 空港待ち時間 */
  connectingTime: Scalars['String'];
};

export type FlightTransitInput = {
  /** UTCの出発日時 ex. 2022-04-16T15:00:00Z */
  departureUtcDateTime: Scalars['String'];
  /** UTCの到着日時 ex. 2022-04-16T18:00:00Z */
  arrivalUtcDateTime: Scalars['String'];
  /** 空港のタイムゾーン ex. +09:00 */
  timeZoneOffset: Scalars['String'];
  /** 一時寄港する空港のIATAコード */
  airportIATACode: Scalars['String'];
};

export type Flights = Node & {
  __typename?: 'Flights';
  /** ID */
  id: Scalars['ID'];
  /** 航空券一覧 */
  flights: Array<Flight>;
};

export type FlightsForDpFlight = {
  __typename?: 'FlightsForDPFlight';
  /** 航空券一覧 */
  flights: Array<Flight>;
  /** INFINI空席照会をしたときのみ返される空席キー */
  routingId?: Maybe<Scalars['String']>;
  /** ポーリング必要有無 */
  isPollingRequired: Scalars['Boolean'];
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  inclusivePriceInfo: InclusivePriceInfo;
  /** 分析用ログのための情報 */
  logInfo?: Maybe<FlightsForDpFlightLogInfo>;
};

export type FlightsForDpFlightInput = {
  /** 出発の場所や空港のIATAコード ex. TYO */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード ex. TYO */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 航空券選択をするための検索条件 */
  flightsForDPFlightSearchInput?: Maybe<FlightsForDpFlightSearchInput>;
  /** Cartから作られたSnapshotのID */
  cartSnapshotId?: Maybe<Scalars['String']>;
  /** 座席クラス */
  flightClassCode: FlightClassCode;
  /** ポーリング用の空席キー */
  routingId?: Maybe<Scalars['String']>;
};

export type FlightsForDpFlightLogInfo = {
  __typename?: 'FlightsForDPFlightLogInfo';
  going: GoingAndReturningFlightsLogInfo;
  returning: GoingAndReturningFlightsLogInfo;
};

export type FlightsForDpFlightSearchInput = {
  /** 行きのフライトの出発日 ex. 2022-12-12 */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 ex. 2022-12-12 */
  returningDate: Scalars['String'];
  /** 搭乗者情報 */
  occupancy: OccupancyInput;
  /** 1名あたりの最安値の航空券の場合の往復の税サ込みの合計料金 */
  minimumInclusivePricePerPerson: Scalars['Int'];
};

export enum GdsVendors {
  Amadeus = 'AMADEUS',
  TravelFusion = 'TRAVEL_FUSION'
}

export type GetChildZonesInput = {
  /** 取得する子の親となるゾーンの種類 */
  parentZoneType: ZoneTypeEnum;
  /** 取得する子の親となるゾーンのID */
  parentZoneId: Scalars['Int'];
};

export type GoingAndReturningFlightsLogInfo = {
  __typename?: 'GoingAndReturningFlightsLogInfo';
  /** 航空券再選択前のフライトの航空会社のIATAコード */
  originalCarrierIATACode: Scalars['String'];
  /** 航空券再選択前のフライトの便名 ex. 221 */
  originalFlightNumber: Scalars['String'];
};

export type GoingFlightInfoInput = {
  /** 行きの航空券選択で選択された往復での料金 */
  selectedInclusivePricePerPerson: Scalars['Int'];
  /** 行きの航空券選択で選択された往路の区間情報 */
  flightSectors: Array<FlightSectorInput>;
};

export type GoingFlightsInput = {
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 行きのフライトの出発日 */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 */
  returningDate: Scalars['String'];
  /** 搭乗者情報 */
  occupancy: OccupancyInput;
  /** 座席クラス */
  flightClassCode: FlightClassCode;
};

export type GooglePlaceReview = {
  __typename?: 'GooglePlaceReview';
  authorName: Scalars['String'];
  authorUrl?: Maybe<Scalars['String']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  text: Scalars['String'];
  time: Scalars['String'];
};

export type GooglePlaceReviews = Node & {
  __typename?: 'GooglePlaceReviews';
  id: Scalars['ID'];
  googlePlaceId: Scalars['String'];
  reviews: Array<GooglePlaceReview>;
};

export type GqlZoneType = Node & {
  __typename?: 'GqlZoneType';
  /** ID */
  id: Scalars['ID'];
  /** ゾーンの種別 */
  zoneType: ZoneTypeEnum;
  /** ゾーンに属するホテルの件数 */
  zoneHotelCount?: Maybe<Scalars['Int']>;
  /** 地方ID */
  regionId?: Maybe<Scalars['Int']>;
  /** 地方のパス */
  regionPath?: Maybe<Scalars['String']>;
  /** 地方の名前 */
  regionName?: Maybe<Scalars['String']>;
  /** 都道府県ID */
  prefectureId?: Maybe<Scalars['Int']>;
  /** 都道府県のパス */
  prefecturePath?: Maybe<Scalars['String']>;
  /** 都道府県の名前 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 国ID */
  countryId?: Maybe<Scalars['Int']>;
  /** 国のコード */
  countryCode?: Maybe<Scalars['String']>;
  /** 国名 */
  countryName?: Maybe<Scalars['String']>;
  /** 地域ID */
  districtId?: Maybe<Scalars['Int']>;
  /** 地域のパス */
  districtPath?: Maybe<Scalars['String']>;
  /** 地域名 */
  districtName?: Maybe<Scalars['String']>;
  /** エリアID */
  areaId?: Maybe<Scalars['Int']>;
  /** エリアのパス */
  areaPath?: Maybe<Scalars['String']>;
  /** エリア名 */
  areaName?: Maybe<Scalars['String']>;
};

export type GroupedTravelDestination = {
  __typename?: 'GroupedTravelDestination';
  name: Scalars['String'];
  travelDestinations: Array<TravelDestination>;
};

export type Hotel = Node & ICocoolocalaHotel & IExpediaHotel & ICococlocalaHotelDetails & {
  __typename?: 'Hotel';
  /** ID(hotel:{cocolocalaHotelId}) */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 検索のときのこころからで算出しているソート順 */
  sort?: Maybe<Scalars['Int']>;
  /** ホテルの表示するステータス情報 */
  displayStatus: HotelDisplayStatusEnum;
  /** ホテルのデータ元の関連サービスのID */
  relationalServiceIds?: Maybe<RelationalServiceIds>;
  /** 位置情報 */
  location: HotelLocation;
  /** ホテルについてのコメント */
  comments: Array<Scalars['String']>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars['String']>;
  /** ホテルについての詳細情報 */
  description?: Maybe<Scalars['String']>;
  /** ホテルについてのリード文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** ホテルについての説明 */
  summaryDescription?: Maybe<Scalars['String']>;
  /** ホテルのWebサイトのURL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
  /** 料金キャッシュのタイプ */
  availabilityCalendarCacheType?: Maybe<HotelAvailabilityCalendarCacheEnum>;
  /** ホテルの最低料金 */
  minimumPrices: HotelMinimumPrices;
  /** ホテルの画像 */
  images: Array<HotelImage>;
  /** チェックインの情報 */
  checkin?: Maybe<Checkin>;
  /** チェックアウトの情報 */
  checkout?: Maybe<Checkout>;
  /** ホテルの説明 */
  hotelExplanation?: Maybe<HotelExplanation>;
  /** ホテルの部屋数など */
  statics: HotelStatistics;
  /** ペット情報 */
  pets: Array<Scalars['String']>;
  /** ホテルタイプ */
  hotelType?: Maybe<HotelType>;
  /** 施設のアメニティ情報 */
  hotelAmenities: HotelAmenities;
  /** 部屋情報 */
  rooms: Array<HotelRoom>;
  /** Covid19の情報 */
  covid19Tags?: Maybe<Covid19Tag>;
  /** Expediaでの宿泊者レビュー。こちらのデータはExpediaの規約的にGoogle BotなどのクローラーにキャッシュさせてはいけないのでBotからの取得を弾きCSRでのみ取得する（SSRをさせない） https://www.notion.so/hotspring-inc/Expedia-84236d99efcc4265a4700fbf9311abf2 */
  expediaGuestReviews?: Maybe<Array<ExpediaGuestReview>>;
  /** ホテルの注意事項 */
  hotelCautions: HotelCautions;
  /** GoogleのPlace情報でのレビュー */
  googlePlaceReviews?: Maybe<GooglePlaceReviews>;
  /** コンテンツ(リッチコンテンツ) */
  contents?: Maybe<Array<HotelContentItem>>;
  /** 人気のプラン */
  popularPlans?: Maybe<Array<PlanSummaryForHotel>>;
  /** おすすめプラン */
  recommendedPlans?: Maybe<Array<PlanSummaryForHotel>>;
  /** 周辺スポット(レストランを除く) */
  aroundSpots?: Maybe<Array<SpotSummaryForHotel>>;
  /** 周辺レストラン */
  aroundRestaurants?: Maybe<Array<SpotSummaryForHotel>>;
  /** 周辺のホテル */
  aroundHotels?: Maybe<Array<HotelSummaryForHotel>>;
};

export type HotelAmenities = {
  __typename?: 'HotelAmenities';
  /** WiFiの対応 */
  wifiCondition?: Maybe<HotelWifiCondition>;
  /** WiFiの対応 */
  japaneseCondition?: Maybe<HotelJapaneseCondition>;
  /** アメニティの情報 */
  amenities: Array<Amenity>;
};

/** ホテルの料金カレンダーのキャッシュタイプ */
export enum HotelAvailabilityCalendarCacheEnum {
  Short = 'Short',
  Long = 'Long'
}

export type HotelCautions = {
  __typename?: 'HotelCautions';
  /** チェックイン時の情報 */
  checkInInstruction?: Maybe<Scalars['String']>;
  /** チェックイン時の特別な情報 */
  checkInSpecialInstruction?: Maybe<Scalars['String']>;
  /** その他の情報 */
  knowBeforeYouGo?: Maybe<Scalars['String']>;
  /** オプションの追加料金 */
  optionalFees?: Maybe<Scalars['String']>;
};

export type HotelCheckInCheckOutInfo = {
  __typename?: 'HotelCheckInCheckOutInfo';
  /** チェックインの日付. ex. '2023-04-02' */
  checkInDate: Scalars['String'];
  /** チェックインの日付. ex. '2020年4月2日(金)' */
  checkInDateText: Scalars['String'];
  /** チェックイン可能な時間. ex '15:00 〜 22:00' */
  availableCheckInTimeRange: Scalars['String'];
  /** チェックアウトの日付. ex. '2023-04-03' */
  checkOutDate: Scalars['String'];
  /** チェックアウトの日付. ex. '2020年4月2日(金)' */
  checkOutDateText: Scalars['String'];
  /** チェックアウト時間. ex '11:00' */
  checkOutTime: Scalars['String'];
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
};

export type HotelContentItem = {
  __typename?: 'HotelContentItem';
  title: Scalars['String'];
  description: Scalars['String'];
  images: Array<HotelContentItemImage>;
};

export type HotelContentItemImage = {
  __typename?: 'HotelContentItemImage';
  url: Scalars['String'];
  creditText?: Maybe<Scalars['String']>;
  creditLinkUrl?: Maybe<Scalars['String']>;
};

export type HotelData = {
  __typename?: 'HotelData';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** レーティング Int or Float */
  rating?: Maybe<Scalars['String']>;
  areaName: Scalars['String'];
  prefectureName: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  inclusivePrice?: Maybe<Scalars['Int']>;
  exclusivePrice?: Maybe<Scalars['Int']>;
  strikeThroughPrice?: Maybe<Scalars['Int']>;
  numberOfAdults?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
};

/** ホテルの特定の日付の料金 */
export type HotelDayMinimumPrice = {
  __typename?: 'HotelDayMinimumPrice';
  date: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
};

export type HotelDetailInfoForDpFlight = {
  __typename?: 'HotelDetailInfoForDPFlight';
  /** ホテルについてのリード文 */
  summaryDescription?: Maybe<Scalars['String']>;
  /** ホテルについての詳細情報 */
  description?: Maybe<Scalars['String']>;
  /** チェックインの情報 */
  checkin?: Maybe<Checkin>;
  /** チェックアウトの情報 */
  checkout?: Maybe<Checkout>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars['String']>;
  /** 施設のアメニティ情報 */
  hotelAmenities: HotelAmenities;
  /** 位置情報 */
  location: HotelLocation;
  /** ホテルの説明 */
  hotelExplanation?: Maybe<HotelExplanation>;
  /** ホテルの注意事項 */
  hotelCautions: HotelCautions;
  /** ホテルの部屋数など */
  statics: HotelStatistics;
  /** ホテルのWebサイトのURL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** ホテルタイプ */
  hotelType?: Maybe<HotelType>;
};

export enum HotelDisplayStatusEnum {
  Active = 'Active',
  TemporaryRedirect = 'TemporaryRedirect',
  PermanentlyRedirect = 'PermanentlyRedirect'
}

export type HotelExplanation = {
  __typename?: 'HotelExplanation';
  /** 設備／サービス */
  amenities?: Maybe<Scalars['String']>;
  /** 食事 */
  dining?: Maybe<Scalars['String']>;
  /** アクセス */
  access?: Maybe<Scalars['String']>;
};

export type HotelForOrderConfirm = Node & {
  __typename?: 'HotelForOrderConfirm';
  /** ID(hotel:{cocolocalaHotelId}) */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  hotelName: Scalars['String'];
  /** ホテルについてのリード文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** こころからでのレーティング */
  rating: Scalars['String'];
  /** ホテルのロケーション ex ハワイ > ホノルル */
  hotelLocation: Scalars['String'];
  /** ホテルのデータ元の関連サービスのID */
  relationalServiceIds?: Maybe<RelationalServiceIds>;
  /** ホテルの画像 */
  imageUrls: Array<Scalars['String']>;
  /** 施設詳細情報 */
  hotelDetailInfo: HotelDetailInfoForDpFlight;
  /** GoogleのPlace情報でのレビュー */
  googlePlaceReviews?: Maybe<GooglePlaceReviews>;
  /** コンテンツ(リッチコンテンツ) */
  contents?: Maybe<Array<HotelContentItem>>;
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  inclusivePriceInfo: InclusivePriceInfo;
};

export type HotelForOrderConfirmInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['String'];
};

export type HotelImage = {
  __typename?: 'HotelImage';
  /** 画像のURL */
  url: Scalars['String'];
  /** ヒーロー画像かどうか */
  heroImage: Scalars['Boolean'];
  /** キャプション */
  caption?: Maybe<Scalars['String']>;
};

export type HotelInput = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['String'];
  /** サムネイルの条件 */
  thumbnailCondition?: Maybe<HotelThumbnailsConditionInput>;
  /** 販売チャネル */
  channel?: Maybe<Channel>;
};

export enum HotelJapaneseCondition {
  NoJapanese = 'NoJapanese',
  Japanese = 'Japanese',
  Undecided = 'Undecided'
}

export type HotelListItemData = Node & {
  __typename?: 'HotelListItemData';
  /** ホテルID */
  id: Scalars['ID'];
  /** ホテル名 */
  name: Scalars['String'];
  /** レーティング（5点満点） */
  rating?: Maybe<Scalars['Float']>;
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリア名 */
  areaName: Scalars['String'];
  /** 地域ID */
  districtId: Scalars['Int'];
  /** 都道府県ID */
  prefectureId: Scalars['Int'];
  /** 都道府県名 */
  prefectureName: Scalars['String'];
  /** 地区ID */
  regionId: Scalars['Int'];
  /** ホテルのデータの元になっている関連するサービスのID */
  relationalServiceIds?: Maybe<RelationalServiceIds>;
  /** 距離 */
  distance?: Maybe<Scalars['String']>;
  /** ホテルの画像のURL一覧 */
  imageUrls: Array<Scalars['String']>;
  /** 部屋の価格と条件 */
  rates: Array<Rate>;
  /** 最低価格を持つRate */
  minimumRate?: Maybe<Rate>;
  /** 1人のときの最低価格のキャッシュ */
  minimumPricingPerOne?: Maybe<MinimumPricing>;
  /** 2人のときの最低価格のキャッシュ */
  minimumPricingPerTwo?: Maybe<MinimumPricing>;
  /** ホテルの持つ部屋の条件が含まれる（ホテル一覧ページのときのみ値がある） */
  conditions?: Maybe<Conditions>;
};

/** ホテルの位置情報 */
export type HotelLocation = ICocolocalaZone & {
  __typename?: 'HotelLocation';
  /** 郵便番号 */
  zipCode?: Maybe<Scalars['String']>;
  /** 住所 */
  address?: Maybe<Scalars['String']>;
  /** 詳細 */
  description?: Maybe<Scalars['String']>;
  /** 緯度 */
  latitude?: Maybe<Scalars['String']>;
  /** 経度 */
  longitude?: Maybe<Scalars['String']>;
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリアのパス */
  areaPath: Scalars['String'];
  /** エリアの表示名 */
  areaName: Scalars['String'];
  /** 地域のID */
  districtId: Scalars['Int'];
  /** 地域のパス */
  districtPath: Scalars['String'];
  /** 地域の表示名 */
  districtName: Scalars['String'];
  /** 都道府県のID */
  prefectureId: Scalars['Int'];
  /** 都道府県のパス */
  prefecturePath: Scalars['String'];
  /** 都道府県の表示名 */
  prefectureName: Scalars['String'];
  /** 地方のID */
  regionId: Scalars['Int'];
  /** 地方のパス */
  regionPath: Scalars['String'];
  /** 地方の表示名 */
  regionName: Scalars['String'];
  /** 最寄駅のID */
  stationId?: Maybe<Scalars['Int']>;
  /** 最寄駅のパス */
  stationPath?: Maybe<Scalars['String']>;
  /** 最寄駅の表示名 */
  stationName?: Maybe<Scalars['String']>;
  /** 最寄駅のニックネーム */
  stationNickname?: Maybe<Scalars['String']>;
  /** 国のコード（2文字のJP等） */
  countryCode: Scalars['String'];
  /** 国の表示名 */
  countryName: Scalars['String'];
  /** 国の中にエリアが１つのみの場合 true */
  isOnlyOneAreaInCountry?: Maybe<Scalars['Boolean']>;
  /** 地方の中にエリアが１つのみの場合 true */
  isOnlyOneAreaInRegion?: Maybe<Scalars['Boolean']>;
};

export type HotelMinimumPrice = {
  __typename?: 'HotelMinimumPrice';
  /** 割引後の料金 */
  inclusive: Scalars['Int'];
  /** 割引前の料金 */
  strikeThrough?: Maybe<Scalars['Int']>;
};

export type HotelMinimumPriceCalendar = Node & {
  __typename?: 'HotelMinimumPriceCalendar';
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['String'];
  /** ExpediaのホテルID */
  expediaHotelId?: Maybe<Scalars['String']>;
  /** 料金キャッシュのタイプ */
  cache?: Maybe<HotelAvailabilityCalendarCacheEnum>;
  /** 人数ごとの料金カレンダー情報 */
  minimumPriceCalendarByNumberOfPeople: HotelMinimumPriceCalendarByNumberOfPeople;
  /** 料金カレンダーで最も安い日の料金 */
  lowestMinimumPrices: HotelMinimumPrices;
};

/** 人数ごとの料金カレンダー情報 */
export type HotelMinimumPriceCalendarByNumberOfPeople = Node & {
  __typename?: 'HotelMinimumPriceCalendarByNumberOfPeople';
  id: Scalars['ID'];
  perOne: Array<HotelDayMinimumPrice>;
  perTwo: Array<HotelDayMinimumPrice>;
};

export type HotelMinimumPriceCalendarInput = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['String'];
  /** 販売チャネル */
  channel?: Maybe<Channel>;
};

/** ホテルの料金の1人のときと2人のときの料金のキャッシュ */
export type HotelMinimumPrices = Node & {
  __typename?: 'HotelMinimumPrices';
  id: Scalars['ID'];
  /** 1人の時 */
  perOne?: Maybe<HotelMinimumPrice>;
  /** 2人の時 */
  perTwo?: Maybe<HotelMinimumPrice>;
};

export enum HotelPriceRange {
  Undecided = 'UNDECIDED',
  To_4000 = 'TO_4000',
  From_4001To_7000 = 'FROM_4001_TO_7000',
  LessThan_8000 = 'LESS_THAN_8000',
  From_7001To_10000 = 'FROM_7001_TO_10000',
  LessThan_12000 = 'LESS_THAN_12000',
  From_10001To_15000 = 'FROM_10001_TO_15000',
  From_15001 = 'FROM_15001'
}

export enum HotelProvider {
  Expedia = 'EXPEDIA',
  Rakuten = 'RAKUTEN',
  Dida = 'DIDA'
}

export type HotelRangeFilter = {
  /** 下限 */
  begin?: Maybe<Scalars['Float']>;
  /** 上限 */
  end?: Maybe<Scalars['Float']>;
};

export enum HotelRankFilter {
  Undecided = 'UNDECIDED',
  One = 'ONE',
  Two = 'TWO',
  Three = 'THREE',
  Four = 'FOUR',
  Five = 'FIVE'
}

export type HotelReservationInfo = {
  __typename?: 'HotelReservationInfo';
  /** 無料キャンセル終了時間 */
  expediaFreeCancelEndTime?: Maybe<Scalars['Int']>;
  /** 人数 */
  numberOfPeople: Scalars['Int'];
  /** 大人の人数 */
  numberOfAdults: Scalars['Int'];
  /** 子供の年齢 */
  childAges: Array<Scalars['Int']>;
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
  /** 喫煙可能か */
  smoking: Scalars['Boolean'];
  /** Expediaの予約に必要なURL */
  bookingUrl?: Maybe<Scalars['String']>;
  /** Didaの予約に必要な番号 */
  referenceNo?: Maybe<Scalars['String']>;
  /** こころからのStayのID */
  stayId: Scalars['Int'];
  /** ExpeidaのホテルのID */
  externalHotelId: Scalars['String'];
  /** ExpediaホテルのルームID */
  roomId: Scalars['String'];
  /** ExpediaホテルのルームのレートID */
  rateId: Scalars['String'];
  /** ExpediaホテルのルームのレートのベッドグループID */
  bedGroupId: Scalars['String'];
  /** salesChannel */
  salesChannel: Scalars['String'];
  /** rateOptionで会員割引とするか */
  rateOptionMember: Scalars['Boolean'];
  /** 残りの部屋数 */
  numberOfRoomsRemaining?: Maybe<Scalars['Int']>;
  /** 特記事項 */
  importantNotices: Array<Scalars['String']>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
};

export type HotelReservationInput = {
  /** 無料キャンセル終了時間 */
  expediaFreeCancelEndTime?: Maybe<Scalars['Int']>;
  /** 喫煙可能か */
  smoking: Scalars['Boolean'];
  /** Expediaの予約に必要なURL */
  bookingUrl?: Maybe<Scalars['String']>;
  /** Didaの予約に必要な番号 */
  referenceNo?: Maybe<Scalars['String']>;
  /** こころからのStayのID */
  stayId: Scalars['Int'];
  /** ExpeidaのホテルのID TODO: expediaHotelIdという命名に変えたいHOT-4859対応 */
  externalHotelId: Scalars['String'];
  /** ExpediaホテルのルームID */
  roomId: Scalars['String'];
  /** ExpediaホテルのルームのレートID */
  rateId: Scalars['String'];
  /** ExpediaホテルのルームのレートのベッドグループID */
  bedGroupId: Scalars['String'];
  /** salesChannel */
  salesChannel: Scalars['String'];
  /** rateOptionで会員割引とするか */
  rateOptionMember: Scalars['Boolean'];
  /** 大人の人数 */
  numberOfAdults: Scalars['Int'];
  /** 子供の年齢 */
  childAges: Array<Scalars['Int']>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
};

export type HotelReviews = Node & {
  __typename?: 'HotelReviews';
  id: Scalars['ID'];
  pagination: Pagination;
  reviewItems: Array<ReviewItemWithReviewUser>;
};

export type HotelReviewsInput = {
  pagination: PaginationInput;
};

export type HotelRoom = Node & {
  __typename?: 'HotelRoom';
  id: Scalars['ID'];
  /** ID(Expediaでの部屋のID) */
  roomId: Scalars['String'];
  /** 部屋名 */
  roomName: Scalars['String'];
  /** 部屋の概要 */
  overview: Scalars['String'];
  /** 喫煙情報 */
  smokingCondition: SmokingCondition;
  /** 部屋の画像 */
  images: Array<HotelImage>;
  /** 部屋からの眺め */
  view?: Maybe<Scalars['String']>;
  /** ベッドの種類 */
  bedGroups: Array<RoomBedGroup>;
  /** 部屋の定員 */
  maxAllowedOccupancy?: Maybe<RoomMaxAllowedOccupancy>;
  /** アメニティ情報 */
  amenities: Array<Amenity>;
  /** 部屋のRate情報（空室検索したとき） */
  rates?: Maybe<Array<HotelRoomRate>>;
};

export type HotelRoomFacility = {
  __typename?: 'HotelRoomFacility';
  /** 設備タイプ */
  type: HotelRoomFacilityType;
  /** 表示ラベル */
  label: Scalars['String'];
};

export enum HotelRoomFacilityType {
  /** ベッド */
  Bed = 'BED',
  /** 人数 */
  Peoples = 'PEOPLES',
  /** 長め */
  View = 'VIEW',
  /** WiFi */
  Wifi = 'WIFI',
  /** 禁煙 */
  NoSmoking = 'NO_SMOKING',
  /** 日本語 */
  Japanese = 'JAPANESE',
  /** 食事 */
  Meal = 'MEAL'
}

export type HotelRoomForDpFlight = Node & {
  __typename?: 'HotelRoomForDPFlight';
  id: Scalars['ID'];
  /** ID(Expediaでの部屋のID) */
  roomId: Scalars['String'];
  /** 部屋名 */
  roomName: Scalars['String'];
  /** 部屋の概要 */
  overview: Scalars['String'];
  /** 喫煙情報 */
  smokingCondition: SmokingCondition;
  /** 部屋の画像 */
  images: Array<HotelImage>;
  /** 部屋からの眺め */
  view?: Maybe<Scalars['String']>;
  /** ベッドの種類 */
  bedGroups: Array<RoomBedGroup>;
  /** 部屋の定員 */
  maxAllowedOccupancy?: Maybe<RoomMaxAllowedOccupancy>;
  /** Wifi無料かどうか */
  hasWifi: Scalars['Boolean'];
  /** 部屋のRate情報（空室検索したとき） */
  rates: Array<HotelRoomRateForDpFlight>;
  /** 空き部屋数 */
  availableRooms?: Maybe<Scalars['Int']>;
  /** 部屋の一人当たりの最安料金 */
  minimumRoomRatePriceDiffPerPerson?: Maybe<Scalars['Int']>;
};

export type HotelRoomInfo = {
  __typename?: 'HotelRoomInfo';
  /** 部屋名 */
  roomName: Scalars['String'];
  /** ルームのサムネイル画像 */
  roomThumbnailUrl?: Maybe<Scalars['String']>;
  /** 部屋の設備 */
  facilities: Array<HotelRoomFacility>;
};

export type HotelRoomRate = Node & {
  __typename?: 'HotelRoomRate';
  id: Scalars['ID'];
  /** ExpediaのRateのID */
  rateId: Scalars['String'];
  /** 空き部屋数 */
  availableRooms: Scalars['Int'];
  /** 返金可能化 */
  refundable: Scalars['Boolean'];
  /** 会員限定割引か */
  fencedDeal: Scalars['Boolean'];
  /** 会員限定割引が存在するか */
  fencedDealAvailable: Scalars['Boolean'];
  /** プロモーション情報 */
  promotions?: Maybe<HotelRoomRatePromotions>;
  /** こころからの取扱手数料込の料金情報 */
  occupancyPricing: HotelRoomRatePricing;
  /** キャンセル条件 */
  cancelPenalties?: Maybe<Array<HotelRoomRateCancelPenalties>>;
  /** ベッドグループ情報 */
  bedGroups: Array<RoomBedGroup>;
  /** アメニティ情報 */
  amenities: Array<Amenity>;
  /** 食事情報 */
  meal: Scalars['String'];
};

export type HotelRoomRateCancelPenalties = {
  __typename?: 'HotelRoomRateCancelPenalties';
  /** 通貨 */
  currency: Scalars['String'];
  /** キャンセルペナルティの期限（開始） */
  start?: Maybe<Scalars['String']>;
  /** キャンセルペナルティの期限（終了） */
  end?: Maybe<Scalars['String']>;
  /** ○円のキャンセルペナルティがかかるとき */
  amount?: Maybe<Scalars['String']>;
  /** ○泊のキャンセルペナルティがかかるとき */
  nights?: Maybe<Scalars['String']>;
  /** 料金の○%のキャンセルペナルティがかかるとき */
  percent?: Maybe<Scalars['String']>;
};

export type HotelRoomRateForDpFlight = Node & {
  __typename?: 'HotelRoomRateForDPFlight';
  id: Scalars['ID'];
  /** ExpediaのRateのID */
  rateId: Scalars['String'];
  /** 返金可能か */
  refundable: Scalars['Boolean'];
  /** 会員限定割引か */
  fencedDeal: Scalars['Boolean'];
  /** 会員限定割引が存在するか */
  fencedDealAvailable: Scalars['Boolean'];
  /** プロモーション情報 */
  promotions?: Maybe<HotelRoomRatePromotions>;
  /** こころからの取扱手数料込の料金情報 */
  occupancyPricing: HotelRoomRatePricingForDpFlight;
  /** キャンセル条件 */
  cancelPenalties: Array<HotelRoomRateCancelPenalties>;
  /** ベッドグループ情報 */
  bedGroups: Array<RoomBedGroup>;
  /** Wifi無料かどうか */
  hasWifi: Scalars['Boolean'];
  /** 食事情報 */
  mealLabel: Scalars['String'];
};

export type HotelRoomRatePricing = {
  __typename?: 'HotelRoomRatePricing';
  /** 割引前料金 */
  strikethroughPrice?: Maybe<Scalars['Int']>;
  /** 税・サービス料込料金 */
  inclusivePrice?: Maybe<Scalars['Int']>;
  /** 税・サービス料なし料金 */
  exclusivePrice: Scalars['Int'];
  /** 割引率 */
  discountRate?: Maybe<Scalars['Float']>;
  /** こころからの取扱手数料 */
  cocolocalaTransactionFee: Scalars['Int'];
  cocolocalaTransactionFeeTax: Scalars['Int'];
};

export type HotelRoomRatePricingForDpFlight = {
  __typename?: 'HotelRoomRatePricingForDPFlight';
  /** ホテルの金額 Dida用 */
  hotelInclusiveStrikethrough: Scalars['Int'];
  /** 仕入れ価格の税・サービス料抜き */
  hotelExclusivePrice: Scalars['Int'];
  /** 割引前の仕入れ価格 */
  hotelExclusiveStrikethroughPrice?: Maybe<Scalars['Int']>;
  /** 仕入れ価格の税・サービス料 */
  hotelTaxAndServiceCharge: Scalars['Int'];
  /** 一人あたりの最安値料金との差額 */
  ratePriceDiffPerPerson: Scalars['Int'];
  /** ホテルの金額 + 最安値の航空券の場合の往復の税サ込みの合計料金 */
  totalPrice: Scalars['Int'];
  /** 1名あたりホテルの金額 + の最安値の航空券の場合の往復の税サ込みの合計料金 */
  totalPricePerPerson: Scalars['Int'];
};

export type HotelRoomRatePromotions = {
  __typename?: 'HotelRoomRatePromotions';
  /** dealのID */
  dealId?: Maybe<Scalars['String']>;
  /** dealの説明 */
  dealDescription?: Maybe<Scalars['String']>;
  /** 特典情報 */
  valueAdds: Array<Scalars['String']>;
};

export enum HotelSortType {
  Popular = 'POPULAR',
  Low = 'LOW',
  DiscountRate = 'DISCOUNT_RATE'
}

export type HotelStatistics = {
  __typename?: 'HotelStatistics';
  /** 部屋数 */
  roomsCount?: Maybe<Scalars['Int']>;
};

export type HotelSummary = Node & IHotelSummary & {
  __typename?: 'HotelSummary';
  /** ID */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ExpediaのホテルID */
  expediaHotelId: Scalars['String'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 位置情報 */
  zoneInfo: HotelSummaryZoneInfo;
  /** 最低料金情報 */
  minimumPrices: HotelSummaryMinimumPrices;
  /** ホテルの画像 */
  images: Array<HotelImage>;
};

export type HotelSummaryForHotel = Node & {
  __typename?: 'HotelSummaryForHotel';
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 現在の地域との距離 */
  distance?: Maybe<Scalars['String']>;
  /** エリアの表示名 */
  areaName?: Maybe<Scalars['String']>;
  /** 都道府県の表示名 */
  prefectureName?: Maybe<Scalars['String']>;
  /** ホテルの最低料金 */
  minimumPrices: HotelMinimumPrices;
  /** サムネイル画像 */
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type HotelSummaryMinimumPriceInfo = {
  __typename?: 'HotelSummaryMinimumPriceInfo';
  /** こころからの取扱手数料が含まれた合計料金 */
  inclusivePrice: Scalars['Int'];
  /** セールなどでの割引があるときの割引前の料金 */
  strikeThroughPrice?: Maybe<Scalars['Int']>;
  /** セールなどの割引があるときのラベル */
  discountLabel?: Maybe<Scalars['String']>;
};

/** 人数ごとの1泊の料金情報 */
export type HotelSummaryMinimumPrices = {
  __typename?: 'HotelSummaryMinimumPrices';
  /** 1人1泊のときの料金 */
  one?: Maybe<HotelSummaryMinimumPriceInfo>;
  /** 2人1泊のときの料金 */
  two?: Maybe<HotelSummaryMinimumPriceInfo>;
};

/** ホテルの位置情報 */
export type HotelSummaryZoneInfo = ICocolocalaZone & {
  __typename?: 'HotelSummaryZoneInfo';
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリアのパス */
  areaPath: Scalars['String'];
  /** エリアの表示名 */
  areaName: Scalars['String'];
  /** 地域のID */
  districtId: Scalars['Int'];
  /** 地域のパス */
  districtPath: Scalars['String'];
  /** 地域の表示名 */
  districtName: Scalars['String'];
  /** 都道府県のID */
  prefectureId: Scalars['Int'];
  /** 都道府県のパス */
  prefecturePath: Scalars['String'];
  /** 都道府県の表示名 */
  prefectureName: Scalars['String'];
  /** 地方のID */
  regionId: Scalars['Int'];
  /** 地方のパス */
  regionPath: Scalars['String'];
  /** 地方の表示名 */
  regionName: Scalars['String'];
  /** 国のコード（2文字のJP等） */
  countryCode: Scalars['String'];
  /** 国の表示名 */
  countryName: Scalars['String'];
};

export type HotelTab = {
  __typename?: 'HotelTab';
  label: Scalars['String'];
  hotelIds: Array<Scalars['Int']>;
};

export type HotelTabsForOrderConfirm = {
  __typename?: 'HotelTabsForOrderConfirm';
  /** ホテルのタブ情報 */
  hotelTabs: Array<HotelTab>;
};

export type HotelTabsForOrderConfirmInput = {
  cartSnapshotId: Scalars['String'];
};

export type HotelThumbnailsConditionInput = {
  /** 指定位置の枚数から取得を行いたいとき */
  offset?: Maybe<Scalars['Int']>;
  /** 上限枚数を指定（指定がないときすべての枚数） */
  limit?: Maybe<Scalars['Int']>;
};

export type HotelTopicsMoreLink = {
  __typename?: 'HotelTopicsMoreLink';
  title: Scalars['String'];
  url: Scalars['String'];
};

export type HotelType = {
  __typename?: 'HotelType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum HotelTypeFilter {
  Property = 'PROPERTY',
  Hotel = 'HOTEL',
  Motel = 'MOTEL',
  Resort = 'RESORT',
  Inn = 'INN',
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  Guesthouse = 'GUESTHOUSE',
  Condo = 'CONDO',
  AllInclusiveProperty = 'ALL_INCLUSIVE_PROPERTY',
  Cabin = 'CABIN',
  Chalet = 'CHALET',
  Cottage = 'COTTAGE',
  HostelBackpackerAccommodation = 'HOSTEL_BACKPACKER_ACCOMMODATION',
  Ranch = 'RANCH',
  Villa = 'VILLA',
  Lodge = 'LODGE',
  Apartment = 'APARTMENT',
  PrivateVacationHome = 'PRIVATE_VACATION_HOME',
  Houseboat = 'HOUSEBOAT',
  Ryokan = 'RYOKAN',
  TreeHouseProperty = 'TREE_HOUSE_PROPERTY',
  Aparthotel = 'APARTHOTEL',
  CondominiumResort = 'CONDOMINIUM_RESORT',
  Campsite = 'CAMPSITE',
  Riad = 'RIAD',
  Hostal = 'HOSTAL',
  CountryHouse = 'COUNTRY_HOUSE',
  Pension = 'PENSION',
  PousadaPortugal = 'POUSADA_PORTUGAL',
  PousadaBrazil = 'POUSADA_BRAZIL',
  Residence = 'RESIDENCE',
  Townhouse = 'TOWNHOUSE',
  Castle = 'CASTLE',
  SafariTentalow = 'SAFARI_TENTALOW',
  Palace = 'PALACE',
  AgritourismProperty = 'AGRITOURISM_PROPERTY',
  Cruise = 'CRUISE',
  HolidayPark = 'HOLIDAY_PARK'
}

export enum HotelWifiCondition {
  NoWifi = 'NoWifi',
  HasWifi = 'HasWifi',
  Undecided = 'Undecided'
}

export type Hotels = IPaginationResult & {
  __typename?: 'Hotels';
  /** 空室のホテルの一覧 */
  hotels: Array<HotelSummary>;
  /** ページネーション結果 */
  pagination: PaginationWithPageInfo;
};

export type HotelsFiltersInput = {
  cocolocalaHotelIds: Array<Scalars['String']>;
  /** ホテルのランクのフィルター */
  rankFilters: Array<HotelRankFilter>;
  /** 口コミの範囲 (0.0~5.0) */
  ratingGuestAverageFilter?: Maybe<HotelRangeFilter>;
  /** 価格帯の絞り込み */
  priceRangeFilters: Array<HotelPriceRange>;
  /** 割引率 (0.0~1.0) */
  discountRateRangeFilter?: Maybe<HotelRangeFilter>;
  /** セール料金の範囲 */
  discountInclusiveRangeFilter?: Maybe<HotelRangeFilter>;
  /** セール料金があるか */
  hasDiscount?: Maybe<Scalars['Boolean']>;
  /** ホテルのタイプ指定 */
  hotelTypeFilters: Array<HotelTypeFilter>;
};

export type HotelsForDpFlightThemes = {
  __typename?: 'HotelsForDPFlightThemes';
  /** スタッフのコメント */
  staffComment: Scalars['String'];
  /** ホテルの一覧 */
  hotels: Array<TravelThemeHotelSummary>;
  /** 人数分の海外航空券の最低料金(税・サービス料抜き) */
  minimumFlightPrice: Scalars['Int'];
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
};

export type HotelsForDpFlightThemesInput = {
  /** テーマID */
  themeId: Scalars['String'];
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** チェックインの日付 (YYYY-MM-DD) */
  checkInDate: Scalars['String'];
  /** チェックアウトの日付 (YYYY-MM-DD) */
  checkOutDate: Scalars['String'];
  /** 行きのフライトの出発日 ex. 2022-12-12 */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 ex. 2022-12-12 */
  returningDate: Scalars['String'];
  /** 宿泊人数 */
  occupancies: Array<OccupancyInput>;
};

export type HotelsInput = {
  zone?: Maybe<HotelsZoneInput>;
  /** ページネーション指定 */
  pagination: PaginationInput;
  sortType?: Maybe<HotelSortType>;
  filters?: Maybe<HotelsFiltersInput>;
};

export type HotelsZoneInput = {
  /** こころからのdistrictId.指定されたdistrictに属するホテルの人気順の最初のホテルの周辺を検索する */
  regionName?: Maybe<Scalars['String']>;
  /** こころからのregionName.指定されたregionに属するホテルの人気順の最初のホテルの周辺を検索する */
  prefectureName?: Maybe<Scalars['String']>;
  /** こころからのprefectureName.指定されたprefectureに属するホテルの人気順の最初のホテルの周辺を検索する */
  districtId?: Maybe<Scalars['String']>;
  /** こころからのareaId.指定されたareaに属するホテルの人気順の最初のホテルの周辺を検索する */
  areaId?: Maybe<Scalars['String']>;
};

export type ICococlocalaHotelDetails = {
  /** GoogleのPlace情報でのレビュー */
  googlePlaceReviews?: Maybe<GooglePlaceReviews>;
  /** コンテンツ(リッチコンテンツ) */
  contents?: Maybe<Array<HotelContentItem>>;
  /** 人気のプラン */
  popularPlans?: Maybe<Array<PlanSummaryForHotel>>;
  /** おすすめプラン */
  recommendedPlans?: Maybe<Array<PlanSummaryForHotel>>;
  /** 周辺スポット(レストランを除く) */
  aroundSpots?: Maybe<Array<SpotSummaryForHotel>>;
  /** 周辺レストラン */
  aroundRestaurants?: Maybe<Array<SpotSummaryForHotel>>;
  /** 周辺のホテル */
  aroundHotels?: Maybe<Array<HotelSummaryForHotel>>;
};

export type ICocolocalaZone = {
  /** エリアのID */
  areaId?: Maybe<Scalars['Int']>;
  /** エリアのパス */
  areaPath?: Maybe<Scalars['String']>;
  /** エリアの表示名 */
  areaName?: Maybe<Scalars['String']>;
  /** 地域のID */
  districtId?: Maybe<Scalars['Int']>;
  /** 地域のパス */
  districtPath?: Maybe<Scalars['String']>;
  /** 地域の表示名 */
  districtName?: Maybe<Scalars['String']>;
  /** 都道府県のID */
  prefectureId?: Maybe<Scalars['Int']>;
  /** 都道府県のパス */
  prefecturePath?: Maybe<Scalars['String']>;
  /** 都道府県の表示名 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 地方のID */
  regionId?: Maybe<Scalars['Int']>;
  /** 地方のパス */
  regionPath?: Maybe<Scalars['String']>;
  /** 地方の表示名 */
  regionName?: Maybe<Scalars['String']>;
  /** 国のコード（2文字のJP等） */
  countryCode?: Maybe<Scalars['String']>;
  /** 国の表示名 */
  countryName?: Maybe<Scalars['String']>;
};

export type ICocoolocalaHotel = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 検索のときのこころからで算出しているソート順 */
  sort?: Maybe<Scalars['Int']>;
  /** ホテルの表示するステータス情報 */
  displayStatus: HotelDisplayStatusEnum;
  /** ホテルのデータ元の関連サービスのID */
  relationalServiceIds?: Maybe<RelationalServiceIds>;
  /** 位置情報 */
  location: HotelLocation;
  /** ホテルについてのコメント */
  comments: Array<Scalars['String']>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars['String']>;
  /** ホテルについての詳細情報 */
  description?: Maybe<Scalars['String']>;
  /** ホテルについてのリード文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** ホテルについての説明 */
  summaryDescription?: Maybe<Scalars['String']>;
  /** ホテルのWebサイトのURL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
  /** 料金キャッシュのタイプ */
  availabilityCalendarCacheType?: Maybe<HotelAvailabilityCalendarCacheEnum>;
  /** ホテルの最低料金 */
  minimumPrices: HotelMinimumPrices;
};

export type IdpCar = {
  /** 車名 */
  name?: Maybe<Scalars['String']>;
  /** 車の画像URL */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** 車のオプション情報 */
  options: Array<DpCarOption>;
};

export type IdpCarPriceInfo = {
  /** 総額 */
  price?: Maybe<Scalars['Int']>;
  /** 予約手数料 */
  transactionFee?: Maybe<Scalars['Int']>;
  /** 税 */
  tax?: Maybe<Scalars['Int']>;
  /** 通貨コード */
  currencyCode?: Maybe<Scalars['String']>;
  /** こころからの取扱手数料も含めた金額 */
  inclusivePrice?: Maybe<Scalars['Int']>;
  /** こころからの取扱手数料 */
  cocolocalaTransactionFee?: Maybe<Scalars['Int']>;
  /** こころからの取扱手数料に対する税額 */
  cocolocalaTransactionFeeTax?: Maybe<Scalars['Int']>;
};

export type IExpediaHotel = {
  /** ホテルの画像 */
  images: Array<HotelImage>;
  /** チェックインの情報 */
  checkin?: Maybe<Checkin>;
  /** チェックアウトの情報 */
  checkout?: Maybe<Checkout>;
  /** ホテルの注意事項 */
  hotelCautions: HotelCautions;
  /** ホテルの説明 */
  hotelExplanation?: Maybe<HotelExplanation>;
  /** ホテルの部屋数など */
  statics: HotelStatistics;
  /** ペット情報 */
  pets: Array<Scalars['String']>;
  /** ホテルタイプ */
  hotelType?: Maybe<HotelType>;
  /** 施設のアメニティ情報 */
  hotelAmenities: HotelAmenities;
  /** 部屋情報 */
  rooms: Array<HotelRoom>;
  /** Covid19の情報 */
  covid19Tags?: Maybe<Covid19Tag>;
  /** Expediaでの宿泊者レビュー。こちらのデータはExpediaの規約的にGoogle BotなどのクローラーにキャッシュさせてはいけないのでBotからの取得を弾きCSRでのみ取得する（SSRをさせない） https://www.notion.so/hotspring-inc/Expedia-84236d99efcc4265a4700fbf9311abf2 */
  expediaGuestReviews?: Maybe<Array<ExpediaGuestReview>>;
};

export type IHotelSummary = {
  /** ID */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId?: Maybe<Scalars['Int']>;
  /** ExpediaのホテルID */
  expediaHotelId?: Maybe<Scalars['String']>;
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 位置情報 */
  zoneInfo?: Maybe<ICocolocalaZone>;
  /** ホテルの画像 */
  images: Array<HotelImage>;
};

export type IOrderCompleteOrHistoryDpCarInfo = {
  /** 営業所の情報 */
  vendorInfo: DpCarVendorInfo;
  /** レンタカー情報 */
  car: DpCar;
};

export type IOrderCompleteOrHistoryHotelInfo = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['String'];
  /** ホテルのサムネイル画像 */
  hotelThumbnailUrl?: Maybe<Scalars['String']>;
  /** ホテル名 */
  hotelName: Scalars['String'];
  /** チェックイン/チェックアウト情報 */
  checkInCheckOutInfo: HotelCheckInCheckOutInfo;
  /** 宿泊の詳細情報 */
  stayDetails: Array<DetailsTableItem>;
  /** 宿泊人数情報 */
  numberOfPeople: Scalars['Int'];
  /** 特記事項 */
  importantNotices: Array<Scalars['String']>;
};

export type IOrderCompleteOrHistoryUserInfo = {
  email?: Maybe<Scalars['String']>;
};

export type IOrderDpCarPriceInfo = {
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
};

export type IOrderFlightInfo = {
  /** 行きのフライトの区間情報一覧 */
  goingFlightSectors: Array<FlightSector>;
  /** 帰りのフライトの区間情報一覧 */
  returningFlightSectors: Array<FlightSector>;
  /** 出発日 ex. 2021年4月2日（金） */
  goingDeparturePointDate: Scalars['String'];
  /** 現地出発日 ex. 2021年4月16日（木） */
  returningDeparturePointDate: Scalars['String'];
  /** 人数 */
  numberOfPeople: Scalars['Int'];
};

export type IOrderFlightPriceInfo = {
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
};

export type IOrderHotelInfo = {
  id?: Maybe<Scalars['ID']>;
  cocolocalaHotelId?: Maybe<Scalars['String']>;
  expediaHotelId?: Maybe<Scalars['String']>;
  /** 客室のRateID */
  selectedRateId?: Maybe<Scalars['String']>;
  /** 宿泊人数情報 */
  numberOfPeople?: Maybe<Scalars['Int']>;
  /** 残りの部屋数 */
  numberOfRoomsRemaining?: Maybe<Scalars['Int']>;
  /** 特記事項 */
  importantNotices?: Maybe<Array<Scalars['String']>>;
  /** ホテルの在庫切れフラグ */
  isSoldOut?: Maybe<Scalars['Boolean']>;
  hotelSummary?: Maybe<OrderHotelSummary>;
  roomSummary?: Maybe<OrderHotelRoomSummary>;
  hotelDetail?: Maybe<OrderHotelDetail>;
  roomDetail?: Maybe<OrderHotelRoomDetail>;
  targetHotelZonePath?: Maybe<Scalars['String']>;
};

export type IOrderHotelPriceInfo = {
  /** 料金内訳モーダルの見出し（例: 宿泊（3泊）） */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
  /** 現地で支払う必要のある料金 */
  propertyCollectionPriceInfo: Array<PropertyCollectionPriceInfo>;
};

export type IOrderPriceDetail = {
  /** ラベル */
  label?: Maybe<Scalars['String']>;
  /** 料金 */
  value?: Maybe<Scalars['String']>;
};

export type IOrderSignOrPurchaseDpCarInfo = {
  /** サムネイルURL */
  thumbnailUrl: Scalars['String'];
  /** 車種名 */
  carName: Scalars['String'];
  /** レンタカーの詳細情報 */
  dPCarDetails: Array<DetailsTableItem>;
};

export type IOrderSignOrPurchasePaymentInfo = {
  /** コンビニ払いの支払い期限 */
  convenienceStorePaymentDeadline?: Maybe<Scalars['String']>;
  /** 銀行振込の支払い期限 */
  bankTransferDeadline?: Maybe<Scalars['String']>;
};

export type IOrderSupportPlanInfo = {
  supportPlanType: DpFlightSupportPlanType;
};

export type IOrderSupportPlanPriceInfo = {
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
};

export type IPagination = {
  /** 次のページがあるか */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** 次のオフセット */
  nextOffset?: Maybe<Scalars['Int']>;
};

export type IPaginationResult = {
  pagination?: Maybe<IPagination>;
};

export type IReviewItem = {
  reviewItemId?: Maybe<Scalars['Int']>;
  reviewItemImages?: Maybe<Array<Maybe<IReviewItemImage>>>;
  category?: Maybe<ReviewItemCategoryWithLabel>;
  comment?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type IReviewItemImage = {
  reviewItemImageId: Scalars['Int'];
  imageUrl: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ImageData = {
  __typename?: 'ImageData';
  /** アップロードされた画像アセットのURL */
  url: Scalars['String'];
  /** 画像幅px */
  height?: Maybe<Scalars['Int']>;
  /** 画像高さpx */
  width?: Maybe<Scalars['Int']>;
  /** 出典元テキスト */
  creditText?: Maybe<Scalars['String']>;
  /** 出典元画像ロゴURL */
  creditImageUrl?: Maybe<Scalars['String']>;
  /** 出典元URL */
  creditLinkUrl?: Maybe<Scalars['String']>;
};

export type InclusivePriceInfo = {
  __typename?: 'InclusivePriceInfo';
  /** 合計料金 */
  total: Scalars['Int'];
  /** 一人あたりの料金 */
  perPerson: Scalars['Int'];
  /** 人数 */
  numberOfPeople: Scalars['Int'];
  /** 宿泊数 */
  numberOfStays: Scalars['Int'];
};

export type IncrementalSearch = {
  __typename?: 'IncrementalSearch';
  zones: Array<IncrementalSearchZoneItem>;
  hotels: Array<IncrementalSearchHotelItem>;
};

export type IncrementalSearchHotelItem = Node & {
  __typename?: 'IncrementalSearchHotelItem';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
  prefectureName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  cocolocalaHotelId: Scalars['Int'];
  sort?: Maybe<Scalars['Int']>;
};

export type IncrementalSearchInput = {
  query: Scalars['String'];
  searchType?: Maybe<IncrementalSearchTypeEnum>;
};

export enum IncrementalSearchTypeEnum {
  All = 'ALL',
  OnlyZone = 'ONLY_ZONE',
  OnlyHotel = 'ONLY_HOTEL'
}

export type IncrementalSearchZoneItem = Node & {
  __typename?: 'IncrementalSearchZoneItem';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
  prefectureName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  areaName?: Maybe<Scalars['String']>;
  zoneType: ZoneTypeEnum;
  path: Scalars['String'];
  hotelCount?: Maybe<Scalars['Int']>;
};

export type InstagramImage = {
  __typename?: 'InstagramImage';
  /** 画像のURL */
  imageUrl: Scalars['String'];
  /** アカウント名 */
  accountName: Scalars['String'];
};

export enum InternationalFlightReservationErrorType {
  /** 空席がない場合 */
  VacantSeatNotFound = 'VACANT_SEAT_NOT_FOUND',
  /** Amadeusセッションが有効期限切れの場合 */
  AmadeusSessionExpired = 'AMADEUS_SESSION_EXPIRED',
  /** 14日以内に予約された場合 */
  NonReservablePeriods = 'NON_RESERVABLE_PERIODS',
  /** その他の場合 */
  OtherError = 'OTHER_ERROR'
}

export enum InternationalOrDomestic {
  International = 'International',
  Domestic = 'Domestic'
}

export type InternationalTravelSituation = {
  __typename?: 'InternationalTravelSituation';
  /** 旅行の歯やすさの点数. 1~5点 */
  travelStatus: TravelStatus;
  /** 現在の状況 */
  currentStatuses: Array<ExpandableContent>;
  /** コメント */
  comments: Array<StaffComment>;
};

export type JpTopPage = {
  __typename?: 'JpTopPage';
  /** ページ上部のカルーセルと下部のキャンペーンのバナー */
  campaignBanners: Array<CampaignBanner>;
  popularAreaDescription: PopularAreaDescription;
  /** 人気の旅行先一覧 */
  areas: Array<Area>;
  /** 人気のホテル */
  popularHotels: Array<HotelData>;
  /** セール中のホテル一覧 */
  saleHotels: Array<HotelData>;
  /** 人気のプラン */
  popularPlans: Array<RecommendedPlanData>;
  /** 人気の旅行先に付随するテキストリンク */
  popularDestinations: Array<PopularDestination>;
};

export type LatestReservedReservationInfo = {
  __typename?: 'LatestReservedReservationInfo';
  /** 直近30日以内に海外DPの予約があったかどうかのフラグ */
  isDPFlightReservedWithin30Days: Scalars['Boolean'];
};

export type Lawson = {
  __typename?: 'Lawson';
  /** お客様番号（11桁） */
  customerCode: Scalars['String'];
  /** 確認番号（6桁） */
  confirmationCode: Scalars['String'];
};

export type LimitedTimeSaleInfo = {
  __typename?: 'LimitedTimeSaleInfo';
  /** 期間限定セールの名前 */
  limitedTimeSaleLabel: Scalars['String'];
  /** 期間限定セールの30分前かどうか */
  isWithin30MinOfLimitedTimeSaleDiscount: Scalars['Boolean'];
  /** 期間限定セールの終了時間 */
  limitedTimeSaleEndTime: Scalars['String'];
  /** 期間限定セールのタイプ */
  limitedTimeSaleType: LimitedTimeSaleType;
  /** バナー */
  limitedTimeSaleImageBannerPath: Scalars['String'];
};

export enum LimitedTimeSaleType {
  /** 新春セール */
  NewYear = 'NewYear',
  /** サマーセール */
  SummerSale = 'SummerSale',
  /** ブラックフライデー */
  BlackFriday = 'BlackFriday',
  /** 秋セール */
  AutumnSale = 'AutumnSale',
  /** 秋セールファイナル */
  AutumnSaleFinal = 'AutumnSaleFinal',
  /** 冬セール */
  WinterSale = 'WinterSale',
  /** クリスマスセール */
  ChristmasSale = 'ChristmasSale',
  /** 歳末セール */
  YearEnd = 'YearEnd',
  /** 円高還元セール */
  StrongYenSale = 'StrongYenSale',
  /** その他セール1 */
  SpecialSale = 'SpecialSale',
  /** その他セール2（SpecialSaleが日を挟まずに続く＆カラーに変更がある場合用） */
  SpecialSale2 = 'SpecialSale2'
}

export type LocalActivity = {
  __typename?: 'LocalActivity';
  title: Scalars['String'];
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  linkUrl?: Maybe<Scalars['String']>;
};

export enum MealCondition {
  /** 食事なし */
  NoMeal = 'NoMeal',
  /** 朝食付き */
  WithBreakfast = 'WithBreakfast',
  /** 夕食付き */
  WithDinner = 'WithDinner',
  /** 2食付き */
  WithBreakfastAndDinner = 'WithBreakfastAndDinner',
  /** オールインクルーシブ */
  WithAllInclusive = 'WithAllInclusive',
  /** 指定なし */
  Undecided = 'Undecided'
}

export type MigrateAnonymouseUserToAuthenticatedUserInput = {
  /** 匿名ユーザのときのユーザのUID */
  anonymouseUid: Scalars['String'];
  /** 会員登録済みのユーザのUID */
  authenticatedUid: Scalars['String'];
};

export type MigrateAnonymouseUserToAuthenticatedUserPayload = {
  __typename?: 'MigrateAnonymouseUserToAuthenticatedUserPayload';
  /** 匿名ユーザのときのユーザのUID */
  anonymouseUid: Scalars['String'];
  /** 会員登録済みのユーザのUID */
  authenticatedUid: Scalars['String'];
};

export type MiniStop = {
  __typename?: 'MiniStop';
  /** お客様番号（11桁） */
  customerCode: Scalars['String'];
  /** 確認番号（6桁） */
  confirmationCode: Scalars['String'];
};

export type MinimumDpCarLocationConditionInput = {
  /** こころからのホテルID.指定されたときにこのホテルの周辺を検索する */
  cocolocalaHotelId?: Maybe<Scalars['String']>;
  /** こころからのdistrictId.指定されたdistrictに属するホテルの人気順の最初のホテルの周辺を検索する */
  regionName?: Maybe<Scalars['String']>;
  /** こころからのregionName.指定されたregionに属するホテルの人気順の最初のホテルの周辺を検索する */
  prefectureName?: Maybe<Scalars['String']>;
  /** こころからのprefectureName.指定されたprefectureに属するホテルの人気順の最初のホテルの周辺を検索する */
  districtId?: Maybe<Scalars['String']>;
  /** こころからのareaId.指定されたareaに属するホテルの人気順の最初のホテルの周辺を検索する */
  areaId?: Maybe<Scalars['String']>;
};

export type MinimumDpCarPriceInfoInput = {
  /** レンタカーの検索をする位置情報の条件の指定 */
  locationCondition: MinimumDpCarLocationConditionInput;
  /** 出発日 (YYYY-MM-DD) */
  pickupDate: Scalars['String'];
  /** 出発時間 (hh:mm) */
  pickupTime: Scalars['String'];
  /** 返却日 (YYYY-MM-DD) */
  returnDate: Scalars['String'];
  /** 返却時間 (hh:mm) */
  returnTime: Scalars['String'];
  /** 運転手を除く乗車人数 */
  numberOfPassengers: Scalars['Int'];
};

export type MinimumFlightPriceSearchInfo = {
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
};

export type MinimumInclusivePriceInfoForDpFlight = {
  __typename?: 'MinimumInclusivePriceInfoForDPFlight';
  /** 合計料金 */
  total: Scalars['Int'];
  /** 1名あたりの料金 */
  perPerson: Scalars['Int'];
  /** 割引情報 */
  discountInfo?: Maybe<DiscountInfoForDpFlight>;
  /** 人数 */
  numberOfPeople: Scalars['Int'];
  /** 宿泊数 */
  numberOfStays: Scalars['Int'];
};

export type MinimumPricing = {
  __typename?: 'MinimumPricing';
  /** こころからでの手数料も含まれた税サ込み料金 */
  inclusiveWithCocolocalaTransactionFee: CurrencyData;
  /** Expediaの税サ込み */
  inclusive: CurrencyData;
  /** Expediaの税サ抜き */
  exclusive: CurrencyData;
  /** こころからの手数料も含まれた割引前価格 */
  strikeThroughWithCocolocalaTransactionFee?: Maybe<CurrencyData>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminBookExpediaHotel: AdminBookExpediaHotelPayload;
  adminDeleteFlightPassengerAndPassport: AdminDeleteFlightPassengerAndPassportPayload;
  adminFullRefundFincodePayment: AdminFullRefundFincodePaymentPayload;
  adminSendReserved: AdminSendReservedPayload;
  adminUpdateContact: AdminUpdateContactPayload;
  adminUpdateFlightPassengerAndPassports: AdminUpdateFlightPassengerAndPassportPayload;
  adminUpdateFlightReservation: AdminUpdateFlightReservationPayload;
  adminUpdateHotelPhotosByCountryCode: AdminUpdateHotelPhotosByCountryCodePayload;
  adminUpdateOrderStatusReserved: AdminUpdateOrderStatusReservedPayload;
  adminUpdatePaymentStatusRefunded: AdminUpdatePaymentStatusRefundedPayload;
  adminUpdateTemporarySuspendedFlightCarriers: AdminUpdateTemporarySuspendedFlightCarriersPayload;
  adminUpdateTravelDescription: AdminUpdateTravelDescriptionPayload;
  cancelOrderAndRefund: CancelOrderAndRefundPayload;
  cancelPNR: CancelPnrPayload;
  cancelReservedCar: CancelReservedCarPayload;
  cancelReservedDidaHotel: CancelReservedDidaHotelPayload;
  cancelReservedHotel: CancelReservedHotelPayload;
  createDPFlightTheme: CreateDpFlightThemePayload;
  deleteDPFlightTheme: DeleteDpFlightThemePayload;
  refundCreditCard: RefundCreditCardPayload;
  updateDPFlightTheme: UpdateDpFlightThemePayload;
  updateDPFlightThemePublishStatus: UpdateDpFlightThemePublishStatusPayload;
  updateHotelPhotos: UpdateHotelPhotosPayload;
  updateOrderStatusCanceledOrInvalidAndPaymentStatusRefunded: UpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedPayload;
  updateTravel: UpdateTravelPayload;
  addBookmarkHotel: AddBookmarkHotelPayload;
  removeBookmarkHotel: RemoveBookmarkHotelPayload;
  addDPCarToCartsForOrderPurchase: AddToCartPayload;
  addFlightToCart: AddToCartPayload;
  addHotelToCart: AddToCartPayload;
  addHotelToCartsForOrderPurchase: AddToCartPayload;
  addSelectedCancelForAnyReason: AddSelectedCancelForAnyReasonPayload;
  migrateAnonymouseUserToAuthenticatedUser: MigrateAnonymouseUserToAuthenticatedUserPayload;
  applyReservation: ApplyReservationPayload;
  prepareReservationViaStripe: PrepareReservationViaStripePayload;
  applyReservationViaStripe: ApplyReservationPayload;
  applyReservationViaFincode: ApplyReservationViaFincodePayload;
  changeDPFlightCancelForAnyReason: ChangeDpFlightCancelForAnyReasonPayload;
  changeDPFlightOptions: ChangeDpFlightOptionsPayload;
  changeDPFlightSupportPlan: ChangeDpFlightSupportPlanPayload;
  changeFlight: ChangeFlightPayload;
  changeHotelRoom: ChangeHotelRoomPayload;
  changeSelectedBaggageOption: ChangeSelectedBaggageOptionPayload;
  changeUseAirportTransfer: ChangeUseAirportTransferPayload;
  confirmReservationViaFincode: ApplyReservationPayload;
  prepareReservationViaFincode: PrepareReservationViaFincodePayload;
  saveOrderReservationInformation: SaveOrderReservationInformationPayload;
  savePassport: SavePassportPayload;
  sendEmergencyContact: SendEmergencyContactPayload;
  sendSelectedProducts: SendSelectedProductsPayload;
  updateOrderTodoList: UpdateOrderTodoListPayload;
  createMyReview: CreateMyReviewPayload;
  createMyReviewItem: CreateMyReviewItemPayload;
  deleteMyReview: DeleteMyReviewPayload;
  deleteMyReviewItem: DeleteMyReviewItemPayload;
  updateMyReviewItem: UpdateMyReviewItemPayload;
  updateMyReviewPublishStatusPublish: UpdateMyReviewPublishStatusPublishPayload;
  updateMyReviewSummary: UpdateMyReviewSummaryPayload;
  upsertMyReviewUser: UpsertMyReviewUserPayload;
  updateEmail: UpdateEmailPayload;
};


export type MutationAdminBookExpediaHotelArgs = {
  input: AdminBookExpediaHotelInput;
};


export type MutationAdminDeleteFlightPassengerAndPassportArgs = {
  input: AdminDeleteFlightPassengerAndPassportInput;
};


export type MutationAdminFullRefundFincodePaymentArgs = {
  input: AdminFullRefundFincodePaymentInput;
};


export type MutationAdminSendReservedArgs = {
  input: AdminSendReservedInput;
};


export type MutationAdminUpdateContactArgs = {
  input: AdminUpdateContactInput;
};


export type MutationAdminUpdateFlightPassengerAndPassportsArgs = {
  input: AdminUpdateFlightPassengerAndPassportsInput;
};


export type MutationAdminUpdateFlightReservationArgs = {
  input: AdminUpdateFlightReservationInput;
};


export type MutationAdminUpdateHotelPhotosByCountryCodeArgs = {
  input: AdminUpdateHotelPhotosByCountryCodeInput;
};


export type MutationAdminUpdateOrderStatusReservedArgs = {
  input: AdminUpdateOrderStatusReservedInput;
};


export type MutationAdminUpdatePaymentStatusRefundedArgs = {
  input: AdminUpdatePaymentStatusRefundedInput;
};


export type MutationAdminUpdateTemporarySuspendedFlightCarriersArgs = {
  input: AdminUpdateTemporarySuspendedFlightCarriersInput;
};


export type MutationAdminUpdateTravelDescriptionArgs = {
  input: AdminUpdateTravelDescriptionInput;
};


export type MutationCancelOrderAndRefundArgs = {
  input: CancelOrderAndRefundInput;
};


export type MutationCancelPnrArgs = {
  input: CancelPnrInput;
};


export type MutationCancelReservedCarArgs = {
  input: CancelReservedCarInput;
};


export type MutationCancelReservedDidaHotelArgs = {
  input: CancelReservedDidaHotelInput;
};


export type MutationCancelReservedHotelArgs = {
  input: CancelReservedHotelInput;
};


export type MutationCreateDpFlightThemeArgs = {
  input: CreateDpFlightThemeInput;
};


export type MutationDeleteDpFlightThemeArgs = {
  input: DeleteDpFlightThemeInput;
};


export type MutationRefundCreditCardArgs = {
  input: RefundCreditCardInput;
};


export type MutationUpdateDpFlightThemeArgs = {
  input: UpdateDpFlightThemeInput;
};


export type MutationUpdateDpFlightThemePublishStatusArgs = {
  input: UpdateDpFlightThemePublishStatusInput;
};


export type MutationUpdateHotelPhotosArgs = {
  input: UpdateHotelPhotosInput;
};


export type MutationUpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedArgs = {
  input: UpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedInput;
};


export type MutationUpdateTravelArgs = {
  input: UpdateTravelInput;
};


export type MutationAddBookmarkHotelArgs = {
  input: AddBookmarkHotelInput;
};


export type MutationRemoveBookmarkHotelArgs = {
  input: RemoveBookmarkHotelInput;
};


export type MutationAddDpCarToCartsForOrderPurchaseArgs = {
  input: AddDpCarToCartsForOrderPurchaseInput;
};


export type MutationAddFlightToCartArgs = {
  input: AddFlightToCartInput;
};


export type MutationAddHotelToCartArgs = {
  input: AddHotelToCartInput;
};


export type MutationAddHotelToCartsForOrderPurchaseArgs = {
  input: AddHotelToCartsForOrderPurchaseInput;
};


export type MutationAddSelectedCancelForAnyReasonArgs = {
  input: AddSelectedCancelForAnyReasonInput;
};


export type MutationMigrateAnonymouseUserToAuthenticatedUserArgs = {
  input: MigrateAnonymouseUserToAuthenticatedUserInput;
};


export type MutationApplyReservationArgs = {
  input: ApplyReservationInput;
};


export type MutationPrepareReservationViaStripeArgs = {
  input: PrepareReservationViaStripeInput;
};


export type MutationApplyReservationViaStripeArgs = {
  input: ApplyReservationViaStripeInput;
};


export type MutationApplyReservationViaFincodeArgs = {
  input: ApplyReservationViaFincodeInput;
};


export type MutationChangeDpFlightCancelForAnyReasonArgs = {
  input: ChangeDpFlightCancelForAnyReasonInput;
};


export type MutationChangeDpFlightOptionsArgs = {
  input: ChangeDpFlightOptionsInput;
};


export type MutationChangeDpFlightSupportPlanArgs = {
  input: ChangeDpFlightSupportPlanInput;
};


export type MutationChangeFlightArgs = {
  input: ChangeFlightInput;
};


export type MutationChangeHotelRoomArgs = {
  input: ChangeHotelRoomInput;
};


export type MutationChangeSelectedBaggageOptionArgs = {
  input: ChangeSelectedBaggageOptionInput;
};


export type MutationChangeUseAirportTransferArgs = {
  input: ChangeUseAirportTransferInput;
};


export type MutationConfirmReservationViaFincodeArgs = {
  input: ConfirmReservationViaFincodeInput;
};


export type MutationPrepareReservationViaFincodeArgs = {
  input: PrepareReservationViaFincodeInput;
};


export type MutationSaveOrderReservationInformationArgs = {
  input: SaveOrderReservationInformationInput;
};


export type MutationSavePassportArgs = {
  input: SavePassportInput;
};


export type MutationSendEmergencyContactArgs = {
  input: SendEmergencyContactInput;
};


export type MutationSendSelectedProductsArgs = {
  input: SendSelectedProductsInput;
};


export type MutationUpdateOrderTodoListArgs = {
  input: UpdateOrderTodoListInput;
};


export type MutationCreateMyReviewArgs = {
  input: CreateMyReviewInput;
};


export type MutationCreateMyReviewItemArgs = {
  input: CreateMyReviewItemInput;
};


export type MutationDeleteMyReviewArgs = {
  input: DeleteMyReviewInput;
};


export type MutationDeleteMyReviewItemArgs = {
  input: DeleteMyReviewItemInput;
};


export type MutationUpdateMyReviewItemArgs = {
  input: UpdateMyReviewItemInput;
};


export type MutationUpdateMyReviewPublishStatusPublishArgs = {
  input: UpdateMyReviewPublishStatusPublishInput;
};


export type MutationUpdateMyReviewSummaryArgs = {
  input: UpdateMyReviewSummaryInput;
};


export type MutationUpsertMyReviewUserArgs = {
  input: UpsertMyReviewUserInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};

export type MyHotelBookmark = {
  __typename?: 'MyHotelBookmark';
  cocolocalaHotelId: Scalars['Int'];
  bookmarked: Scalars['Boolean'];
};

export type MyHotelBookmarkHotels = {
  __typename?: 'MyHotelBookmarkHotels';
  hotels: Array<HotelSummary>;
  pagination: PaginationWithPageInfo;
};

export type MyHotelBookmarkHotelsInput = {
  pagination: PaginationInput;
};

export type MyHotelBookmarkInput = {
  /** こころからホテルID */
  cocolocalaHotelId: Scalars['Int'];
};

export type MyReview = Node & {
  __typename?: 'MyReview';
  id: Scalars['ID'];
  reviewId: Scalars['Int'];
  cocolocalaHotelId: Scalars['Int'];
  hotelImageUrl?: Maybe<Scalars['String']>;
  hotelName: Scalars['String'];
  stayedAt: Scalars['String'];
  numberOfPeople: Scalars['Int'];
  useSceneWithLabel: UseSceneWithLabel;
  versionNo: Scalars['Int'];
  reviewItems: Array<MyReviewItem>;
  publishStatus: ReviewPublishStatus;
};

export type MyReviewInput = {
  reviewId: Scalars['Int'];
};

export type MyReviewItem = Node & IReviewItem & {
  __typename?: 'MyReviewItem';
  id: Scalars['ID'];
  reviewItemId: Scalars['Int'];
  reviewItemImages: Array<MyReviewItemImage>;
  category: ReviewItemCategoryWithLabel;
  comment: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type MyReviewItemImage = Node & IReviewItemImage & {
  __typename?: 'MyReviewItemImage';
  id: Scalars['ID'];
  reviewItemImageId: Scalars['Int'];
  imageUrl: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type MyReviews = {
  __typename?: 'MyReviews';
  id: Scalars['ID'];
  account?: Maybe<MyReviewsAccount>;
  reviews: Array<MyReviewsReview>;
};

export type MyReviewsAccount = {
  __typename?: 'MyReviewsAccount';
  iconUrl?: Maybe<Scalars['String']>;
  nickname: Scalars['String'];
  versionNo: Scalars['Int'];
};

export type MyReviewsReview = Node & {
  __typename?: 'MyReviewsReview';
  id: Scalars['ID'];
  reviewId: Scalars['Int'];
  cocolocalaHotelId: Scalars['Int'];
  hotelImageUrl?: Maybe<Scalars['String']>;
  hotelName: Scalars['String'];
  stayedAt: Scalars['String'];
  editDateTime: Scalars['String'];
  publishStatus: ReviewPublishStatus;
  versionNo: Scalars['Int'];
};

export type NationalityOption = {
  __typename?: 'NationalityOption';
  value: Scalars['String'];
  label: Scalars['String'];
};

export type Node = {
  id: Scalars['ID'];
};

/** テキスト、テキストと画像などの汎用的な表示要素を含むモデルコースのアイテム */
export type NormalModelCourseItem = {
  __typename?: 'NormalModelCourseItem';
  /** モデルコースのアイテムタイプ */
  itemType: PlanModelCourseItemType;
  /** コース要素に訪れる現地時間 24h表記 * ex. 11:00 */
  time?: Maybe<Scalars['String']>;
  /** タイトル要素 */
  name: Scalars['String'];
  /** 説明文などの要素 */
  description?: Maybe<Scalars['String']>;
  /** 画像の表示要素 */
  images: Array<PlanImage>;
};

export type OgpImage = {
  __typename?: 'OGPImage';
  imageUrl: Scalars['String'];
};

export type OgpImageForOrderConfirm = Node & {
  __typename?: 'OGPImageForOrderConfirm';
  /** ID */
  id: Scalars['ID'];
  /** OGP画像 */
  ogpImage: OgpImage;
};

export type OgpImageForOrderConfirmInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

/** 人数情報 */
export type Occupancy = {
  __typename?: 'Occupancy';
  /** 大人の人数 */
  numberOfAdults: Scalars['Int'];
  /** 子供の年齢 */
  childAges: Array<Scalars['Int']>;
};

/** 人数のInput */
export type OccupancyInput = {
  /** 大人の人数 */
  numberOfAdults: Scalars['Int'];
  /** 子供の年齢 */
  childAges: Array<Scalars['Int']>;
};

export type OrderAirportInfo = Node & {
  __typename?: 'OrderAirportInfo';
  /** ID */
  id: Scalars['ID'];
  /** IATAの空港コード */
  airportIATACode: Scalars['String'];
  /** 空港名 */
  airportName: Scalars['String'];
  /** 空港の所在する国/都市名 ex. ハワイ/アメリカ */
  countryAndCityName: Scalars['String'];
};

export type OrderCancelForAnyReason = {
  __typename?: 'OrderCancelForAnyReason';
  /** キャンセル保証が追加されているかどうか */
  hasCancelForAnyReason: Scalars['Boolean'];
  /** キャンセル保証期限 ex. 2024年5月15日 11:15 */
  limitDateTimeText: Scalars['String'];
  /** キャンセル保証期限切れ ex. 2024年5月15日 11:16 */
  expireDateTimeText: Scalars['String'];
};

export type OrderCancelForAnyReasonPriceInfo = {
  __typename?: 'OrderCancelForAnyReasonPriceInfo';
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
  /** 1人あたりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePerPerson: Scalars['Int'];
};

export type OrderCancelInfo = {
  __typename?: 'OrderCancelInfo';
  /** キャンセル無料期間の期限 */
  freeCancellation?: Maybe<Scalars['String']>;
  /** キャンセルポリシー */
  cancelPolicies: Array<CancelPolicySection>;
  /** 予約の変更、キャンセル、領収書の発行の依頼フォームを表示するか */
  showRequestForm?: Maybe<Scalars['Boolean']>;
  /** 航空券のキャンセルポリシー */
  flightCancelPolicy?: Maybe<FlightCancelPolicy>;
  /** こころからで定める一人あたりの変更手数料 */
  cocolocalaChangeFeePerPersonText: Scalars['String'];
};

export type OrderCarrier = Node & {
  __typename?: 'OrderCarrier';
  /** ID */
  id: Scalars['ID'];
  /** IATAの航空会社コード */
  carrierIATACode: Scalars['String'];
  /** 航空会社名 */
  name: Scalars['String'];
  /** キャリアタイプ */
  carrierType: CarrierType;
};

export type OrderCocolocalaTransactionPriceInfo = {
  __typename?: 'OrderCocolocalaTransactionPriceInfo';
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
  /** 税込みの取扱手数料 */
  cocolocalaTransactionFeeAndTaxText: Scalars['String'];
};

export type OrderComplete = Node & {
  __typename?: 'OrderComplete';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  status: OrderStatus;
  /** 海外DPフラグ */
  isDPFlight: Scalars['Boolean'];
  /** アフィリエイト(ex. アクセストレード・アフィタウン)の売上報酬額 */
  affiliateCVPrice: Scalars['Int'];
  /** お客さまのメールアドレス */
  email: Scalars['String'];
  paymentMethod: PaymentMethod;
};

export type OrderCompleteInput = {
  orderId: Scalars['Int'];
};

export type OrderConfirm = Node & {
  __typename?: 'OrderConfirm';
  id: Scalars['ID'];
  /** 宿泊施設情報 */
  hotelInfo?: Maybe<OrderConfirmHotelInfo>;
  /** 予約情報サマリ */
  reservationSummaryInfo: ReservationSummaryInfo;
  /** 海外航空券情報詳細 */
  flightDetail: OrderFlightInfo;
  /** 海外あんしんサポートプラン情報 */
  supportPlan?: Maybe<DpFlightSupportPlan>;
  /** すべての海外あんしんサポートプラン情報（詳細モーダルで利用） */
  supportPlans: Array<DpFlightSupportPlan>;
  /** キャンセル保証情報 */
  cancelForAnyReason?: Maybe<OrderCancelForAnyReason>;
  /** 料金情報 */
  priceInfo: OrderPriceInfoForOrderConfirm;
  /** キャンセル情報 */
  cancelInfo?: Maybe<OrderCancelInfo>;
  /** 検索条件（日程／人数／出発地／目的地） */
  searchCondition: OrderConfirmSearchCondition;
  /** 一部日程であるかどうか */
  isPartialStayDaysOfEntireItinerary: Scalars['Boolean'];
  /** Confirm画面に再訪するときの情報 */
  orderConfirmRevisitInfo?: Maybe<OrderConfirmRevisitInfo>;
  /** 追加オプション */
  additionalOptionsInfo?: Maybe<AdditionalOptionsInfo>;
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
  /** 空港送迎の利用有無 */
  useAirportTransfer?: Maybe<Scalars['Boolean']>;
  /** パスポート情報入力必要有無 */
  passportRequirement: PassportRequirement;
  /** 泊数の調整が行われた場合のお知らせ */
  adjustedCheckInDateNote?: Maybe<Scalars['String']>;
  /** 予約時に購入可能な受託手荷物オプション */
  baggageOptionInfo?: Maybe<BaggageOptionInfo>;
  /** 選択済みの受託手荷物オプション */
  selectedBaggageOptionInfo?: Maybe<OrderConfirmOrReservationInformationSelectedBaggageOptionInfo>;
};

export type OrderConfirmHotelInfo = IOrderHotelInfo & {
  __typename?: 'OrderConfirmHotelInfo';
  id: Scalars['ID'];
  cocolocalaHotelId: Scalars['String'];
  expediaHotelId: Scalars['String'];
  hotelSummary: OrderHotelSummary;
  roomSummary: OrderHotelRoomSummary;
  hotelDetail: OrderHotelDetail;
  roomDetail: OrderHotelRoomDetail;
  targetHotelZonePath?: Maybe<Scalars['String']>;
  /** 客室のRateID */
  selectedRateId: Scalars['String'];
  /** 宿泊人数情報 */
  numberOfPeople: Scalars['Int'];
  /** 残りの部屋数 */
  numberOfRoomsRemaining: Scalars['Int'];
  /** 特記事項 */
  importantNotices: Array<Scalars['String']>;
  /** ホテルの在庫切れフラグ */
  isSoldOut: Scalars['Boolean'];
};

export type OrderConfirmInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

export type OrderConfirmOrReservationInformationSelectedBaggageOptionInfo = {
  __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionInfo';
  /** 旅客単位の受託手荷物オプション */
  perPassengers: Array<OrderConfirmOrReservationInformationSelectedBaggageOptionPerPassengerInfo>;
  /** 全旅客の受託手荷物オプション */
  perFlight?: Maybe<SelectedBaggageOptionInfo>;
};

export type OrderConfirmOrReservationInformationSelectedBaggageOptionPerPassengerInfo = {
  __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionPerPassengerInfo';
  selectedBaggageOption: SelectedBaggageOptionInfo;
};

export type OrderConfirmRevisitInfo = {
  __typename?: 'OrderConfirmRevisitInfo';
  /** ZoneName(ex: ハワイ) */
  zoneName: Scalars['String'];
  /** ホテル名 */
  hotelName: Scalars['String'];
  /** ホテルのサムネイルURL */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** 出発日(ex: 2023-09-08) */
  departureDate: Scalars['String'];
  /** 人数 */
  numberOfPeople: Scalars['Int'];
  /** 航空会社名 */
  flightCarrierNames: Array<Scalars['String']>;
};

export type OrderConfirmSearchCondition = {
  __typename?: 'OrderConfirmSearchCondition';
  goingCityOrAirportIATACode: Scalars['String'];
  returningCityOrAirportIATACode: Scalars['String'];
  goingDate: Scalars['String'];
  returningDate: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  childAges: Array<Scalars['Int']>;
  zonePath?: Maybe<Scalars['String']>;
};

export type OrderDpCarInfo = Node & {
  __typename?: 'OrderDPCarInfo';
  id: Scalars['ID'];
  /** 営業所の情報 */
  vendorInfo: DpCarVendorInfo;
  /** レンタカー情報 */
  car: DpCar;
};

export type OrderDpCarPriceInfo = IOrderDpCarPriceInfo & {
  __typename?: 'OrderDPCarPriceInfo';
  label: Scalars['String'];
  priceDetails: Array<OrderPriceDetail>;
};

export type OrderDiscountDetail = IOrderPriceDetail & {
  __typename?: 'OrderDiscountDetail';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type OrderDiscountSectionPriceInfo = {
  __typename?: 'OrderDiscountSectionPriceInfo';
  /** 料金内訳モーダルの見出し */
  label: Scalars['String'];
  /** 料金内訳 */
  priceDetails: Array<OrderPriceDetail>;
};

export type OrderFlightInfo = {
  __typename?: 'OrderFlightInfo';
  goingFlight: Flight;
  returningFlight: Flight;
};

export type OrderFlightPriceInfo = IOrderFlightPriceInfo & {
  __typename?: 'OrderFlightPriceInfo';
  label: Scalars['String'];
  priceDetails: Array<OrderPriceDetail>;
};

export type OrderHistory = Node & {
  __typename?: 'OrderHistory';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  status: OrderStatus;
  detailsTableItems: Array<DetailsTableItem>;
  hotelInfo?: Maybe<OrderHistoryHotelInfo>;
  dPCarInfo?: Maybe<OrderDpCarInfo>;
  flightInfo?: Maybe<OrderFlightInfo>;
  supportPlanInfo?: Maybe<DpFlightSupportPlan>;
  /** すべての海外あんしんサポートプラン情報（詳細モーダルで利用） */
  supportPlans: Array<DpFlightSupportPlan>;
  cancelForAnyReasonInfo?: Maybe<OrderCancelForAnyReason>;
  cancelInfo?: Maybe<OrderCancelInfo>;
  priceInfo: OrderPriceInfoForOrderHistory;
  paymentInfo: OrderPaymentInfo;
  isClosed: Scalars['Boolean'];
  IsNotAllPassportsCompleted?: Maybe<Scalars['Boolean']>;
  /** 追加オプション */
  additionalOptionsInfo?: Maybe<AdditionalOptionsInfo>;
};

export type OrderHistoryConvenienceStorePayment = Node & {
  __typename?: 'OrderHistoryConvenienceStorePayment';
  id: Scalars['ID'];
  barcode: Scalars['String'];
  inclusivePrice: Scalars['Int'];
  convenienceStoreTransferDeadline: Scalars['String'];
};

export type OrderHistoryConvenienceStorePaymentInput = {
  orderId: Scalars['Int'];
};

export type OrderHistoryHotelInfo = IOrderHotelInfo & {
  __typename?: 'OrderHistoryHotelInfo';
  id: Scalars['ID'];
  cocolocalaHotelId: Scalars['String'];
  hotelSummary: OrderHotelSummary;
  roomSummary: OrderHotelRoomSummary;
  hotelDetail?: Maybe<OrderHotelDetail>;
  roomDetail?: Maybe<OrderHotelRoomDetail>;
  importantNotices: Array<Scalars['String']>;
  numberOfPeople: Scalars['Int'];
  targetHotelZonePath?: Maybe<Scalars['String']>;
  expediaHotelId?: Maybe<Scalars['String']>;
  /** 客室のRateID */
  selectedRateId?: Maybe<Scalars['String']>;
  /** 残りの部屋数 */
  numberOfRoomsRemaining?: Maybe<Scalars['Int']>;
  /** ホテルの在庫切れフラグ */
  isSoldOut?: Maybe<Scalars['Boolean']>;
};

export type OrderHistoryInput = {
  orderId: Scalars['Int'];
};

export type OrderHistorySummary = Node & {
  __typename?: 'OrderHistorySummary';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  labels: Array<OrderHistorySummaryLabel>;
  detailsTableItems: Array<DetailsTableItem>;
  hotelInfo?: Maybe<OrderHistorySummaryHotelInfo>;
  flightInfo?: Maybe<OrderHistorySummaryFlightInfo>;
};

export type OrderHistorySummaryFlightInfo = {
  __typename?: 'OrderHistorySummaryFlightInfo';
  /** 行き帰りの航空便情報 */
  flightInfoText: Scalars['String'];
  /** 行きのフライトの空港コード */
  goingFlightFirstAirportIata: Scalars['String'];
  /** 行きのフライトの搭乗日 */
  goingFlightDepartureDate: Scalars['String'];
  /** 行きのフライトの搭乗時刻 */
  goingFlightDepartureTime: Scalars['String'];
  /** 行きのフライトの到着日 */
  goingFlightArrivalDate: Scalars['String'];
  /** 行きのフライトの到着時刻 */
  goingFlightArrivalTime: Scalars['String'];
  /** 帰りのフライトの空港コード */
  returningFlightFirstAirportIata: Scalars['String'];
  /** 帰りのフライトの搭乗日 */
  returningFlightDepartureDate: Scalars['String'];
  /** 帰りのフライトの搭乗時刻 */
  returningFlightDepartureTime: Scalars['String'];
  /** 帰りのフライトの到着日 */
  returningFlightArrivalDate: Scalars['String'];
  /** 帰りのフライトの到着時刻 */
  returningFlightArrivalTime: Scalars['String'];
};

export type OrderHistorySummaryHotelInfo = {
  __typename?: 'OrderHistorySummaryHotelInfo';
  /** ホテル名 */
  hotelName: Scalars['String'];
  /** サムネイル画像 */
  hotelThumbnailUrl?: Maybe<Scalars['String']>;
  /** 客室名 */
  roomName: Scalars['String'];
  /** チェックイン日 */
  checkInDate: Scalars['String'];
  /** チェックアウト日 */
  checkOutDate: Scalars['String'];
  /** チェックイン可能な時間 */
  availableCheckInTimeRange: Scalars['String'];
  /** チェックアウト時間 */
  checkOutTime: Scalars['String'];
};

export type OrderHistorySummaryLabel = {
  __typename?: 'OrderHistorySummaryLabel';
  label: Scalars['String'];
  orderStatus?: Maybe<OrderStatus>;
};

export type OrderHotelDetail = {
  __typename?: 'OrderHotelDetail';
  cocolocalaHotelId: Scalars['String'];
  hotelName: Scalars['String'];
  images: Array<HotelImage>;
  summaryTitle?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  hotelLocation: Scalars['String'];
  googlePlaceReviews?: Maybe<GooglePlaceReviews>;
  summaryDescription?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  checkin?: Maybe<Checkin>;
  checkout?: Maybe<Checkout>;
  phoneNumber?: Maybe<Scalars['String']>;
  hotelAmenities: HotelAmenities;
  location: HotelLocation;
  hotelExplanation?: Maybe<HotelExplanation>;
  hotelCautions: HotelCautions;
  statics: HotelStatistics;
  websiteUrl?: Maybe<Scalars['String']>;
  hotelType?: Maybe<HotelType>;
};

export type OrderHotelPriceInfo = IOrderHotelPriceInfo & {
  __typename?: 'OrderHotelPriceInfo';
  label: Scalars['String'];
  priceDetails: Array<OrderPriceDetail>;
  propertyCollectionPriceInfo: Array<PropertyCollectionPriceInfo>;
};

export type OrderHotelRoomDetail = {
  __typename?: 'OrderHotelRoomDetail';
  roomId: Scalars['String'];
  images: Array<HotelImage>;
  roomName: Scalars['String'];
  view?: Maybe<Scalars['String']>;
  bedGroups: Array<RoomBedGroup>;
  smokingCondition: SmokingCondition;
  maxAllowedOccupancy?: Maybe<RoomMaxAllowedOccupancy>;
  hasWifi: Scalars['Boolean'];
  overview: Scalars['String'];
};

export type OrderHotelRoomSummary = {
  __typename?: 'OrderHotelRoomSummary';
  roomThumbnailUrl?: Maybe<Scalars['String']>;
  roomName: Scalars['String'];
  facilities?: Maybe<Array<HotelRoomFacility>>;
};

export type OrderHotelSummary = {
  __typename?: 'OrderHotelSummary';
  hotelThumbnailUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  hotelName: Scalars['String'];
  checkInCheckOutInfo: HotelCheckInCheckOutInfo;
};

export type OrderLogInfo = {
  __typename?: 'OrderLogInfo';
  /** ログ用のproductTypeフィールド */
  productType: Scalars['String'];
};

export type OrderPaymentInfo = {
  __typename?: 'OrderPaymentInfo';
  /** 決済手段 */
  paymentMethod: PaymentMethod;
  /** 決済手段の名前 */
  paymentMethodName: Scalars['String'];
  /** 支払い情報詳細.支払い待ち以外のときは空配列となる */
  paymentDetailItems: Array<DetailsTableItem>;
  /** 支払い情報詳細.支払い待ち以外のときは空配列となる */
  paymentUserDetailItems: Array<DetailsTableItem>;
  /** 支払い方法の説明リンク */
  howToPaymentLink?: Maybe<Scalars['String']>;
  /** 銀行振込(fincode)の支払い期限 */
  bankTransferDeadline?: Maybe<Scalars['String']>;
  /** コンビニ払い(fincode)の支払い期限 */
  convenienceStoreTransferDeadline?: Maybe<Scalars['String']>;
};

export type OrderPriceDetail = IOrderPriceDetail & {
  __typename?: 'OrderPriceDetail';
  /** ラベル */
  label: Scalars['String'];
  /** 料金 */
  value: Scalars['String'];
  /** 指定なしだと通常の表示 */
  priceType?: Maybe<PriceType>;
};

export type OrderPriceInfo = {
  /** お客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmount: Scalars['Int'];
  /** 一人当たりのお客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmountPerPerson?: Maybe<Scalars['Int']>;
  /** 割引前の合計金額 */
  strikethroughAmount?: Maybe<Scalars['Int']>;
  /** 商材の割引の金額 */
  discountAmount?: Maybe<Scalars['Int']>;
  /** 期間限定セールの商材の割引の金額 */
  limitedTimeSaleDiscountAmount?: Maybe<Scalars['Int']>;
  /** ホテルの料金内訳セクション */
  hotelPriceInfo?: Maybe<OrderHotelPriceInfo>;
  /** レンタカーの料金 */
  dPCarPriceInfo?: Maybe<OrderDpCarPriceInfo>;
  /** 航空券の料金内訳セクション */
  flightPriceInfo?: Maybe<OrderFlightPriceInfo>;
  /** サポートプランの料金内訳セクション */
  supportPlanPriceInfo?: Maybe<OrderSupportPlanPriceInfo>;
  /** 一人当たりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePricePerPerson?: Maybe<Scalars['Int']>;
  /** らくらくキャンセルの料金内訳セクション */
  cancelForAnyReasonPriceInfo?: Maybe<OrderCancelForAnyReasonPriceInfo>;
  /** 取扱手数料の料金内訳セクション */
  cocolocalaTransactionFeePriceInfo?: Maybe<OrderCocolocalaTransactionPriceInfo>;
  /** 割引の料金内訳セクション */
  discountSectionPriceInfo?: Maybe<OrderDiscountSectionPriceInfo>;
  /** 合計料金の詳細 */
  totalPriceDetails: Array<OrderPriceDetail>;
  /** 割引のラベル ex. ホテル割引 */
  discountLabel?: Maybe<Scalars['String']>;
  /** すべての料金の割引情報 */
  discountDetails: Array<OrderDiscountDetail>;
  /** applyReservation時に必要となる情報 */
  applyReservationPriceInfo?: Maybe<ApplyReservationPriceInfo>;
  /** 会員割引適用不可のメッセージを表示するか */
  displayUnAvailableMemberDiscount: Scalars['Boolean'];
};

export type OrderPriceInfoForOrderConfirm = OrderPriceInfo & {
  __typename?: 'OrderPriceInfoForOrderConfirm';
  /** お客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmount: Scalars['Int'];
  /** 一人当たりのお客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmountPerPerson: Scalars['Int'];
  /** 割引前の合計金額 */
  strikethroughAmount?: Maybe<Scalars['Int']>;
  /** 商材の割引の金額 */
  discountAmount?: Maybe<Scalars['Int']>;
  /** 期間限定セールの商材の割引の金額 */
  limitedTimeSaleDiscountAmount?: Maybe<Scalars['Int']>;
  /** キャンペーン割引の金額 */
  campaignDiscountAmount?: Maybe<Scalars['Int']>;
  /** ホテルの料金内訳セクション */
  hotelPriceInfo?: Maybe<OrderHotelPriceInfo>;
  /** 航空券の料金内訳セクション */
  flightPriceInfo: OrderFlightPriceInfo;
  /** 受託手荷物の料金内訳セクション */
  baggageOptionPriceInfo?: Maybe<BaggageOptionPriceInfo>;
  /** サポートプランの料金内訳セクション */
  supportPlanPriceInfo?: Maybe<OrderSupportPlanPriceInfo>;
  /** 一人当たりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePricePerPerson?: Maybe<Scalars['Int']>;
  /** らくらくキャンセルの料金内訳セクション */
  cancelForAnyReasonPriceInfo?: Maybe<OrderCancelForAnyReasonPriceInfo>;
  /** 取扱手数料の料金内訳セクション */
  cocolocalaTransactionFeePriceInfo?: Maybe<OrderCocolocalaTransactionPriceInfo>;
  /** 割引の料金内訳セクション */
  discountSectionPriceInfo?: Maybe<OrderDiscountSectionPriceInfo>;
  /** 合計料金の詳細 */
  totalPriceDetails: Array<OrderPriceDetail>;
  /** すべての料金の割引情報 */
  discountDetails: Array<OrderDiscountDetail>;
  /** レンタカーの料金 */
  dPCarPriceInfo?: Maybe<OrderDpCarPriceInfo>;
  /** 割引のラベル ex. ホテル割引 */
  discountLabel?: Maybe<Scalars['String']>;
  /** applyReservation時に必要となる情報 */
  applyReservationPriceInfo?: Maybe<ApplyReservationPriceInfo>;
  /** 会員割引適用不可のメッセージを表示するか */
  displayUnAvailableMemberDiscount: Scalars['Boolean'];
};

export type OrderPriceInfoForOrderHistory = OrderPriceInfo & {
  __typename?: 'OrderPriceInfoForOrderHistory';
  /** お客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmount: Scalars['Int'];
  /** 割引前の合計金額 */
  strikethroughAmount?: Maybe<Scalars['Int']>;
  /** 商材の割引の金額 */
  discountAmount?: Maybe<Scalars['Int']>;
  /** ホテルの料金内訳セクション */
  hotelPriceInfo?: Maybe<OrderHotelPriceInfo>;
  /** レンタカーの料金 */
  dPCarPriceInfo?: Maybe<OrderDpCarPriceInfo>;
  /** 航空券の料金内訳セクション */
  flightPriceInfo?: Maybe<OrderFlightPriceInfo>;
  /** 受託手荷物の料金内訳セクション */
  baggageOptionPriceInfo?: Maybe<BaggageOptionPriceInfo>;
  /** サポートプランの料金内訳セクション */
  supportPlanPriceInfo?: Maybe<OrderSupportPlanPriceInfo>;
  /** 一人当たりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePricePerPerson?: Maybe<Scalars['Int']>;
  /** らくらくキャンセルの料金内訳セクション */
  cancelForAnyReasonPriceInfo?: Maybe<OrderCancelForAnyReasonPriceInfo>;
  /** 取扱手数料の料金内訳セクション */
  cocolocalaTransactionFeePriceInfo?: Maybe<OrderCocolocalaTransactionPriceInfo>;
  /** 割引の料金内訳セクション */
  discountSectionPriceInfo?: Maybe<OrderDiscountSectionPriceInfo>;
  /** 合計料金の詳細 */
  totalPriceDetails: Array<OrderPriceDetail>;
  /** 割引のラベル ex. ホテル割引 */
  discountLabel?: Maybe<Scalars['String']>;
  /** すべての料金の割引情報 */
  discountDetails: Array<OrderDiscountDetail>;
  /** 会員割引適用不可のメッセージを表示するか */
  displayUnAvailableMemberDiscount: Scalars['Boolean'];
  /** 期間限定セールの商材の割引の金額 */
  limitedTimeSaleDiscountAmount?: Maybe<Scalars['Int']>;
  /** 一人当たりのお客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmountPerPerson?: Maybe<Scalars['Int']>;
  /** applyReservation時に必要となる情報 */
  applyReservationPriceInfo?: Maybe<ApplyReservationPriceInfo>;
};

export type OrderPriceInfoForOrderPurchase = OrderPriceInfo & {
  __typename?: 'OrderPriceInfoForOrderPurchase';
  /** お客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmount: Scalars['Int'];
  /** 割引前の合計金額 */
  strikethroughAmount?: Maybe<Scalars['Int']>;
  /** 商材の割引の金額 */
  discountAmount?: Maybe<Scalars['Int']>;
  /** 期間限定セール割引 */
  limitedTimeSaleDiscount?: Maybe<Scalars['Int']>;
  /** ホテルの料金内訳セクション */
  hotelPriceInfo?: Maybe<OrderHotelPriceInfo>;
  /** レンタカーの料金 */
  dPCarPriceInfo?: Maybe<OrderDpCarPriceInfo>;
  /** 航空券の料金内訳セクション */
  flightPriceInfo?: Maybe<OrderFlightPriceInfo>;
  /** 受託手荷物の料金内訳セクション */
  baggageOptionPriceInfo?: Maybe<BaggageOptionPriceInfo>;
  /** サポートプランの料金内訳セクション */
  supportPlanPriceInfo?: Maybe<OrderSupportPlanPriceInfo>;
  /** 一人当たりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePricePerPerson?: Maybe<Scalars['Int']>;
  /** らくらくキャンセルの料金内訳セクション */
  cancelForAnyReasonPriceInfo?: Maybe<OrderCancelForAnyReasonPriceInfo>;
  /** 取扱手数料の料金内訳セクション */
  cocolocalaTransactionFeePriceInfo?: Maybe<OrderCocolocalaTransactionPriceInfo>;
  /** 割引の料金内訳セクション */
  discountSectionPriceInfo?: Maybe<OrderDiscountSectionPriceInfo>;
  /** 合計料金の詳細 */
  totalPriceDetails: Array<OrderPriceDetail>;
  /** 割引のラベル ex. ホテル割引 */
  discountLabel?: Maybe<Scalars['String']>;
  /** すべての料金の割引情報 */
  discountDetails: Array<OrderDiscountDetail>;
  /** applyReservation時に必要となる情報 */
  applyReservationPriceInfo: ApplyReservationPriceInfo;
  /** 会員割引適用不可のメッセージを表示するか */
  displayUnAvailableMemberDiscount: Scalars['Boolean'];
  /** 期間限定セールの商材の割引の金額 */
  limitedTimeSaleDiscountAmount?: Maybe<Scalars['Int']>;
  /** キャンペーン割引の金額 */
  campaignDiscountAmount?: Maybe<Scalars['Int']>;
  /** 一人当たりのお客様がHotspringへ支払う合計金額（手数料などすべて込み） */
  totalAmountPerPerson?: Maybe<Scalars['Int']>;
};

export type OrderPurchase = Node & {
  __typename?: 'OrderPurchase';
  id: Scalars['ID'];
  /** 作成されたTravelのID */
  travelId: Scalars['Int'];
  /** 料金情報 */
  priceInfo: OrderPriceInfoForOrderPurchase;
  /** 支払い情報 */
  paymentInfo: OrderPurchasePaymentInfo;
  /** 予約時に必要なデータ */
  reservationInfo: OrderPurchaseReservationInfo;
  /** ログ用の情報 */
  logInfo: OrderLogInfo;
  /** キャンセル情報 */
  cancelInfo?: Maybe<OrderCancelInfo>;
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
  /** 選択商材のラベル情報 */
  selectedProductsSummaryLabelInfo: SelectedProductsSummaryLabelInfo;
  /** 商材タイプ */
  productType: ProductTypeV2;
  /** 海外DPサポートプラン */
  dPFlightSupportPlan?: Maybe<DpFlightSupportPlanType>;
  /** 空港送迎の利用有無 */
  useAirportTransfer: Scalars['Boolean'];
  /** 機能制限フラグ */
  isHotspringMember: Scalars['Boolean'];
};

export type OrderPurchasePaymentInfo = IOrderSignOrPurchasePaymentInfo & {
  __typename?: 'OrderPurchasePaymentInfo';
  /** コンビニ払いの支払い期限 */
  convenienceStorePaymentDeadline?: Maybe<Scalars['String']>;
  /** 銀行振込の支払い期限 */
  bankTransferDeadline?: Maybe<Scalars['String']>;
};

export type OrderPurchaseReservationInfo = {
  __typename?: 'OrderPurchaseReservationInfo';
  /** Expediaの予約に必要な情報 */
  hotelReservationInfo?: Maybe<HotelReservationInfo>;
  /** DPレンタカーの予約のときに必要な情報 */
  dPCarReservationInfo?: Maybe<DpCarReservationInfo>;
  /** 航空券の予約のときに必要な情報 */
  flightReservationInfo?: Maybe<FlightReservationInfo>;
};

export type OrderReservationInformation = {
  __typename?: 'OrderReservationInformation';
  /** 人数 ex. 2 */
  numberOfPeople: Scalars['Int'];
  /** 海外DPフラグ */
  isDP: Scalars['Boolean'];
  /** パスポート情報入力必要有無 */
  passportRequirement: PassportRequirement;
  /** 選択商材のラベル情報 */
  selectedProductsSummaryLabelInfo: SelectedProductsSummaryLabelInfo;
  /** 一人当たりの税込のキャンセル保証料 */
  cancelForAnyReasonInclusivePricePerPerson?: Maybe<Scalars['Int']>;
  /** 海外あんしんサポートプラン情報 */
  supportPlan?: Maybe<DpFlightSupportPlan>;
  /** すべての海外あんしんサポートプラン情報（詳細モーダルで利用） */
  supportPlans: Array<DpFlightSupportPlan>;
  /** キャンセル保証情報 */
  hasCancelForAnyReason?: Maybe<Scalars['Boolean']>;
  /** 合計料金と一人当たりの料金 */
  priceInfo: OrderReservationInformationPriceInfo;
  /** 予約時に購入可能な受託手荷物オプション */
  baggageOptionInfo?: Maybe<BaggageOptionInfo>;
  /** 選択済みの受託手荷物オプション */
  selectedBaggageOptionInfo?: Maybe<OrderConfirmOrReservationInformationSelectedBaggageOptionInfo>;
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
  /** 国籍の選択肢一覧 */
  nationalityOptions: Array<NationalityOption>;
  /** 出発日 (YYYY-MM-DD) */
  departureDateText: Scalars['String'];
  /** 旅客情報フォームに再入力するための情報 */
  presetFormOrderReservationInformation?: Maybe<PresetFormOrderReservationInformation>;
  /** 機能制限フラグ */
  isHotspringMember: Scalars['Boolean'];
};

export type OrderReservationInformationInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
};

export type OrderReservationInformationPriceInfo = {
  __typename?: 'OrderReservationInformationPriceInfo';
  totalAmount: Scalars['Int'];
  totalAmountPerPerson: Scalars['Int'];
  flightBaggageOptionInclusivePrice?: Maybe<Scalars['Int']>;
  cocolocalaTransactionFeeAndTaxText: Scalars['String'];
};

export type OrderReserveInfo = {
  __typename?: 'OrderReserveInfo';
  hotelId: Scalars['String'];
  roomId: Scalars['String'];
  rateId: Scalars['String'];
  bedGroupId?: Maybe<Scalars['String']>;
  checkinDate: Scalars['String'];
  checkoutDate: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  childAges: Array<Scalars['Int']>;
  isMember?: Maybe<Scalars['Boolean']>;
  salesChannel?: Maybe<Scalars['String']>;
  reservationPrice: Scalars['Int'];
  lastName: Scalars['String'];
  firstName: Scalars['String'];
  smoking?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
};

export type OrderSign = Node & {
  __typename?: 'OrderSign';
  id: Scalars['ID'];
  /** ログ用の情報 */
  logInfo: OrderLogInfo;
};

export type OrderSignInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  /** Order作成時 */
  BeforePayment = 'BEFORE_PAYMENT',
  /** 銀行, コンビニの支払い待ち又はクレカ決済時の過程 */
  Paying = 'PAYING',
  /** 銀行, コンビニの支払い済み又はクレカ決済時の過程 */
  Paid = 'PAID',
  /** 決済後の予約確定成功 */
  Reserved = 'RESERVED',
  /** 未使用 */
  Departured = 'DEPARTURED',
  /** 未使用 */
  Finished = 'FINISHED',
  /** 予約キャンセル */
  Canceled = 'CANCELED',
  /** トランザクション処理中(未使用？) */
  InTransaction = 'IN_TRANSACTION',
  /** 不正 */
  Invalid = 'INVALID',
  /** 3Dセキュア中 */
  ThreeDSecure = 'THREE_D_SECURE',
  /** 予約確定待ち */
  BeforeReserved = 'BEFORE_RESERVED',
  /** 支払い期限切れ */
  PaymentExpired = 'PAYMENT_EXPIRED'
}

export type OrderSummary = {
  __typename?: 'OrderSummary';
  /** orderId */
  id: Scalars['Int'];
  /** 予約ステータス */
  status: OrderStatus;
  /** 商材: ex. ホテル単体／レンタカー＋ホテル */
  productTypeText: Scalars['String'];
  /** 旅行日程: ex. 2022/12/12 ~ 2022/12/13 */
  checkInAndCheckOutDate: Scalars['String'];
  /** 合計料金: ex. ¥123,456 */
  totalAmount: Scalars['String'];
  appliedAt: Scalars['String'];
};

export type OrderSupportPlanInfo = IOrderSupportPlanInfo & {
  __typename?: 'OrderSupportPlanInfo';
  /** 海外あんしんサポートプランのタイプ */
  supportPlanType: DpFlightSupportPlanType;
};

export type OrderSupportPlanPriceInfo = IOrderSupportPlanPriceInfo & {
  __typename?: 'OrderSupportPlanPriceInfo';
  label: Scalars['String'];
  priceDetails: Array<OrderPriceDetail>;
};

export type OrderTodoList = {
  __typename?: 'OrderTodoList';
  todoList: Array<Todo>;
};

export type OrderTodoListInput = {
  orderId: Scalars['Int'];
};

export type OrdersInput = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  statuses?: Maybe<OrderStatus>;
  userId?: Maybe<Scalars['Int']>;
  hotelId?: Maybe<Scalars['Int']>;
  paymentId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  expediaExternalId?: Maybe<Scalars['String']>;
};

export type OverseasDpFlight = Node & {
  __typename?: 'OverseasDPFlight';
  id: Scalars['ID'];
  /** OverseasDPFlightの静的な情報 */
  overseasDPFlightInfo?: Maybe<OverseasDpFlightInfo>;
  /** まとめて検索のタブ(Zone)の情報 */
  overseasDPFlightTabs: Array<OverseasDpFlightTabs>;
};

export type OverseasDpFlightBulkSearchInput = {
  tabIndex: Scalars['Int'];
  goingCityOrAirportIATACode: Scalars['String'];
  goingDate?: Maybe<Scalars['String']>;
  returningDate?: Maybe<Scalars['String']>;
  numberOfAdults: Scalars['Int'];
  childAges: Array<Scalars['Int']>;
};

export type OverseasDpFlightInfo = {
  __typename?: 'OverseasDPFlightInfo';
  /** 出発地の空港リスト */
  departureAirports: Array<AirportSection>;
  /** 目的地の空港リスト */
  arrivalAirports: Array<AirportSection>;
  /** 海外あんしんサポートのプラン情報 */
  dPFlightSupportPlans: Array<DpFlightSupportPlan>;
  /** 人気の旅行先 */
  recommendedTravelDestinations: Array<TravelDestination>;
  parentsOfEachTravelDestination: Array<TravelDestination>;
  /** エリアから探す */
  groupedTravelDestination: Array<GroupedTravelDestination>;
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
};

export type OverseasDpFlightInput = {
  cacheOnly: Scalars['Boolean'];
  bulkSearch?: Maybe<OverseasDpFlightBulkSearchInput>;
};

export type OverseasDpFlightTabZone = {
  __typename?: 'OverseasDPFlightTabZone';
  countryName: Scalars['String'];
  cityName?: Maybe<Scalars['String']>;
  zonePath: Scalars['String'];
  zoneImageUrl: Scalars['String'];
  numberOfStays: Scalars['Int'];
  minimumPricePerPerson?: Maybe<Scalars['Int']>;
  goingDate?: Maybe<Scalars['String']>;
  returningDate?: Maybe<Scalars['String']>;
  goingCityOrAirportIATACode: Scalars['String'];
  returningCityOrAirportIATACode: Scalars['String'];
  numberOfAdults: Scalars['Int'];
  childAges: Array<Scalars['Int']>;
  minimumFlightPrice?: Maybe<Scalars['Int']>;
  vacantHotels: Array<VacantHotelsForDpFlightHotelDetail>;
};

export type OverseasDpFlightTabs = {
  __typename?: 'OverseasDPFlightTabs';
  label: Scalars['String'];
  zones: Array<OverseasDpFlightTabZone>;
};

export type OverseasInformation = {
  __typename?: 'OverseasInformation';
  /** ヘッダー/OGP画像URL */
  headerImageUrl: Scalars['String'];
  /** 最終更新日時. ex. 2021年12月13日 */
  updatedAt: Scalars['String'];
  /** スライド画像 */
  slideImageUrls: Array<Scalars['String']>;
  /** 現在の海外旅行の状況 */
  internationalTravelSituation: InternationalTravelSituation;
  /** おすすめの時期の説明 */
  recommendedSeason: RecommendedSeason;
  /** 「withコロナ時代の海外旅行」のセクションで表示する情報 */
  safetyTravelInformation: SafetyTravelInformation;
  /** おすすめの旅行先 */
  recommendedTravelDestinations: Array<RecommendedTravelDestination>;
};

export type OverseasTop = {
  __typename?: 'OverseasTop';
  /** ページ上部のカルーセルと下部のキャンペーンのバナー */
  campaignBanners: Array<CampaignBanner>;
  /** いま人気の海外旅行先セクションの見出し */
  popularAreaDescription: PopularAreaDescription;
  /** いま人気の海外旅行先一覧 */
  popularAreas: Array<OverseasTopArea>;
  /** いま人気の海外エリア */
  popularDestinations: Array<PopularDestination>;
};

export type OverseasTopArea = {
  __typename?: 'OverseasTopArea';
  name: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  path: Scalars['String'];
};

export type OverseasZoneDpFlight = Node & {
  __typename?: 'OverseasZoneDPFlight';
  id: Scalars['ID'];
  /** ヘッダー画像 */
  imageUrl: Scalars['String'];
  /** 最低料金目安 */
  referenceMinimumPrice?: Maybe<Scalars['String']>;
  /** 出発地の空港リスト */
  departureAirports: Array<AirportSection>;
  /** 目的地の空港リスト */
  arrivalAirports: Array<AirportSection>;
  /** 目的地のIATAコード ex. TYO */
  returningCityOrAirportIATACode: Scalars['String'];
  /** 子供の都市を返す 無ければ空配列 */
  cities: Array<TravelDestination>;
  /** ゾーン名 */
  zoneName: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** 親のゾーン情報 パンクズ用 */
  parentZoneInfo?: Maybe<ZoneInfo>;
  /** 旅行の歯やすさの点数. 1~5点 */
  travelStatus?: Maybe<TravelStatus>;
  /** おすすめの宿泊日数 */
  recommendedStayDays: Scalars['Int'];
  /** 最安値日程 ex. 2023-03-30 */
  lowestPriceSchedule: FlightSchedule;
  /** 海外あんしんサポートのプラン情報 */
  dPFlightSupportPlans: Array<DpFlightSupportPlan>;
  /** 人気の旅行先 */
  recommendedTravelDestinations: Array<TravelDestination>;
  /** テーマが存在するかどうか */
  existsDPFlightThemes: Scalars['Boolean'];
  /** 事前確認事項 */
  priorConfirmation?: Maybe<Scalars['String']>;
  /** ホテルリスト */
  hotels: Array<HotelData>;
  /** ホテルのタブ情報 */
  hotelTabs: Array<HotelTab>;
  /** テーマ一覧 */
  travelThemes: Array<TravelTheme>;
  /** 基本情報 */
  basicInformation?: Maybe<ZoneBasicInfomration>;
  /** 出国のための事前準備 */
  travelPreparationForDeparture?: Maybe<Scalars['String']>;
  /** 帰国のための事前準備 */
  travelPreparationForReturn?: Maybe<Scalars['String']>;
  /** 期間限定セールに関する情報 */
  limitedTimeSaleInfo?: Maybe<LimitedTimeSaleInfo>;
  /** キャンペーンに関する情報 */
  campaignInfo?: Maybe<CampaignInfo>;
};

export type OverseasZoneDpFlightInput = {
  zoneNameEn: Scalars['String'];
  country: Scalars['String'];
};

export type OverseasZoneInformation = {
  __typename?: 'OverseasZoneInformation';
  /** ゾーン名 */
  zoneName: Scalars['String'];
  /** 地域のパス ex. /us/hawaii */
  zonePath: Scalars['String'];
  /** OGP画像URL */
  ogpImageUrl: Scalars['String'];
  /** ヘッダー/OGP画像URL */
  headerImageUrl: Scalars['String'];
  /** 最終更新日時. ex. 2021年12月13日 */
  updatedAt: Scalars['String'];
  /** スライド画像 */
  slideImageUrls: Array<Scalars['String']>;
  /** 現在の海外旅行の状況 */
  internationalTravelSituation: TravelSituationForZone;
  /** おすすめの時期の説明 */
  recommendedSeason: RecommendedSeasonForZone;
  /** 旅行の流れの情報 */
  travelSteps: Array<ExpandableContentsSection>;
  /** おすすめの旅行先 */
  recommendedTravelDestinations: Array<RecommendedTravelDestination>;
  /** 最近の旅行先の画像 */
  recentImages: Array<InstagramImage>;
  /** 海外DPの予約導線を表示するかどうか */
  showRecommendReservation: Scalars['Boolean'];
  /** テーマを持っているか */
  hasThemes: Scalars['Boolean'];
};

export type OverseasZoneInformationInput = {
  /** 国や都市名 */
  zoneNameEn: Scalars['String'];
};

export type Pagination = IPagination & {
  __typename?: 'Pagination';
  /** 次のページがあるか */
  hasNext: Scalars['Boolean'];
  /** 次のオフセット */
  nextOffset?: Maybe<Scalars['Int']>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  /** 合計アイテム数 */
  total: Scalars['Int'];
  /** レスポンスの数 */
  resultCount: Scalars['Int'];
  /** 1ページのサイズ */
  paginationSize: Scalars['Int'];
  /** 現在のページ数 */
  page: Scalars['Int'];
};

export type PaginationInput = {
  /** 取得するデータのオフセット */
  offset: Scalars['Int'];
  /** 1ページでの件数 */
  limit: Scalars['Int'];
};

export type PaginationV2 = {
  __typename?: 'PaginationV2';
  /** 次のページがあるか */
  hasNext: Scalars['Boolean'];
  /** 次のページ */
  nextPage: Scalars['Int'];
  /** 次のページのどの位置から取得するか */
  nextIndex: Scalars['Int'];
};

export type PaginationV2Input = {
  /** 取得するページ */
  page: Scalars['Int'];
  /** ページのどの位置から取得するか */
  index: Scalars['Int'];
  /** 1ページでの件数 */
  limit: Scalars['Int'];
};

/** ページネーションに最大ページ数と現在のページ数を返す情報を追加したデータ型 */
export type PaginationWithPageInfo = IPagination & {
  __typename?: 'PaginationWithPageInfo';
  /** 次のページがあるか */
  hasNext: Scalars['Boolean'];
  /** 次のオフセット */
  nextOffset?: Maybe<Scalars['Int']>;
  /** 合計アイテム数 */
  total: Scalars['Int'];
  /** 1ページのサイズ */
  paginationSize: Scalars['Int'];
};

export type Passenger = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: DpFlightBirthdayOrPassportExpiryInput;
  nationality: Scalars['String'];
  passport?: Maybe<Passport>;
  isRepresentative: Scalars['Boolean'];
  /** 旅客単位の受託手荷物オプション */
  selectedBaggageOption?: Maybe<SelectedBaggageOptionInfoInput>;
};

export type PassengerNameRecord = Node & {
  __typename?: 'PassengerNameRecord';
  id: Scalars['ID'];
};

export type PassengerNameRecordInput = {
  controlNumber: Scalars['String'];
};

export type Passport = {
  passportNumber: Scalars['String'];
  passportExpiry: DpFlightBirthdayOrPassportExpiryInput;
  passportIssuingCountry: Scalars['String'];
};

export type PassportInformation = Node & {
  __typename?: 'PassportInformation';
  id: Scalars['ID'];
  vendor: Scalars['String'];
  /** 搭乗者情報 */
  passengers: Array<FlightPassenger>;
  /** 全旅客の受託手荷物オプション */
  selectedBaggageOption?: Maybe<SelectedBaggageOptionInfo>;
  /** 国籍の選択肢一覧 */
  nationalityOptions: Array<NationalityOption>;
  /** 出発日 (YYYY-MM-DD) */
  departureDateText: Scalars['String'];
};

export type PassportInformationInput = {
  orderId: Scalars['Int'];
};

export enum PassportRequirement {
  /** 予約前に必要 */
  RequiredBeforeReservation = 'RequiredBeforeReservation',
  /** 後入れ */
  RequiredAfterReservation = 'RequiredAfterReservation',
  /** 不要 */
  NotRequired = 'NotRequired'
}

export enum PathType {
  Prefecture = 'prefecture',
  Region = 'region',
  District = 'district',
  Area = 'area'
}

export type PayEasyPaymentDetail = {
  __typename?: 'PayEasyPaymentDetail';
  agencyCode: Scalars['String'];
  customerCode: Scalars['String'];
  /** ペイジー払いの支払い期限 */
  payEasyPaymentDeadline: Scalars['String'];
};

/** 決済手段 */
export enum PaymentMethod {
  CreditCard = 'CreditCard',
  BankTransferFincode = 'BankTransferFincode',
  ConvenienceStoreTransferFincode = 'ConvenienceStoreTransferFincode',
  PayEasy = 'PayEasy',
  ConvenienceStore = 'ConvenienceStore'
}

export enum PaymentStatusEnum {
  Created = 'CREATED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Refunded = 'REFUNDED',
  Declined = 'DECLINED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  Unknown = 'UNKNOWN'
}

export type Phone = {
  countryCode: Scalars['String'];
  areaCode: Scalars['String'];
  number: Scalars['String'];
};

/** プラン情報 */
export type Plan = Node & {
  __typename?: 'Plan';
  id: Scalars['ID'];
  /** プランID */
  planId: Scalars['Int'];
  /** プランタイトル */
  title: Scalars['String'];
  /** 旅行プランでまわることになるエリアを総称するような情報。 */
  areaName: Scalars['String'];
  /** プランに紐づく地方名 */
  regions: Array<PlanRegion>;
  /** プランに紐づく都道府県情報 */
  prefectures: Array<PlanPrefecture>;
  /** プランに紐づく地域情報 */
  districts: Array<PlanDistrict>;
  /** 旅行プラン全体に関連する画像オブジェクトの配列 */
  summaryImages: Array<PlanImage>;
  /** プランをnoIndexさせるか */
  noIndex: Scalars['Boolean'];
  /** 他社メディアと連携している場合に提供元などが記載される。 */
  producedBy?: Maybe<Scalars['String']>;
  /** モデルコースの表示要素 日ごとの配列になっている */
  modelCourseItemsPerDays: Array<PlanModelCourseItemsPerDay>;
  /** スタッフのおすすめひとことコメント */
  comments: Array<Scalars['String']>;
  /** 宿泊数 */
  numberOfStays: Scalars['Int'];
  /** プランに紐づくホテル情報 */
  hotels: Array<PlanHotel>;
  /** 周辺エリアのプラン情報 */
  nearDistrictPlans: Array<PlanSummary>;
  /** プランの所属する都道府県のホテル */
  prefectureHotels: Array<HotelSummaryForHotel>;
};

/** プランに紐づく地域情報 */
export type PlanDistrict = {
  __typename?: 'PlanDistrict';
  /** 地域ID */
  id: Scalars['Int'];
  /** 地域名 */
  name: Scalars['String'];
};

/** プランに紐づくホテル情報 */
export type PlanHotel = {
  __typename?: 'PlanHotel';
  /** ホテルID */
  hotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** 厳選ポイント */
  speciality?: Maybe<Scalars['String']>;
  /** ホテルの魅力をざっくりと */
  popText?: Maybe<Scalars['String']>;
  /** ホテルの部屋画像 */
  images: Array<PlanImage>;
  /** スタッフのひとことコメント */
  comments: Array<Scalars['String']>;
  /** そこでできることのひとことまとめ */
  summaryTitle?: Maybe<Scalars['String']>;
  /** 最低料金 */
  minimumPrice?: Maybe<Scalars['Int']>;
};

/** プラン関連画像情報 */
export type PlanImage = {
  __typename?: 'PlanImage';
  /** アップロードされた画像アセットのURL */
  url: Scalars['String'];
  /** 画像幅px */
  width?: Maybe<Scalars['Int']>;
  /** 画像高さpx */
  height?: Maybe<Scalars['Int']>;
  /** 出典元テキスト */
  creditText?: Maybe<Scalars['String']>;
  /** 出典元画像ロゴURL */
  creditImageUrl?: Maybe<Scalars['String']>;
  /** 出典元URL */
  creditLinkUrl?: Maybe<Scalars['String']>;
};

/** planクエリのInput */
export type PlanInput = {
  /** プランID */
  planId: Scalars['Int'];
};

/** プランにひもづくモデルコースのアイテム要素 */
export type PlanModelCourseItem = SpotModelCourseItem | NormalModelCourseItem;

/** プランにひもづくモデルコースのアイテムタイプ */
export enum PlanModelCourseItemType {
  /** テキスト、テキストと画像などの汎用的な表示要素 */
  Normal = 'Normal',
  /** スポット要素 */
  Spot = 'Spot'
}

/** ○日目のモデルコースの表示要素 */
export type PlanModelCourseItemsPerDay = {
  __typename?: 'PlanModelCourseItemsPerDay';
  /** モデルコースの該当日 * ex. day: 1 -> 1日目 */
  day: Scalars['Int'];
  modelCourseItems: Array<PlanModelCourseItem>;
};

/** プランに紐づく都道府県情報 */
export type PlanPrefecture = {
  __typename?: 'PlanPrefecture';
  /** 都道府県名 */
  name: Scalars['String'];
  /** 都道府県名（アルファベット） */
  nameAlphabet: Scalars['String'];
};

/** プランに紐づく地方情報 */
export type PlanRegion = {
  __typename?: 'PlanRegion';
  /** 地方名 */
  name: Scalars['String'];
  /** 地方名（アルファベット） */
  nameAlphabet: Scalars['String'];
};

/** プラン概要情報 */
export type PlanSummary = Node & {
  __typename?: 'PlanSummary';
  id: Scalars['ID'];
  /** プランID */
  planId: Scalars['Int'];
  /** プランタイトル */
  title: Scalars['String'];
  /** 旅行プランでまわることになるエリアを総称するような情報。 */
  areaName: Scalars['String'];
  /** サムネイル画像のURL */
  thumbnailUrl: Scalars['String'];
};

export type PlanSummaryForHotel = Node & {
  __typename?: 'PlanSummaryForHotel';
  id: Scalars['ID'];
  /** プランID */
  planId: Scalars['String'];
  /** タイトル */
  title: Scalars['String'];
  /** エリア名 */
  areaName: Scalars['String'];
  /** サムネイル画像 */
  thumbnailUrls: Array<Scalars['String']>;
};

export type PopularAreaDescription = {
  __typename?: 'PopularAreaDescription';
  description: Scalars['String'];
  thumbnailUrl: Scalars['String'];
};

export type PopularDestination = {
  __typename?: 'PopularDestination';
  /** 名前 */
  label: Scalars['String'];
  /** 絶対パス ex) /chiba/d80/a406/hotels */
  path: Scalars['String'];
};

export type PopularSpot = {
  __typename?: 'PopularSpot';
  /** ID */
  id: Scalars['Int'];
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリア名 */
  areaName: Scalars['String'];
  /** 都道府県のID */
  prefectureId: Scalars['Int'];
  /** 都道府県名 */
  prefectureName: Scalars['String'];
  /** カテゴリのID */
  categoryChildId?: Maybe<Scalars['Int']>;
  /** スポット名 */
  name: Scalars['String'];
  /** レーティング Int or Float */
  rating: Scalars['String'];
  /** データの参照元サービスのID */
  relationalServiceIds?: Maybe<RelationalServiceIds>;
  /** 説明文 */
  description?: Maybe<Scalars['String']>;
  /** 距離 */
  distance?: Maybe<Scalars['String']>;
  /** 画像のURL */
  imageUrls: Array<Scalars['String']>;
};

export type PrepareReservationViaFincodeInput = {
  /** 決済手段問わず共通で使用するデータ */
  shared: ReservationSharedInput;
  /** 決済手段 */
  paymentMethod: PaymentMethod;
  /** fincodeのトークン */
  token: Scalars['String'];
  /** ホテルの予約情報 */
  hotelReservationInfo?: Maybe<HotelReservationInput>;
  /** 外部サービスの予約情報 */
  flightExternalReservationInfo?: Maybe<FlightExternalReservationInput>;
  /** らくらくキャンセルの情報 */
  cancelForAnyReasonInfo?: Maybe<CancelForAnyReasonInput>;
  /** 海外DPあんしんサポートプラン */
  dPFlightSupportPlan?: Maybe<DpFlightSupportPlanType>;
  /** 空港送迎の有無 */
  useAirportTransfer?: Maybe<Scalars['Boolean']>;
};

export type PrepareReservationViaFincodePayload = Node & {
  __typename?: 'PrepareReservationViaFincodePayload';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  /** 3Dセキュアパスワード入力画面へ遷移するためのURL */
  acsUrl: Scalars['String'];
};

export type PrepareReservationViaStripeInput = {
  /** 決済手段問わず共通で使用するデータ */
  shared: ReservationSharedInput;
  /** 決済手段 */
  paymentMethod: PaymentMethod;
  /** Stripeから取得したID */
  paymentMethodId: Scalars['String'];
  /** ホテルの予約情報 */
  hotelReservationInfo?: Maybe<HotelReservationInput>;
  /** レンタカーの予約情報 */
  dPCarReservationInfo?: Maybe<DpCarReservationInput>;
  /** 外部サービスの予約情報 */
  flightExternalReservationInfo?: Maybe<FlightExternalReservationInput>;
  /** らくらくキャンセルの情報 */
  cancelForAnyReasonInfo?: Maybe<CancelForAnyReasonInput>;
  /** 海外DPあんしんサポートプラン */
  dPFlightSupportPlan?: Maybe<DpFlightSupportPlanType>;
  /** 空港送迎の有無 */
  useAirportTransfer?: Maybe<Scalars['Boolean']>;
};

export type PrepareReservationViaStripeNeed3DSecure = {
  __typename?: 'PrepareReservationViaStripeNeed3DSecure';
  clientSecretKey: Scalars['String'];
};

export type PrepareReservationViaStripePayload = Node & {
  __typename?: 'PrepareReservationViaStripePayload';
  id: Scalars['ID'];
  orderId: Scalars['Int'];
  /** 3Dセキュアが必要なケースの情報 */
  need3DSecure?: Maybe<PrepareReservationViaStripeNeed3DSecure>;
  /** 3Dセキュアが不要なケースの情報(決済済み) */
  without3DSecure?: Maybe<ApplyReservationPayload>;
};

export type PresetFormOrderReservationBaggageOption = {
  __typename?: 'PresetFormOrderReservationBaggageOption';
  /** 受託手荷物のValue: 1, 2, 3 */
  goingBaggageOptionValue?: Maybe<Scalars['Int']>;
  returningBaggageOptionValue?: Maybe<Scalars['Int']>;
  roundBaggageOptionValue?: Maybe<Scalars['Int']>;
};

export type PresetFormOrderReservationInformation = {
  __typename?: 'PresetFormOrderReservationInformation';
  passengers: Array<PresetFormOrderReservationPassenger>;
  /** 旅客全体に対する手荷物情報 */
  selectedBaggageOption?: Maybe<PresetFormOrderReservationBaggageOption>;
};

export type PresetFormOrderReservationPassenger = {
  __typename?: 'PresetFormOrderReservationPassenger';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender: DpFlightGender;
  birthday: BirthdayOrPassportExpiry;
  /** 3レター国コード */
  nationality: Scalars['String'];
  selectedBaggageOption?: Maybe<PresetFormOrderReservationBaggageOption>;
  passport?: Maybe<FlightPassengerPassport>;
};

export enum PriceCheckStatus {
  Matched = 'MATCHED',
  PriceChanged = 'PRICE_CHANGED',
  SoldOut = 'SOLD_OUT'
}

/** 料金タイプ */
export enum PriceType {
  Discounted = 'DISCOUNTED',
  Subtotal = 'SUBTOTAL',
  SubtotalWithDiscounted = 'SUBTOTAL_WITH_DISCOUNTED'
}

export type Pricing = {
  __typename?: 'Pricing';
  /** 税・サービス代込料金 */
  inclusive: CurrencyData;
  /** 税・サービス代抜き料金 */
  exclusive?: Maybe<CurrencyData>;
  /** 割引前料金 */
  strikethrough?: Maybe<CurrencyData>;
  /** 割引率 */
  discountRate?: Maybe<Scalars['Float']>;
};

export enum ProductType {
  /** ホテル */
  Hotel = 'HOTEL',
  /** 海外航空券 */
  Flight = 'FLIGHT',
  /** レンタカーDP */
  DpCar = 'DP_CAR',
  /** 海外航空券DP */
  DpFlight = 'DP_FLIGHT'
}

export enum ProductTypeV2 {
  /** 国内ホテル単体 */
  DomesticHotel = 'DOMESTIC_HOTEL',
  /** 海外ホテル単体 */
  OverseasHotel = 'OVERSEAS_HOTEL',
  /** 海外航空券単体 */
  OverseasFlight = 'OVERSEAS_FLIGHT',
  /** 国内レンタカーDP */
  DomesticDpCar = 'DOMESTIC_DP_CAR',
  /** 海外航空券DP */
  OverseasDpFlight = 'OVERSEAS_DP_FLIGHT'
}

export type Promotions = {
  __typename?: 'Promotions';
  deal: Deal;
};

export type PropertyCollectionPriceInfo = IOrderPriceDetail & {
  __typename?: 'PropertyCollectionPriceInfo';
  /** ラベル */
  label: Scalars['String'];
  /** 料金 */
  value: Scalars['String'];
  /** 現地支払タイプ */
  type: PropertyCollectionPriceType;
};

export enum PropertyCollectionPriceType {
  MandatoryTax = 'MANDATORY_TAX',
  ResortFee = 'RESORT_FEE',
  MandatoryFee = 'MANDATORY_FEE'
}

export type Query = {
  __typename?: 'Query';
  adminCheckPriceBy: AdminCheckPriceBy;
  adminDPFlightTheme: AdminDpFlightTheme;
  adminDPFlightThemeZones: Array<AdminDpFlightThemeZone>;
  adminDPFlightThemes: AdminDpFlightThemes;
  adminTemporarySuspendedFlightCarriers: AdminTemporarySuspendedFlightCarriers;
  order: AdminOrder;
  orders: Array<OrderSummary>;
  passengerNameRecord: PassengerNameRecord;
  reservedCar: ReservedCar;
  myHotelBookmark: MyHotelBookmark;
  myHotelBookmarkHotels: MyHotelBookmarkHotels;
  userCoupons: Array<Coupon>;
  dPCarVendors: Array<DpCarVendor>;
  dPFlightCancelForAnyReason: DpFlightCancelForAnyReason;
  dPFlightTheme: DpFlightTheme;
  dPFlightThemes: DpFlightThemes;
  flightOptions: FlightOptions;
  flightsForDPFlight: FlightsForDpFlight;
  hotelsForDPFlightThemes: HotelsForDpFlightThemes;
  latestReservedReservationInfo: LatestReservedReservationInfo;
  overseasDPFlight: OverseasDpFlight;
  overseasDPFlightPlans: Array<DpFlightSupportPlan>;
  overseasZoneDPFlight: OverseasZoneDpFlight;
  returningFlightsForDPFlight?: Maybe<ReturningFlightsForDpFlight>;
  vacantHotelForDPFlight: VacantHotelForDpFlight;
  vacantHotelsForDPFlight: VacantHotelsForDpFlight;
  airport: Airport;
  airports: Airports;
  airportsForDPFlightThemes: AirportsForDpFlightThemes;
  goingFlights: Flights;
  returningFlights: Flights;
  aroundVacantHotels: AroundVacantHotels;
  /** ホテル情報を取得する */
  hotel: Hotel;
  /** ホテルの最低料金カレンダー情報 */
  hotelMinimumPriceCalendar: HotelMinimumPriceCalendar;
  /** 指定したゾーンのホテルの検索結果 */
  hotels: Hotels;
  /** inputで渡されたこころからのホテルのIDの周辺のレンタカーを検索し、最も安い料金を返す */
  minimumDPCarPriceInfo: DpCarPriceInfo;
  /** 単一のホテルを空室検索する */
  vacantHotel: VacantHotel;
  vacantHotelRooms: VacantHotelRooms;
  /** 指定したゾーンのホテルの空室検索結果 */
  vacantHotels: VacantHotels;
  incrementalSearch: IncrementalSearch;
  overseasInformation: OverseasInformation;
  overseasZoneInformation: OverseasZoneInformation;
  couponCode: CouponCode;
  dPFlightCancelForAnyReasonForOrderConfirm: DpFlightCancelForAnyReasonForOrderConfirm;
  dPFlightSupportPlanForOrderConfirm: DpFlightSupportPlanForOrderConfirm;
  flightTicketStatus: FlightTicketStatus;
  hotelForOrderConfirm: HotelForOrderConfirm;
  hotelTabsForOrderConfirm: HotelTabsForOrderConfirm;
  ogpImageForOrderConfirm: OgpImageForOrderConfirm;
  orderComplete: OrderComplete;
  orderConfirm: OrderConfirm;
  orderHistory: OrderHistory;
  orderHistoryConvenienceStorePayment: OrderHistoryConvenienceStorePayment;
  orderHistorySummaries: Array<OrderHistorySummary>;
  orderPurchase: OrderPurchase;
  orderReservationInformation: OrderReservationInformation;
  orderSign: OrderSign;
  orderTodoList: OrderTodoList;
  passportInformation: PassportInformation;
  returningFlightsForOrderConfirm: ReturningFlightsForOrderConfirm;
  selectedProductsSummary: SelectedProductsSummary;
  /** プラン情報を取得する */
  plan: Plan;
  /** 人気のプラン一覧情報を取得する */
  popularPlans: Array<PlanSummary>;
  hotelReviews: HotelReviews;
  myReview: MyReview;
  myReviews: MyReviews;
  review: Review;
  reviewItems: ReviewItems;
  spot: Spot;
  spots: Spots;
  jpTopPage: JpTopPage;
  overseasTop: OverseasTop;
  topPage: TopPage;
  childZones: Array<Maybe<GqlZoneType>>;
};


export type QueryAdminCheckPriceByArgs = {
  input: AdminCheckPriceByInput;
};


export type QueryAdminDpFlightThemeArgs = {
  input: AdminDpFlightThemeInput;
};


export type QueryAdminDpFlightThemesArgs = {
  input: AdminDpFlightThemesInput;
};


export type QueryOrderArgs = {
  input: AdminOrderInput;
};


export type QueryOrdersArgs = {
  input: OrdersInput;
};


export type QueryPassengerNameRecordArgs = {
  input: PassengerNameRecordInput;
};


export type QueryReservedCarArgs = {
  input: ReservedCarInput;
};


export type QueryMyHotelBookmarkArgs = {
  input: MyHotelBookmarkInput;
};


export type QueryMyHotelBookmarkHotelsArgs = {
  input: MyHotelBookmarkHotelsInput;
};


export type QueryDpCarVendorsArgs = {
  input: FilterAvailableDpCarVendorsInput;
};


export type QueryDpFlightThemeArgs = {
  input: DpFlightThemeInput;
};


export type QueryDpFlightThemesArgs = {
  input: DpFlightThemesInput;
};


export type QueryFlightOptionsArgs = {
  input: FlightOptionsInput;
};


export type QueryFlightsForDpFlightArgs = {
  input: FlightsForDpFlightInput;
};


export type QueryHotelsForDpFlightThemesArgs = {
  input: HotelsForDpFlightThemesInput;
};


export type QueryOverseasDpFlightArgs = {
  input: OverseasDpFlightInput;
};


export type QueryOverseasZoneDpFlightArgs = {
  input: OverseasZoneDpFlightInput;
};


export type QueryReturningFlightsForDpFlightArgs = {
  input: ReturningFlightsForDpFlightInput;
};


export type QueryVacantHotelForDpFlightArgs = {
  input: VacantHotelForDpFlightInput;
};


export type QueryVacantHotelsForDpFlightArgs = {
  input: VacantHotelsForDpFlightInput;
};


export type QueryAirportArgs = {
  input: AirportInput;
};


export type QueryAirportsForDpFlightThemesArgs = {
  input: AirportsForDpFlightThemesInput;
};


export type QueryGoingFlightsArgs = {
  input: GoingFlightsInput;
};


export type QueryReturningFlightsArgs = {
  input: ReturningFlightsInput;
};


export type QueryAroundVacantHotelsArgs = {
  input: AroundVacantHotelsInput;
};


export type QueryHotelArgs = {
  input: HotelInput;
};


export type QueryHotelMinimumPriceCalendarArgs = {
  input: HotelMinimumPriceCalendarInput;
};


export type QueryHotelsArgs = {
  input: HotelsInput;
};


export type QueryMinimumDpCarPriceInfoArgs = {
  input: MinimumDpCarPriceInfoInput;
};


export type QueryVacantHotelArgs = {
  input: VacantHotelInput;
};


export type QueryVacantHotelRoomsArgs = {
  input: VacantHotelRoomsInput;
};


export type QueryVacantHotelsArgs = {
  input: VacantHotelsInput;
};


export type QueryIncrementalSearchArgs = {
  input: IncrementalSearchInput;
};


export type QueryOverseasZoneInformationArgs = {
  input: OverseasZoneInformationInput;
};


export type QueryCouponCodeArgs = {
  input: CouponCodeInput;
};


export type QueryDpFlightCancelForAnyReasonForOrderConfirmArgs = {
  input: DpFlightCancelForAnyReasonForOrderConfirmInput;
};


export type QueryDpFlightSupportPlanForOrderConfirmArgs = {
  input: DpFlightSupportPlanForOrderConfirmInput;
};


export type QueryFlightTicketStatusArgs = {
  input: FlightTicketStatusInput;
};


export type QueryHotelForOrderConfirmArgs = {
  input: HotelForOrderConfirmInput;
};


export type QueryHotelTabsForOrderConfirmArgs = {
  input: HotelTabsForOrderConfirmInput;
};


export type QueryOgpImageForOrderConfirmArgs = {
  input: OgpImageForOrderConfirmInput;
};


export type QueryOrderCompleteArgs = {
  input: OrderCompleteInput;
};


export type QueryOrderConfirmArgs = {
  input: OrderConfirmInput;
};


export type QueryOrderHistoryArgs = {
  input: OrderHistoryInput;
};


export type QueryOrderHistoryConvenienceStorePaymentArgs = {
  input: OrderHistoryConvenienceStorePaymentInput;
};


export type QueryOrderReservationInformationArgs = {
  input: OrderReservationInformationInput;
};


export type QueryOrderSignArgs = {
  input: OrderSignInput;
};


export type QueryOrderTodoListArgs = {
  input: OrderTodoListInput;
};


export type QueryPassportInformationArgs = {
  input: PassportInformationInput;
};


export type QueryReturningFlightsForOrderConfirmArgs = {
  input: ReturningFlightsForOrderConfirmInput;
};


export type QuerySelectedProductsSummaryArgs = {
  input: SelectedProductsSummaryInput;
};


export type QueryPlanArgs = {
  input: PlanInput;
};


export type QueryHotelReviewsArgs = {
  input: HotelReviewsInput;
};


export type QueryMyReviewArgs = {
  input: MyReviewInput;
};


export type QueryReviewArgs = {
  input: ReviewInput;
};


export type QueryReviewItemsArgs = {
  input: ReviewItemsInput;
};


export type QuerySpotArgs = {
  input: SpotInput;
};


export type QuerySpotsArgs = {
  input: SpotsInput;
};


export type QueryChildZonesArgs = {
  input: GetChildZonesInput;
};

export type Rate = {
  __typename?: 'Rate';
  /** 会員限定価格が適用されているか */
  fencedDeal: Scalars['Boolean'];
  /** 会員限定価格が利用可能か */
  fencedDealAvailable: Scalars['Boolean'];
  /** 割引情報 */
  promotions?: Maybe<Promotions>;
  /** 料金 */
  pricing: Pricing;
  /** 料金条件 */
  priceRangeCondition: HotelPriceRange;
  /** ベッド条件 */
  bedTypeConditions: Array<RoomBedType>;
  /** 喫煙条件 */
  smokingCondition: SmokingCondition;
  /** 返金可能か */
  refundable?: Maybe<Scalars['Boolean']>;
  /** キャンセルペナルティ */
  cancelPenalties?: Maybe<Array<HotelRoomRateCancelPenalties>>;
};

export type RecommendedPlanData = {
  __typename?: 'RecommendedPlanData';
  /** プランID */
  planId: Scalars['Int'];
  /** タイトル */
  title: Scalars['String'];
  /** エリア名 */
  areaName: Scalars['String'];
  /** サムネイル画像 */
  thumbnail: ImageData;
};

export type RecommendedSeason = {
  __typename?: 'RecommendedSeason';
  /** おすすめの時期へのコメント */
  comments: Array<StaffComment>;
  /** おすすめの時期のテキスト */
  text: Scalars['String'];
  /** おすすめ以外の時期の説明 */
  otherSeasonsInformation: Array<ExpandableContent>;
};

export type RecommendedSeasonForZone = {
  __typename?: 'RecommendedSeasonForZone';
  /** おすすめの時期のテキスト */
  text: Scalars['String'];
  /** おすすめの時期へのコメント */
  comments: Array<StaffComment>;
};

export type RecommendedTravelDestination = {
  __typename?: 'RecommendedTravelDestination';
  /** 表示名 */
  name: Scalars['String'];
  /** 英語名 */
  nameEn: Scalars['String'];
  /** 遷移先のパス */
  path: Scalars['String'];
  /** OGP画像URL */
  ogpImageUrl: Scalars['String'];
  /** サムネイルの画像URL */
  imageUrl: Scalars['String'];
  /** おすすめの時期のテキスト */
  recommendedSeasonText: Scalars['String'];
  /** 旅行のしやすさでの現在のステータス */
  status: TravelStatus;
  /** 目的地のIATAコード ex. TYO */
  returningCityOrAirportIATACode: Scalars['String'];
  /** テーマを持っているか */
  hasThemes?: Maybe<Scalars['Boolean']>;
};

export type RedirectInfo = {
  __typename?: 'RedirectInfo';
  cocolocalaHotelId: Scalars['Int'];
  queryParameterForSelectGoingFlight: Scalars['String'];
  queryParameterForHotel: Scalars['String'];
};

export enum RedirectPath {
  Top = 'TOP',
  SignIn = 'SIGN_IN',
  OrderReservationInformation = 'ORDER_RESERVATION_INFORMATION',
  OrderPurchase = 'ORDER_PURCHASE'
}

export type RefundCreditCardInput = {
  id: Scalars['Int'];
  amount: Scalars['Int'];
  paymentMethod: Scalars['String'];
};

export type RefundCreditCardPayload = {
  __typename?: 'RefundCreditCardPayload';
  ok: Scalars['Boolean'];
};

export type RelationalServiceIds = {
  __typename?: 'RelationalServiceIds';
  agoda?: Maybe<Scalars['String']>;
  expedia?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<Scalars['String']>;
  rakuten?: Maybe<Scalars['String']>;
};

/** ホテルのブックマークを削除するinput */
export type RemoveBookmarkHotelInput = {
  /** こころからホテルID */
  cocolocalaHotelId: Scalars['Int'];
};

export type RemoveBookmarkHotelPayload = {
  __typename?: 'RemoveBookmarkHotelPayload';
  ok: Scalars['Boolean'];
};

export type ReservationContactInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
};

export type ReservationSharedInput = {
  /** Orderと紐づけるTravelのID */
  travelId: Scalars['Int'];
  /** 使用するCouponのID */
  couponId?: Maybe<Scalars['Int']>;
  /** 支払い合計料金 */
  totalAmount: Scalars['Int'];
  /** 値引き前料金 */
  amountBeforeDiscount: Scalars['Int'];
  /** 値引き料金 */
  discountAmount?: Maybe<Scalars['Int']>;
  /** 期間限定セール割引料金 */
  limitedTimeSaleDiscount?: Maybe<Scalars['Int']>;
  /** キャンペーン割引料金 */
  campaignDiscountAmount?: Maybe<Scalars['Int']>;
  /** こころからの取扱手数料 */
  cocolocalaTransactionFee: Scalars['Int'];
  /** こころからの取扱手数料に対する税 */
  cocolocalaTransactionFeeTax: Scalars['Int'];
  /** 決済手数料 */
  paymentFee: Scalars['Int'];
  /** 通貨単位 */
  currency: Scalars['String'];
  /** 予約者の連絡先情報 */
  contact: ReservationContactInput;
  /** 備考 */
  remarks: Scalars['String'];
  /** 分析用のJSON.stringifyしたデータ */
  metadata: Scalars['String'];
  /** 分析用ID */
  gaClientId?: Maybe<Scalars['String']>;
};

export enum ReservationStatus {
  Reserved = 'RESERVED',
  Paid = 'PAID',
  BeforePayment = 'BEFORE_PAYMENT',
  Canceled = 'CANCELED'
}

export type ReservationSummaryInfo = {
  __typename?: 'ReservationSummaryInfo';
  /** 出発日 ex. 2021年4月2日（金） */
  goingDeparturePointDate: Scalars['String'];
  /** 現地出発日 ex. 2021年4月16日（木） */
  returningDeparturePointDate: Scalars['String'];
  /** 人数 */
  numberOfPeople: Scalars['Int'];
};

export type ReservedCar = Node & {
  __typename?: 'ReservedCar';
  id: Scalars['ID'];
  /** 予約ステータス */
  status: Scalars['String'];
  /** キャンセル情報 */
  cancelInfo: ReservedCarCancelInfo;
  /** 支払い情報 */
  paymentInfo: Array<ReservedCarPaymentInfo>;
};

export type ReservedCarCancelInfo = {
  __typename?: 'ReservedCarCancelInfo';
  policy: Scalars['String'];
};

export type ReservedCarInput = {
  reservationConfId: Scalars['String'];
};

export type ReservedCarPaymentInfo = {
  __typename?: 'ReservedCarPaymentInfo';
  /** 支払情報 ex. 返金額,　支払額など */
  type: Scalars['String'];
  /** 金額情報 ex. 85.5ユーロ */
  value: Scalars['String'];
};

export type ReturningFlightsForDpFlight = {
  __typename?: 'ReturningFlightsForDPFlight';
  /** 航空券一覧 */
  flights: Array<Flight>;
  /** 宿泊日数 */
  numberOfStays: Scalars['Int'];
  /** 人数 */
  numberOfPeople: Scalars['Int'];
  /** 最安値の航空券の場合の往復の税サ込みの合計料金 */
  totalPrice: Scalars['Int'];
  /** 1名あたりの最安値の航空券の場合の往復の税サ込みの合計料金 */
  totalPricePerPerson: Scalars['Int'];
  /** 帰りのフライトの出発日 ex. 2021.4.2(金) */
  returningDate: Scalars['String'];
};

export type ReturningFlightsForDpFlightInput = {
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 行きのフライトの出発日 */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 */
  returningDate: Scalars['String'];
  /** 搭乗者情報 */
  occupancy: OccupancyInput;
  /** 行きの航空券情報 */
  goingFlightInfo: GoingFlightInfoInput;
  /** 座席クラス */
  flightClassCode: FlightClassCode;
};

export type ReturningFlightsForOrderConfirm = {
  __typename?: 'ReturningFlightsForOrderConfirm';
  /** 航空券一覧 */
  flights: Array<Flight>;
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  inclusivePriceInfo: InclusivePriceInfo;
};

export type ReturningFlightsForOrderConfirmInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId: Scalars['String'];
  /** 出発の場所や空港のIATAコード ex. TYO */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード ex. TYO */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 行きの航空券情報 */
  goingFlightInfo: GoingFlightInfoInput;
  /** 座席クラス */
  flightClassCode: FlightClassCode;
};

export type ReturningFlightsInput = {
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 行きのフライトの出発日 */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 */
  returningDate: Scalars['String'];
  /** 搭乗者情報 */
  occupancy: OccupancyInput;
  /** 行きの航空券情報 */
  goingFlightInfo: GoingFlightInfoInput;
  /** 座席クラス */
  flightClassCode: FlightClassCode;
};

export type Review = Node & {
  __typename?: 'Review';
  id: Scalars['ID'];
  reviewId: Scalars['Int'];
  cocolocalaHotelId: Scalars['Int'];
  hotelImageUrl?: Maybe<Scalars['String']>;
  areaName: Scalars['String'];
  hotelName: Scalars['String'];
  nickname: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  stayedAt: Scalars['String'];
  numberOfPeople: Scalars['Int'];
  useScene: UseSceneWithLabel;
  reviewItems: Array<ReviewItem>;
  reviewItemImages: Array<ReviewItemImage>;
};

export type ReviewInput = {
  hotelId: Scalars['Int'];
  reviewId: Scalars['Int'];
};

export type ReviewItem = Node & {
  __typename?: 'ReviewItem';
  id: Scalars['ID'];
  reviewItemId: Scalars['Int'];
  reviewItemImages: Array<ReviewItemImage>;
  comment: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum ReviewItemCategory {
  Other = 'OTHER',
  Room = 'ROOM',
  RoomOther = 'ROOM_OTHER',
  Bathroom = 'BATHROOM',
  Breakfast = 'BREAKFAST',
  LunchAfternoonOther = 'LUNCH_AFTERNOON_OTHER',
  Dinner = 'DINNER',
  InstitutionRestaurantBar = 'INSTITUTION_RESTAURANT_BAR',
  InstitutionPoolSpa = 'INSTITUTION_POOL_SPA',
  InstitutionOther = 'INSTITUTION_OTHER',
  Appearance = 'APPEARANCE'
}

export type ReviewItemCategoryWithLabel = {
  __typename?: 'ReviewItemCategoryWithLabel';
  value: ReviewItemCategory;
  label: Scalars['String'];
};

export type ReviewItemImage = Node & {
  __typename?: 'ReviewItemImage';
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ReviewItemImageInput = {
  imageUrl: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ReviewItemWithReviewUser = Node & {
  __typename?: 'ReviewItemWithReviewUser';
  id: Scalars['ID'];
  reviewId: Scalars['Int'];
  reviewItemId: Scalars['Int'];
  nickname: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  reviewItemImageUrl: Scalars['String'];
  comment: Scalars['String'];
  cocolocalaHotelId: Scalars['Int'];
};

export type ReviewItems = Node & {
  __typename?: 'ReviewItems';
  id: Scalars['ID'];
  pagination: ReviewItemsPaginationResponse;
  reviewItems: Array<ReviewItemWithReviewUser>;
};

export type ReviewItemsInput = {
  cocolocalaHotelId: Scalars['Int'];
  pagination: ReviewItemsPaginationInput;
};

export type ReviewItemsPaginationInput = {
  limit: Scalars['Int'];
  reviewOffset: Scalars['Int'];
  reviewItemOffset: Scalars['Int'];
};

export type ReviewItemsPaginationResponse = {
  __typename?: 'ReviewItemsPaginationResponse';
  nextReviewOffset: Scalars['Int'];
  nextReviewItemOffset: Scalars['Int'];
  hasNext: Scalars['Boolean'];
};

export enum ReviewPublishStatus {
  Published = 'PUBLISHED',
  Draft = 'DRAFT'
}

export type RoomBedGroup = {
  __typename?: 'RoomBedGroup';
  /** ID */
  id?: Maybe<Scalars['String']>;
  bedGroupId: Scalars['String'];
  /** 概要 */
  description?: Maybe<Scalars['String']>;
  /** 部屋のベッドの内容 */
  configuration?: Maybe<Array<Maybe<BedGroupConfiguration>>>;
  /** ExpediaのAPIでpriceCheckをするURLのパス (空室検索したとき) */
  expediaPriceCheckHref?: Maybe<Scalars['String']>;
};

export enum RoomBedType {
  Undecided = 'Undecided',
  /** キング */
  King = 'King',
  /** シングル */
  Single = 'Single',
  /** セミダブル */
  ThreeQuarter = 'ThreeQuarter',
  /** シングル、セミダブル、ダブルでベッドが2つあるとき */
  TwinRoom = 'TwinRoom',
  /** クイーン */
  Queen = 'Queen',
  /** ダブル */
  Full = 'Full',
  /** 乳幼児用 */
  Crib = 'Crib'
}

export type RoomMaxAllowedOccupancy = {
  __typename?: 'RoomMaxAllowedOccupancy';
  /** 合計 */
  total: Scalars['Int'];
  /** 大人の人数 */
  adults: Scalars['Int'];
  /** 子供の人数 */
  children: Scalars['Int'];
};

export type RoomRequest = {
  title?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  familyName: Scalars['String'];
  email: Scalars['String'];
  phone: Phone;
  smoking: Scalars['Boolean'];
  specialRequest?: Maybe<Scalars['String']>;
};

export type SafetyTravelInformation = {
  __typename?: 'SafetyTravelInformation';
  /** 上のコメント */
  headerComments: Array<StaffComment>;
  /** 下のコメント */
  footerComments: Array<StaffComment>;
  /** 確認すべきポイント */
  checkPoints: Array<ExpandableContentsSection>;
};

export enum SalesEnvironment {
  HotelOnly = 'HOTEL_ONLY',
  HotelPackage = 'HOTEL_PACKAGE',
  Loyalty = 'LOYALTY'
}

export type SaveOrderReservationInformationInput = {
  cartSnapshotId: Scalars['String'];
  passengers: Array<Passenger>;
  phoneNumber: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  hasCancelForAnyReason: Scalars['Boolean'];
  /** 全旅客の受託手荷物オプション */
  selectedBaggageOption?: Maybe<SelectedBaggageOptionInfoInput>;
};

export type SaveOrderReservationInformationPayload = {
  __typename?: 'SaveOrderReservationInformationPayload';
  ok: Scalars['Boolean'];
};

export type SavePassportInput = {
  orderId: Scalars['Int'];
  passenger: FlightPassengerInput;
};

export type SavePassportPayload = {
  __typename?: 'SavePassportPayload';
  ok: Scalars['Boolean'];
};

export type SeicoMart = {
  __typename?: 'SeicoMart';
  /** オンライン決済番号（11桁） */
  paymentCode: Scalars['String'];
};

export type SelectedBaggageOptionInfo = {
  __typename?: 'SelectedBaggageOptionInfo';
  round?: Maybe<BaggageOption>;
  going?: Maybe<BaggageOption>;
  returning?: Maybe<BaggageOption>;
};

export type SelectedBaggageOptionInfoInput = {
  round?: Maybe<BaggageOptionInput>;
  going?: Maybe<BaggageOptionInput>;
  returning?: Maybe<BaggageOptionInput>;
};

export type SelectedProductsSummary = {
  __typename?: 'SelectedProductsSummary';
  /** 宿泊施設情報 */
  hotelInfo?: Maybe<SelectedProductsSummaryHotelInfo>;
  /** レンタカー情報 */
  dPCarInfo?: Maybe<OrderDpCarInfo>;
  /** 海外航空券情報詳細 */
  flightInfo?: Maybe<OrderFlightInfo>;
  /** 海外あんしんサポートプラン情報 */
  supportPlan?: Maybe<DpFlightSupportPlan>;
  /** すべての海外あんしんサポートプラン情報（詳細モーダルで利用） */
  supportPlans: Array<DpFlightSupportPlan>;
  /** キャンセル保証情報 */
  cancelForAnyReason?: Maybe<OrderCancelForAnyReason>;
  /** キャンセル情報 */
  cancelInfo?: Maybe<OrderCancelInfo>;
};

export type SelectedProductsSummaryHotelInfo = IOrderHotelInfo & {
  __typename?: 'SelectedProductsSummaryHotelInfo';
  id: Scalars['ID'];
  cocolocalaHotelId: Scalars['String'];
  hotelSummary: OrderHotelSummary;
  roomSummary: OrderHotelRoomSummary;
  /** 宿泊人数情報 */
  numberOfPeople: Scalars['Int'];
  /** 特記事項 */
  importantNotices: Array<Scalars['String']>;
  expediaHotelId?: Maybe<Scalars['String']>;
  hotelDetail?: Maybe<OrderHotelDetail>;
  roomDetail?: Maybe<OrderHotelRoomDetail>;
  targetHotelZonePath?: Maybe<Scalars['String']>;
  /** 客室のRateID */
  selectedRateId?: Maybe<Scalars['String']>;
  /** ホテルの在庫切れフラグ */
  isSoldOut?: Maybe<Scalars['Boolean']>;
  /** 残りの部屋数 */
  numberOfRoomsRemaining?: Maybe<Scalars['Int']>;
};

export type SelectedProductsSummaryInput = {
  /** Cartから作られたSnapshotのID */
  cartSnapshotId?: Maybe<Scalars['String']>;
};

export type SelectedProductsSummaryLabel = {
  __typename?: 'SelectedProductsSummaryLabel';
  /** ラベル */
  label: Scalars['String'];
  /** 日時のテキスト ex) 5/11(土) - 5/13(月), 5/11(土) 15:00 */
  dateTimeText: Scalars['String'];
  dayDiff?: Maybe<Scalars['Int']>;
  /** 詳細 */
  detail: Scalars['String'];
};

export type SelectedProductsSummaryLabelInfo = {
  __typename?: 'SelectedProductsSummaryLabelInfo';
  labels: Array<SelectedProductsSummaryLabel>;
};

export type SendEmergencyContactInput = {
  /** メールアドレス */
  email: Scalars['String'];
  /** 氏名 */
  name: Scalars['String'];
  /** 予約サポート番号 */
  reservationSupportNumber: Scalars['String'];
  /** 電話番号 */
  phoneNumber: Scalars['String'];
  /** ご連絡概要 */
  contactType: ContactType;
  /** 旅行日当日のご連絡 */
  dayOfTravel?: Maybe<DayOfTravel>;
  /** 予約日当日のご連絡 */
  dayOfAppointment?: Maybe<DayOfAppointment>;
  /** その他のご連絡 */
  etc?: Maybe<Etc>;
};

export type SendEmergencyContactPayload = {
  __typename?: 'SendEmergencyContactPayload';
  ok: Scalars['Boolean'];
};

export type SendSelectedProductsInput = {
  /** GA用のパラメータ ex. system_mail */
  utmSource: Scalars['String'];
  /** GA用のパラメータ ex. email */
  utmMedium: Scalars['String'];
  /** GA用のパラメータ ex. dp_flights_international_itinerary_confirmation */
  utmCampaign: Scalars['String'];
  /** GA用のパラメータ */
  utmContent: Scalars['String'];
  /** カートのスナップショットID */
  cartSnapshotId: Scalars['String'];
};

export type SendSelectedProductsPayload = {
  __typename?: 'SendSelectedProductsPayload';
  ok: Scalars['Boolean'];
};

export type SevenEleven = {
  __typename?: 'SevenEleven';
  /** 決済画面URL（PC用 */
  paymentUrlPc: Scalars['String'];
  /** 決済画面URL（携帯用） */
  paymentUrlSp: Scalars['String'];
};

export enum SmokingCondition {
  NoSmoking = 'NoSmoking',
  Smoking = 'Smoking',
  Undecided = 'Undecided'
}

export type Spot = {
  __typename?: 'Spot';
  id: Scalars['Int'];
  areaId: Scalars['Int'];
  areaPath: Scalars['String'];
  areaName: Scalars['String'];
  districtId: Scalars['Int'];
  districtPath: Scalars['String'];
  districtName: Scalars['String'];
  prefectureId: Scalars['Int'];
  prefecturePath: Scalars['String'];
  prefectureName: Scalars['String'];
  regionId: Scalars['Int'];
  regionPath: Scalars['String'];
  regionName: Scalars['String'];
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  name: Scalars['String'];
  rating?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  summaryTitle?: Maybe<Scalars['String']>;
  summaryDescription?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  businessHours?: Maybe<Scalars['String']>;
  location: SpotLocation;
  comments?: Maybe<Array<SpotComment>>;
  relationalServiceIds: SpotRelationalServiceIds;
  imageUrls?: Maybe<Array<Scalars['String']>>;
};

export type SpotComment = {
  __typename?: 'SpotComment';
  id: Scalars['Int'];
  text: Scalars['String'];
};

export type SpotInput = {
  spotId: Scalars['Int'];
};

export type SpotLocation = {
  __typename?: 'SpotLocation';
  zipCode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
};

/** プランにひもづく観光スポット要素を含むモデルコースのアイテム */
export type SpotModelCourseItem = {
  __typename?: 'SpotModelCourseItem';
  /** モデルコースのアイテムタイプ */
  itemType: PlanModelCourseItemType;
  /** コース要素に訪れる現地時間 24h表記 * ex. 11:00 */
  time?: Maybe<Scalars['String']>;
  /** スポットID */
  spotId: Scalars['Int'];
  /** スポット名 */
  name: Scalars['String'];
  /** そこでできることのひとことまとめ */
  summaryTitle: Scalars['String'];
  /** スタッフのおすすめポイント長文 */
  summaryDescription: Scalars['String'];
  /** 画像の表示要素 */
  images: Array<PlanImage>;
};

export type SpotRelationalServiceIds = {
  __typename?: 'SpotRelationalServiceIds';
  foursquare?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<Scalars['String']>;
};

export type SpotSummaryForHotel = Node & {
  __typename?: 'SpotSummaryForHotel';
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaSpotId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 現在の地域との距離 */
  distance?: Maybe<Scalars['String']>;
  /** エリアの表示名 */
  areaName?: Maybe<Scalars['String']>;
  /** 都道府県の表示名 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 説明文 */
  description?: Maybe<Scalars['String']>;
  /** サムネイル画像 */
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type Spots = {
  __typename?: 'Spots';
  hits: Array<Spot>;
};

export type SpotsFilterInput = {
  filterType: ElasticsearchFilterType;
  filterKey: Scalars['String'];
  filterValues: Array<Scalars['String']>;
  isNested?: Maybe<Scalars['Boolean']>;
};

export type SpotsInput = {
  q?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  filters?: Maybe<Array<SpotsFilterInput>>;
  geoLocation?: Maybe<ElasticsearchGeoLocationFilterInput>;
  sort?: Maybe<Array<ElasticsearchSort>>;
};

export type StaffComment = {
  __typename?: 'StaffComment';
  /** 担当スタッフのコメント内容がポジティブかネガティブのステータス */
  status: StaffCommentStatus;
  text: Scalars['String'];
};

export enum StaffCommentStatus {
  /** ポジティブなコメント */
  Positive = 'POSITIVE',
  /** ネガティブなコメント */
  Negative = 'NEGATIVE'
}

export enum TerminalType {
  InternationalFlight = 'INTERNATIONAL_FLIGHT',
  DomesticFlight = 'DOMESTIC_FLIGHT'
}

export type ThemeRecommendedDays = {
  __typename?: 'ThemeRecommendedDays';
  /** 宿泊日数 */
  stay: Scalars['Int'];
  /** 旅行日数 */
  total: Scalars['Int'];
};

export type Todo = {
  __typename?: 'Todo';
  sectionTitle: Scalars['String'];
  sortIndex: Scalars['Int'];
  items: Array<TodoItem>;
};

export type TodoItem = {
  __typename?: 'TodoItem';
  id: Scalars['Int'];
  isRequired: Scalars['Boolean'];
  title: Scalars['String'];
  content: Scalars['String'];
  sortIndex: Scalars['Int'];
  isChecked: Scalars['Boolean'];
};

export type TodoListItem = {
  id: Scalars['Int'];
  isChecked: Scalars['Boolean'];
};

export type TopPage = {
  __typename?: 'TopPage';
  /** ページ上部のカルーセルと下部のキャンペーンのバナー */
  campaignBanners: Array<CampaignBanner>;
  /** いま人気の海外旅行先 */
  overseasPopularAreaDescription: PopularAreaDescription;
  overseasPopularAreas: Array<OverseasTopArea>;
  /** いま人気の海外エリア */
  overseasPopularDestinations: Array<PopularDestination>;
  /** いま人気の国内旅行先 */
  jpPopularAreaDescription: PopularAreaDescription;
  /** いま人気の国内エリア */
  jpPopularDestinations: Array<PopularDestination>;
  jpPopularAreas: Array<Area>;
  /** 国内ホテル・旅館セール */
  saleHotels: Array<HotelData>;
};

export type TravelDestination = {
  __typename?: 'TravelDestination';
  /** 表示名 */
  name: Scalars['String'];
  /** 遷移先のパス */
  path: Scalars['String'];
  /** サムネイルの画像URL */
  imageUrl: Scalars['String'];
  /** 最安日程の最安値 */
  lowestPrice?: Maybe<Scalars['Int']>;
};

export type TravelSituationForZone = {
  __typename?: 'TravelSituationForZone';
  /** 旅行の歯やすさの点数. 1~5点 */
  travelStatus: TravelStatus;
  /** 現在の状況 */
  restrictedInformation: Array<ExpandableContent>;
  /** コメント */
  comments: Array<StaffComment>;
};

export enum TravelStatus {
  /** いますぐ旅行OK */
  Allowed = 'ALLOWED',
  /** 計画におすすめ */
  RecommendedForPlanning = 'RECOMMENDED_FOR_PLANNING',
  /** 情報収集をしっかりと */
  NeedGatherInformation = 'NEED_GATHER_INFORMATION',
  /** おすすめしません */
  NotRecommended = 'NOT_RECOMMENDED',
  /** 渡航できません */
  NotAllowed = 'NOT_ALLOWED'
}

export type TravelTheme = {
  __typename?: 'TravelTheme';
  themeId: Scalars['String'];
  /** タイトル */
  title: Scalars['String'];
  /** 画像 */
  imageUrls: Array<Scalars['String']>;
  /** おすすめ日数 */
  recommendedDays: ThemeRecommendedDays;
  /** 最低料金 */
  minimumPrice?: Maybe<Scalars['Int']>;
  /** 説明 */
  description: Scalars['String'];
};

export type TravelThemeHotelSummary = {
  __typename?: 'TravelThemeHotelSummary';
  /** ID */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** ホテルの説明文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['Int']>;
  /** 宿泊数 */
  numberOfStays?: Maybe<Scalars['Int']>;
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  priceInfo?: Maybe<TravelThemeHotelSummaryPriceInfo>;
  /** ホテルの画像 */
  imageUrl?: Maybe<Scalars['String']>;
};

export type TravelThemeHotelSummaryPriceInfo = {
  __typename?: 'TravelThemeHotelSummaryPriceInfo';
  /** 1名あたりの最低料金 */
  minimumPricePerPerson: Scalars['Int'];
  /** 割引情報 */
  discountInfo?: Maybe<DiscountInfoForDpFlight>;
};

export type UpdateDpFlightThemeInput = {
  /** テーマID */
  dPFlightThemeId: Scalars['Int'];
  /** タイトル */
  title: Scalars['String'];
  /** 説明文 */
  description: Scalars['String'];
  /** 宿泊日数 */
  recommendedStayDays: Scalars['Int'];
  /** 合計日数 */
  recommendedTotalDays: Scalars['Int'];
  /** 1人当たりの目安の最低料金 */
  minimumPrice?: Maybe<Scalars['Int']>;
  /** 並び順 */
  sortOrder: Scalars['Int'];
  /** 地域のID */
  dPFlightThemeZoneId: Scalars['Int'];
  /** 到着空港のIATAコード ex. HNL */
  arrivalAirportIATACode: Scalars['String'];
  /** 画像URL */
  imageUrls: Array<Scalars['String']>;
  /** スタッフコメント */
  staffComment: Scalars['String'];
  /** ホテル */
  hotels: Array<DpFlightThemeHotel>;
  /** バージョン番号 */
  versionNo: Scalars['Int'];
};

export type UpdateDpFlightThemePayload = {
  __typename?: 'UpdateDPFlightThemePayload';
  dPFlightThemeId: Scalars['Int'];
};

export type UpdateDpFlightThemePublishStatusInput = {
  /** テーマID */
  dPFlightThemeId: Scalars['Int'];
  /** 公開ステータス */
  publishStatus: DpFlightThemePublishStatus;
  /** バージョン番号 */
  versionNo: Scalars['Int'];
};

export type UpdateDpFlightThemePublishStatusPayload = {
  __typename?: 'UpdateDPFlightThemePublishStatusPayload';
  ok: Scalars['Boolean'];
};

export type UpdateEmailInput = {
  email: Scalars['String'];
};

export type UpdateEmailPayload = {
  __typename?: 'UpdateEmailPayload';
  email: Scalars['String'];
};

export type UpdateHotelPhotosInput = {
  cocolocalaHotelId: Scalars['String'];
};

export type UpdateHotelPhotosPayload = {
  __typename?: 'UpdateHotelPhotosPayload';
  ok: Scalars['Boolean'];
};

export type UpdateMyReviewItemInput = {
  /** レビューのID */
  reviewId: Scalars['Int'];
  /** レビューアイテムのID */
  reviewItemId: Scalars['Int'];
  /** レビューアイテムのカテゴリ */
  category: ReviewItemCategory;
  /** レビューアイテムのコメント */
  comment: Scalars['String'];
  /** レビューアイテムの並び順 */
  sortOrder: Scalars['Int'];
  /** レビューのバージョン番号 */
  reviewVersionNo: Scalars['Int'];
  /** レビューアイテムの画像のリスト */
  reviewItemImages: Array<ReviewItemImageInput>;
  /** GCSから削除する画像URLのリスト */
  deleteImageUrls: Array<Scalars['String']>;
};

export type UpdateMyReviewItemPayload = {
  __typename?: 'UpdateMyReviewItemPayload';
  /** レビューアイテムのID */
  reviewItemId: Scalars['Int'];
};

export type UpdateMyReviewPublishStatusPublishInput = {
  reviewId: Scalars['Int'];
  versionNo: Scalars['Int'];
};

export type UpdateMyReviewPublishStatusPublishPayload = {
  __typename?: 'UpdateMyReviewPublishStatusPublishPayload';
  reviewId: Scalars['Int'];
};

export type UpdateMyReviewSummaryInput = {
  reviewId: Scalars['Int'];
  stayedAt: Scalars['String'];
  numberOfPeople: Scalars['Int'];
  useScene: UseScene;
  versionNo: Scalars['Int'];
};

export type UpdateMyReviewSummaryPayload = {
  __typename?: 'UpdateMyReviewSummaryPayload';
  reviewId: Scalars['Int'];
};

export type UpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedInput = {
  orderId: Scalars['Int'];
  orderStatusCancelOrInvalid: OrderStatus;
  paymentIdForUpdatingStatusRefunded?: Maybe<Scalars['Int']>;
};

export type UpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedPayload = {
  __typename?: 'UpdateOrderStatusCanceledOrInvalidAndPaymentStatusRefundedPayload';
  ok: Scalars['Boolean'];
};

export type UpdateOrderTodoListInput = {
  orderId: Scalars['Int'];
  todoList: Array<TodoListItem>;
};

export type UpdateOrderTodoListPayload = {
  __typename?: 'UpdateOrderTodoListPayload';
  ok: Scalars['Boolean'];
};

export type UpdateTravelFlightSectorInput = {
  departureAirportIata: Scalars['String'];
  departureUtcDateTime: Scalars['String'];
  departureTimeZoneOffset: Scalars['String'];
  arrivalAirportIata: Scalars['String'];
  arrivalUtcDateTime: Scalars['String'];
  arrivalTimeZoneOffset: Scalars['String'];
  flightCarrierIata: Scalars['String'];
  flightCarrierName: Scalars['String'];
  flightNumber: Scalars['String'];
  fareClassCode: Scalars['String'];
  codeShareAirlines: Array<Scalars['String']>;
  flightTransits: Array<UpdateTravelFlightTransitInput>;
};

export type UpdateTravelFlightTransitInput = {
  arrivalUtcDateTime: Scalars['String'];
  departureUtcDateTime: Scalars['String'];
  timeZoneOffset: Scalars['String'];
  airportIata: Scalars['String'];
};

export type UpdateTravelFlightsInput = {
  goingFlightSectors: Array<UpdateTravelFlightSectorInput>;
  returningFlightSectors: Array<UpdateTravelFlightSectorInput>;
};

export type UpdateTravelInput = {
  orderId: Scalars['Int'];
  description: Scalars['String'];
  flights?: Maybe<Array<UpdateTravelFlightsInput>>;
};

export type UpdateTravelPayload = {
  __typename?: 'UpdateTravelPayload';
  ok: Scalars['Boolean'];
};

export type UpsertMyReviewUserInput = {
  nickname: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  versionNo?: Maybe<Scalars['Int']>;
};

export type UpsertMyReviewUserPayload = {
  __typename?: 'UpsertMyReviewUserPayload';
  versionNo: Scalars['Int'];
};

export enum UseScene {
  Other = 'OTHER',
  Alone = 'ALONE',
  Friends = 'FRIENDS',
  Couple = 'COUPLE',
  Family = 'FAMILY',
  FamilyWithInfants = 'FAMILY_WITH_INFANTS',
  Business = 'BUSINESS'
}

export type UseSceneWithLabel = {
  __typename?: 'UseSceneWithLabel';
  value: UseScene;
  label: Scalars['String'];
};

export type VacantHotel = Node & {
  __typename?: 'VacantHotel';
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** ExpediaのホテルID */
  expediaHotelId: Scalars['String'];
  /** 空室情報 */
  rooms: Array<HotelRoom>;
  /** ホテルの場所情報 */
  locationInfo: VacantHotelLocationInfo;
  /** ホテルの画像 */
  images?: Maybe<Array<HotelImage>>;
  /** expediaRoomIdが指定されていたとき存在(ResolveFieldのため) */
  selectedRoomId?: Maybe<Scalars['String']>;
  /** expediaRoomIdが指定されていたときのRoom情報 */
  selectedRoom?: Maybe<HotelRoom>;
  /** expediaRateIdが指定されていたとき存在(ResolveFieldのため) */
  selectedRateId?: Maybe<Scalars['String']>;
  /** expediaRateIdが指定されていたときにそのときのRate */
  selectedRate?: Maybe<HotelRoomRate>;
  /** selectedBedGroupが指定されていたとき存在(ResolveFieldのため) */
  selectedBedGroupId?: Maybe<Scalars['String']>;
  /** expediaBedGroupが指定されていたときのBedGroup */
  selectedBedGroup?: Maybe<RoomBedGroup>;
};

export type VacantHotelForDpFlight = Node & {
  __typename?: 'VacantHotelForDPFlight';
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  expediaHotelId: Scalars['String'];
  didaHotelId?: Maybe<Scalars['String']>;
  /** ホテルに関するスタッフのコメント（テーマ型の場合のみ返す） */
  staffCommentForHotel?: Maybe<Scalars['String']>;
  /** ホテル名 */
  hotelName: Scalars['String'];
  /** ホテルについてのリード文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** ホテルのロケーション ex ハワイ > ホノルル */
  hotelLocation: Scalars['String'];
  /** ホテルの画像 */
  images: Array<HotelImage>;
  /** 施設詳細情報 */
  hotelDetailInfo: HotelDetailInfoForDpFlight;
  /** GoogleのPlace情報でのレビュー */
  googlePlaceReviews?: Maybe<GooglePlaceReviews>;
  /** コンテンツ(リッチコンテンツ) */
  contents?: Maybe<Array<HotelContentItem>>;
  /** ホテルの地方パス */
  regionPath: Scalars['String'];
  /** 客室に関するスタッフのコメント（テーマ型の場合のみ返す） */
  staffCommentForRoom?: Maybe<Scalars['String']>;
  /** 客室情報 */
  rooms: Array<HotelRoomForDpFlight>;
  /** 出発地の空港リスト */
  departureAirports: Array<AirportSection>;
  /** 目的地の空港リスト */
  arrivalAirports: Array<AirportSection>;
  /** 国内または海外か */
  internationalOrDomestic: InternationalOrDomestic;
  /** 航空券の最安値料金 */
  minimumFlightPrice: Scalars['Int'];
  /** ホテルと航空券の料金を足した最小の合計金額情報 */
  minimumInclusivePriceInfo?: Maybe<MinimumInclusivePriceInfoForDpFlight>;
};

export type VacantHotelForDpFlightInput = {
  cocolocalaHotelId: Scalars['String'];
  themeId?: Maybe<Scalars['String']>;
  checkInDate: Scalars['String'];
  checkOutDate: Scalars['String'];
  goingDate: Scalars['String'];
  returningDate: Scalars['String'];
  occupancies: Array<OccupancyInput>;
  minimumFlightPrice?: Maybe<Scalars['Int']>;
  minimumFlightPriceSearchInfo: MinimumFlightPriceSearchInfo;
  cartSnapshotId?: Maybe<Scalars['String']>;
};

/** 単一のホテルを空室検索するInput */
export type VacantHotelInput = {
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** チェックイン日 */
  checkinDate: Scalars['String'];
  /** チェックアウト日 */
  checkoutDate: Scalars['String'];
  /** 宿泊人数 */
  occupancies: Array<OccupancyInput>;
  /** ExpediaのホテルID */
  expediaHotelId?: Maybe<Scalars['String']>;
  /** ExpediaのRoomID */
  expediaRoomId?: Maybe<Scalars['String']>;
  /** ExpediaのRateID */
  expediaRateId?: Maybe<Scalars['String']>;
  /** ExpediaのBedGroupID */
  expediaBedGroupId?: Maybe<Scalars['String']>;
  /** 販売環境.指定がいないときはHOTEL_ONLYとなる */
  salesEnvironment?: Maybe<SalesEnvironment>;
  /** 会員限定価格 */
  isAvailableMemberDiscount?: Maybe<Scalars['Boolean']>;
};

/** ホテルの位置情報 */
export type VacantHotelLocationInfo = ICocolocalaZone & {
  __typename?: 'VacantHotelLocationInfo';
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリアのパス */
  areaPath: Scalars['String'];
  /** エリアの表示名 */
  areaName: Scalars['String'];
  /** 地域のID */
  districtId: Scalars['Int'];
  /** 地域のパス */
  districtPath: Scalars['String'];
  /** 地域の表示名 */
  districtName: Scalars['String'];
  /** 都道府県のID */
  prefectureId: Scalars['Int'];
  /** 都道府県のパス */
  prefecturePath: Scalars['String'];
  /** 都道府県の表示名 */
  prefectureName: Scalars['String'];
  /** 地方のID */
  regionId: Scalars['Int'];
  /** 地方のパス */
  regionPath: Scalars['String'];
  /** 地方の表示名 */
  regionName: Scalars['String'];
  /** 最寄駅のID */
  stationId: Scalars['Int'];
  /** 最寄駅のパス */
  stationPath: Scalars['String'];
  /** 最寄駅の表示名 */
  stationName: Scalars['String'];
  /** 最寄駅のニックネーム */
  stationNickname: Scalars['String'];
  /** 国のコード（2文字のJP等） */
  countryCode: Scalars['String'];
  /** 国の表示名 */
  countryName: Scalars['String'];
  /** 国の中にエリアが一つしかないかどうか */
  isOnlyOneAreaInCountry?: Maybe<Scalars['Boolean']>;
  /** 地方の中にエリアが一つしかないかどうか */
  isOnlyOneAreaInRegion?: Maybe<Scalars['Boolean']>;
};

export type VacantHotelRoom = {
  __typename?: 'VacantHotelRoom';
  id?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  overview?: Maybe<Scalars['String']>;
  isNoSmoking: Scalars['Boolean'];
  images?: Maybe<Array<Maybe<VacantHotelRoomImage>>>;
  rates?: Maybe<Array<Maybe<VacantHotelRoomRate>>>;
  view?: Maybe<VacantHotelRoomView>;
  bedGroups?: Maybe<Array<Maybe<VacantHotelRoomBedGroup>>>;
  occupancy?: Maybe<VacantHotelRoomOccupancy>;
  amenities?: Maybe<Array<Amenity>>;
};

export type VacantHotelRoomBedGroup = {
  __typename?: 'VacantHotelRoomBedGroup';
  id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  configuration?: Maybe<Array<Maybe<VacantHotelRoomRateBedGroupConfiguration>>>;
};

export type VacantHotelRoomImage = {
  __typename?: 'VacantHotelRoomImage';
  heroImage?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['Int']>;
  caption?: Maybe<Scalars['String']>;
  links?: Maybe<VacantHotelRoomImageLink>;
};

export type VacantHotelRoomImageLink = {
  __typename?: 'VacantHotelRoomImageLink';
  large?: Maybe<VacantHotelRoomImageSource>;
  medium?: Maybe<VacantHotelRoomImageSource>;
  small?: Maybe<VacantHotelRoomImageSource>;
};

export type VacantHotelRoomImageSource = {
  __typename?: 'VacantHotelRoomImageSource';
  method?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomOccupancy = {
  __typename?: 'VacantHotelRoomOccupancy';
  maxAllowed?: Maybe<VacantHotelRoomOccupancyMaxAllowed>;
  ageCategories?: Maybe<VacantHotelRoomOccupancyAgeCategories>;
};

export type VacantHotelRoomOccupancyAgeCategories = {
  __typename?: 'VacantHotelRoomOccupancyAgeCategories';
  adult?: Maybe<VacantHotelRoomOccupancyAgeCategoriesPerson>;
  infant?: Maybe<VacantHotelRoomOccupancyAgeCategoriesPerson>;
  childAgeA?: Maybe<VacantHotelRoomOccupancyAgeCategoriesPerson>;
};

export type VacantHotelRoomOccupancyAgeCategoriesPerson = {
  __typename?: 'VacantHotelRoomOccupancyAgeCategoriesPerson';
  name?: Maybe<Scalars['String']>;
  minimumAge?: Maybe<Scalars['Int']>;
};

export type VacantHotelRoomOccupancyMaxAllowed = {
  __typename?: 'VacantHotelRoomOccupancyMaxAllowed';
  total?: Maybe<Scalars['Int']>;
  children?: Maybe<Scalars['Int']>;
  adults?: Maybe<Scalars['Int']>;
};

export type VacantHotelRoomRate = {
  __typename?: 'VacantHotelRoomRate';
  id: Scalars['String'];
  availableRooms: Scalars['Int'];
  refundable: Scalars['Boolean'];
  fencedDeal: Scalars['Boolean'];
  fencedDealAvailable: Scalars['Boolean'];
  depositRequired: Scalars['Boolean'];
  merchantOfRecord: Scalars['String'];
  promotions?: Maybe<VacantHotelRoomRatePromotions>;
  occupancyPricing: VacantHotelRoomRateOccupancyPricing;
  occupancyPricingWithoutCocolocalaTransactionFee: VacantHotelRoomRateOccupancyPricing;
  cancelPenalties?: Maybe<Array<VacantHotelRoomRateCancelPenalty>>;
  bedGroups?: Maybe<Array<VacantHotelRoomRateBedGroup>>;
  amenities?: Maybe<Array<Amenity>>;
  meal: Scalars['String'];
  priceRange: VacantHotelRoomRatePriceRangeEnum;
};

export type VacantHotelRoomRateBedGroup = {
  __typename?: 'VacantHotelRoomRateBedGroup';
  id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  configuration?: Maybe<Array<Maybe<VacantHotelRoomRateBedGroupConfiguration>>>;
  links?: Maybe<VacantHotelRoomRateBedGroupLink>;
};

export type VacantHotelRoomRateBedGroupConfiguration = {
  __typename?: 'VacantHotelRoomRateBedGroupConfiguration';
  type?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type VacantHotelRoomRateBedGroupLink = {
  __typename?: 'VacantHotelRoomRateBedGroupLink';
  priceCheck?: Maybe<VacantHotelRoomRateBedGroupLinkPriceCheck>;
};

export type VacantHotelRoomRateBedGroupLinkPriceCheck = {
  __typename?: 'VacantHotelRoomRateBedGroupLinkPriceCheck';
  method: Scalars['String'];
  href: Scalars['String'];
  expires?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomRateCancelPenalty = {
  __typename?: 'VacantHotelRoomRateCancelPenalty';
  currency: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  nights?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomRateOccupancyPricing = {
  __typename?: 'VacantHotelRoomRateOccupancyPricing';
  fees?: Maybe<VacantHotelRoomRateOccupancyPricingFees>;
  totals: VacantHotelRoomRateOccupancyPricingTotals;
};

export type VacantHotelRoomRateOccupancyPricingFee = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingFee';
  billableCurrency?: Maybe<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency>;
  requestCurrency?: Maybe<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency>;
  scope?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomRateOccupancyPricingFeeBillableCurrency = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency';
  value?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomRateOccupancyPricingFeeRequestCurrency = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency';
  value?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomRateOccupancyPricingFees = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingFees';
  mandatoryFee?: Maybe<VacantHotelRoomRateOccupancyPricingFee>;
  resortFee?: Maybe<VacantHotelRoomRateOccupancyPricingFee>;
  mandatoryTax?: Maybe<VacantHotelRoomRateOccupancyPricingFee>;
};

export type VacantHotelRoomRateOccupancyPricingTotals = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingTotals';
  inclusive?: Maybe<VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency>;
  strikethrough?: Maybe<VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency>;
  marketingFee?: Maybe<VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency>;
  grossProfit?: Maybe<VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency>;
  exclusive?: Maybe<VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency>;
  discountRate?: Maybe<Scalars['Float']>;
};

export type VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency = {
  __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency';
  billableCurrency?: Maybe<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency>;
  requestCurrency?: Maybe<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency>;
};

export enum VacantHotelRoomRatePriceRangeEnum {
  Undecided = 'Undecided',
  To4000 = 'To4000',
  From4001To7000 = 'From4001To7000',
  From7001To10000 = 'From7001To10000',
  From10001To15000 = 'From10001To15000',
  From15001 = 'From15001'
}

export type VacantHotelRoomRatePromotions = {
  __typename?: 'VacantHotelRoomRatePromotions';
  deal?: Maybe<VacantHotelRoomRatePromotionsDeal>;
  valueAdds: Array<Scalars['String']>;
};

export type VacantHotelRoomRatePromotionsDeal = {
  __typename?: 'VacantHotelRoomRatePromotionsDeal';
  id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type VacantHotelRoomView = {
  __typename?: 'VacantHotelRoomView';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type VacantHotelRooms = {
  __typename?: 'VacantHotelRooms';
  rooms: Array<VacantHotelRoom>;
};

export type VacantHotelRoomsInput = {
  expediaHotelId: Scalars['String'];
  checkInDate: Scalars['String'];
  checkOutDate: Scalars['String'];
  occupancies: Array<OccupancyInput>;
  isMember: Scalars['Boolean'];
  productType: ProductType;
};

export type VacantHotelSummary = Node & IHotelSummary & {
  __typename?: 'VacantHotelSummary';
  /** ID */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ExpediaのホテルID */
  expediaHotelId: Scalars['String'];
  /** ホテル名 */
  name: Scalars['String'];
  /** こころからでのレーティング */
  rating?: Maybe<Scalars['String']>;
  /** 位置情報 */
  zoneInfo: VacantHotelSummaryZoneInfo;
  /** 宿泊数 */
  numberOfStays: Scalars['Int'];
  /** 宿泊人数 */
  numberOfPeople: Scalars['Int'];
  /** 最低料金情報 */
  minimumPriceInfo: VacantHotelSummaryMinimumPriceInfo;
  /** ホテルの画像 */
  images: Array<HotelImage>;
  /** キャンセル無料期間の期限 */
  freeCancellation?: Maybe<Scalars['String']>;
  /** チェックインの情報 */
  checkin?: Maybe<Checkin>;
};

export type VacantHotelSummaryMinimumPriceInfo = {
  __typename?: 'VacantHotelSummaryMinimumPriceInfo';
  /** こころからの取扱手数料が含まれた合計料金 */
  inclusivePrice: Scalars['Int'];
  /** セールなどでの割引があるときの割引前の料金 */
  strikeThroughPrice?: Maybe<Scalars['Int']>;
  /** セールなどの割引があるときのラベル */
  discountLabel?: Maybe<Scalars['String']>;
  /** 会員割引が適用されているか */
  isMemberDiscount?: Maybe<Scalars['Boolean']>;
  /** 会員割引が利用可能か */
  isAvailableMemberDiscount?: Maybe<Scalars['Boolean']>;
};

export type VacantHotelSummaryPriceInfoForDpFlight = {
  __typename?: 'VacantHotelSummaryPriceInfoForDPFlight';
  /** 1名あたりの最低料金 */
  minimumPricePerPerson: Scalars['Int'];
  /** 割引情報 */
  discountInfo?: Maybe<DiscountInfoForDpFlight>;
  /** CartSnapshotで選択済みのホテルと比較した場合の1名あたりの税サ込みの合計金額の差額 */
  priceDiff?: Maybe<Scalars['Int']>;
};

/** ホテルの位置情報 */
export type VacantHotelSummaryZoneInfo = ICocolocalaZone & {
  __typename?: 'VacantHotelSummaryZoneInfo';
  /** エリアのID */
  areaId: Scalars['Int'];
  /** エリアのパス */
  areaPath: Scalars['String'];
  /** エリアの表示名 */
  areaName: Scalars['String'];
  /** 地域のID */
  districtId: Scalars['Int'];
  /** 地域のパス */
  districtPath: Scalars['String'];
  /** 地域の表示名 */
  districtName: Scalars['String'];
  /** 都道府県のID */
  prefectureId: Scalars['Int'];
  /** 都道府県のパス */
  prefecturePath: Scalars['String'];
  /** 都道府県の表示名 */
  prefectureName: Scalars['String'];
  /** 地方のID */
  regionId: Scalars['Int'];
  /** 地方のパス */
  regionPath: Scalars['String'];
  /** 地方の表示名 */
  regionName: Scalars['String'];
  /** 国のコード（2文字のJP等） */
  countryCode: Scalars['String'];
  /** 国の表示名 */
  countryName: Scalars['String'];
  /** 国の中にエリアが一つしかないかどうか */
  isOnlyOneAreaInCountry?: Maybe<Scalars['Boolean']>;
  /** 地方の中にエリアが一つしかないかどうか */
  isOnlyOneAreaInRegion?: Maybe<Scalars['Boolean']>;
};

export type VacantHotels = IPaginationResult & {
  __typename?: 'VacantHotels';
  /** 空室のホテルの一覧 */
  vacantHotels: Array<VacantHotelSummary>;
  /** ページネーション結果 */
  pagination: Pagination;
};

export type VacantHotelsFiltersInput = {
  /** ホテルIDの指定 */
  cocolocalaHotelIds: Array<Scalars['String']>;
  /** ホテルのランクのフィルター */
  rankFilters: Array<HotelRankFilter>;
  /** 口コミの範囲 (0.0~5.0) */
  ratingGuestAverageFilter?: Maybe<HotelRangeFilter>;
  /** 価格帯の絞り込み */
  priceRangeFilters: Array<HotelPriceRange>;
  /** 割引率 (0.0~1.0) */
  discountRateRangeFilter?: Maybe<HotelRangeFilter>;
  /** セール料金があるか */
  hasDiscount?: Maybe<Scalars['Boolean']>;
  /** ホテルのタイプ指定 */
  hotelTypeFilters: Array<HotelTypeFilter>;
  /** キャンセル無料か */
  hasFreeCancellation?: Maybe<Scalars['Boolean']>;
};

export type VacantHotelsForDpFlight = {
  __typename?: 'VacantHotelsForDPFlight';
  /** 空室のホテルの一覧 */
  vacantHotels: Array<VacantHotelsForDpFlightHotelDetail>;
  /** 人数分の海外航空券の最低料金(税・サービス料抜き) */
  minimumFlightPrice?: Maybe<Scalars['Int']>;
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  inclusivePriceInfo?: Maybe<InclusivePriceInfo>;
};

export type VacantHotelsForDpFlightHotelDetail = Node & {
  __typename?: 'VacantHotelsForDPFlightHotelDetail';
  /** ID */
  id: Scalars['ID'];
  /** こころからのホテルID */
  cocolocalaHotelId: Scalars['Int'];
  /** ホテル名 */
  name: Scalars['String'];
  /** ホテルの説明文 */
  summaryTitle?: Maybe<Scalars['String']>;
  /** こころからでのレーティング */
  rating: Scalars['Int'];
  /** 宿泊数 */
  numberOfStays: Scalars['Int'];
  /** ホテル・航空券・海外あんしんサポートを合わせた税サ込の合計料金の情報 */
  priceInfo: VacantHotelSummaryPriceInfoForDpFlight;
  /** 人気順を表す値 小さい値ほど人気 */
  popularScore: Scalars['Int'];
  /** ホテルの画像 */
  images: Array<Scalars['String']>;
};

export type VacantHotelsForDpFlightInput = {
  vacantHotelsInput?: Maybe<VacantHotelsInputForDpFlight>;
  vacantHotelsForOrderConfirmInput?: Maybe<VacantHotelsForOrderConfirmInput>;
};

export type VacantHotelsForOrderConfirmInput = {
  cartSnapshotId: Scalars['String'];
};

export type VacantHotelsInput = {
  /** チェックインの日付 */
  checkInDate: Scalars['String'];
  /** チェックアウトの日付 */
  checkOutDate: Scalars['String'];
  /** 宿泊人数 */
  occupancies: Array<OccupancyInput>;
  zone?: Maybe<VacantHotelsZoneInput>;
  /** ページネーション指定 */
  pagination: PaginationInput;
  /** 空室検索のタイプ */
  searchType: VacantHotelsSearchType;
  sortType?: Maybe<HotelSortType>;
  filters?: Maybe<VacantHotelsFiltersInput>;
  isMember: Scalars['Boolean'];
};

export type VacantHotelsInputForDpFlight = {
  /** 出発の場所や空港のIATAコード */
  departureCityOrAirportIATACode: Scalars['String'];
  /** 到着の場所や空港のIATAコード */
  arrivalCityOrAirportIATACode: Scalars['String'];
  /** 行きのフライトの出発日 (YYYY-MM-DD) */
  goingDate: Scalars['String'];
  /** 帰りのフライトの出発日 (YYYY-MM-DD) */
  returningDate: Scalars['String'];
  /** チェックインの日付 (YYYY-MM-DD) */
  checkInDate: Scalars['String'];
  /** チェックアウトの日付 (YYYY-MM-DD) */
  checkOutDate: Scalars['String'];
  /** 宿泊人数 */
  occupancies: Array<OccupancyInput>;
  /** 海外航空券の最低料金（2ページ目以降で航空券の計算の省略のために利用する） */
  minimumFlightPrice?: Maybe<Scalars['Int']>;
  /** キャッシュのみを返すフラグ */
  cacheOnly?: Maybe<Scalars['Boolean']>;
};

export enum VacantHotelsSearchType {
  /** ホテル単体 */
  HotelOnly = 'HOTEL_ONLY',
  /** レンタカーDP */
  DpCar = 'DP_CAR'
}

export type VacantHotelsZoneInput = {
  /** こころからのdistrictId.指定されたdistrictに属するホテルの人気順の最初のホテルの周辺を検索する */
  regionName?: Maybe<Scalars['String']>;
  /** こころからのregionName.指定されたregionに属するホテルの人気順の最初のホテルの周辺を検索する */
  prefectureName?: Maybe<Scalars['String']>;
  /** こころからのprefectureName.指定されたprefectureに属するホテルの人気順の最初のホテルの周辺を検索する */
  districtId?: Maybe<Scalars['String']>;
  /** こころからのareaId.指定されたareaに属するホテルの人気順の最初のホテルの周辺を検索する */
  areaId?: Maybe<Scalars['String']>;
};


export type ZoneBasicInfomration = {
  __typename?: 'ZoneBasicInfomration';
  /** 言語 */
  language?: Maybe<Scalars['String']>;
  /** 気候・天気 */
  climate?: Maybe<Scalars['String']>;
  /** ベストシーズン */
  bestSeason?: Maybe<Scalars['String']>;
  /** フライト時間 */
  flightHour?: Maybe<Scalars['String']>;
  /** 日本の時差 */
  timeZone?: Maybe<Scalars['String']>;
  /** お金 */
  currency?: Maybe<Scalars['String']>;
  /** チップの習慣 */
  tippingEtiquette?: Maybe<Scalars['String']>;
  /** 現地での交通手段 */
  transportation?: Maybe<Scalars['String']>;
};

export type ZoneInfo = {
  __typename?: 'ZoneInfo';
  /** 表示名 */
  name: Scalars['String'];
  /** 遷移先のパス */
  path: Scalars['String'];
};

export enum ZoneTypeEnum {
  Country = 'country',
  Region = 'region',
  Prefecture = 'prefecture',
  District = 'district',
  Area = 'area'
}

export type AddBookmarkHotelMutationVariables = Exact<{
  input: AddBookmarkHotelInput;
}>;


export type AddBookmarkHotelMutation = (
  { __typename?: 'Mutation' }
  & { addBookmarkHotel: (
    { __typename?: 'AddBookmarkHotelPayload' }
    & Pick<AddBookmarkHotelPayload, 'ok'>
  ) }
);

export type AddDpCarToCartsForOrderPurchaseMutationVariables = Exact<{
  input: AddDpCarToCartsForOrderPurchaseInput;
}>;


export type AddDpCarToCartsForOrderPurchaseMutation = (
  { __typename?: 'Mutation' }
  & { addDPCarToCartsForOrderPurchase: (
    { __typename?: 'AddToCartPayload' }
    & Pick<AddToCartPayload, 'ok'>
  ) }
);

export type AddHotelToCartMutationVariables = Exact<{
  input: AddHotelToCartInput;
}>;


export type AddHotelToCartMutation = (
  { __typename?: 'Mutation' }
  & { addHotelToCart: (
    { __typename?: 'AddToCartPayload' }
    & Pick<AddToCartPayload, 'ok'>
  ) }
);

export type AddHotelToCartsForOrderPurchaseMutationVariables = Exact<{
  input: AddHotelToCartsForOrderPurchaseInput;
}>;


export type AddHotelToCartsForOrderPurchaseMutation = (
  { __typename?: 'Mutation' }
  & { addHotelToCartsForOrderPurchase: (
    { __typename?: 'AddToCartPayload' }
    & Pick<AddToCartPayload, 'ok'>
  ) }
);

export type AddSelectedCancelForAnyReasonMutationVariables = Exact<{
  input: AddSelectedCancelForAnyReasonInput;
}>;


export type AddSelectedCancelForAnyReasonMutation = (
  { __typename?: 'Mutation' }
  & { addSelectedCancelForAnyReason: (
    { __typename?: 'AddSelectedCancelForAnyReasonPayload' }
    & Pick<AddSelectedCancelForAnyReasonPayload, 'cartSnapshotId'>
  ) }
);

export type ApplyReservationMutationVariables = Exact<{
  input: ApplyReservationInput;
}>;


export type ApplyReservationMutation = (
  { __typename?: 'Mutation' }
  & { applyReservation: (
    { __typename?: 'ApplyReservationPayload' }
    & Pick<ApplyReservationPayload, 'id' | 'orderId' | 'travelId' | 'cocolocalaUserId' | 'firebaseUserId' | 'totalAmount'>
    & { hotelInfo?: Maybe<(
      { __typename?: 'ApplyReservationHotelInfo' }
      & Pick<ApplyReservationHotelInfo, 'cocolocalaHotelId' | 'checkInDate' | 'checkOutDate' | 'nights' | 'numberOfPeople' | 'numberOfAdults' | 'numberOfChildren' | 'numberOfBabies' | 'hotelName' | 'mealLabel'>
    )>, flightInfo?: Maybe<(
      { __typename?: 'ApplyReservationFlightInfo' }
      & Pick<ApplyReservationFlightInfo, 'flightReservationId'>
    )>, logInfo: (
      { __typename?: 'ApplyReservationLogInfo' }
      & Pick<ApplyReservationLogInfo, 'email'>
    ) }
  ) }
);

export type ApplyReservationViaFincodeMutationVariables = Exact<{
  input: ApplyReservationViaFincodeInput;
}>;


export type ApplyReservationViaFincodeMutation = (
  { __typename?: 'Mutation' }
  & { applyReservationViaFincode: (
    { __typename?: 'ApplyReservationViaFincodePayload' }
    & Pick<ApplyReservationViaFincodePayload, 'id' | 'orderId'>
    & { needChallengeInfo?: Maybe<(
      { __typename?: 'ApplyReservationViaFincodeNeedChallenge' }
      & Pick<ApplyReservationViaFincodeNeedChallenge, 'challengeUrl'>
    )>, withoutChallengeInfo?: Maybe<(
      { __typename?: 'ApplyReservationPayload' }
      & Pick<ApplyReservationPayload, 'id' | 'orderId' | 'travelId' | 'cocolocalaUserId' | 'firebaseUserId' | 'totalAmount'>
      & { hotelInfo?: Maybe<(
        { __typename?: 'ApplyReservationHotelInfo' }
        & Pick<ApplyReservationHotelInfo, 'cocolocalaHotelId' | 'checkInDate' | 'checkOutDate' | 'nights' | 'numberOfPeople' | 'numberOfAdults' | 'numberOfChildren' | 'numberOfBabies' | 'hotelName' | 'mealLabel'>
      )>, flightInfo?: Maybe<(
        { __typename?: 'ApplyReservationFlightInfo' }
        & Pick<ApplyReservationFlightInfo, 'flightReservationId'>
      )>, logInfo: (
        { __typename?: 'ApplyReservationLogInfo' }
        & Pick<ApplyReservationLogInfo, 'email'>
      ) }
    )> }
  ) }
);

export type ApplyReservationViaStripeMutationVariables = Exact<{
  input: ApplyReservationViaStripeInput;
}>;


export type ApplyReservationViaStripeMutation = (
  { __typename?: 'Mutation' }
  & { applyReservationViaStripe: (
    { __typename?: 'ApplyReservationPayload' }
    & Pick<ApplyReservationPayload, 'id' | 'orderId' | 'travelId' | 'cocolocalaUserId' | 'firebaseUserId' | 'totalAmount'>
    & { hotelInfo?: Maybe<(
      { __typename?: 'ApplyReservationHotelInfo' }
      & Pick<ApplyReservationHotelInfo, 'cocolocalaHotelId' | 'checkInDate' | 'checkOutDate' | 'nights' | 'numberOfPeople' | 'numberOfAdults' | 'numberOfChildren' | 'numberOfBabies' | 'hotelName' | 'mealLabel'>
    )>, flightInfo?: Maybe<(
      { __typename?: 'ApplyReservationFlightInfo' }
      & Pick<ApplyReservationFlightInfo, 'flightReservationId'>
    )>, logInfo: (
      { __typename?: 'ApplyReservationLogInfo' }
      & Pick<ApplyReservationLogInfo, 'email'>
    ) }
  ) }
);

export type ChangeDpFlightCancelForAnyReasonMutationVariables = Exact<{
  input: ChangeDpFlightCancelForAnyReasonInput;
}>;


export type ChangeDpFlightCancelForAnyReasonMutation = (
  { __typename?: 'Mutation' }
  & { changeDPFlightCancelForAnyReason: (
    { __typename?: 'ChangeDPFlightCancelForAnyReasonPayload' }
    & Pick<ChangeDpFlightCancelForAnyReasonPayload, 'cartSnapshotId'>
    & { orderPriceInfo: (
      { __typename?: 'OrderPriceInfoForOrderConfirm' }
      & FOrderPriceInfoForOrderConfirmFragment
    ) }
  ) }
);

export type ChangeDpFlightOptionsMutationVariables = Exact<{
  input: ChangeDpFlightOptionsInput;
}>;


export type ChangeDpFlightOptionsMutation = (
  { __typename?: 'Mutation' }
  & { changeDPFlightOptions: (
    { __typename?: 'ChangeDPFlightOptionsPayload' }
    & Pick<ChangeDpFlightOptionsPayload, 'cartSnapshotId'>
    & { orderPriceInfo: (
      { __typename?: 'OrderPriceInfoForOrderConfirm' }
      & FOrderPriceInfoForOrderConfirmFragment
    ) }
  ) }
);

export type ChangeDpFlightSupportPlanMutationVariables = Exact<{
  input: ChangeDpFlightSupportPlanInput;
}>;


export type ChangeDpFlightSupportPlanMutation = (
  { __typename?: 'Mutation' }
  & { changeDPFlightSupportPlan: (
    { __typename?: 'ChangeDPFlightSupportPlanPayload' }
    & Pick<ChangeDpFlightSupportPlanPayload, 'cartSnapshotId'>
    & { orderPriceInfo: (
      { __typename?: 'OrderPriceInfoForOrderConfirm' }
      & FOrderPriceInfoForOrderConfirmFragment
    ) }
  ) }
);

export type ChangeFlightMutationVariables = Exact<{
  input: ChangeFlightInput;
}>;


export type ChangeFlightMutation = (
  { __typename?: 'Mutation' }
  & { changeFlight: (
    { __typename?: 'ChangeFlightPayload' }
    & Pick<ChangeFlightPayload, 'cartSnapshotId'>
  ) }
);

export type ChangeHotelRoomMutationVariables = Exact<{
  input: ChangeHotelRoomInput;
}>;


export type ChangeHotelRoomMutation = (
  { __typename?: 'Mutation' }
  & { changeHotelRoom: (
    { __typename?: 'ChangeHotelRoomPayload' }
    & Pick<ChangeHotelRoomPayload, 'cartSnapshotId'>
  ) }
);

export type ChangeSelectedBaggageOptionMutationVariables = Exact<{
  input: ChangeSelectedBaggageOptionInput;
}>;


export type ChangeSelectedBaggageOptionMutation = (
  { __typename?: 'Mutation' }
  & { changeSelectedBaggageOption: (
    { __typename?: 'ChangeSelectedBaggageOptionPayload' }
    & Pick<ChangeSelectedBaggageOptionPayload, 'cartSnapshotId'>
    & { orderPriceInfo: (
      { __typename?: 'OrderPriceInfoForOrderConfirm' }
      & FOrderPriceInfoForOrderConfirmFragment
    ) }
  ) }
);

export type ChangeUseAirportTransferMutationVariables = Exact<{
  input: ChangeUseAirportTransferInput;
}>;


export type ChangeUseAirportTransferMutation = (
  { __typename?: 'Mutation' }
  & { changeUseAirportTransfer: (
    { __typename?: 'ChangeUseAirportTransferPayload' }
    & Pick<ChangeUseAirportTransferPayload, 'cartSnapshotId'>
  ) }
);

export type ConfirmReservationViaFincodeMutationVariables = Exact<{
  input: ConfirmReservationViaFincodeInput;
}>;


export type ConfirmReservationViaFincodeMutation = (
  { __typename?: 'Mutation' }
  & { confirmReservationViaFincode: (
    { __typename?: 'ApplyReservationPayload' }
    & Pick<ApplyReservationPayload, 'id' | 'orderId' | 'travelId' | 'cocolocalaUserId' | 'firebaseUserId' | 'totalAmount'>
    & { hotelInfo?: Maybe<(
      { __typename?: 'ApplyReservationHotelInfo' }
      & Pick<ApplyReservationHotelInfo, 'cocolocalaHotelId' | 'checkInDate' | 'checkOutDate' | 'nights' | 'numberOfPeople' | 'numberOfAdults' | 'numberOfChildren' | 'numberOfBabies' | 'hotelName' | 'mealLabel'>
    )>, flightInfo?: Maybe<(
      { __typename?: 'ApplyReservationFlightInfo' }
      & Pick<ApplyReservationFlightInfo, 'flightReservationId'>
    )>, logInfo: (
      { __typename?: 'ApplyReservationLogInfo' }
      & Pick<ApplyReservationLogInfo, 'email'>
    ) }
  ) }
);

export type MigrateAnonymouseUserToAuthenticatedUserMutationVariables = Exact<{
  input: MigrateAnonymouseUserToAuthenticatedUserInput;
}>;


export type MigrateAnonymouseUserToAuthenticatedUserMutation = (
  { __typename?: 'Mutation' }
  & { migrateAnonymouseUserToAuthenticatedUser: (
    { __typename?: 'MigrateAnonymouseUserToAuthenticatedUserPayload' }
    & Pick<MigrateAnonymouseUserToAuthenticatedUserPayload, 'anonymouseUid' | 'authenticatedUid'>
  ) }
);

export type PrepareReservationViaFincodeMutationVariables = Exact<{
  input: PrepareReservationViaFincodeInput;
}>;


export type PrepareReservationViaFincodeMutation = (
  { __typename?: 'Mutation' }
  & { prepareReservationViaFincode: (
    { __typename?: 'PrepareReservationViaFincodePayload' }
    & Pick<PrepareReservationViaFincodePayload, 'id' | 'orderId' | 'acsUrl'>
  ) }
);

export type PrepareReservationViaStripeMutationVariables = Exact<{
  input: PrepareReservationViaStripeInput;
}>;


export type PrepareReservationViaStripeMutation = (
  { __typename?: 'Mutation' }
  & { prepareReservationViaStripe: (
    { __typename?: 'PrepareReservationViaStripePayload' }
    & Pick<PrepareReservationViaStripePayload, 'id' | 'orderId'>
    & { need3DSecure?: Maybe<(
      { __typename?: 'PrepareReservationViaStripeNeed3DSecure' }
      & Pick<PrepareReservationViaStripeNeed3DSecure, 'clientSecretKey'>
    )>, without3DSecure?: Maybe<(
      { __typename?: 'ApplyReservationPayload' }
      & Pick<ApplyReservationPayload, 'id' | 'orderId' | 'travelId' | 'cocolocalaUserId' | 'firebaseUserId' | 'totalAmount'>
      & { hotelInfo?: Maybe<(
        { __typename?: 'ApplyReservationHotelInfo' }
        & Pick<ApplyReservationHotelInfo, 'cocolocalaHotelId' | 'checkInDate' | 'checkOutDate' | 'nights' | 'numberOfPeople' | 'numberOfAdults' | 'numberOfChildren' | 'numberOfBabies' | 'hotelName' | 'mealLabel'>
      )>, flightInfo?: Maybe<(
        { __typename?: 'ApplyReservationFlightInfo' }
        & Pick<ApplyReservationFlightInfo, 'flightReservationId'>
      )>, logInfo: (
        { __typename?: 'ApplyReservationLogInfo' }
        & Pick<ApplyReservationLogInfo, 'email'>
      ) }
    )> }
  ) }
);

export type RemoveBookmarkHotelMutationVariables = Exact<{
  input: RemoveBookmarkHotelInput;
}>;


export type RemoveBookmarkHotelMutation = (
  { __typename?: 'Mutation' }
  & { removeBookmarkHotel: (
    { __typename?: 'RemoveBookmarkHotelPayload' }
    & Pick<RemoveBookmarkHotelPayload, 'ok'>
  ) }
);

export type SaveOrderReservationInformationMutationVariables = Exact<{
  input: SaveOrderReservationInformationInput;
}>;


export type SaveOrderReservationInformationMutation = (
  { __typename?: 'Mutation' }
  & { saveOrderReservationInformation: (
    { __typename?: 'SaveOrderReservationInformationPayload' }
    & Pick<SaveOrderReservationInformationPayload, 'ok'>
  ) }
);

export type SavePassportMutationVariables = Exact<{
  input: SavePassportInput;
}>;


export type SavePassportMutation = (
  { __typename?: 'Mutation' }
  & { savePassport: (
    { __typename?: 'SavePassportPayload' }
    & Pick<SavePassportPayload, 'ok'>
  ) }
);

export type SendEmergencyContactMutationVariables = Exact<{
  input: SendEmergencyContactInput;
}>;


export type SendEmergencyContactMutation = (
  { __typename?: 'Mutation' }
  & { sendEmergencyContact: (
    { __typename?: 'SendEmergencyContactPayload' }
    & Pick<SendEmergencyContactPayload, 'ok'>
  ) }
);

export type SendSelectedProductsMutationVariables = Exact<{
  input: SendSelectedProductsInput;
}>;


export type SendSelectedProductsMutation = (
  { __typename?: 'Mutation' }
  & { sendSelectedProducts: (
    { __typename?: 'SendSelectedProductsPayload' }
    & Pick<SendSelectedProductsPayload, 'ok'>
  ) }
);

export type UpdateEmailMutationVariables = Exact<{
  input: UpdateEmailInput;
}>;


export type UpdateEmailMutation = (
  { __typename?: 'Mutation' }
  & { updateEmail: (
    { __typename?: 'UpdateEmailPayload' }
    & Pick<UpdateEmailPayload, 'email'>
  ) }
);

export type UpdateOrderTodoListMutationVariables = Exact<{
  input: UpdateOrderTodoListInput;
}>;


export type UpdateOrderTodoListMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderTodoList: (
    { __typename?: 'UpdateOrderTodoListPayload' }
    & Pick<UpdateOrderTodoListPayload, 'ok'>
  ) }
);

export type ChildZonesQueryVariables = Exact<{
  input: GetChildZonesInput;
}>;


export type ChildZonesQuery = (
  { __typename?: 'Query' }
  & { childZones: Array<Maybe<(
    { __typename?: 'GqlZoneType' }
    & ZoneFragmentFragment
  )>> }
);

export type FetchAroundVacantHotelsQueryVariables = Exact<{
  aroundVacantHotelsInput: AroundVacantHotelsInput;
}>;


export type FetchAroundVacantHotelsQuery = (
  { __typename?: 'Query' }
  & { aroundVacantHotels: (
    { __typename?: 'AroundVacantHotels' }
    & { result: Array<(
      { __typename?: 'HotelListItemData' }
      & Pick<HotelListItemData, 'id' | 'name' | 'rating' | 'areaId' | 'areaName' | 'districtId' | 'prefectureId' | 'prefectureName' | 'regionId' | 'distance' | 'imageUrls'>
      & { relationalServiceIds?: Maybe<(
        { __typename?: 'RelationalServiceIds' }
        & Pick<RelationalServiceIds, 'agoda' | 'expedia' | 'googlePlace' | 'rakuten'>
      )>, rates: Array<(
        { __typename?: 'Rate' }
        & FRateFragment
      )>, minimumRate?: Maybe<(
        { __typename?: 'Rate' }
        & FRateFragment
      )>, minimumPricingPerOne?: Maybe<(
        { __typename?: 'MinimumPricing' }
        & FMinimumPricingFragment
      )>, minimumPricingPerTwo?: Maybe<(
        { __typename?: 'MinimumPricing' }
        & FMinimumPricingFragment
      )>, conditions?: Maybe<(
        { __typename?: 'Conditions' }
        & Pick<Conditions, 'priceRangeConditions' | 'bedTypeConditions' | 'smokingConditions' | 'wifiConditions' | 'japaneseConditions'>
      )> }
    )>, pagination: (
      { __typename?: 'PaginationData' }
      & Pick<PaginationData, 'total' | 'resultCount' | 'paginationSize' | 'page'>
    ) }
  ) }
);

export type FetchFlightTicketStatusQueryVariables = Exact<{
  input: FlightTicketStatusInput;
}>;


export type FetchFlightTicketStatusQuery = (
  { __typename?: 'Query' }
  & { flightTicketStatus: (
    { __typename?: 'FlightTicketStatus' }
    & Pick<FlightTicketStatus, 'status'>
    & { redirectInfo?: Maybe<(
      { __typename?: 'RedirectInfo' }
      & Pick<RedirectInfo, 'cocolocalaHotelId' | 'queryParameterForSelectGoingFlight' | 'queryParameterForHotel'>
    )> }
  ) }
);

export type FetchJpTopPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJpTopPageQuery = (
  { __typename?: 'Query' }
  & { jpTopPage: (
    { __typename?: 'JpTopPage' }
    & { campaignBanners: Array<(
      { __typename?: 'CampaignBanner' }
      & Pick<CampaignBanner, 'description' | 'linkUrl'>
      & { imageData: (
        { __typename?: 'ImageData' }
        & FImageDataFragment
      ) }
    )>, popularAreaDescription: (
      { __typename?: 'PopularAreaDescription' }
      & Pick<PopularAreaDescription, 'description' | 'thumbnailUrl'>
    ), areas: Array<(
      { __typename?: 'Area' }
      & Pick<Area, 'name' | 'thumbnailUrl' | 'path' | 'type' | 'count'>
    )>, popularHotels: Array<(
      { __typename?: 'HotelData' }
      & Pick<HotelData, 'id' | 'name' | 'rating' | 'areaName' | 'prefectureName' | 'date' | 'inclusivePrice' | 'exclusivePrice' | 'strikeThroughPrice' | 'numberOfAdults' | 'imageUrl'>
    )>, saleHotels: Array<(
      { __typename?: 'HotelData' }
      & Pick<HotelData, 'id' | 'name' | 'rating' | 'areaName' | 'prefectureName' | 'date' | 'inclusivePrice' | 'exclusivePrice' | 'strikeThroughPrice' | 'numberOfAdults' | 'imageUrl'>
    )>, popularPlans: Array<(
      { __typename?: 'RecommendedPlanData' }
      & Pick<RecommendedPlanData, 'planId' | 'title' | 'areaName'>
      & { thumbnail: (
        { __typename?: 'ImageData' }
        & FImageDataFragment
      ) }
    )>, popularDestinations: Array<(
      { __typename?: 'PopularDestination' }
      & Pick<PopularDestination, 'label' | 'path'>
    )> }
  ) }
);

export type FetchOverseasTopPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchOverseasTopPageQuery = (
  { __typename?: 'Query' }
  & { overseasTop: (
    { __typename?: 'OverseasTop' }
    & { campaignBanners: Array<(
      { __typename?: 'CampaignBanner' }
      & Pick<CampaignBanner, 'description' | 'linkUrl'>
      & { imageData: (
        { __typename?: 'ImageData' }
        & FImageDataFragment
      ) }
    )>, popularAreaDescription: (
      { __typename?: 'PopularAreaDescription' }
      & Pick<PopularAreaDescription, 'description' | 'thumbnailUrl'>
    ), popularAreas: Array<(
      { __typename?: 'OverseasTopArea' }
      & Pick<OverseasTopArea, 'name' | 'thumbnailUrl' | 'path'>
    )>, popularDestinations: Array<(
      { __typename?: 'PopularDestination' }
      & Pick<PopularDestination, 'label' | 'path'>
    )> }
  ) }
);

export type FetchTopPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchTopPageQuery = (
  { __typename?: 'Query' }
  & { topPage: (
    { __typename?: 'TopPage' }
    & { campaignBanners: Array<(
      { __typename?: 'CampaignBanner' }
      & Pick<CampaignBanner, 'description' | 'linkUrl'>
      & { imageData: (
        { __typename?: 'ImageData' }
        & FImageDataFragment
      ) }
    )>, overseasPopularAreaDescription: (
      { __typename?: 'PopularAreaDescription' }
      & Pick<PopularAreaDescription, 'description' | 'thumbnailUrl'>
    ), overseasPopularAreas: Array<(
      { __typename?: 'OverseasTopArea' }
      & Pick<OverseasTopArea, 'name' | 'thumbnailUrl' | 'path'>
    )>, overseasPopularDestinations: Array<(
      { __typename?: 'PopularDestination' }
      & Pick<PopularDestination, 'label' | 'path'>
    )>, jpPopularAreaDescription: (
      { __typename?: 'PopularAreaDescription' }
      & Pick<PopularAreaDescription, 'description' | 'thumbnailUrl'>
    ), jpPopularDestinations: Array<(
      { __typename?: 'PopularDestination' }
      & Pick<PopularDestination, 'label' | 'path'>
    )>, jpPopularAreas: Array<(
      { __typename?: 'Area' }
      & Pick<Area, 'name' | 'thumbnailUrl' | 'path' | 'type' | 'count'>
    )>, saleHotels: Array<(
      { __typename?: 'HotelData' }
      & Pick<HotelData, 'id' | 'name' | 'rating' | 'areaName' | 'prefectureName' | 'date' | 'inclusivePrice' | 'exclusivePrice' | 'strikeThroughPrice' | 'numberOfAdults' | 'imageUrl'>
    )> }
  ) }
);

export type FilterAvailableDpCarVendorsQueryVariables = Exact<{
  filterAvailableDPCarVendorsInput: FilterAvailableDpCarVendorsInput;
}>;


export type FilterAvailableDpCarVendorsQuery = (
  { __typename?: 'Query' }
  & { dPCarVendors: Array<(
    { __typename?: 'DPCarVendor' }
    & FdpCarVendorFragment
  )> }
);

export type FindFlightsForDpFlightQueryVariables = Exact<{
  input: FlightsForDpFlightInput;
}>;


export type FindFlightsForDpFlightQuery = (
  { __typename?: 'Query' }
  & { flightsForDPFlight: (
    { __typename?: 'FlightsForDPFlight' }
    & Pick<FlightsForDpFlight, 'routingId' | 'isPollingRequired'>
    & { flights: Array<(
      { __typename?: 'Flight' }
      & FFlightFragment
    )>, inclusivePriceInfo: (
      { __typename?: 'InclusivePriceInfo' }
      & Pick<InclusivePriceInfo, 'numberOfStays' | 'numberOfPeople' | 'total' | 'perPerson'>
    ), logInfo?: Maybe<(
      { __typename?: 'FlightsForDPFlightLogInfo' }
      & { going: (
        { __typename?: 'GoingAndReturningFlightsLogInfo' }
        & Pick<GoingAndReturningFlightsLogInfo, 'originalCarrierIATACode' | 'originalFlightNumber'>
      ), returning: (
        { __typename?: 'GoingAndReturningFlightsLogInfo' }
        & Pick<GoingAndReturningFlightsLogInfo, 'originalCarrierIATACode' | 'originalFlightNumber'>
      ) }
    )> }
  ) }
);

export type FilterHotelReviewsQueryVariables = Exact<{
  hotelReviewsInput: HotelReviewsInput;
}>;


export type FilterHotelReviewsQuery = (
  { __typename?: 'Query' }
  & { hotelReviews: (
    { __typename?: 'HotelReviews' }
    & { pagination: (
      { __typename?: 'Pagination' }
      & FPaginationFragment
    ), reviewItems: Array<(
      { __typename?: 'ReviewItemWithReviewUser' }
      & FReviewItemWithReviewUserFragment
    )> }
  ) }
);

export type FilterHotelsQueryVariables = Exact<{
  input: HotelsInput;
}>;


export type FilterHotelsQuery = (
  { __typename?: 'Query' }
  & { hotels: (
    { __typename?: 'Hotels' }
    & { hotels: Array<(
      { __typename?: 'HotelSummary' }
      & FHotelSummaryFragment
    )>, pagination: (
      { __typename?: 'PaginationWithPageInfo' }
      & Pick<PaginationWithPageInfo, 'hasNext' | 'nextOffset' | 'total' | 'paginationSize'>
    ) }
  ) }
);

export type FilterHotelsForDpFlightThemesQueryVariables = Exact<{
  input: HotelsForDpFlightThemesInput;
}>;


export type FilterHotelsForDpFlightThemesQuery = (
  { __typename?: 'Query' }
  & { hotelsForDPFlightThemes: (
    { __typename?: 'HotelsForDPFlightThemes' }
    & Pick<HotelsForDpFlightThemes, 'staffComment' | 'minimumFlightPrice'>
    & { hotels: Array<(
      { __typename?: 'TravelThemeHotelSummary' }
      & Pick<TravelThemeHotelSummary, 'id' | 'cocolocalaHotelId' | 'name' | 'summaryTitle' | 'rating' | 'numberOfStays' | 'imageUrl'>
      & { priceInfo?: Maybe<(
        { __typename?: 'TravelThemeHotelSummaryPriceInfo' }
        & Pick<TravelThemeHotelSummaryPriceInfo, 'minimumPricePerPerson'>
        & { discountInfo?: Maybe<(
          { __typename?: 'DiscountInfoForDPFlight' }
          & FDiscountInfoForDpFlightFragment
        )> }
      )> }
    )>, limitedTimeSaleInfo?: Maybe<(
      { __typename?: 'LimitedTimeSaleInfo' }
      & FLimitedTimeSaleInfoFragment
    )> }
  ) }
);

export type FilterOrderHistorySummariesQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterOrderHistorySummariesQuery = (
  { __typename?: 'Query' }
  & { orderHistorySummaries: Array<(
    { __typename?: 'OrderHistorySummary' }
    & Pick<OrderHistorySummary, 'id' | 'orderId'>
    & { labels: Array<(
      { __typename?: 'OrderHistorySummaryLabel' }
      & Pick<OrderHistorySummaryLabel, 'label' | 'orderStatus'>
    )>, detailsTableItems: Array<(
      { __typename?: 'DetailsTableItem' }
      & Pick<DetailsTableItem, 'title' | 'content'>
    )>, hotelInfo?: Maybe<(
      { __typename?: 'OrderHistorySummaryHotelInfo' }
      & Pick<OrderHistorySummaryHotelInfo, 'hotelName' | 'hotelThumbnailUrl' | 'roomName' | 'checkInDate' | 'checkOutDate' | 'availableCheckInTimeRange' | 'checkOutTime'>
    )>, flightInfo?: Maybe<(
      { __typename?: 'OrderHistorySummaryFlightInfo' }
      & Pick<OrderHistorySummaryFlightInfo, 'flightInfoText' | 'goingFlightFirstAirportIata' | 'goingFlightDepartureDate' | 'goingFlightDepartureTime' | 'goingFlightArrivalDate' | 'goingFlightArrivalTime' | 'returningFlightFirstAirportIata' | 'returningFlightDepartureDate' | 'returningFlightDepartureTime' | 'returningFlightArrivalDate' | 'returningFlightArrivalTime'>
    )> }
  )> }
);

export type FilterReviewItemsQueryVariables = Exact<{
  reviewItemsInput: ReviewItemsInput;
}>;


export type FilterReviewItemsQuery = (
  { __typename?: 'Query' }
  & { reviewItems: (
    { __typename?: 'ReviewItems' }
    & { pagination: (
      { __typename?: 'ReviewItemsPaginationResponse' }
      & FReviewItemsPaginationResponseFragment
    ), reviewItems: Array<(
      { __typename?: 'ReviewItemWithReviewUser' }
      & FReviewItemWithReviewUserFragment
    )> }
  ) }
);

export type FilterSpotsQueryVariables = Exact<{
  input: SpotsInput;
}>;


export type FilterSpotsQuery = (
  { __typename?: 'Query' }
  & { spots: (
    { __typename?: 'Spots' }
    & { hits: Array<(
      { __typename?: 'Spot' }
      & FSpotFragment
    )> }
  ) }
);

export type FilterVacantHotelsQueryVariables = Exact<{
  vacantHotelsInput: VacantHotelsInput;
}>;


export type FilterVacantHotelsQuery = (
  { __typename?: 'Query' }
  & { vacantHotels: (
    { __typename?: 'VacantHotels' }
    & { vacantHotels: Array<(
      { __typename?: 'VacantHotelSummary' }
      & FVacantHotelSummaryFragment
    )>, pagination: (
      { __typename?: 'Pagination' }
      & FPaginationFragment
    ) }
  ) }
);

export type FilterVacantHotelsForDpFlightQueryVariables = Exact<{
  input: VacantHotelsForDpFlightInput;
}>;


export type FilterVacantHotelsForDpFlightQuery = (
  { __typename?: 'Query' }
  & { vacantHotelsForDPFlight: (
    { __typename?: 'VacantHotelsForDPFlight' }
    & Pick<VacantHotelsForDpFlight, 'minimumFlightPrice'>
    & { vacantHotels: Array<(
      { __typename?: 'VacantHotelsForDPFlightHotelDetail' }
      & FVacantHotelsForDpFlightHotelDetailFragment
    )>, inclusivePriceInfo?: Maybe<(
      { __typename?: 'InclusivePriceInfo' }
      & FInclusivePriceInfoFragment
    )> }
  ) }
);

export type FindAirportQueryVariables = Exact<{
  input: AirportInput;
}>;


export type FindAirportQuery = (
  { __typename?: 'Query' }
  & { airport: (
    { __typename?: 'Airport' }
    & FAirportFragment
  ) }
);

export type FindAirportsForDpFlightThemesQueryVariables = Exact<{
  input: AirportsForDpFlightThemesInput;
}>;


export type FindAirportsForDpFlightThemesQuery = (
  { __typename?: 'Query' }
  & { airportsForDPFlightThemes: (
    { __typename?: 'AirportsForDPFlightThemes' }
    & Pick<AirportsForDpFlightThemes, 'imageUrl' | 'returningCityOrAirportIATACode' | 'zonePath'>
    & { departureAirports: Array<(
      { __typename?: 'AirportSection' }
      & FAirportSectionFragment
    )>, arrivalAirports: Array<(
      { __typename?: 'AirportSection' }
      & FAirportSectionFragment
    )> }
  ) }
);

export type FindCouponCodeQueryVariables = Exact<{
  input: CouponCodeInput;
}>;


export type FindCouponCodeQuery = (
  { __typename?: 'Query' }
  & { couponCode: (
    { __typename?: 'CouponCode' }
    & Pick<CouponCode, 'isAvailableDiscount' | 'isAvailableFifteenPercentDiscount' | 'isAvailablePerPersonDiscount' | 'couponCode' | 'isDPFlight'>
  ) }
);

export type FindDpFlightCancelForAnyReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDpFlightCancelForAnyReasonQuery = (
  { __typename?: 'Query' }
  & { dPFlightCancelForAnyReason: (
    { __typename?: 'DPFlightCancelForAnyReason' }
    & Pick<DpFlightCancelForAnyReason, 'numberOfStays' | 'numberOfPeople' | 'limitDateTimeText'>
    & { cancelForAnyReasonPrice: (
      { __typename?: 'DPFlightCancelForAnyReasonPrice' }
      & Pick<DpFlightCancelForAnyReasonPrice, 'totalPrice' | 'totalPricePerPerson' | 'inclusivePricePerPerson'>
    ), defaultPrice: (
      { __typename?: 'DPFlightCancelForAnyReasonPrice' }
      & Pick<DpFlightCancelForAnyReasonPrice, 'totalPrice' | 'totalPricePerPerson' | 'inclusivePricePerPerson'>
    ) }
  ) }
);

export type FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables = Exact<{
  input: DpFlightCancelForAnyReasonForOrderConfirmInput;
}>;


export type FindDpFlightCancelForAnyReasonForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { dPFlightCancelForAnyReasonForOrderConfirm: (
    { __typename?: 'DPFlightCancelForAnyReasonForOrderConfirm' }
    & Pick<DpFlightCancelForAnyReasonForOrderConfirm, 'numberOfStays' | 'numberOfPeople' | 'limitDateTimeText' | 'hasCancelForAnyReason'>
    & { cancelForAnyReasonPrice: (
      { __typename?: 'DPFlightCancelForAnyReasonPriceForOrderConfirm' }
      & Pick<DpFlightCancelForAnyReasonPriceForOrderConfirm, 'totalPrice' | 'totalPricePerPerson' | 'priceDiff'>
    ), defaultPrice: (
      { __typename?: 'DPFlightCancelForAnyReasonPriceForOrderConfirm' }
      & Pick<DpFlightCancelForAnyReasonPriceForOrderConfirm, 'totalPrice' | 'totalPricePerPerson' | 'priceDiff'>
    ) }
  ) }
);

export type FindDpFlightSupportPlanForOrderConfirmQueryVariables = Exact<{
  input: DpFlightSupportPlanForOrderConfirmInput;
}>;


export type FindDpFlightSupportPlanForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { dPFlightSupportPlanForOrderConfirm: (
    { __typename?: 'DPFlightSupportPlanForOrderConfirm' }
    & Pick<DpFlightSupportPlanForOrderConfirm, 'numberOfStays' | 'numberOfPeople' | 'selectedPlanType'>
    & { basicPlanPrice: (
      { __typename?: 'DPFlightSupportPlanPriceForOrderConfirm' }
      & Pick<DpFlightSupportPlanPriceForOrderConfirm, 'planType' | 'totalPricePerPerson' | 'totalPrice' | 'priceDiff'>
    ), allPlanPrice: (
      { __typename?: 'DPFlightSupportPlanPriceForOrderConfirm' }
      & Pick<DpFlightSupportPlanPriceForOrderConfirm, 'planType' | 'totalPricePerPerson' | 'totalPrice' | 'priceDiff'>
    ), overseasDPFlightPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )> }
  ) }
);

export type FindDpFlightThemeQueryVariables = Exact<{
  input: DpFlightThemeInput;
}>;


export type FindDpFlightThemeQuery = (
  { __typename?: 'Query' }
  & { dPFlightTheme: (
    { __typename?: 'DPFlightTheme' }
    & Pick<DpFlightTheme, 'zoneName' | 'zoneNameEn' | 'zonePath' | 'staffComment' | 'returningCityOrAirportIATACode' | 'arrivalAirportName' | 'arrivalAirportCityName'>
    & { parentZoneInfo?: Maybe<(
      { __typename?: 'ZoneInfo' }
      & FZoneInfoFragment
    )>, travelTheme: (
      { __typename?: 'TravelTheme' }
      & FTravelThemeFragment
    ), hotels: Array<(
      { __typename?: 'TravelThemeHotelSummary' }
      & Pick<TravelThemeHotelSummary, 'id' | 'cocolocalaHotelId' | 'name' | 'summaryTitle' | 'rating' | 'numberOfStays' | 'imageUrl'>
      & { priceInfo?: Maybe<(
        { __typename?: 'TravelThemeHotelSummaryPriceInfo' }
        & Pick<TravelThemeHotelSummaryPriceInfo, 'minimumPricePerPerson'>
        & { discountInfo?: Maybe<(
          { __typename?: 'DiscountInfoForDPFlight' }
          & FDiscountInfoForDpFlightFragment
        )> }
      )> }
    )>, supportPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, departureAirports: Array<(
      { __typename?: 'AirportSection' }
      & FAirportSectionFragment
    )>, recommendedThemes: Array<(
      { __typename?: 'TravelTheme' }
      & FTravelThemeFragment
    )>, lowestPriceSchedule: (
      { __typename?: 'FlightSchedule' }
      & Pick<FlightSchedule, 'goingDate' | 'returningDate'>
    ) }
  ) }
);

export type FindDpFlightThemesQueryVariables = Exact<{
  input: DpFlightThemesInput;
}>;


export type FindDpFlightThemesQuery = (
  { __typename?: 'Query' }
  & { dPFlightThemes: (
    { __typename?: 'DPFlightThemes' }
    & Pick<DpFlightThemes, 'zoneName' | 'zonePath' | 'headerImageUrl' | 'priorConfirmation'>
    & { parentZoneInfo?: Maybe<(
      { __typename?: 'ZoneInfo' }
      & FZoneInfoFragment
    )>, cities: Array<(
      { __typename?: 'TravelDestination' }
      & FTravelDestinationFragment
    )>, supportPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, recommendedTravelDestinations: Array<(
      { __typename?: 'TravelDestination' }
      & FTravelDestinationFragment
    )>, travelThemes: Array<(
      { __typename?: 'TravelTheme' }
      & FTravelThemeFragment
    )>, travelThemesFilter: (
      { __typename?: 'DPFlightTravelThemesFilter' }
      & FdpFlightTravelThemesFilterFragment
    ), limitedTimeSaleInfo?: Maybe<(
      { __typename?: 'LimitedTimeSaleInfo' }
      & FLimitedTimeSaleInfoFragment
    )>, campaignInfo?: Maybe<(
      { __typename?: 'CampaignInfo' }
      & FCampaignInfoFragment
    )> }
  ) }
);

export type FindFlightOptionsQueryVariables = Exact<{
  input: FlightOptionsInput;
}>;


export type FindFlightOptionsQuery = (
  { __typename?: 'Query' }
  & { flightOptions: (
    { __typename?: 'FlightOptions' }
    & Pick<FlightOptions, 'isPassportRequired'>
    & { goingFlight: (
      { __typename?: 'FlightOption' }
      & Pick<FlightOption, 'freeBaggageAllowance' | 'fareClassCodes'>
    ), returningFlight: (
      { __typename?: 'FlightOption' }
      & Pick<FlightOption, 'freeBaggageAllowance' | 'fareClassCodes'>
    ), baggageOptionInfo?: Maybe<(
      { __typename?: 'BaggageOptionInfo' }
      & { round?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, going?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, returning?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )> }
    )> }
  ) }
);

export type FindHotelForAroundHotelsQueryVariables = Exact<{
  hotelInput: HotelInput;
}>;


export type FindHotelForAroundHotelsQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'cocolocalaHotelId' | 'name'>
    & { aroundHotels?: Maybe<Array<(
      { __typename?: 'HotelSummaryForHotel' }
      & FHotelSummaryForHotelFragment
    )>> }
  ) }
);

export type FindHotelForHotelDetailQueryVariables = Exact<{
  hotelInput: HotelInput;
}>;


export type FindHotelForHotelDetailQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & FFullHotelFragment
  ) }
);

export type FindHotelForHotelImagesQueryVariables = Exact<{
  hotelInput: HotelInput;
}>;


export type FindHotelForHotelImagesQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'cocolocalaHotelId' | 'name'>
    & { location: (
      { __typename?: 'HotelLocation' }
      & FHotelLocationFragment
    ), minimumPrices: (
      { __typename?: 'HotelMinimumPrices' }
      & FHotelMinimumPricesFragment
    ), images: Array<(
      { __typename?: 'HotelImage' }
      & FHotelImageFragment
    )> }
  ) }
);

export type FindHotelForOrderConfirmQueryVariables = Exact<{
  input: HotelForOrderConfirmInput;
}>;


export type FindHotelForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { hotelForOrderConfirm: (
    { __typename?: 'HotelForOrderConfirm' }
    & Pick<HotelForOrderConfirm, 'id' | 'cocolocalaHotelId' | 'hotelName' | 'summaryTitle' | 'rating' | 'hotelLocation' | 'imageUrls'>
    & { relationalServiceIds?: Maybe<(
      { __typename?: 'RelationalServiceIds' }
      & Pick<RelationalServiceIds, 'expedia' | 'googlePlace'>
    )>, hotelDetailInfo: (
      { __typename?: 'HotelDetailInfoForDPFlight' }
      & Pick<HotelDetailInfoForDpFlight, 'summaryDescription' | 'description' | 'phoneNumber' | 'websiteUrl'>
      & { checkin?: Maybe<(
        { __typename?: 'Checkin' }
        & Pick<Checkin, 'beginTime' | 'endTime' | 'twentyFourHour'>
      )>, checkout?: Maybe<(
        { __typename?: 'Checkout' }
        & Pick<Checkout, 'time'>
      )>, hotelAmenities: (
        { __typename?: 'HotelAmenities' }
        & Pick<HotelAmenities, 'wifiCondition' | 'japaneseCondition'>
        & { amenities: Array<(
          { __typename?: 'Amenity' }
          & FAmenityFragment
        )> }
      ), location: (
        { __typename?: 'HotelLocation' }
        & FHotelLocationFragment
      ), hotelExplanation?: Maybe<(
        { __typename?: 'HotelExplanation' }
        & Pick<HotelExplanation, 'amenities' | 'dining' | 'access'>
      )>, hotelCautions: (
        { __typename?: 'HotelCautions' }
        & FHotelCautionsFragment
      ), statics: (
        { __typename?: 'HotelStatistics' }
        & Pick<HotelStatistics, 'roomsCount'>
      ), hotelType?: Maybe<(
        { __typename?: 'HotelType' }
        & Pick<HotelType, 'id' | 'name'>
      )> }
    ), googlePlaceReviews?: Maybe<(
      { __typename?: 'GooglePlaceReviews' }
      & FGooglePlaceReviewsFragment
    )>, contents?: Maybe<Array<(
      { __typename?: 'HotelContentItem' }
      & FHotelContentItemFragment
    )>>, inclusivePriceInfo: (
      { __typename?: 'InclusivePriceInfo' }
      & FInclusivePriceInfoFragment
    ) }
  ) }
);

export type FindHotelMinimumPriceCalendarQueryVariables = Exact<{
  input: HotelMinimumPriceCalendarInput;
}>;


export type FindHotelMinimumPriceCalendarQuery = (
  { __typename?: 'Query' }
  & { hotelMinimumPriceCalendar: (
    { __typename?: 'HotelMinimumPriceCalendar' }
    & { minimumPriceCalendarByNumberOfPeople: (
      { __typename?: 'HotelMinimumPriceCalendarByNumberOfPeople' }
      & Pick<HotelMinimumPriceCalendarByNumberOfPeople, 'id'>
      & { perOne: Array<(
        { __typename?: 'HotelDayMinimumPrice' }
        & FHotelDayMinimumPriceFragment
      )>, perTwo: Array<(
        { __typename?: 'HotelDayMinimumPrice' }
        & FHotelDayMinimumPriceFragment
      )> }
    ), lowestMinimumPrices: (
      { __typename?: 'HotelMinimumPrices' }
      & Pick<HotelMinimumPrices, 'id'>
      & { perOne?: Maybe<(
        { __typename?: 'HotelMinimumPrice' }
        & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
      )>, perTwo?: Maybe<(
        { __typename?: 'HotelMinimumPrice' }
        & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
      )> }
    ) }
  ) }
);

export type FindHotelSummaryForReviewQueryVariables = Exact<{
  hotelInput: HotelInput;
}>;


export type FindHotelSummaryForReviewQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & FHotelSummaryForReviewFragment
  ) }
);

export type FindHotelTabsForOrderConfirmQueryVariables = Exact<{
  input: HotelTabsForOrderConfirmInput;
}>;


export type FindHotelTabsForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { hotelTabsForOrderConfirm: (
    { __typename?: 'HotelTabsForOrderConfirm' }
    & { hotelTabs: Array<(
      { __typename?: 'HotelTab' }
      & Pick<HotelTab, 'label' | 'hotelIds'>
    )> }
  ) }
);

export type FindLatestReservedReservationInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type FindLatestReservedReservationInfoQuery = (
  { __typename?: 'Query' }
  & { latestReservedReservationInfo: (
    { __typename?: 'LatestReservedReservationInfo' }
    & Pick<LatestReservedReservationInfo, 'isDPFlightReservedWithin30Days'>
  ) }
);

export type FindOverseasLineSupportQueryVariables = Exact<{
  input: OverseasDpFlightInput;
}>;


export type FindOverseasLineSupportQuery = (
  { __typename?: 'Query' }
  & { overseasDPFlight: (
    { __typename?: 'OverseasDPFlight' }
    & { overseasDPFlightInfo?: Maybe<(
      { __typename?: 'OverseasDPFlightInfo' }
      & { recommendedTravelDestinations: Array<(
        { __typename?: 'TravelDestination' }
        & FTravelDestinationFragment
      )> }
    )> }
  ) }
);

export type FindMinimumDpCarPriceInfoQueryVariables = Exact<{
  input: MinimumDpCarPriceInfoInput;
}>;


export type FindMinimumDpCarPriceInfoQuery = (
  { __typename?: 'Query' }
  & { minimumDPCarPriceInfo: (
    { __typename?: 'DPCarPriceInfo' }
    & Pick<DpCarPriceInfo, 'inclusivePrice'>
  ) }
);

export type FindMobileHotelDetailWithAreaHotelsQueryVariables = Exact<{
  input: HotelInput;
}>;


export type FindMobileHotelDetailWithAreaHotelsQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'id'>
    & { googlePlaceReviews?: Maybe<(
      { __typename?: 'GooglePlaceReviews' }
      & FGooglePlaceReviewsFragment
    )> }
    & FCocoolocalaHotelFragment
    & FExpediaHotelFragment
  ) }
);

export type FindMyHotelBookmarkQueryVariables = Exact<{
  input: MyHotelBookmarkInput;
}>;


export type FindMyHotelBookmarkQuery = (
  { __typename?: 'Query' }
  & { myHotelBookmark: (
    { __typename?: 'MyHotelBookmark' }
    & Pick<MyHotelBookmark, 'cocolocalaHotelId' | 'bookmarked'>
  ) }
);

export type FindOgpImageForOrderConfirmQueryVariables = Exact<{
  input: OgpImageForOrderConfirmInput;
}>;


export type FindOgpImageForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { ogpImageForOrderConfirm: (
    { __typename?: 'OGPImageForOrderConfirm' }
    & Pick<OgpImageForOrderConfirm, 'id'>
    & { ogpImage: (
      { __typename?: 'OGPImage' }
      & Pick<OgpImage, 'imageUrl'>
    ) }
  ) }
);

export type FindOrderCompleteQueryVariables = Exact<{
  input: OrderCompleteInput;
}>;


export type FindOrderCompleteQuery = (
  { __typename?: 'Query' }
  & { orderComplete: (
    { __typename?: 'OrderComplete' }
    & Pick<OrderComplete, 'orderId' | 'status' | 'isDPFlight' | 'affiliateCVPrice' | 'email' | 'paymentMethod'>
  ) }
);

export type FindOrderConfirmQueryVariables = Exact<{
  input: OrderConfirmInput;
}>;


export type FindOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { orderConfirm: (
    { __typename?: 'OrderConfirm' }
    & Pick<OrderConfirm, 'id' | 'isPartialStayDaysOfEntireItinerary' | 'useAirportTransfer' | 'passportRequirement' | 'adjustedCheckInDateNote'>
    & { hotelInfo?: Maybe<(
      { __typename?: 'OrderConfirmHotelInfo' }
      & Pick<OrderConfirmHotelInfo, 'id' | 'cocolocalaHotelId' | 'selectedRateId' | 'importantNotices' | 'numberOfPeople' | 'targetHotelZonePath' | 'numberOfRoomsRemaining' | 'isSoldOut'>
      & { hotelSummary: (
        { __typename?: 'OrderHotelSummary' }
        & FOrderHotelSummaryFragment
      ), roomSummary: (
        { __typename?: 'OrderHotelRoomSummary' }
        & FOrderHotelRoomSummaryFragment
      ), hotelDetail: (
        { __typename?: 'OrderHotelDetail' }
        & FOrderHotelDetailFragment
      ), roomDetail: (
        { __typename?: 'OrderHotelRoomDetail' }
        & FOrderHotelRoomDetailFragment
      ) }
    )>, reservationSummaryInfo: (
      { __typename?: 'ReservationSummaryInfo' }
      & Pick<ReservationSummaryInfo, 'goingDeparturePointDate' | 'returningDeparturePointDate' | 'numberOfPeople'>
    ), flightDetail: (
      { __typename?: 'OrderFlightInfo' }
      & { goingFlight: (
        { __typename?: 'Flight' }
        & FFlightFragment
      ), returningFlight: (
        { __typename?: 'Flight' }
        & FFlightFragment
      ) }
    ), supportPlan?: Maybe<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, supportPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, cancelForAnyReason?: Maybe<(
      { __typename?: 'OrderCancelForAnyReason' }
      & FOrderCancelForAnyReasonFragment
    )>, priceInfo: (
      { __typename?: 'OrderPriceInfoForOrderConfirm' }
      & FOrderPriceInfoForOrderConfirmFragment
    ), cancelInfo?: Maybe<(
      { __typename?: 'OrderCancelInfo' }
      & FOrderCancelInfoFragment
    )>, searchCondition: (
      { __typename?: 'OrderConfirmSearchCondition' }
      & Pick<OrderConfirmSearchCondition, 'goingCityOrAirportIATACode' | 'returningCityOrAirportIATACode' | 'goingDate' | 'returningDate' | 'numberOfAdults' | 'childAges' | 'zonePath'>
    ), orderConfirmRevisitInfo?: Maybe<(
      { __typename?: 'OrderConfirmRevisitInfo' }
      & Pick<OrderConfirmRevisitInfo, 'zoneName' | 'hotelName' | 'thumbnailUrl' | 'departureDate' | 'numberOfPeople' | 'flightCarrierNames'>
    )>, additionalOptionsInfo?: Maybe<(
      { __typename?: 'AdditionalOptionsInfo' }
      & FAdditionalOptionsInfoFragment
    )>, limitedTimeSaleInfo?: Maybe<(
      { __typename?: 'LimitedTimeSaleInfo' }
      & FLimitedTimeSaleInfoFragment
    )>, baggageOptionInfo?: Maybe<(
      { __typename?: 'BaggageOptionInfo' }
      & { round?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, going?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, returning?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )> }
    )>, selectedBaggageOptionInfo?: Maybe<(
      { __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionInfo' }
      & { perFlight?: Maybe<(
        { __typename?: 'SelectedBaggageOptionInfo' }
        & { round?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )>, going?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )>, returning?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, perPassengers: Array<(
        { __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionPerPassengerInfo' }
        & { selectedBaggageOption: (
          { __typename?: 'SelectedBaggageOptionInfo' }
          & { round?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )>, going?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )>, returning?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )> }
        ) }
      )> }
    )> }
  ) }
);

export type FindOrderHistoryQueryVariables = Exact<{
  input: OrderHistoryInput;
}>;


export type FindOrderHistoryQuery = (
  { __typename?: 'Query' }
  & { orderHistory: (
    { __typename?: 'OrderHistory' }
    & FOrderHistoryFragment
  ) }
);

export type FindOrderHistoryConvenienceStorePaymentQueryVariables = Exact<{
  input: OrderHistoryConvenienceStorePaymentInput;
}>;


export type FindOrderHistoryConvenienceStorePaymentQuery = (
  { __typename?: 'Query' }
  & { orderHistoryConvenienceStorePayment: (
    { __typename?: 'OrderHistoryConvenienceStorePayment' }
    & Pick<OrderHistoryConvenienceStorePayment, 'barcode' | 'inclusivePrice' | 'convenienceStoreTransferDeadline'>
  ) }
);

export type FindOrderPurchaseQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOrderPurchaseQuery = (
  { __typename?: 'Query' }
  & { orderPurchase: (
    { __typename?: 'OrderPurchase' }
    & FOrderPurchaseFragment
  ) }
);

export type FindOrderReservationInformationQueryVariables = Exact<{
  input: OrderReservationInformationInput;
}>;


export type FindOrderReservationInformationQuery = (
  { __typename?: 'Query' }
  & { orderReservationInformation: (
    { __typename?: 'OrderReservationInformation' }
    & Pick<OrderReservationInformation, 'numberOfPeople' | 'isDP' | 'passportRequirement' | 'cancelForAnyReasonInclusivePricePerPerson' | 'hasCancelForAnyReason' | 'numberOfStays' | 'departureDateText' | 'isHotspringMember'>
    & { selectedProductsSummaryLabelInfo: (
      { __typename?: 'SelectedProductsSummaryLabelInfo' }
      & { labels: Array<(
        { __typename?: 'SelectedProductsSummaryLabel' }
        & FSelectedProductsSummaryLabelFragment
      )> }
    ), supportPlan?: Maybe<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, supportPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, priceInfo: (
      { __typename?: 'OrderReservationInformationPriceInfo' }
      & Pick<OrderReservationInformationPriceInfo, 'totalAmount' | 'totalAmountPerPerson' | 'flightBaggageOptionInclusivePrice' | 'cocolocalaTransactionFeeAndTaxText'>
    ), baggageOptionInfo?: Maybe<(
      { __typename?: 'BaggageOptionInfo' }
      & { round?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, going?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, returning?: Maybe<(
        { __typename?: 'BaggageOptionDetail' }
        & Pick<BaggageOptionDetail, 'perPassenger'>
        & { baggageOptions: Array<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )> }
    )>, selectedBaggageOptionInfo?: Maybe<(
      { __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionInfo' }
      & { perFlight?: Maybe<(
        { __typename?: 'SelectedBaggageOptionInfo' }
        & { round?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )>, going?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )>, returning?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
        )> }
      )>, perPassengers: Array<(
        { __typename?: 'OrderConfirmOrReservationInformationSelectedBaggageOptionPerPassengerInfo' }
        & { selectedBaggageOption: (
          { __typename?: 'SelectedBaggageOptionInfo' }
          & { round?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )>, going?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )>, returning?: Maybe<(
            { __typename?: 'BaggageOption' }
            & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'maxQuantity' | 'maxWeight'>
          )> }
        ) }
      )> }
    )>, nationalityOptions: Array<(
      { __typename?: 'NationalityOption' }
      & Pick<NationalityOption, 'value' | 'label'>
    )>, presetFormOrderReservationInformation?: Maybe<(
      { __typename?: 'PresetFormOrderReservationInformation' }
      & { passengers: Array<(
        { __typename?: 'PresetFormOrderReservationPassenger' }
        & Pick<PresetFormOrderReservationPassenger, 'firstName' | 'lastName' | 'gender' | 'nationality'>
        & { birthday: (
          { __typename?: 'BirthdayOrPassportExpiry' }
          & Pick<BirthdayOrPassportExpiry, 'year' | 'month' | 'day'>
        ), selectedBaggageOption?: Maybe<(
          { __typename?: 'PresetFormOrderReservationBaggageOption' }
          & Pick<PresetFormOrderReservationBaggageOption, 'goingBaggageOptionValue' | 'returningBaggageOptionValue' | 'roundBaggageOptionValue'>
        )>, passport?: Maybe<(
          { __typename?: 'FlightPassengerPassport' }
          & Pick<FlightPassengerPassport, 'passportNumber' | 'passportIssuingCountry'>
          & { passportExpiry: (
            { __typename?: 'BirthdayOrPassportExpiry' }
            & Pick<BirthdayOrPassportExpiry, 'year' | 'month' | 'day'>
          ) }
        )> }
      )>, selectedBaggageOption?: Maybe<(
        { __typename?: 'PresetFormOrderReservationBaggageOption' }
        & Pick<PresetFormOrderReservationBaggageOption, 'goingBaggageOptionValue' | 'returningBaggageOptionValue' | 'roundBaggageOptionValue'>
      )> }
    )> }
  ) }
);

export type FindOrderSignQueryVariables = Exact<{
  input: OrderSignInput;
}>;


export type FindOrderSignQuery = (
  { __typename?: 'Query' }
  & { orderSign: (
    { __typename?: 'OrderSign' }
    & Pick<OrderSign, 'id'>
    & { logInfo: (
      { __typename?: 'OrderLogInfo' }
      & Pick<OrderLogInfo, 'productType'>
    ) }
  ) }
);

export type FindOrderTodoListQueryVariables = Exact<{
  input: OrderTodoListInput;
}>;


export type FindOrderTodoListQuery = (
  { __typename?: 'Query' }
  & { orderTodoList: (
    { __typename?: 'OrderTodoList' }
    & { todoList: Array<(
      { __typename?: 'Todo' }
      & Pick<Todo, 'sectionTitle' | 'sortIndex'>
      & { items: Array<(
        { __typename?: 'TodoItem' }
        & Pick<TodoItem, 'id' | 'isRequired' | 'title' | 'content' | 'sortIndex' | 'isChecked'>
      )> }
    )> }
  ) }
);

export type FindOverseasDpFlightQueryVariables = Exact<{
  input: OverseasDpFlightInput;
}>;


export type FindOverseasDpFlightQuery = (
  { __typename?: 'Query' }
  & { overseasDPFlight: (
    { __typename?: 'OverseasDPFlight' }
    & Pick<OverseasDpFlight, 'id'>
    & { overseasDPFlightInfo?: Maybe<(
      { __typename?: 'OverseasDPFlightInfo' }
      & { departureAirports: Array<(
        { __typename?: 'AirportSection' }
        & FAirportSectionFragment
      )>, arrivalAirports: Array<(
        { __typename?: 'AirportSection' }
        & FAirportSectionFragment
      )>, dPFlightSupportPlans: Array<(
        { __typename?: 'DPFlightSupportPlan' }
        & FdpFlightSupportPlanFragment
      )>, recommendedTravelDestinations: Array<(
        { __typename?: 'TravelDestination' }
        & FTravelDestinationFragment
      )>, groupedTravelDestination: Array<(
        { __typename?: 'GroupedTravelDestination' }
        & Pick<GroupedTravelDestination, 'name'>
        & { travelDestinations: Array<(
          { __typename?: 'TravelDestination' }
          & FTravelDestinationFragment
        )> }
      )>, parentsOfEachTravelDestination: Array<(
        { __typename?: 'TravelDestination' }
        & FTravelDestinationFragment
      )>, limitedTimeSaleInfo?: Maybe<(
        { __typename?: 'LimitedTimeSaleInfo' }
        & FLimitedTimeSaleInfoFragment
      )> }
    )>, overseasDPFlightTabs: Array<(
      { __typename?: 'OverseasDPFlightTabs' }
      & FOverseasDpFlightTabsFragment
    )> }
  ) }
);

export type FindOverseasDpFlightPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type FindOverseasDpFlightPlansQuery = (
  { __typename?: 'Query' }
  & { overseasDPFlightPlans: Array<(
    { __typename?: 'DPFlightSupportPlan' }
    & FdpFlightSupportPlanFragment
  )> }
);

export type FindOverseasHotelQueryVariables = Exact<{
  input: OverseasDpFlightInput;
}>;


export type FindOverseasHotelQuery = (
  { __typename?: 'Query' }
  & { overseasDPFlight: (
    { __typename?: 'OverseasDPFlight' }
    & Pick<OverseasDpFlight, 'id'>
    & { overseasDPFlightInfo?: Maybe<(
      { __typename?: 'OverseasDPFlightInfo' }
      & { departureAirports: Array<(
        { __typename?: 'AirportSection' }
        & FAirportSectionFragment
      )>, arrivalAirports: Array<(
        { __typename?: 'AirportSection' }
        & FAirportSectionFragment
      )>, dPFlightSupportPlans: Array<(
        { __typename?: 'DPFlightSupportPlan' }
        & FdpFlightSupportPlanFragment
      )>, recommendedTravelDestinations: Array<(
        { __typename?: 'TravelDestination' }
        & Pick<TravelDestination, 'name' | 'path' | 'imageUrl'>
      )>, groupedTravelDestination: Array<(
        { __typename?: 'GroupedTravelDestination' }
        & Pick<GroupedTravelDestination, 'name'>
        & { travelDestinations: Array<(
          { __typename?: 'TravelDestination' }
          & Pick<TravelDestination, 'name' | 'path' | 'imageUrl'>
        )> }
      )>, parentsOfEachTravelDestination: Array<(
        { __typename?: 'TravelDestination' }
        & FTravelDestinationFragment
      )> }
    )>, overseasDPFlightTabs: Array<(
      { __typename?: 'OverseasDPFlightTabs' }
      & FOverseasDpFlightTabsFragment
    )> }
  ) }
);

export type FindOverseasZoneDpFlightQueryVariables = Exact<{
  input: OverseasZoneDpFlightInput;
}>;


export type FindOverseasZoneDpFlightQuery = (
  { __typename?: 'Query' }
  & { overseasZoneDPFlight: (
    { __typename?: 'OverseasZoneDPFlight' }
    & Pick<OverseasZoneDpFlight, 'id' | 'imageUrl' | 'referenceMinimumPrice' | 'travelStatus' | 'zoneName' | 'zonePath' | 'returningCityOrAirportIATACode' | 'existsDPFlightThemes' | 'priorConfirmation' | 'travelPreparationForDeparture' | 'travelPreparationForReturn' | 'recommendedStayDays'>
    & { departureAirports: Array<(
      { __typename?: 'AirportSection' }
      & FAirportSectionFragment
    )>, arrivalAirports: Array<(
      { __typename?: 'AirportSection' }
      & FAirportSectionFragment
    )>, parentZoneInfo?: Maybe<(
      { __typename?: 'ZoneInfo' }
      & FZoneInfoFragment
    )>, dPFlightSupportPlans: Array<(
      { __typename?: 'DPFlightSupportPlan' }
      & FdpFlightSupportPlanFragment
    )>, cities: Array<(
      { __typename?: 'TravelDestination' }
      & FTravelDestinationFragment
    )>, recommendedTravelDestinations: Array<(
      { __typename?: 'TravelDestination' }
      & FTravelDestinationFragment
    )>, lowestPriceSchedule: (
      { __typename?: 'FlightSchedule' }
      & Pick<FlightSchedule, 'goingDate' | 'returningDate'>
    ), hotels: Array<(
      { __typename?: 'HotelData' }
      & Pick<HotelData, 'id' | 'name' | 'rating' | 'areaName' | 'prefectureName' | 'imageUrl'>
    )>, hotelTabs: Array<(
      { __typename?: 'HotelTab' }
      & Pick<HotelTab, 'label' | 'hotelIds'>
    )>, travelThemes: Array<(
      { __typename?: 'TravelTheme' }
      & FTravelThemeFragment
    )>, basicInformation?: Maybe<(
      { __typename?: 'ZoneBasicInfomration' }
      & FZoneBasicInfomrationFragment
    )>, limitedTimeSaleInfo?: Maybe<(
      { __typename?: 'LimitedTimeSaleInfo' }
      & FLimitedTimeSaleInfoFragment
    )>, campaignInfo?: Maybe<(
      { __typename?: 'CampaignInfo' }
      & FCampaignInfoFragment
    )> }
  ) }
);

export type FindPassportInformationQueryVariables = Exact<{
  input: PassportInformationInput;
}>;


export type FindPassportInformationQuery = (
  { __typename?: 'Query' }
  & { passportInformation: (
    { __typename?: 'PassportInformation' }
    & Pick<PassportInformation, 'id' | 'vendor' | 'departureDateText'>
    & { selectedBaggageOption?: Maybe<(
      { __typename?: 'SelectedBaggageOptionInfo' }
      & { round?: Maybe<(
        { __typename?: 'BaggageOption' }
        & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
      )>, going?: Maybe<(
        { __typename?: 'BaggageOption' }
        & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
      )>, returning?: Maybe<(
        { __typename?: 'BaggageOption' }
        & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
      )> }
    )>, passengers: Array<(
      { __typename?: 'FlightPassenger' }
      & Pick<FlightPassenger, 'flightPassengerId' | 'firstName' | 'lastName' | 'nationality' | 'gender' | 'isNeedPassport' | 'isRepresentative'>
      & { birthday: (
        { __typename?: 'BirthdayOrPassportExpiry' }
        & Pick<BirthdayOrPassportExpiry, 'year' | 'month' | 'day'>
      ), passport?: Maybe<(
        { __typename?: 'FlightPassengerPassport' }
        & Pick<FlightPassengerPassport, 'passportNumber' | 'passportIssuingCountry'>
        & { passportExpiry: (
          { __typename?: 'BirthdayOrPassportExpiry' }
          & Pick<BirthdayOrPassportExpiry, 'year' | 'month' | 'day'>
        ) }
      )>, selectedBaggageOption?: Maybe<(
        { __typename?: 'SelectedBaggageOptionInfo' }
        & { round?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )>, going?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )>, returning?: Maybe<(
          { __typename?: 'BaggageOption' }
          & Pick<BaggageOption, 'value' | 'allowance' | 'price' | 'inclusivePrice' | 'maxQuantity' | 'maxWeight'>
        )> }
      )> }
    )>, nationalityOptions: Array<(
      { __typename?: 'NationalityOption' }
      & Pick<NationalityOption, 'value' | 'label'>
    )> }
  ) }
);

export type FindPcHotelDetailWithAreaHotelsQueryVariables = Exact<{
  input: HotelInput;
}>;


export type FindPcHotelDetailWithAreaHotelsQuery = (
  { __typename?: 'Query' }
  & { hotel: (
    { __typename?: 'Hotel' }
    & Pick<Hotel, 'id'>
    & FCocoolocalaHotelFragment
    & FExpediaHotelFragment
  ) }
);

export type FindPlanQueryVariables = Exact<{
  input: PlanInput;
}>;


export type FindPlanQuery = (
  { __typename?: 'Query' }
  & { plan: (
    { __typename?: 'Plan' }
    & Pick<Plan, 'id' | 'planId' | 'title' | 'areaName' | 'noIndex' | 'producedBy' | 'comments' | 'numberOfStays'>
    & { regions: Array<(
      { __typename?: 'PlanRegion' }
      & Pick<PlanRegion, 'name' | 'nameAlphabet'>
    )>, districts: Array<(
      { __typename?: 'PlanDistrict' }
      & Pick<PlanDistrict, 'id' | 'name'>
    )>, prefectures: Array<(
      { __typename?: 'PlanPrefecture' }
      & Pick<PlanPrefecture, 'name' | 'nameAlphabet'>
    )>, summaryImages: Array<(
      { __typename?: 'PlanImage' }
      & FPlanImageFragment
    )>, modelCourseItemsPerDays: Array<(
      { __typename?: 'PlanModelCourseItemsPerDay' }
      & Pick<PlanModelCourseItemsPerDay, 'day'>
      & { modelCourseItems: Array<(
        { __typename?: 'SpotModelCourseItem' }
        & Pick<SpotModelCourseItem, 'itemType' | 'time' | 'spotId' | 'name' | 'summaryDescription' | 'summaryTitle'>
        & { images: Array<(
          { __typename?: 'PlanImage' }
          & FPlanImageFragment
        )> }
      ) | (
        { __typename?: 'NormalModelCourseItem' }
        & Pick<NormalModelCourseItem, 'itemType' | 'time' | 'name' | 'description'>
        & { images: Array<(
          { __typename?: 'PlanImage' }
          & FPlanImageFragment
        )> }
      )> }
    )>, hotels: Array<(
      { __typename?: 'PlanHotel' }
      & Pick<PlanHotel, 'hotelId' | 'name' | 'speciality' | 'popText' | 'comments' | 'summaryTitle' | 'minimumPrice'>
      & { images: Array<(
        { __typename?: 'PlanImage' }
        & FPlanImageFragment
      )> }
    )>, nearDistrictPlans: Array<(
      { __typename?: 'PlanSummary' }
      & FPlanSummaryFragment
    )>, prefectureHotels: Array<(
      { __typename?: 'HotelSummaryForHotel' }
      & FHotelSummaryForHotelFragment
    )> }
  ), popularPlans: Array<(
    { __typename?: 'PlanSummary' }
    & FPlanSummaryFragment
  )> }
);

export type FindReturningFlightsForOrderConfirmQueryVariables = Exact<{
  input: ReturningFlightsForOrderConfirmInput;
}>;


export type FindReturningFlightsForOrderConfirmQuery = (
  { __typename?: 'Query' }
  & { returningFlightsForOrderConfirm: (
    { __typename?: 'ReturningFlightsForOrderConfirm' }
    & { flights: Array<(
      { __typename?: 'Flight' }
      & FFlightFragment
    )>, inclusivePriceInfo: (
      { __typename?: 'InclusivePriceInfo' }
      & Pick<InclusivePriceInfo, 'total' | 'perPerson' | 'numberOfPeople' | 'numberOfStays'>
    ) }
  ) }
);

export type FindReviewDetailQueryVariables = Exact<{
  reviewInput: ReviewInput;
}>;


export type FindReviewDetailQuery = (
  { __typename?: 'Query' }
  & { review: (
    { __typename?: 'Review' }
    & { reviewItems: Array<(
      { __typename?: 'ReviewItem' }
      & FReviewItemFragment
    )>, reviewItemImages: Array<(
      { __typename?: 'ReviewItemImage' }
      & FReviewItemImageFragment
    )> }
    & FReviewSummaryForReviewDetailFragment
  ) }
);

export type FindSelectedProductsSummaryQueryVariables = Exact<{
  input: SelectedProductsSummaryInput;
}>;


export type FindSelectedProductsSummaryQuery = (
  { __typename?: 'Query' }
  & { selectedProductsSummary: (
    { __typename?: 'SelectedProductsSummary' }
    & FSelectedProductsSummaryFragment
  ) }
);

export type FindSpotQueryVariables = Exact<{
  input: SpotInput;
}>;


export type FindSpotQuery = (
  { __typename?: 'Query' }
  & { spot: (
    { __typename?: 'Spot' }
    & FSpotFragment
  ) }
);

export type FindVacantHotelQueryVariables = Exact<{
  vacantHotelInput: VacantHotelInput;
}>;


export type FindVacantHotelQuery = (
  { __typename?: 'Query' }
  & { vacantHotel: (
    { __typename?: 'VacantHotel' }
    & FVacantHotelForDpCarFragment
  ) }
);

export type FindVacantHotelForDpFlightQueryVariables = Exact<{
  input: VacantHotelForDpFlightInput;
}>;


export type FindVacantHotelForDpFlightQuery = (
  { __typename?: 'Query' }
  & { vacantHotelForDPFlight: (
    { __typename?: 'VacantHotelForDPFlight' }
    & FVacantHotelForDpFlightFragment
  ) }
);

export type FindVacantHotelRoomsQueryVariables = Exact<{
  input: VacantHotelRoomsInput;
}>;


export type FindVacantHotelRoomsQuery = (
  { __typename?: 'Query' }
  & { vacantHotelRooms: (
    { __typename?: 'VacantHotelRooms' }
    & { rooms: Array<(
      { __typename?: 'VacantHotelRoom' }
      & Pick<VacantHotelRoom, 'id' | 'roomName' | 'overview' | 'isNoSmoking'>
      & { images?: Maybe<Array<Maybe<(
        { __typename?: 'VacantHotelRoomImage' }
        & Pick<VacantHotelRoomImage, 'caption'>
        & { links?: Maybe<(
          { __typename?: 'VacantHotelRoomImageLink' }
          & { large?: Maybe<(
            { __typename?: 'VacantHotelRoomImageSource' }
            & Pick<VacantHotelRoomImageSource, 'href'>
          )>, medium?: Maybe<(
            { __typename?: 'VacantHotelRoomImageSource' }
            & Pick<VacantHotelRoomImageSource, 'href'>
          )>, small?: Maybe<(
            { __typename?: 'VacantHotelRoomImageSource' }
            & Pick<VacantHotelRoomImageSource, 'href'>
          )> }
        )> }
      )>>>, rates?: Maybe<Array<Maybe<(
        { __typename?: 'VacantHotelRoomRate' }
        & Pick<VacantHotelRoomRate, 'id' | 'availableRooms' | 'refundable' | 'fencedDeal' | 'fencedDealAvailable' | 'depositRequired' | 'merchantOfRecord' | 'meal' | 'priceRange'>
        & { promotions?: Maybe<(
          { __typename?: 'VacantHotelRoomRatePromotions' }
          & Pick<VacantHotelRoomRatePromotions, 'valueAdds'>
          & { deal?: Maybe<(
            { __typename?: 'VacantHotelRoomRatePromotionsDeal' }
            & Pick<VacantHotelRoomRatePromotionsDeal, 'id' | 'description'>
          )> }
        )>, occupancyPricing: (
          { __typename?: 'VacantHotelRoomRateOccupancyPricing' }
          & { fees?: Maybe<(
            { __typename?: 'VacantHotelRoomRateOccupancyPricingFees' }
            & { mandatoryFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, resortFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, mandatoryTax?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )> }
          )>, totals: (
            { __typename?: 'VacantHotelRoomRateOccupancyPricingTotals' }
            & Pick<VacantHotelRoomRateOccupancyPricingTotals, 'discountRate'>
            & { inclusive?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, strikethrough?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, marketingFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, grossProfit?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, exclusive?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )> }
          ) }
        ), occupancyPricingWithoutCocolocalaTransactionFee: (
          { __typename?: 'VacantHotelRoomRateOccupancyPricing' }
          & { fees?: Maybe<(
            { __typename?: 'VacantHotelRoomRateOccupancyPricingFees' }
            & { mandatoryFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, resortFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, mandatoryTax?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingFee' }
              & Pick<VacantHotelRoomRateOccupancyPricingFee, 'scope' | 'frequency'>
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )> }
          )>, totals: (
            { __typename?: 'VacantHotelRoomRateOccupancyPricingTotals' }
            & Pick<VacantHotelRoomRateOccupancyPricingTotals, 'discountRate'>
            & { inclusive?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, strikethrough?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, marketingFee?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, grossProfit?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )>, exclusive?: Maybe<(
              { __typename?: 'VacantHotelRoomRateOccupancyPricingTotalsBillableAndCurrency' }
              & { billableCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeBillableCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeBillableCurrency, 'value' | 'currency'>
              )>, requestCurrency?: Maybe<(
                { __typename?: 'VacantHotelRoomRateOccupancyPricingFeeRequestCurrency' }
                & Pick<VacantHotelRoomRateOccupancyPricingFeeRequestCurrency, 'value' | 'currency'>
              )> }
            )> }
          ) }
        ), cancelPenalties?: Maybe<Array<(
          { __typename?: 'VacantHotelRoomRateCancelPenalty' }
          & Pick<VacantHotelRoomRateCancelPenalty, 'currency' | 'start' | 'end' | 'amount' | 'nights' | 'percent'>
        )>>, bedGroups?: Maybe<Array<(
          { __typename?: 'VacantHotelRoomRateBedGroup' }
          & Pick<VacantHotelRoomRateBedGroup, 'id' | 'description'>
          & { configuration?: Maybe<Array<Maybe<(
            { __typename?: 'VacantHotelRoomRateBedGroupConfiguration' }
            & Pick<VacantHotelRoomRateBedGroupConfiguration, 'type' | 'size' | 'quantity'>
          )>>>, links?: Maybe<(
            { __typename?: 'VacantHotelRoomRateBedGroupLink' }
            & { priceCheck?: Maybe<(
              { __typename?: 'VacantHotelRoomRateBedGroupLinkPriceCheck' }
              & Pick<VacantHotelRoomRateBedGroupLinkPriceCheck, 'method' | 'href' | 'expires'>
            )> }
          )> }
        )>>, amenities?: Maybe<Array<(
          { __typename?: 'Amenity' }
          & Pick<Amenity, 'id' | 'name' | 'value'>
        )>> }
      )>>>, occupancy?: Maybe<(
        { __typename?: 'VacantHotelRoomOccupancy' }
        & { maxAllowed?: Maybe<(
          { __typename?: 'VacantHotelRoomOccupancyMaxAllowed' }
          & Pick<VacantHotelRoomOccupancyMaxAllowed, 'total' | 'adults' | 'children'>
        )> }
      )>, bedGroups?: Maybe<Array<Maybe<(
        { __typename?: 'VacantHotelRoomBedGroup' }
        & Pick<VacantHotelRoomBedGroup, 'id' | 'description'>
        & { configuration?: Maybe<Array<Maybe<(
          { __typename?: 'VacantHotelRoomRateBedGroupConfiguration' }
          & Pick<VacantHotelRoomRateBedGroupConfiguration, 'type' | 'size' | 'quantity'>
        )>>> }
      )>>>, view?: Maybe<(
        { __typename?: 'VacantHotelRoomView' }
        & Pick<VacantHotelRoomView, 'id' | 'name'>
      )>, amenities?: Maybe<Array<(
        { __typename?: 'Amenity' }
        & Pick<Amenity, 'id' | 'name'>
      )>> }
    )> }
  ) }
);

export type FAirportSectionFragment = (
  { __typename?: 'AirportSection' }
  & Pick<AirportSection, 'name'>
  & { airports: Array<(
    { __typename?: 'AirportWithChildren' }
    & { airport: (
      { __typename?: 'Airport' }
      & Pick<Airport, 'id' | 'cityName' | 'iata' | 'airportName' | 'zonePath'>
    ), children?: Maybe<Array<(
      { __typename?: 'Airport' }
      & Pick<Airport, 'id' | 'cityName' | 'iata' | 'airportName'>
    )>> }
  )> }
);

export type FVacantHotelsForDpFlightHotelDetailFragment = (
  { __typename?: 'VacantHotelsForDPFlightHotelDetail' }
  & Pick<VacantHotelsForDpFlightHotelDetail, 'id' | 'cocolocalaHotelId' | 'name' | 'summaryTitle' | 'rating' | 'numberOfStays' | 'popularScore' | 'images'>
  & { priceInfo: (
    { __typename?: 'VacantHotelSummaryPriceInfoForDPFlight' }
    & Pick<VacantHotelSummaryPriceInfoForDpFlight, 'minimumPricePerPerson' | 'priceDiff'>
    & { discountInfo?: Maybe<(
      { __typename?: 'DiscountInfoForDPFlight' }
      & FDiscountInfoForDpFlightFragment
    )> }
  ) }
);

export type FTravelThemeFragment = (
  { __typename?: 'TravelTheme' }
  & Pick<TravelTheme, 'themeId' | 'title' | 'imageUrls' | 'minimumPrice' | 'description'>
  & { recommendedDays: (
    { __typename?: 'ThemeRecommendedDays' }
    & Pick<ThemeRecommendedDays, 'stay' | 'total'>
  ) }
);

export type FdpFlightTravelThemesFilterFragment = (
  { __typename?: 'DPFlightTravelThemesFilter' }
  & { conditions: Array<(
    { __typename?: 'DPFlightTravelThemesFilterCondition' }
    & Pick<DpFlightTravelThemesFilterCondition, 'title' | 'summaryTitle'>
    & { options: Array<(
      { __typename?: 'DPFlightTravelThemesFilterConditionOption' }
      & Pick<DpFlightTravelThemesFilterConditionOption, 'id' | 'text'>
    )> }
  )>, results: Array<(
    { __typename?: 'DPFlightTravelThemesFilterResult' }
    & Pick<DpFlightTravelThemesFilterResult, 'filterConditionOptionIds' | 'themeIds'>
  )> }
);

export type FdpFlightSupportPlanFragment = (
  { __typename?: 'DPFlightSupportPlan' }
  & Pick<DpFlightSupportPlan, 'planType' | 'title' | 'description' | 'inclusivePrice' | 'iconUrl' | 'isRecommend' | 'planColor' | 'zonePath'>
  & { contents: Array<(
    { __typename?: 'DPFlightSupportPlanContent' }
    & Pick<DpFlightSupportPlanContent, 'title' | 'description' | 'iconUrl'>
  )> }
);

export type FMinimumInclusivePriceInfoFragment = (
  { __typename?: 'MinimumInclusivePriceInfoForDPFlight' }
  & Pick<MinimumInclusivePriceInfoForDpFlight, 'total' | 'perPerson' | 'numberOfPeople' | 'numberOfStays'>
  & { discountInfo?: Maybe<(
    { __typename?: 'DiscountInfoForDPFlight' }
    & FDiscountInfoForDpFlightFragment
  )> }
);

export type FFlightTicketPriceInfoFragment = (
  { __typename?: 'FlightTicketPriceInfo' }
  & Pick<FlightTicketPriceInfo, 'originalExclusivePriceOfAdults' | 'originalExclusivePriceOfChildren' | 'originalExclusivePriceOfInfants' | 'originalExclusivePrice' | 'originalTaxOfAdults' | 'originalTaxOfChildren' | 'originalTaxOfInfants' | 'originalInclusivePrice' | 'originalTax' | 'currencyCode' | 'inclusivePrice' | 'inclusivePricePerPerson'>
);

export type FVacantHotelForDpFlightFragment = (
  { __typename?: 'VacantHotelForDPFlight' }
  & Pick<VacantHotelForDpFlight, 'id' | 'cocolocalaHotelId' | 'expediaHotelId' | 'didaHotelId' | 'staffCommentForHotel' | 'hotelName' | 'summaryTitle' | 'rating' | 'hotelLocation' | 'regionPath' | 'staffCommentForRoom' | 'internationalOrDomestic' | 'minimumFlightPrice'>
  & { images: Array<(
    { __typename?: 'HotelImage' }
    & Pick<HotelImage, 'url' | 'heroImage' | 'caption'>
  )>, hotelDetailInfo: (
    { __typename?: 'HotelDetailInfoForDPFlight' }
    & Pick<HotelDetailInfoForDpFlight, 'summaryDescription' | 'description' | 'phoneNumber' | 'websiteUrl'>
    & { checkin?: Maybe<(
      { __typename?: 'Checkin' }
      & Pick<Checkin, 'beginTime' | 'endTime' | 'twentyFourHour'>
    )>, checkout?: Maybe<(
      { __typename?: 'Checkout' }
      & Pick<Checkout, 'time'>
    )>, hotelAmenities: (
      { __typename?: 'HotelAmenities' }
      & Pick<HotelAmenities, 'wifiCondition' | 'japaneseCondition'>
      & { amenities: Array<(
        { __typename?: 'Amenity' }
        & FAmenityFragment
      )> }
    ), location: (
      { __typename?: 'HotelLocation' }
      & FHotelLocationFragment
    ), hotelExplanation?: Maybe<(
      { __typename?: 'HotelExplanation' }
      & Pick<HotelExplanation, 'amenities' | 'dining' | 'access'>
    )>, hotelCautions: (
      { __typename?: 'HotelCautions' }
      & FHotelCautionsFragment
    ), statics: (
      { __typename?: 'HotelStatistics' }
      & Pick<HotelStatistics, 'roomsCount'>
    ), hotelType?: Maybe<(
      { __typename?: 'HotelType' }
      & Pick<HotelType, 'id' | 'name'>
    )> }
  ), googlePlaceReviews?: Maybe<(
    { __typename?: 'GooglePlaceReviews' }
    & FGooglePlaceReviewsFragment
  )>, contents?: Maybe<Array<(
    { __typename?: 'HotelContentItem' }
    & FHotelContentItemFragment
  )>>, rooms: Array<(
    { __typename?: 'HotelRoomForDPFlight' }
    & FHotelRoomForDpFlightFragment
  )>, departureAirports: Array<(
    { __typename?: 'AirportSection' }
    & FAirportSectionFragment
  )>, arrivalAirports: Array<(
    { __typename?: 'AirportSection' }
    & FAirportSectionFragment
  )>, minimumInclusivePriceInfo?: Maybe<(
    { __typename?: 'MinimumInclusivePriceInfoForDPFlight' }
    & FMinimumInclusivePriceInfoFragment
  )> }
);

export type FAirportFragment = (
  { __typename?: 'Airport' }
  & Pick<Airport, 'id' | 'cityName' | 'iata' | 'airportName'>
);

export type FDiscountInfoForDpFlightFragment = (
  { __typename?: 'DiscountInfoForDPFlight' }
  & Pick<DiscountInfoForDpFlight, 'strikethroughPerPerson' | 'hotelDiscountAmountPerPerson' | 'limitedTimeSaleDiscountAmountPerPerson' | 'campaignDiscountAmountPerPerson'>
);

export type FRecommendedTravelDestinationFragment = (
  { __typename?: 'RecommendedTravelDestination' }
  & Pick<RecommendedTravelDestination, 'name' | 'nameEn' | 'path' | 'imageUrl' | 'recommendedSeasonText' | 'status' | 'hasThemes'>
);

export type FTravelDestinationFragment = (
  { __typename?: 'TravelDestination' }
  & Pick<TravelDestination, 'name' | 'path' | 'imageUrl' | 'lowestPrice'>
);

export type FZoneInfoFragment = (
  { __typename?: 'ZoneInfo' }
  & Pick<ZoneInfo, 'name' | 'path'>
);

export type FZoneBasicInfomrationFragment = (
  { __typename?: 'ZoneBasicInfomration' }
  & Pick<ZoneBasicInfomration, 'language' | 'climate' | 'bestSeason' | 'flightHour' | 'timeZone' | 'currency' | 'tippingEtiquette' | 'transportation'>
);

export type FdpCarVendorFragment = (
  { __typename?: 'DPCarVendor' }
  & Pick<DpCarVendor, 'id'>
  & { vendorInfo: (
    { __typename?: 'DPCarVendorInfo' }
    & FdpCarVendorInfoFragment
  ), cars: Array<(
    { __typename?: 'DPCarWithReference' }
    & Pick<DpCarWithReference, 'id' | 'name' | 'thumbnailUrl'>
    & { options: Array<(
      { __typename?: 'DPCarOption' }
      & FdpCarOptionFragment
    )>, priceInfo: (
      { __typename?: 'DPCarPriceInfoWithPriceDiffFromLowestPrice' }
      & Pick<DpCarPriceInfoWithPriceDiffFromLowestPrice, 'price' | 'priceDiffFromLowestPrice' | 'transactionFee' | 'tax' | 'currencyCode' | 'inclusivePrice' | 'cocolocalaTransactionFee' | 'cocolocalaTransactionFeeTax' | 'inclusivePriceDiffFromLowestPrice'>
    ), reference: (
      { __typename?: 'DPCarReference' }
      & FdpCarReferenceFragment
    ) }
  )> }
);

export type FdpCarReferenceFragment = (
  { __typename?: 'DPCarReference' }
  & Pick<DpCarReference, 'type' | 'id' | 'idContext' | 'dateTime' | 'url'>
);

export type FCocoolocalaHotelFragment = (
  { __typename?: 'Hotel' }
  & Pick<Hotel, 'cocolocalaHotelId' | 'name' | 'rating' | 'sort' | 'displayStatus' | 'comments' | 'phoneNumber' | 'description' | 'summaryTitle' | 'summaryDescription' | 'websiteUrl' | 'internationalOrDomestic' | 'availabilityCalendarCacheType'>
  & { relationalServiceIds?: Maybe<(
    { __typename?: 'RelationalServiceIds' }
    & Pick<RelationalServiceIds, 'agoda' | 'expedia' | 'googlePlace' | 'rakuten'>
  )>, location: (
    { __typename?: 'HotelLocation' }
    & FHotelLocationFragment
  ), minimumPrices: (
    { __typename?: 'HotelMinimumPrices' }
    & { perOne?: Maybe<(
      { __typename?: 'HotelMinimumPrice' }
      & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
    )>, perTwo?: Maybe<(
      { __typename?: 'HotelMinimumPrice' }
      & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
    )> }
  ) }
);

export type FHotelMinimumPricesFragment = (
  { __typename?: 'HotelMinimumPrices' }
  & { perOne?: Maybe<(
    { __typename?: 'HotelMinimumPrice' }
    & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
  )>, perTwo?: Maybe<(
    { __typename?: 'HotelMinimumPrice' }
    & Pick<HotelMinimumPrice, 'inclusive' | 'strikeThrough'>
  )> }
);

export type FExpediaHotelFragment = (
  { __typename?: 'Hotel' }
  & Pick<Hotel, 'pets'>
  & { images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )>, checkin?: Maybe<(
    { __typename?: 'Checkin' }
    & Pick<Checkin, 'beginTime' | 'endTime' | 'twentyFourHour'>
  )>, checkout?: Maybe<(
    { __typename?: 'Checkout' }
    & Pick<Checkout, 'time'>
  )>, hotelCautions: (
    { __typename?: 'HotelCautions' }
    & FHotelCautionsFragment
  ), hotelExplanation?: Maybe<(
    { __typename?: 'HotelExplanation' }
    & Pick<HotelExplanation, 'amenities' | 'dining' | 'access'>
  )>, statics: (
    { __typename?: 'HotelStatistics' }
    & Pick<HotelStatistics, 'roomsCount'>
  ), hotelType?: Maybe<(
    { __typename?: 'HotelType' }
    & Pick<HotelType, 'id' | 'name'>
  )>, hotelAmenities: (
    { __typename?: 'HotelAmenities' }
    & Pick<HotelAmenities, 'wifiCondition' | 'japaneseCondition'>
    & { amenities: Array<(
      { __typename?: 'Amenity' }
      & FAmenityFragment
    )> }
  ), rooms: Array<(
    { __typename?: 'HotelRoom' }
    & Pick<HotelRoom, 'id' | 'roomId' | 'roomName' | 'overview' | 'smokingCondition' | 'view'>
    & { images: Array<(
      { __typename?: 'HotelImage' }
      & FHotelImageFragment
    )>, bedGroups: Array<(
      { __typename?: 'RoomBedGroup' }
      & FRoomBedGroupFragment
    )>, maxAllowedOccupancy?: Maybe<(
      { __typename?: 'RoomMaxAllowedOccupancy' }
      & Pick<RoomMaxAllowedOccupancy, 'total' | 'adults' | 'children'>
    )>, amenities: Array<(
      { __typename?: 'Amenity' }
      & FAmenityFragment
    )> }
  )>, covid19Tags?: Maybe<(
    { __typename?: 'Covid19Tag' }
    & Pick<Covid19Tag, 'mask' | 'freeAntisepticSolution' | 'cleaning' | 'individualPackagingForMeal' | 'noMeetCheckIn' | 'individualPackagingForRoomService'>
  )> }
);

export type FFullHotelFragment = (
  { __typename?: 'Hotel' }
  & Pick<Hotel, 'id'>
  & { googlePlaceReviews?: Maybe<(
    { __typename?: 'GooglePlaceReviews' }
    & FGooglePlaceReviewsFragment
  )>, contents?: Maybe<Array<(
    { __typename?: 'HotelContentItem' }
    & FHotelContentItemFragment
  )>>, recommendedPlans?: Maybe<Array<(
    { __typename?: 'PlanSummaryForHotel' }
    & FPlanSummaryForHotelFragment
  )>>, aroundSpots?: Maybe<Array<(
    { __typename?: 'SpotSummaryForHotel' }
    & FSpotSummaryForHotelFragment
  )>>, aroundRestaurants?: Maybe<Array<(
    { __typename?: 'SpotSummaryForHotel' }
    & FSpotSummaryForHotelFragment
  )>>, aroundHotels?: Maybe<Array<(
    { __typename?: 'HotelSummaryForHotel' }
    & FHotelSummaryForHotelFragment
  )>> }
  & FCocoolocalaHotelFragment
  & FExpediaHotelFragment
);

export type FRoomBedGroupFragment = (
  { __typename?: 'RoomBedGroup' }
  & Pick<RoomBedGroup, 'id' | 'bedGroupId' | 'description'>
  & { configuration?: Maybe<Array<Maybe<(
    { __typename?: 'BedGroupConfiguration' }
    & FBedGroupConfigurationFragment
  )>>> }
);

export type FHotelRoomRateFragment = (
  { __typename?: 'HotelRoomRate' }
  & Pick<HotelRoomRate, 'id' | 'rateId' | 'availableRooms' | 'refundable' | 'fencedDeal' | 'fencedDealAvailable' | 'meal'>
  & { promotions?: Maybe<(
    { __typename?: 'HotelRoomRatePromotions' }
    & Pick<HotelRoomRatePromotions, 'dealId' | 'dealDescription' | 'valueAdds'>
  )>, occupancyPricing: (
    { __typename?: 'HotelRoomRatePricing' }
    & Pick<HotelRoomRatePricing, 'inclusivePrice' | 'exclusivePrice' | 'strikethroughPrice' | 'discountRate'>
  ), cancelPenalties?: Maybe<Array<(
    { __typename?: 'HotelRoomRateCancelPenalties' }
    & Pick<HotelRoomRateCancelPenalties, 'currency' | 'start' | 'end' | 'amount' | 'nights' | 'percent'>
  )>>, bedGroups: Array<(
    { __typename?: 'RoomBedGroup' }
    & Pick<RoomBedGroup, 'expediaPriceCheckHref'>
    & FRoomBedGroupFragment
  )>, amenities: Array<(
    { __typename?: 'Amenity' }
    & FAmenityFragment
  )> }
);

export type FBedGroupConfigurationFragment = (
  { __typename?: 'BedGroupConfiguration' }
  & Pick<BedGroupConfiguration, 'type' | 'size' | 'quantity'>
);

export type FAmenityFragment = (
  { __typename?: 'Amenity' }
  & Pick<Amenity, 'id' | 'name' | 'value'>
);

export type FHotelImageFragment = (
  { __typename?: 'HotelImage' }
  & Pick<HotelImage, 'url' | 'heroImage' | 'caption'>
);

export type FGooglePlaceReviewsFragment = (
  { __typename?: 'GooglePlaceReviews' }
  & Pick<GooglePlaceReviews, 'id' | 'googlePlaceId'>
  & { reviews: Array<(
    { __typename?: 'GooglePlaceReview' }
    & Pick<GooglePlaceReview, 'authorUrl' | 'authorName' | 'profilePhotoUrl' | 'language' | 'rating' | 'text' | 'time'>
  )> }
);

export type FHotelContentItemFragment = (
  { __typename?: 'HotelContentItem' }
  & Pick<HotelContentItem, 'title' | 'description'>
  & { images: Array<(
    { __typename?: 'HotelContentItemImage' }
    & Pick<HotelContentItemImage, 'url' | 'creditText' | 'creditLinkUrl'>
  )> }
);

export type FPlanSummaryForHotelFragment = (
  { __typename?: 'PlanSummaryForHotel' }
  & Pick<PlanSummaryForHotel, 'id' | 'planId' | 'title' | 'thumbnailUrls' | 'areaName'>
);

export type FHotelSummaryForHotelFragment = (
  { __typename?: 'HotelSummaryForHotel' }
  & Pick<HotelSummaryForHotel, 'id' | 'cocolocalaHotelId' | 'name' | 'rating' | 'distance' | 'areaName' | 'prefectureName' | 'thumbnailUrl'>
  & { minimumPrices: (
    { __typename?: 'HotelMinimumPrices' }
    & FHotelMinimumPricesFragment
  ) }
);

export type FSpotSummaryForHotelFragment = (
  { __typename?: 'SpotSummaryForHotel' }
  & Pick<SpotSummaryForHotel, 'id' | 'cocolocalaSpotId' | 'name' | 'rating' | 'distance' | 'areaName' | 'prefectureName' | 'description' | 'thumbnailUrl'>
);

export type FVacantHotelForDpCarFragment = (
  { __typename?: 'VacantHotel' }
  & Pick<VacantHotel, 'cocolocalaHotelId' | 'expediaHotelId' | 'name' | 'selectedRoomId' | 'selectedRateId' | 'selectedBedGroupId'>
  & { locationInfo: (
    { __typename?: 'VacantHotelLocationInfo' }
    & Pick<VacantHotelLocationInfo, 'areaId' | 'areaPath' | 'areaName'>
  ), selectedRoom?: Maybe<(
    { __typename?: 'HotelRoom' }
    & Pick<HotelRoom, 'roomId' | 'roomName' | 'overview'>
    & { images: Array<(
      { __typename?: 'HotelImage' }
      & FHotelImageFragment
    )> }
  )>, selectedRate?: Maybe<(
    { __typename?: 'HotelRoomRate' }
    & { occupancyPricing: (
      { __typename?: 'HotelRoomRatePricing' }
      & Pick<HotelRoomRatePricing, 'inclusivePrice' | 'exclusivePrice' | 'strikethroughPrice' | 'discountRate' | 'cocolocalaTransactionFee' | 'cocolocalaTransactionFeeTax'>
    ) }
  )> }
);

export type FVacantHotelSummaryFragment = (
  { __typename?: 'VacantHotelSummary' }
  & Pick<VacantHotelSummary, 'id' | 'cocolocalaHotelId' | 'expediaHotelId' | 'name' | 'rating' | 'numberOfStays' | 'numberOfPeople' | 'freeCancellation'>
  & { zoneInfo: (
    { __typename?: 'VacantHotelSummaryZoneInfo' }
    & Pick<VacantHotelSummaryZoneInfo, 'prefectureName' | 'areaName'>
  ), minimumPriceInfo: (
    { __typename?: 'VacantHotelSummaryMinimumPriceInfo' }
    & Pick<VacantHotelSummaryMinimumPriceInfo, 'inclusivePrice' | 'strikeThroughPrice' | 'discountLabel' | 'isMemberDiscount' | 'isAvailableMemberDiscount'>
  ), images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )>, checkin?: Maybe<(
    { __typename?: 'Checkin' }
    & Pick<Checkin, 'beginTime' | 'endTime'>
  )> }
);

export type FHotelSummaryFragment = (
  { __typename?: 'HotelSummary' }
  & Pick<HotelSummary, 'id' | 'cocolocalaHotelId' | 'expediaHotelId' | 'name' | 'rating'>
  & { zoneInfo: (
    { __typename?: 'HotelSummaryZoneInfo' }
    & Pick<HotelSummaryZoneInfo, 'prefectureName' | 'areaName'>
  ), minimumPrices: (
    { __typename?: 'HotelSummaryMinimumPrices' }
    & { one?: Maybe<(
      { __typename?: 'HotelSummaryMinimumPriceInfo' }
      & Pick<HotelSummaryMinimumPriceInfo, 'inclusivePrice' | 'strikeThroughPrice' | 'discountLabel'>
    )>, two?: Maybe<(
      { __typename?: 'HotelSummaryMinimumPriceInfo' }
      & Pick<HotelSummaryMinimumPriceInfo, 'inclusivePrice' | 'strikeThroughPrice' | 'discountLabel'>
    )> }
  ), images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )> }
);

export type FHotelDayMinimumPriceFragment = (
  { __typename?: 'HotelDayMinimumPrice' }
  & Pick<HotelDayMinimumPrice, 'date' | 'price'>
);

export type FHotelSummaryForReviewFragment = (
  { __typename?: 'Hotel' }
  & Pick<Hotel, 'cocolocalaHotelId' | 'name'>
  & { minimumPrices: (
    { __typename?: 'HotelMinimumPrices' }
    & FHotelMinimumPricesFragment
  ), location: (
    { __typename?: 'HotelLocation' }
    & FHotelLocationFragment
  ), images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )> }
);

export type FHotelRoomRateForDpFlightFragment = (
  { __typename?: 'HotelRoomRateForDPFlight' }
  & Pick<HotelRoomRateForDpFlight, 'id' | 'rateId' | 'refundable' | 'fencedDeal' | 'fencedDealAvailable' | 'hasWifi' | 'mealLabel'>
  & { promotions?: Maybe<(
    { __typename?: 'HotelRoomRatePromotions' }
    & Pick<HotelRoomRatePromotions, 'dealId' | 'dealDescription' | 'valueAdds'>
  )>, occupancyPricing: (
    { __typename?: 'HotelRoomRatePricingForDPFlight' }
    & Pick<HotelRoomRatePricingForDpFlight, 'hotelExclusivePrice' | 'hotelExclusiveStrikethroughPrice' | 'hotelTaxAndServiceCharge' | 'ratePriceDiffPerPerson' | 'totalPrice' | 'totalPricePerPerson'>
  ), cancelPenalties: Array<(
    { __typename?: 'HotelRoomRateCancelPenalties' }
    & Pick<HotelRoomRateCancelPenalties, 'currency' | 'start' | 'end' | 'amount' | 'nights' | 'percent'>
  )>, bedGroups: Array<(
    { __typename?: 'RoomBedGroup' }
    & FRoomBedGroupFragment
  )> }
);

export type FHotelRoomForDpFlightFragment = (
  { __typename?: 'HotelRoomForDPFlight' }
  & Pick<HotelRoomForDpFlight, 'id' | 'roomId' | 'roomName' | 'overview' | 'smokingCondition' | 'view' | 'hasWifi' | 'availableRooms' | 'minimumRoomRatePriceDiffPerPerson'>
  & { images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )>, bedGroups: Array<(
    { __typename?: 'RoomBedGroup' }
    & FRoomBedGroupFragment
  )>, maxAllowedOccupancy?: Maybe<(
    { __typename?: 'RoomMaxAllowedOccupancy' }
    & Pick<RoomMaxAllowedOccupancy, 'total' | 'adults' | 'children'>
  )>, rates: Array<(
    { __typename?: 'HotelRoomRateForDPFlight' }
    & Pick<HotelRoomRateForDpFlight, 'id' | 'rateId' | 'refundable' | 'fencedDeal' | 'fencedDealAvailable' | 'hasWifi' | 'mealLabel'>
    & { promotions?: Maybe<(
      { __typename?: 'HotelRoomRatePromotions' }
      & Pick<HotelRoomRatePromotions, 'dealId' | 'dealDescription' | 'valueAdds'>
    )>, occupancyPricing: (
      { __typename?: 'HotelRoomRatePricingForDPFlight' }
      & Pick<HotelRoomRatePricingForDpFlight, 'hotelInclusiveStrikethrough' | 'hotelExclusivePrice' | 'hotelExclusiveStrikethroughPrice' | 'hotelTaxAndServiceCharge' | 'ratePriceDiffPerPerson' | 'totalPrice' | 'totalPricePerPerson'>
    ), cancelPenalties: Array<(
      { __typename?: 'HotelRoomRateCancelPenalties' }
      & Pick<HotelRoomRateCancelPenalties, 'currency' | 'start' | 'end' | 'amount' | 'nights' | 'percent'>
    )>, bedGroups: Array<(
      { __typename?: 'RoomBedGroup' }
      & FRoomBedGroupFragment
    )> }
  )> }
);

export type FRateFragment = (
  { __typename?: 'Rate' }
  & Pick<Rate, 'fencedDeal' | 'fencedDealAvailable' | 'priceRangeCondition' | 'bedTypeConditions' | 'smokingCondition' | 'refundable'>
  & { promotions?: Maybe<(
    { __typename?: 'Promotions' }
    & { deal: (
      { __typename?: 'Deal' }
      & Pick<Deal, 'id' | 'description'>
    ) }
  )>, pricing: (
    { __typename?: 'Pricing' }
    & Pick<Pricing, 'discountRate'>
    & { inclusive: (
      { __typename?: 'CurrencyData' }
      & Pick<CurrencyData, 'value' | 'currency'>
    ), exclusive?: Maybe<(
      { __typename?: 'CurrencyData' }
      & Pick<CurrencyData, 'value' | 'currency'>
    )>, strikethrough?: Maybe<(
      { __typename?: 'CurrencyData' }
      & Pick<CurrencyData, 'value' | 'currency'>
    )> }
  ), cancelPenalties?: Maybe<Array<(
    { __typename?: 'HotelRoomRateCancelPenalties' }
    & Pick<HotelRoomRateCancelPenalties, 'currency' | 'start' | 'end' | 'amount' | 'nights' | 'percent'>
  )>> }
);

export type FMinimumPricingFragment = (
  { __typename?: 'MinimumPricing' }
  & { inclusiveWithCocolocalaTransactionFee: (
    { __typename?: 'CurrencyData' }
    & Pick<CurrencyData, 'value' | 'currency'>
  ), inclusive: (
    { __typename?: 'CurrencyData' }
    & Pick<CurrencyData, 'value' | 'currency'>
  ), exclusive: (
    { __typename?: 'CurrencyData' }
    & Pick<CurrencyData, 'value' | 'currency'>
  ), strikeThroughWithCocolocalaTransactionFee?: Maybe<(
    { __typename?: 'CurrencyData' }
    & Pick<CurrencyData, 'value' | 'currency'>
  )> }
);

export type FIncrementalSearchZoneItemFragment = (
  { __typename?: 'IncrementalSearchZoneItem' }
  & Pick<IncrementalSearchZoneItem, 'id' | 'displayName' | 'regionName' | 'prefectureName' | 'districtName' | 'areaName' | 'zoneType' | 'path' | 'hotelCount'>
);

export type FIncrementalSearchHotelItemFragment = (
  { __typename?: 'IncrementalSearchHotelItem' }
  & Pick<IncrementalSearchHotelItem, 'id' | 'displayName' | 'regionName' | 'prefectureName' | 'districtName' | 'areaName' | 'cocolocalaHotelId' | 'sort'>
);

export type FOrderPriceInfoForOrderConfirmFragment = (
  { __typename?: 'OrderPriceInfoForOrderConfirm' }
  & Pick<OrderPriceInfoForOrderConfirm, 'totalAmount' | 'totalAmountPerPerson' | 'strikethroughAmount' | 'cancelForAnyReasonInclusivePricePerPerson' | 'discountAmount' | 'limitedTimeSaleDiscountAmount' | 'campaignDiscountAmount' | 'displayUnAvailableMemberDiscount'>
  & { hotelPriceInfo?: Maybe<(
    { __typename?: 'OrderHotelPriceInfo' }
    & Pick<OrderHotelPriceInfo, 'label'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )>, propertyCollectionPriceInfo: Array<(
      { __typename?: 'PropertyCollectionPriceInfo' }
      & FPropertyCollectionPriceInfoFragment
    )> }
  )>, dPCarPriceInfo?: Maybe<(
    { __typename?: 'OrderDPCarPriceInfo' }
    & Pick<OrderDpCarPriceInfo, 'label'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, flightPriceInfo: (
    { __typename?: 'OrderFlightPriceInfo' }
    & Pick<OrderFlightPriceInfo, 'label'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  ), baggageOptionPriceInfo?: Maybe<(
    { __typename?: 'BaggageOptionPriceInfo' }
    & Pick<BaggageOptionPriceInfo, 'label' | 'inclusiveTotalPrice'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, supportPlanPriceInfo?: Maybe<(
    { __typename?: 'OrderSupportPlanPriceInfo' }
    & Pick<OrderSupportPlanPriceInfo, 'label'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, cancelForAnyReasonPriceInfo?: Maybe<(
    { __typename?: 'OrderCancelForAnyReasonPriceInfo' }
    & Pick<OrderCancelForAnyReasonPriceInfo, 'label' | 'cancelForAnyReasonInclusivePerPerson'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, cocolocalaTransactionFeePriceInfo?: Maybe<(
    { __typename?: 'OrderCocolocalaTransactionPriceInfo' }
    & Pick<OrderCocolocalaTransactionPriceInfo, 'label' | 'cocolocalaTransactionFeeAndTaxText'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, discountSectionPriceInfo?: Maybe<(
    { __typename?: 'OrderDiscountSectionPriceInfo' }
    & Pick<OrderDiscountSectionPriceInfo, 'label'>
    & { priceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  )>, discountDetails: Array<(
    { __typename?: 'OrderDiscountDetail' }
    & Pick<OrderDiscountDetail, 'label' | 'value'>
  )>, totalPriceDetails: Array<(
    { __typename?: 'OrderPriceDetail' }
    & FOrderPriceDetailFragment
  )> }
);

export type FOrderHistoryFragment = (
  { __typename?: 'OrderHistory' }
  & Pick<OrderHistory, 'id' | 'orderId' | 'status' | 'isClosed' | 'IsNotAllPassportsCompleted'>
  & { detailsTableItems: Array<(
    { __typename?: 'DetailsTableItem' }
    & FDetailsTableItemFragment
  )>, hotelInfo?: Maybe<(
    { __typename?: 'OrderHistoryHotelInfo' }
    & Pick<OrderHistoryHotelInfo, 'id' | 'cocolocalaHotelId' | 'importantNotices' | 'numberOfPeople' | 'targetHotelZonePath'>
    & { hotelSummary: (
      { __typename?: 'OrderHotelSummary' }
      & FOrderHotelSummaryFragment
    ), roomSummary: (
      { __typename?: 'OrderHotelRoomSummary' }
      & FOrderHotelRoomSummaryFragment
    ), hotelDetail?: Maybe<(
      { __typename?: 'OrderHotelDetail' }
      & FOrderHotelDetailFragment
    )>, roomDetail?: Maybe<(
      { __typename?: 'OrderHotelRoomDetail' }
      & FOrderHotelRoomDetailFragment
    )> }
  )>, dPCarInfo?: Maybe<(
    { __typename?: 'OrderDPCarInfo' }
    & Pick<OrderDpCarInfo, 'id'>
    & FOrderDpCarInfoFragment
  )>, flightInfo?: Maybe<(
    { __typename?: 'OrderFlightInfo' }
    & { goingFlight: (
      { __typename?: 'Flight' }
      & FFlightFragment
    ), returningFlight: (
      { __typename?: 'Flight' }
      & FFlightFragment
    ) }
  )>, cancelInfo?: Maybe<(
    { __typename?: 'OrderCancelInfo' }
    & FOrderCancelInfoFragment
  )>, priceInfo: (
    { __typename?: 'OrderPriceInfoForOrderHistory' }
    & Pick<OrderPriceInfoForOrderHistory, 'totalAmount' | 'strikethroughAmount' | 'cancelForAnyReasonInclusivePricePerPerson' | 'discountAmount' | 'discountLabel'>
    & { hotelPriceInfo?: Maybe<(
      { __typename?: 'OrderHotelPriceInfo' }
      & Pick<OrderHotelPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )>, propertyCollectionPriceInfo: Array<(
        { __typename?: 'PropertyCollectionPriceInfo' }
        & FPropertyCollectionPriceInfoFragment
      )> }
    )>, dPCarPriceInfo?: Maybe<(
      { __typename?: 'OrderDPCarPriceInfo' }
      & Pick<OrderDpCarPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, flightPriceInfo?: Maybe<(
      { __typename?: 'OrderFlightPriceInfo' }
      & Pick<OrderFlightPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, baggageOptionPriceInfo?: Maybe<(
      { __typename?: 'BaggageOptionPriceInfo' }
      & Pick<BaggageOptionPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, supportPlanPriceInfo?: Maybe<(
      { __typename?: 'OrderSupportPlanPriceInfo' }
      & Pick<OrderSupportPlanPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, cancelForAnyReasonPriceInfo?: Maybe<(
      { __typename?: 'OrderCancelForAnyReasonPriceInfo' }
      & Pick<OrderCancelForAnyReasonPriceInfo, 'label' | 'cancelForAnyReasonInclusivePerPerson'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, cocolocalaTransactionFeePriceInfo?: Maybe<(
      { __typename?: 'OrderCocolocalaTransactionPriceInfo' }
      & Pick<OrderCocolocalaTransactionPriceInfo, 'label' | 'cocolocalaTransactionFeeAndTaxText'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, discountSectionPriceInfo?: Maybe<(
      { __typename?: 'OrderDiscountSectionPriceInfo' }
      & Pick<OrderDiscountSectionPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, discountDetails: Array<(
      { __typename?: 'OrderDiscountDetail' }
      & Pick<OrderDiscountDetail, 'label' | 'value'>
    )>, totalPriceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )> }
  ), paymentInfo: (
    { __typename?: 'OrderPaymentInfo' }
    & FOrderPaymentInfoFragment
  ), supportPlanInfo?: Maybe<(
    { __typename?: 'DPFlightSupportPlan' }
    & FdpFlightSupportPlanFragment
  )>, supportPlans: Array<(
    { __typename?: 'DPFlightSupportPlan' }
    & FdpFlightSupportPlanFragment
  )>, cancelForAnyReasonInfo?: Maybe<(
    { __typename?: 'OrderCancelForAnyReason' }
    & FOrderCancelForAnyReasonFragment
  )>, additionalOptionsInfo?: Maybe<(
    { __typename?: 'AdditionalOptionsInfo' }
    & FAdditionalOptionsInfoFragment
  )> }
);

export type FOrderPurchaseFragment = (
  { __typename?: 'OrderPurchase' }
  & Pick<OrderPurchase, 'id' | 'travelId' | 'productType' | 'dPFlightSupportPlan' | 'useAirportTransfer' | 'isHotspringMember'>
  & { priceInfo: (
    { __typename?: 'OrderPriceInfoForOrderPurchase' }
    & Pick<OrderPriceInfoForOrderPurchase, 'totalAmount' | 'strikethroughAmount' | 'cancelForAnyReasonInclusivePricePerPerson' | 'discountAmount' | 'limitedTimeSaleDiscount' | 'campaignDiscountAmount' | 'discountLabel'>
    & { hotelPriceInfo?: Maybe<(
      { __typename?: 'OrderHotelPriceInfo' }
      & Pick<OrderHotelPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )>, propertyCollectionPriceInfo: Array<(
        { __typename?: 'PropertyCollectionPriceInfo' }
        & FPropertyCollectionPriceInfoFragment
      )> }
    )>, dPCarPriceInfo?: Maybe<(
      { __typename?: 'OrderDPCarPriceInfo' }
      & Pick<OrderDpCarPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, flightPriceInfo?: Maybe<(
      { __typename?: 'OrderFlightPriceInfo' }
      & Pick<OrderFlightPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, baggageOptionPriceInfo?: Maybe<(
      { __typename?: 'BaggageOptionPriceInfo' }
      & Pick<BaggageOptionPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, supportPlanPriceInfo?: Maybe<(
      { __typename?: 'OrderSupportPlanPriceInfo' }
      & Pick<OrderSupportPlanPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, cancelForAnyReasonPriceInfo?: Maybe<(
      { __typename?: 'OrderCancelForAnyReasonPriceInfo' }
      & Pick<OrderCancelForAnyReasonPriceInfo, 'label' | 'cancelForAnyReasonInclusivePerPerson'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, cocolocalaTransactionFeePriceInfo?: Maybe<(
      { __typename?: 'OrderCocolocalaTransactionPriceInfo' }
      & Pick<OrderCocolocalaTransactionPriceInfo, 'label' | 'cocolocalaTransactionFeeAndTaxText'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, discountSectionPriceInfo?: Maybe<(
      { __typename?: 'OrderDiscountSectionPriceInfo' }
      & Pick<OrderDiscountSectionPriceInfo, 'label'>
      & { priceDetails: Array<(
        { __typename?: 'OrderPriceDetail' }
        & FOrderPriceDetailFragment
      )> }
    )>, discountDetails: Array<(
      { __typename?: 'OrderDiscountDetail' }
      & Pick<OrderDiscountDetail, 'label' | 'value'>
    )>, totalPriceDetails: Array<(
      { __typename?: 'OrderPriceDetail' }
      & FOrderPriceDetailFragment
    )>, applyReservationPriceInfo: (
      { __typename?: 'ApplyReservationPriceInfo' }
      & Pick<ApplyReservationPriceInfo, 'amountBeforeDiscount' | 'cocolocalaTransactionFee' | 'cocolocalaTransactionFeeTax' | 'currency'>
      & { cancelForAnyReasonPriceInfo?: Maybe<(
        { __typename?: 'ApplyReservationCancelForAnyReasonPriceInfo' }
        & Pick<ApplyReservationCancelForAnyReasonPriceInfo, 'hasCancelForAnyReason' | 'amount' | 'tax'>
      )> }
    ) }
  ), paymentInfo: (
    { __typename?: 'OrderPurchasePaymentInfo' }
    & Pick<OrderPurchasePaymentInfo, 'convenienceStorePaymentDeadline' | 'bankTransferDeadline'>
  ), cancelInfo?: Maybe<(
    { __typename?: 'OrderCancelInfo' }
    & FOrderCancelInfoFragment
    & FOrderCancelInfoFragment
  )>, reservationInfo: (
    { __typename?: 'OrderPurchaseReservationInfo' }
    & { hotelReservationInfo?: Maybe<(
      { __typename?: 'HotelReservationInfo' }
      & Pick<HotelReservationInfo, 'numberOfPeople' | 'numberOfAdults' | 'childAges' | 'numberOfStays' | 'expediaFreeCancelEndTime' | 'smoking' | 'bookingUrl' | 'referenceNo' | 'stayId' | 'externalHotelId' | 'roomId' | 'rateId' | 'bedGroupId' | 'salesChannel' | 'rateOptionMember' | 'numberOfRoomsRemaining' | 'importantNotices' | 'internationalOrDomestic'>
    )>, dPCarReservationInfo?: Maybe<(
      { __typename?: 'DPCarReservationInfo' }
      & Pick<DpCarReservationInfo, 'departureDateTime' | 'returnDateTime' | 'pickupLocationCode' | 'returnLocationCode' | 'passengers'>
      & { reference: (
        { __typename?: 'DPCarReference' }
        & FdpCarReferenceFragment
      ) }
    )>, flightReservationInfo?: Maybe<(
      { __typename?: 'FlightReservationInfo' }
      & Pick<FlightReservationInfo, 'representativeFirstName' | 'representativeLastName' | 'representativePhoneNumber' | 'gdsVendor'>
      & { flightExternalReservationInfo?: Maybe<(
        { __typename?: 'FlightExternalReservationInfo' }
        & Pick<FlightExternalReservationInfo, 'flightExternalReservationId' | 'expectedPrice'>
      )> }
    )> }
  ), logInfo: (
    { __typename?: 'OrderLogInfo' }
    & Pick<OrderLogInfo, 'productType'>
  ), limitedTimeSaleInfo?: Maybe<(
    { __typename?: 'LimitedTimeSaleInfo' }
    & FLimitedTimeSaleInfoFragment
  )>, selectedProductsSummaryLabelInfo: (
    { __typename?: 'SelectedProductsSummaryLabelInfo' }
    & { labels: Array<(
      { __typename?: 'SelectedProductsSummaryLabel' }
      & FSelectedProductsSummaryLabelFragment
    )> }
  ) }
);

export type FHotelCheckInCheckOutInfoFragment = (
  { __typename?: 'HotelCheckInCheckOutInfo' }
  & Pick<HotelCheckInCheckOutInfo, 'checkInDate' | 'checkInDateText' | 'availableCheckInTimeRange' | 'checkOutDate' | 'checkOutDateText' | 'checkOutTime' | 'numberOfStays'>
);

export type FHotelRoomFacilityFragment = (
  { __typename?: 'HotelRoomFacility' }
  & Pick<HotelRoomFacility, 'type' | 'label'>
);

export type FiOrderSignOrPurchaseDpCarInfoFragment = {};

export type FOrderSupportPlanInfoFragment = (
  { __typename?: 'OrderSupportPlanInfo' }
  & Pick<OrderSupportPlanInfo, 'supportPlanType'>
);

export type FFlightClassFragment = (
  { __typename?: 'FlightClass' }
  & Pick<FlightClass, 'id' | 'name' | 'code'>
);

export type FOrderCarrierFragment = (
  { __typename?: 'OrderCarrier' }
  & Pick<OrderCarrier, 'id' | 'carrierIATACode' | 'name' | 'carrierType'>
);

export type FOrderAirportInfoFragment = (
  { __typename?: 'OrderAirportInfo' }
  & Pick<OrderAirportInfo, 'id' | 'airportIATACode' | 'airportName' | 'countryAndCityName'>
);

export type FOverseasDpFlightTabsFragment = (
  { __typename?: 'OverseasDPFlightTabs' }
  & Pick<OverseasDpFlightTabs, 'label'>
  & { zones: Array<(
    { __typename?: 'OverseasDPFlightTabZone' }
    & FOverseasDpFlightTabZoneFragment
  )> }
);

export type FOverseasDpFlightTabZoneFragment = (
  { __typename?: 'OverseasDPFlightTabZone' }
  & Pick<OverseasDpFlightTabZone, 'countryName' | 'cityName' | 'zonePath' | 'zoneImageUrl' | 'numberOfStays' | 'minimumPricePerPerson' | 'goingDate' | 'returningDate' | 'goingCityOrAirportIATACode' | 'returningCityOrAirportIATACode' | 'numberOfAdults' | 'childAges' | 'minimumFlightPrice'>
  & { vacantHotels: Array<(
    { __typename?: 'VacantHotelsForDPFlightHotelDetail' }
    & FVacantHotelsForDpFlightHotelDetailFragment
  )> }
);

export type FPlanSummaryFragment = (
  { __typename?: 'PlanSummary' }
  & Pick<PlanSummary, 'id' | 'planId' | 'title' | 'areaName' | 'thumbnailUrl'>
);

export type FPlanImageFragment = (
  { __typename?: 'PlanImage' }
  & Pick<PlanImage, 'url' | 'width' | 'height' | 'creditText' | 'creditImageUrl' | 'creditLinkUrl'>
);

export type FReviewSummaryForReviewDetailFragment = (
  { __typename?: 'Review' }
  & Pick<Review, 'reviewId' | 'nickname' | 'iconUrl' | 'stayedAt' | 'numberOfPeople'>
  & { useScene: (
    { __typename?: 'UseSceneWithLabel' }
    & Pick<UseSceneWithLabel, 'label'>
  ) }
);

export type FReviewItemImageFragment = (
  { __typename?: 'ReviewItemImage' }
  & Pick<ReviewItemImage, 'id' | 'imageUrl'>
);

export type FReviewItemFragment = (
  { __typename?: 'ReviewItem' }
  & Pick<ReviewItem, 'reviewItemId' | 'comment'>
  & { reviewItemImages: Array<(
    { __typename?: 'ReviewItemImage' }
    & Pick<ReviewItemImage, 'id' | 'imageUrl'>
  )> }
);

export type FReviewItemWithReviewUserFragment = (
  { __typename?: 'ReviewItemWithReviewUser' }
  & Pick<ReviewItemWithReviewUser, 'reviewId' | 'reviewItemId' | 'nickname' | 'iconUrl' | 'reviewItemImageUrl' | 'comment' | 'cocolocalaHotelId'>
);

export type FReviewItemsPaginationResponseFragment = (
  { __typename?: 'ReviewItemsPaginationResponse' }
  & Pick<ReviewItemsPaginationResponse, 'hasNext' | 'nextReviewOffset' | 'nextReviewItemOffset'>
);

export type FSelectedProductsSummaryFragment = (
  { __typename?: 'SelectedProductsSummary' }
  & { hotelInfo?: Maybe<(
    { __typename?: 'SelectedProductsSummaryHotelInfo' }
    & Pick<SelectedProductsSummaryHotelInfo, 'id' | 'cocolocalaHotelId' | 'importantNotices' | 'numberOfPeople'>
    & { hotelSummary: (
      { __typename?: 'OrderHotelSummary' }
      & FOrderHotelSummaryFragment
    ), roomSummary: (
      { __typename?: 'OrderHotelRoomSummary' }
      & FOrderHotelRoomSummaryFragment
    ) }
  )>, dPCarInfo?: Maybe<(
    { __typename?: 'OrderDPCarInfo' }
    & Pick<OrderDpCarInfo, 'id'>
    & FOrderDpCarInfoFragment
  )>, flightInfo?: Maybe<(
    { __typename?: 'OrderFlightInfo' }
    & { goingFlight: (
      { __typename?: 'Flight' }
      & FFlightFragment
    ), returningFlight: (
      { __typename?: 'Flight' }
      & FFlightFragment
    ) }
  )>, supportPlan?: Maybe<(
    { __typename?: 'DPFlightSupportPlan' }
    & FdpFlightSupportPlanFragment
  )>, supportPlans: Array<(
    { __typename?: 'DPFlightSupportPlan' }
    & FdpFlightSupportPlanFragment
  )>, cancelForAnyReason?: Maybe<(
    { __typename?: 'OrderCancelForAnyReason' }
    & FOrderCancelForAnyReasonFragment
  )>, cancelInfo?: Maybe<(
    { __typename?: 'OrderCancelInfo' }
    & FOrderCancelInfoFragment
  )> }
);

export type FHotelLocationFragment = (
  { __typename?: 'HotelLocation' }
  & Pick<HotelLocation, 'zipCode' | 'address' | 'description' | 'latitude' | 'longitude' | 'areaId' | 'areaPath' | 'areaName' | 'districtId' | 'districtPath' | 'districtName' | 'prefectureId' | 'prefecturePath' | 'prefectureName' | 'regionId' | 'regionPath' | 'regionName' | 'countryCode' | 'countryName' | 'isOnlyOneAreaInCountry' | 'isOnlyOneAreaInRegion' | 'stationId' | 'stationPath' | 'stationName' | 'stationNickname'>
);

export type FDetailsTableItemFragment = (
  { __typename?: 'DetailsTableItem' }
  & Pick<DetailsTableItem, 'title' | 'content' | 'contentLink'>
);

export type FOrderPriceDetailFragment = (
  { __typename?: 'OrderPriceDetail' }
  & Pick<OrderPriceDetail, 'label' | 'value' | 'priceType'>
);

export type FPropertyCollectionPriceInfoFragment = (
  { __typename?: 'PropertyCollectionPriceInfo' }
  & Pick<PropertyCollectionPriceInfo, 'label' | 'value' | 'type'>
);

export type FdpCarFragment = (
  { __typename?: 'DPCar' }
  & Pick<DpCar, 'name' | 'thumbnailUrl'>
  & { options: Array<(
    { __typename?: 'DPCarOption' }
    & FdpCarOptionFragment
  )> }
);

export type FdpCarOptionFragment = (
  { __typename?: 'DPCarOption' }
  & Pick<DpCarOption, 'type' | 'value'>
);

export type FdpCarVendorInfoFragment = (
  { __typename?: 'DPCarVendorInfo' }
  & Pick<DpCarVendorInfo, 'id' | 'vendorId' | 'vendorName' | 'address' | 'latitude' | 'longitude' | 'locationCode'>
  & { reservedCarInfo: Array<(
    { __typename?: 'DetailsTableItem' }
    & FDetailsTableItemFragment
  )>, pickupVendor: Array<(
    { __typename?: 'DetailsTableItem' }
    & FDetailsTableItemFragment
  )> }
);

export type FHotelCautionsFragment = (
  { __typename?: 'HotelCautions' }
  & Pick<HotelCautions, 'checkInInstruction' | 'checkInSpecialInstruction' | 'knowBeforeYouGo' | 'optionalFees'>
);

export type FPaginationFragment = (
  { __typename?: 'Pagination' }
  & Pick<Pagination, 'hasNext' | 'nextOffset'>
);

export type FOcuppancyFragment = (
  { __typename?: 'Occupancy' }
  & Pick<Occupancy, 'numberOfAdults' | 'childAges'>
);

export type FOrderDpCarInfoFragment = (
  { __typename?: 'OrderDPCarInfo' }
  & { vendorInfo: (
    { __typename?: 'DPCarVendorInfo' }
    & FdpCarVendorInfoFragment
  ), car: (
    { __typename?: 'DPCar' }
    & FdpCarFragment
  ) }
);

export type FOrderHotelSummaryFragment = (
  { __typename?: 'OrderHotelSummary' }
  & Pick<OrderHotelSummary, 'hotelThumbnailUrl' | 'rating' | 'hotelName'>
  & { checkInCheckOutInfo: (
    { __typename?: 'HotelCheckInCheckOutInfo' }
    & FHotelCheckInCheckOutInfoFragment
  ) }
);

export type FOrderHotelRoomSummaryFragment = (
  { __typename?: 'OrderHotelRoomSummary' }
  & Pick<OrderHotelRoomSummary, 'roomThumbnailUrl' | 'roomName'>
  & { facilities?: Maybe<Array<(
    { __typename?: 'HotelRoomFacility' }
    & FHotelRoomFacilityFragment
  )>> }
);

export type FOrderHotelDetailFragment = (
  { __typename?: 'OrderHotelDetail' }
  & Pick<OrderHotelDetail, 'cocolocalaHotelId' | 'hotelName' | 'summaryTitle' | 'rating' | 'hotelLocation' | 'summaryDescription' | 'description' | 'phoneNumber' | 'websiteUrl'>
  & { images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )>, googlePlaceReviews?: Maybe<(
    { __typename?: 'GooglePlaceReviews' }
    & FGooglePlaceReviewsFragment
  )>, checkin?: Maybe<(
    { __typename?: 'Checkin' }
    & Pick<Checkin, 'twentyFourHour' | 'beginTime' | 'endTime' | 'minAge'>
  )>, checkout?: Maybe<(
    { __typename?: 'Checkout' }
    & Pick<Checkout, 'time'>
  )>, hotelAmenities: (
    { __typename?: 'HotelAmenities' }
    & Pick<HotelAmenities, 'wifiCondition' | 'japaneseCondition'>
    & { amenities: Array<(
      { __typename?: 'Amenity' }
      & FAmenityFragment
    )> }
  ), location: (
    { __typename?: 'HotelLocation' }
    & FHotelLocationFragment
  ), hotelExplanation?: Maybe<(
    { __typename?: 'HotelExplanation' }
    & Pick<HotelExplanation, 'amenities' | 'dining' | 'access'>
  )>, hotelCautions: (
    { __typename?: 'HotelCautions' }
    & FHotelCautionsFragment
  ), statics: (
    { __typename?: 'HotelStatistics' }
    & Pick<HotelStatistics, 'roomsCount'>
  ), hotelType?: Maybe<(
    { __typename?: 'HotelType' }
    & Pick<HotelType, 'id' | 'name'>
  )> }
);

export type FOrderHotelRoomDetailFragment = (
  { __typename?: 'OrderHotelRoomDetail' }
  & Pick<OrderHotelRoomDetail, 'roomId' | 'roomName' | 'view' | 'smokingCondition' | 'hasWifi' | 'overview'>
  & { images: Array<(
    { __typename?: 'HotelImage' }
    & FHotelImageFragment
  )>, bedGroups: Array<(
    { __typename?: 'RoomBedGroup' }
    & FRoomBedGroupFragment
  )>, maxAllowedOccupancy?: Maybe<(
    { __typename?: 'RoomMaxAllowedOccupancy' }
    & Pick<RoomMaxAllowedOccupancy, 'total' | 'adults' | 'children'>
  )> }
);

export type FFlightSectorFragment = (
  { __typename?: 'FlightSector' }
  & Pick<FlightSector, 'flightIndex' | 'flightNumber' | 'fareClassCode' | 'departureDate' | 'departureTime' | 'departureUtcDateTime' | 'departureTimeZoneOffset' | 'arrivalDate' | 'arrivalTime' | 'arrivalUtcDateTime' | 'arrivalTimeZoneOffset' | 'flightTime' | 'connectingTime' | 'codeShareAirlines' | 'isConnectingToAnotherAirport'>
  & { carrier: (
    { __typename?: 'OrderCarrier' }
    & FOrderCarrierFragment
  ), flightClass: Array<(
    { __typename?: 'FlightClass' }
    & FFlightClassFragment
  )>, departureAirport: (
    { __typename?: 'OrderAirportInfo' }
    & FOrderAirportInfoFragment
  ), arrivalAirport: (
    { __typename?: 'OrderAirportInfo' }
    & FOrderAirportInfoFragment
  ), flightTransits: Array<(
    { __typename?: 'FlightTransit' }
    & FFlightTransitFragment
  )> }
);

export type FFlightTransitFragment = (
  { __typename?: 'FlightTransit' }
  & Pick<FlightTransit, 'arrivalDate' | 'arrivalTime' | 'arrivalUtcDateTime' | 'departureDate' | 'departureTime' | 'departureUtcDateTime' | 'timeZoneOffset' | 'flightTime' | 'connectingTime'>
  & { airport: (
    { __typename?: 'OrderAirportInfo' }
    & FOrderAirportInfoFragment
  ) }
);

export type FFlightFragment = (
  { __typename?: 'Flight' }
  & Pick<Flight, 'gdsVendor' | 'passportRequirement' | 'carrierType'>
  & { summary: (
    { __typename?: 'FlightSummary' }
    & FFlightSummaryFragment
  ), detail: (
    { __typename?: 'FlightDetail' }
    & FFlightDetailFragment
  ), additionalFlightInfo?: Maybe<(
    { __typename?: 'AdditionalFlightInfo' }
    & FAdditionalFlightInfoFragment
  )> }
);

export type FFlightSummaryFragment = (
  { __typename?: 'FlightSummary' }
  & Pick<FlightSummary, 'departureTime' | 'arrivalTime' | 'dayDiff' | 'totalTime' | 'totalTimeInMinutes' | 'priceDiff' | 'connectionsAirportNames' | 'numberOfConnections' | 'numberOfConnectingCarriers' | 'carrierIATA' | 'carrierName' | 'arrivalNote' | 'baggageAllowance'>
  & { flightClass: (
    { __typename?: 'FlightClass' }
    & FFlightClassFragment
  ) }
);

export type FAdditionalFlightInfoFragment = (
  { __typename?: 'AdditionalFlightInfo' }
  & Pick<AdditionalFlightInfo, 'externalFlightId'>
  & { recommendedReturningFlights: Array<(
    { __typename?: 'Flight' }
    & FReturningFlightFragment
  )> }
);

export type FReturningFlightFragment = (
  { __typename?: 'Flight' }
  & Pick<Flight, 'gdsVendor' | 'carrierType'>
  & { summary: (
    { __typename?: 'FlightSummary' }
    & FFlightSummaryFragment
  ), detail: (
    { __typename?: 'FlightDetail' }
    & FFlightDetailFragment
  ), additionalFlightInfo?: Maybe<(
    { __typename?: 'AdditionalFlightInfo' }
    & Pick<AdditionalFlightInfo, 'externalFlightId'>
  )> }
);

export type FFlightDetailFragment = (
  { __typename?: 'FlightDetail' }
  & Pick<FlightDetail, 'freeBaggageAllowance' | 'showDifferentAirportsAlertForDeparture' | 'showDifferentAirportsAlertForArrival'>
  & { flightSectors: Array<(
    { __typename?: 'FlightSector' }
    & FFlightSectorFragment
  )>, price?: Maybe<(
    { __typename?: 'FlightTicketPriceInfo' }
    & FFlightTicketPriceInfoFragment
  )> }
);

export type FCancelPolicyTableItemFragment = (
  { __typename?: 'CancelPolicyTableItem' }
  & Pick<CancelPolicyTableItem, 'value'>
  & { beginDate?: Maybe<(
    { __typename?: 'CancelPolicyDateTime' }
    & Pick<CancelPolicyDateTime, 'date' | 'time'>
  )>, endDate?: Maybe<(
    { __typename?: 'CancelPolicyDateTime' }
    & Pick<CancelPolicyDateTime, 'date' | 'time'>
  )> }
);

export type FOrderCancelInfoFragment = (
  { __typename?: 'OrderCancelInfo' }
  & Pick<OrderCancelInfo, 'freeCancellation' | 'cocolocalaChangeFeePerPersonText'>
  & { cancelPolicies: Array<(
    { __typename?: 'CancelPolicySection' }
    & Pick<CancelPolicySection, 'title'>
    & { policies: Array<(
      { __typename?: 'CancelPolicyTableItem' }
      & FCancelPolicyTableItemFragment
    )> }
  )>, flightCancelPolicy?: Maybe<(
    { __typename?: 'FlightCancelPolicy' }
    & FFlightCancelPolicyFragment
  )> }
);

export type FOrderPaymentInfoFragment = (
  { __typename?: 'OrderPaymentInfo' }
  & Pick<OrderPaymentInfo, 'paymentMethod' | 'paymentMethodName' | 'howToPaymentLink' | 'bankTransferDeadline' | 'convenienceStoreTransferDeadline'>
  & { paymentDetailItems: Array<(
    { __typename?: 'DetailsTableItem' }
    & FDetailsTableItemFragment
  )>, paymentUserDetailItems: Array<(
    { __typename?: 'DetailsTableItem' }
    & FDetailsTableItemFragment
  )> }
);

export type FFlightCancelPolicyFragment = (
  { __typename?: 'FlightCancelPolicy' }
  & Pick<FlightCancelPolicy, 'cocolocalaTicketingFeeText' | 'cocolocalaTicketingFeePerPersonText' | 'cocolocalaCancelFeeText' | 'cocolocalaCancelFeePerPersonText' | 'flightCarrierCancelPolicyTextList'>
);

export type FPaginationV2Fragment = (
  { __typename?: 'PaginationV2' }
  & Pick<PaginationV2, 'hasNext' | 'nextPage' | 'nextIndex'>
);

export type FImageDataFragment = (
  { __typename?: 'ImageData' }
  & Pick<ImageData, 'url' | 'height' | 'width' | 'creditText' | 'creditImageUrl' | 'creditLinkUrl'>
);

export type FOrderCancelForAnyReasonFragment = (
  { __typename?: 'OrderCancelForAnyReason' }
  & Pick<OrderCancelForAnyReason, 'hasCancelForAnyReason' | 'limitDateTimeText' | 'expireDateTimeText'>
);

export type FReservationSummaryInfoFragment = (
  { __typename?: 'ReservationSummaryInfo' }
  & Pick<ReservationSummaryInfo, 'goingDeparturePointDate' | 'returningDeparturePointDate' | 'numberOfPeople'>
);

export type FExpandableContentsSectionFragment = (
  { __typename?: 'ExpandableContentsSection' }
  & Pick<ExpandableContentsSection, 'title'>
  & { contents: Array<(
    { __typename?: 'ExpandableContent' }
    & Pick<ExpandableContent, 'title' | 'iconUrl' | 'content' | 'status'>
    & { label?: Maybe<(
      { __typename?: 'ExpandableContentLabel' }
      & Pick<ExpandableContentLabel, 'text' | 'labelColor'>
    )> }
  )> }
);

export type FExpandableContentFragment = (
  { __typename?: 'ExpandableContent' }
  & Pick<ExpandableContent, 'title' | 'iconUrl' | 'content' | 'status'>
  & { label?: Maybe<(
    { __typename?: 'ExpandableContentLabel' }
    & Pick<ExpandableContentLabel, 'text' | 'labelColor'>
  )> }
);

export type FInstagramImageFragment = (
  { __typename?: 'InstagramImage' }
  & Pick<InstagramImage, 'imageUrl' | 'accountName'>
);

export type FStaffCommentFragment = (
  { __typename?: 'StaffComment' }
  & Pick<StaffComment, 'status' | 'text'>
);

export type FLimitedTimeSaleInfoFragment = (
  { __typename?: 'LimitedTimeSaleInfo' }
  & Pick<LimitedTimeSaleInfo, 'limitedTimeSaleLabel' | 'isWithin30MinOfLimitedTimeSaleDiscount' | 'limitedTimeSaleEndTime' | 'limitedTimeSaleType' | 'limitedTimeSaleImageBannerPath'>
);

export type FCampaignInfoFragment = (
  { __typename?: 'CampaignInfo' }
  & Pick<CampaignInfo, 'campaignImageBannerPath' | 'campaignDiscountAmountPerPerson'>
);

export type FAdditionalOptionsInfoFragment = (
  { __typename?: 'AdditionalOptionsInfo' }
  & Pick<AdditionalOptionsInfo, 'isAvailableAirportTransfer'>
  & { localActivities: Array<(
    { __typename?: 'LocalActivity' }
    & Pick<LocalActivity, 'title' | 'description' | 'imageUrl' | 'linkUrl'>
  )> }
);

export type FInclusivePriceInfoFragment = (
  { __typename?: 'InclusivePriceInfo' }
  & Pick<InclusivePriceInfo, 'total' | 'perPerson' | 'numberOfPeople' | 'numberOfStays'>
);

export type FSelectedProductsSummaryLabelFragment = (
  { __typename?: 'SelectedProductsSummaryLabel' }
  & Pick<SelectedProductsSummaryLabel, 'label' | 'dateTimeText' | 'dayDiff' | 'detail'>
);

export type FSpotFragment = (
  { __typename?: 'Spot' }
  & Pick<Spot, 'id' | 'areaId' | 'areaPath' | 'areaName' | 'districtId' | 'districtPath' | 'districtName' | 'prefectureId' | 'prefecturePath' | 'prefectureName' | 'regionId' | 'regionPath' | 'regionName' | 'countryCode' | 'countryName' | 'name' | 'rating' | 'phoneNumber' | 'summaryTitle' | 'summaryDescription' | 'websiteUrl' | 'businessHours' | 'imageUrls'>
  & { location: (
    { __typename?: 'SpotLocation' }
    & FSpotLocationFragment
  ), comments?: Maybe<Array<(
    { __typename?: 'SpotComment' }
    & FSpotCommentFragment
  )>>, relationalServiceIds: (
    { __typename?: 'SpotRelationalServiceIds' }
    & FSpotRelationalServiceIdsFragment
  ) }
);

export type FSpotLocationFragment = (
  { __typename?: 'SpotLocation' }
  & Pick<SpotLocation, 'zipCode' | 'address' | 'description' | 'latitude' | 'longitude'>
);

export type FSpotCommentFragment = (
  { __typename?: 'SpotComment' }
  & Pick<SpotComment, 'id' | 'text'>
);

export type FSpotRelationalServiceIdsFragment = (
  { __typename?: 'SpotRelationalServiceIds' }
  & Pick<SpotRelationalServiceIds, 'foursquare' | 'googlePlace'>
);

export type ZoneFragmentFragment = (
  { __typename?: 'GqlZoneType' }
  & Pick<GqlZoneType, 'id' | 'zoneType' | 'zoneHotelCount' | 'countryId' | 'countryCode' | 'countryName' | 'regionId' | 'regionPath' | 'regionName' | 'prefectureId' | 'prefecturePath' | 'prefectureName' | 'districtId' | 'districtPath' | 'districtName' | 'areaId' | 'areaPath' | 'areaName'>
);

export type IncrementalSearchQueryVariables = Exact<{
  input: IncrementalSearchInput;
}>;


export type IncrementalSearchQuery = (
  { __typename?: 'Query' }
  & { incrementalSearch: (
    { __typename?: 'IncrementalSearch' }
    & { zones: Array<(
      { __typename?: 'IncrementalSearchZoneItem' }
      & FIncrementalSearchZoneItemFragment
    )>, hotels: Array<(
      { __typename?: 'IncrementalSearchHotelItem' }
      & FIncrementalSearchHotelItemFragment
    )> }
  ) }
);

export type ListUserCouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserCouponsQuery = (
  { __typename?: 'Query' }
  & { userCoupons: Array<(
    { __typename?: 'Coupon' }
    & Pick<Coupon, 'id' | 'couponId' | 'title' | 'label' | 'description' | 'discountAmount' | 'discountType' | 'condition' | 'startTime' | 'expireTime' | 'departureStartTime' | 'arrivalEndTime' | 'isUsed' | 'minimumAvailableAmount' | 'discountUnit' | 'usageCountLimit' | 'currentUsageCount' | 'maximumDiscountAmount'>
  )> }
);

export const FTravelThemeFragmentDoc = gql`
    fragment FTravelTheme on TravelTheme {
  themeId
  title
  imageUrls
  recommendedDays {
    stay
    total
  }
  minimumPrice
  description
}
    `;
export const FdpFlightTravelThemesFilterFragmentDoc = gql`
    fragment FDPFlightTravelThemesFilter on DPFlightTravelThemesFilter {
  conditions {
    title
    summaryTitle
    options {
      id
      text
    }
  }
  results {
    filterConditionOptionIds
    themeIds
  }
}
    `;
export const FAmenityFragmentDoc = gql`
    fragment FAmenity on Amenity {
  id
  name
  value
}
    `;
export const FHotelLocationFragmentDoc = gql`
    fragment FHotelLocation on HotelLocation {
  zipCode
  address
  description
  latitude
  longitude
  areaId
  areaPath
  areaName
  districtId
  districtPath
  districtName
  prefectureId
  prefecturePath
  prefectureName
  regionId
  regionPath
  regionName
  countryCode
  countryName
  isOnlyOneAreaInCountry
  isOnlyOneAreaInRegion
  stationId
  stationPath
  stationName
  stationNickname
}
    `;
export const FHotelCautionsFragmentDoc = gql`
    fragment FHotelCautions on HotelCautions {
  checkInInstruction
  checkInSpecialInstruction
  knowBeforeYouGo
  optionalFees
}
    `;
export const FGooglePlaceReviewsFragmentDoc = gql`
    fragment FGooglePlaceReviews on GooglePlaceReviews {
  id
  googlePlaceId
  reviews {
    authorUrl
    authorName
    profilePhotoUrl
    language
    rating
    text
    time
  }
}
    `;
export const FHotelContentItemFragmentDoc = gql`
    fragment FHotelContentItem on HotelContentItem {
  title
  description
  images {
    url
    creditText
    creditLinkUrl
  }
}
    `;
export const FHotelImageFragmentDoc = gql`
    fragment FHotelImage on HotelImage {
  url
  heroImage
  caption
}
    `;
export const FBedGroupConfigurationFragmentDoc = gql`
    fragment FBedGroupConfiguration on BedGroupConfiguration {
  type
  size
  quantity
}
    `;
export const FRoomBedGroupFragmentDoc = gql`
    fragment FRoomBedGroup on RoomBedGroup {
  id
  bedGroupId
  description
  configuration {
    ...FBedGroupConfiguration
  }
}
    ${FBedGroupConfigurationFragmentDoc}`;
export const FHotelRoomForDpFlightFragmentDoc = gql`
    fragment FHotelRoomForDPFlight on HotelRoomForDPFlight {
  id
  roomId
  roomName
  overview
  smokingCondition
  images {
    ...FHotelImage
  }
  view
  bedGroups {
    ...FRoomBedGroup
  }
  maxAllowedOccupancy {
    total
    adults
    children
  }
  hasWifi
  rates {
    id
    rateId
    refundable
    fencedDeal
    fencedDealAvailable
    promotions {
      dealId
      dealDescription
      valueAdds
    }
    occupancyPricing {
      hotelInclusiveStrikethrough
      hotelExclusivePrice
      hotelExclusiveStrikethroughPrice
      hotelTaxAndServiceCharge
      ratePriceDiffPerPerson
      totalPrice
      totalPricePerPerson
    }
    cancelPenalties {
      currency
      start
      end
      amount
      nights
      percent
    }
    bedGroups {
      ...FRoomBedGroup
    }
    hasWifi
    mealLabel
  }
  availableRooms
  minimumRoomRatePriceDiffPerPerson
}
    ${FHotelImageFragmentDoc}
${FRoomBedGroupFragmentDoc}`;
export const FAirportSectionFragmentDoc = gql`
    fragment FAirportSection on AirportSection {
  name
  airports {
    airport {
      id
      cityName
      iata
      airportName
      zonePath
    }
    children {
      id
      cityName
      iata
      airportName
    }
  }
}
    `;
export const FDiscountInfoForDpFlightFragmentDoc = gql`
    fragment FDiscountInfoForDPFlight on DiscountInfoForDPFlight {
  strikethroughPerPerson
  hotelDiscountAmountPerPerson
  limitedTimeSaleDiscountAmountPerPerson
  campaignDiscountAmountPerPerson
}
    `;
export const FMinimumInclusivePriceInfoFragmentDoc = gql`
    fragment FMinimumInclusivePriceInfo on MinimumInclusivePriceInfoForDPFlight {
  total
  perPerson
  discountInfo {
    ...FDiscountInfoForDPFlight
  }
  numberOfPeople
  numberOfStays
}
    ${FDiscountInfoForDpFlightFragmentDoc}`;
export const FVacantHotelForDpFlightFragmentDoc = gql`
    fragment FVacantHotelForDPFlight on VacantHotelForDPFlight {
  id
  cocolocalaHotelId
  expediaHotelId
  didaHotelId
  staffCommentForHotel
  hotelName
  summaryTitle
  rating
  hotelLocation
  images {
    url
    heroImage
    caption
  }
  hotelDetailInfo {
    summaryDescription
    description
    checkin {
      beginTime
      endTime
      twentyFourHour
    }
    checkout {
      time
    }
    phoneNumber
    hotelAmenities {
      wifiCondition
      japaneseCondition
      amenities {
        ...FAmenity
      }
    }
    location {
      ...FHotelLocation
    }
    hotelExplanation {
      amenities
      dining
      access
    }
    hotelCautions {
      ...FHotelCautions
    }
    statics {
      roomsCount
    }
    websiteUrl
    hotelType {
      id
      name
    }
  }
  googlePlaceReviews {
    ...FGooglePlaceReviews
  }
  contents {
    ...FHotelContentItem
  }
  regionPath
  staffCommentForRoom
  rooms {
    ...FHotelRoomForDPFlight
  }
  departureAirports {
    ...FAirportSection
  }
  arrivalAirports {
    ...FAirportSection
  }
  internationalOrDomestic
  minimumFlightPrice
  minimumInclusivePriceInfo {
    ...FMinimumInclusivePriceInfo
  }
}
    ${FAmenityFragmentDoc}
${FHotelLocationFragmentDoc}
${FHotelCautionsFragmentDoc}
${FGooglePlaceReviewsFragmentDoc}
${FHotelContentItemFragmentDoc}
${FHotelRoomForDpFlightFragmentDoc}
${FAirportSectionFragmentDoc}
${FMinimumInclusivePriceInfoFragmentDoc}`;
export const FAirportFragmentDoc = gql`
    fragment FAirport on Airport {
  id
  cityName
  iata
  airportName
}
    `;
export const FRecommendedTravelDestinationFragmentDoc = gql`
    fragment FRecommendedTravelDestination on RecommendedTravelDestination {
  name
  nameEn
  path
  imageUrl
  recommendedSeasonText
  status
  hasThemes
}
    `;
export const FTravelDestinationFragmentDoc = gql`
    fragment FTravelDestination on TravelDestination {
  name
  path
  imageUrl
  lowestPrice
}
    `;
export const FZoneInfoFragmentDoc = gql`
    fragment FZoneInfo on ZoneInfo {
  name
  path
}
    `;
export const FZoneBasicInfomrationFragmentDoc = gql`
    fragment FZoneBasicInfomration on ZoneBasicInfomration {
  language
  climate
  bestSeason
  flightHour
  timeZone
  currency
  tippingEtiquette
  transportation
}
    `;
export const FDetailsTableItemFragmentDoc = gql`
    fragment FDetailsTableItem on DetailsTableItem {
  title
  content
  contentLink
}
    `;
export const FdpCarVendorInfoFragmentDoc = gql`
    fragment FDPCarVendorInfo on DPCarVendorInfo {
  id
  vendorId
  vendorName
  address
  latitude
  longitude
  locationCode
  reservedCarInfo {
    ...FDetailsTableItem
  }
  pickupVendor {
    ...FDetailsTableItem
  }
}
    ${FDetailsTableItemFragmentDoc}`;
export const FdpCarOptionFragmentDoc = gql`
    fragment FDPCarOption on DPCarOption {
  type
  value
}
    `;
export const FdpCarReferenceFragmentDoc = gql`
    fragment FDPCarReference on DPCarReference {
  type
  id
  idContext
  dateTime
  url
}
    `;
export const FdpCarVendorFragmentDoc = gql`
    fragment FDPCarVendor on DPCarVendor {
  id
  vendorInfo {
    ...FDPCarVendorInfo
  }
  cars {
    id
    name
    thumbnailUrl
    options {
      ...FDPCarOption
    }
    priceInfo {
      price
      priceDiffFromLowestPrice
      transactionFee
      tax
      currencyCode
      inclusivePrice
      cocolocalaTransactionFee
      cocolocalaTransactionFeeTax
      inclusivePriceDiffFromLowestPrice
    }
    reference {
      ...FDPCarReference
    }
  }
}
    ${FdpCarVendorInfoFragmentDoc}
${FdpCarOptionFragmentDoc}
${FdpCarReferenceFragmentDoc}`;
export const FCocoolocalaHotelFragmentDoc = gql`
    fragment FCocoolocalaHotel on ICocoolocalaHotel {
  cocolocalaHotelId
  name
  rating
  sort
  displayStatus
  relationalServiceIds {
    agoda
    expedia
    googlePlace
    rakuten
  }
  location {
    ...FHotelLocation
  }
  comments
  phoneNumber
  description
  summaryTitle
  summaryDescription
  websiteUrl
  internationalOrDomestic
  availabilityCalendarCacheType
  minimumPrices {
    perOne {
      inclusive
      strikeThrough
    }
    perTwo {
      inclusive
      strikeThrough
    }
  }
}
    ${FHotelLocationFragmentDoc}`;
export const FExpediaHotelFragmentDoc = gql`
    fragment FExpediaHotel on IExpediaHotel {
  images {
    ...FHotelImage
  }
  checkin {
    beginTime
    endTime
    twentyFourHour
  }
  checkout {
    time
  }
  hotelCautions {
    ...FHotelCautions
  }
  hotelExplanation {
    amenities
    dining
    access
  }
  statics {
    roomsCount
  }
  pets
  hotelType {
    id
    name
  }
  hotelAmenities {
    wifiCondition
    japaneseCondition
    amenities {
      ...FAmenity
    }
  }
  rooms {
    id
    roomId
    roomName
    overview
    smokingCondition
    images {
      ...FHotelImage
    }
    view
    bedGroups {
      ...FRoomBedGroup
    }
    maxAllowedOccupancy {
      total
      adults
      children
    }
    amenities {
      ...FAmenity
    }
  }
  covid19Tags {
    mask
    freeAntisepticSolution
    cleaning
    individualPackagingForMeal
    noMeetCheckIn
    individualPackagingForRoomService
  }
}
    ${FHotelImageFragmentDoc}
${FHotelCautionsFragmentDoc}
${FAmenityFragmentDoc}
${FRoomBedGroupFragmentDoc}`;
export const FPlanSummaryForHotelFragmentDoc = gql`
    fragment FPlanSummaryForHotel on PlanSummaryForHotel {
  id
  planId
  title
  thumbnailUrls
  areaName
}
    `;
export const FSpotSummaryForHotelFragmentDoc = gql`
    fragment FSpotSummaryForHotel on SpotSummaryForHotel {
  id
  cocolocalaSpotId
  name
  rating
  distance
  areaName
  prefectureName
  description
  thumbnailUrl
}
    `;
export const FHotelMinimumPricesFragmentDoc = gql`
    fragment FHotelMinimumPrices on HotelMinimumPrices {
  perOne {
    inclusive
    strikeThrough
  }
  perTwo {
    inclusive
    strikeThrough
  }
}
    `;
export const FHotelSummaryForHotelFragmentDoc = gql`
    fragment FHotelSummaryForHotel on HotelSummaryForHotel {
  id
  cocolocalaHotelId
  name
  rating
  distance
  areaName
  prefectureName
  minimumPrices {
    ...FHotelMinimumPrices
  }
  thumbnailUrl
}
    ${FHotelMinimumPricesFragmentDoc}`;
export const FFullHotelFragmentDoc = gql`
    fragment FFullHotel on Hotel {
  id
  ...FCocoolocalaHotel
  ...FExpediaHotel
  googlePlaceReviews {
    ...FGooglePlaceReviews
  }
  contents {
    ...FHotelContentItem
  }
  recommendedPlans {
    ...FPlanSummaryForHotel
  }
  aroundSpots {
    ...FSpotSummaryForHotel
  }
  aroundRestaurants {
    ...FSpotSummaryForHotel
  }
  aroundHotels {
    ...FHotelSummaryForHotel
  }
}
    ${FCocoolocalaHotelFragmentDoc}
${FExpediaHotelFragmentDoc}
${FGooglePlaceReviewsFragmentDoc}
${FHotelContentItemFragmentDoc}
${FPlanSummaryForHotelFragmentDoc}
${FSpotSummaryForHotelFragmentDoc}
${FHotelSummaryForHotelFragmentDoc}`;
export const FHotelRoomRateFragmentDoc = gql`
    fragment FHotelRoomRate on HotelRoomRate {
  id
  rateId
  availableRooms
  refundable
  fencedDeal
  fencedDealAvailable
  promotions {
    dealId
    dealDescription
    valueAdds
  }
  occupancyPricing {
    inclusivePrice
    exclusivePrice
    strikethroughPrice
    discountRate
  }
  cancelPenalties {
    currency
    start
    end
    amount
    nights
    percent
  }
  bedGroups {
    ...FRoomBedGroup
    expediaPriceCheckHref
  }
  amenities {
    ...FAmenity
  }
  meal
}
    ${FRoomBedGroupFragmentDoc}
${FAmenityFragmentDoc}`;
export const FVacantHotelForDpCarFragmentDoc = gql`
    fragment FVacantHotelForDPCar on VacantHotel {
  cocolocalaHotelId
  expediaHotelId
  name
  locationInfo {
    areaId
    areaPath
    areaName
  }
  selectedRoomId
  selectedRateId
  selectedBedGroupId
  selectedRoom {
    roomId
    roomName
    overview
    images {
      ...FHotelImage
    }
  }
  selectedRate {
    occupancyPricing {
      inclusivePrice
      exclusivePrice
      strikethroughPrice
      discountRate
      cocolocalaTransactionFee
      cocolocalaTransactionFeeTax
    }
  }
}
    ${FHotelImageFragmentDoc}`;
export const FVacantHotelSummaryFragmentDoc = gql`
    fragment FVacantHotelSummary on VacantHotelSummary {
  id
  cocolocalaHotelId
  expediaHotelId
  name
  rating
  zoneInfo {
    prefectureName
    areaName
  }
  numberOfStays
  numberOfPeople
  minimumPriceInfo {
    inclusivePrice
    strikeThroughPrice
    discountLabel
    isMemberDiscount
    isAvailableMemberDiscount
  }
  images {
    ...FHotelImage
  }
  freeCancellation
  checkin {
    beginTime
    endTime
  }
}
    ${FHotelImageFragmentDoc}`;
export const FHotelSummaryFragmentDoc = gql`
    fragment FHotelSummary on HotelSummary {
  id
  cocolocalaHotelId
  expediaHotelId
  name
  rating
  zoneInfo {
    prefectureName
    areaName
  }
  minimumPrices {
    one {
      inclusivePrice
      strikeThroughPrice
      discountLabel
    }
    two {
      inclusivePrice
      strikeThroughPrice
      discountLabel
    }
  }
  images {
    ...FHotelImage
  }
}
    ${FHotelImageFragmentDoc}`;
export const FHotelDayMinimumPriceFragmentDoc = gql`
    fragment FHotelDayMinimumPrice on HotelDayMinimumPrice {
  date
  price
}
    `;
export const FHotelSummaryForReviewFragmentDoc = gql`
    fragment FHotelSummaryForReview on Hotel {
  cocolocalaHotelId
  name
  minimumPrices {
    ...FHotelMinimumPrices
  }
  location {
    ...FHotelLocation
  }
  images {
    ...FHotelImage
  }
}
    ${FHotelMinimumPricesFragmentDoc}
${FHotelLocationFragmentDoc}
${FHotelImageFragmentDoc}`;
export const FHotelRoomRateForDpFlightFragmentDoc = gql`
    fragment FHotelRoomRateForDPFlight on HotelRoomRateForDPFlight {
  id
  rateId
  refundable
  fencedDeal
  fencedDealAvailable
  promotions {
    dealId
    dealDescription
    valueAdds
  }
  occupancyPricing {
    hotelExclusivePrice
    hotelExclusiveStrikethroughPrice
    hotelTaxAndServiceCharge
    ratePriceDiffPerPerson
    totalPrice
    totalPricePerPerson
  }
  cancelPenalties {
    currency
    start
    end
    amount
    nights
    percent
  }
  bedGroups {
    ...FRoomBedGroup
  }
  hasWifi
  mealLabel
}
    ${FRoomBedGroupFragmentDoc}`;
export const FRateFragmentDoc = gql`
    fragment FRate on Rate {
  fencedDeal
  fencedDealAvailable
  promotions {
    deal {
      id
      description
    }
  }
  pricing {
    inclusive {
      value
      currency
    }
    exclusive {
      value
      currency
    }
    strikethrough {
      value
      currency
    }
    discountRate
  }
  priceRangeCondition
  bedTypeConditions
  smokingCondition
  refundable
  cancelPenalties {
    currency
    start
    end
    amount
    nights
    percent
  }
}
    `;
export const FMinimumPricingFragmentDoc = gql`
    fragment FMinimumPricing on MinimumPricing {
  inclusiveWithCocolocalaTransactionFee {
    value
    currency
  }
  inclusive {
    value
    currency
  }
  exclusive {
    value
    currency
  }
  strikeThroughWithCocolocalaTransactionFee {
    value
    currency
  }
}
    `;
export const FIncrementalSearchZoneItemFragmentDoc = gql`
    fragment FIncrementalSearchZoneItem on IncrementalSearchZoneItem {
  id
  displayName
  regionName
  prefectureName
  districtName
  areaName
  zoneType
  path
  hotelCount
}
    `;
export const FIncrementalSearchHotelItemFragmentDoc = gql`
    fragment FIncrementalSearchHotelItem on IncrementalSearchHotelItem {
  id
  displayName
  regionName
  prefectureName
  districtName
  areaName
  cocolocalaHotelId
  sort
}
    `;
export const FOrderPriceDetailFragmentDoc = gql`
    fragment FOrderPriceDetail on OrderPriceDetail {
  label
  value
  priceType
}
    `;
export const FPropertyCollectionPriceInfoFragmentDoc = gql`
    fragment FPropertyCollectionPriceInfo on PropertyCollectionPriceInfo {
  label
  value
  type
}
    `;
export const FOrderPriceInfoForOrderConfirmFragmentDoc = gql`
    fragment FOrderPriceInfoForOrderConfirm on OrderPriceInfoForOrderConfirm {
  totalAmount
  totalAmountPerPerson
  strikethroughAmount
  hotelPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
    propertyCollectionPriceInfo {
      ...FPropertyCollectionPriceInfo
    }
  }
  dPCarPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
  }
  flightPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
  }
  baggageOptionPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
    inclusiveTotalPrice
  }
  supportPlanPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
  }
  cancelForAnyReasonInclusivePricePerPerson
  cancelForAnyReasonPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
    cancelForAnyReasonInclusivePerPerson
  }
  cocolocalaTransactionFeePriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
    cocolocalaTransactionFeeAndTaxText
  }
  discountSectionPriceInfo {
    label
    priceDetails {
      ...FOrderPriceDetail
    }
  }
  discountAmount
  limitedTimeSaleDiscountAmount
  campaignDiscountAmount
  discountDetails {
    label
    value
  }
  totalPriceDetails {
    ...FOrderPriceDetail
  }
  displayUnAvailableMemberDiscount
}
    ${FOrderPriceDetailFragmentDoc}
${FPropertyCollectionPriceInfoFragmentDoc}`;
export const FHotelCheckInCheckOutInfoFragmentDoc = gql`
    fragment FHotelCheckInCheckOutInfo on HotelCheckInCheckOutInfo {
  checkInDate
  checkInDateText
  availableCheckInTimeRange
  checkOutDate
  checkOutDateText
  checkOutTime
  numberOfStays
}
    `;
export const FOrderHotelSummaryFragmentDoc = gql`
    fragment FOrderHotelSummary on OrderHotelSummary {
  hotelThumbnailUrl
  rating
  hotelName
  checkInCheckOutInfo {
    ...FHotelCheckInCheckOutInfo
  }
}
    ${FHotelCheckInCheckOutInfoFragmentDoc}`;
export const FHotelRoomFacilityFragmentDoc = gql`
    fragment FHotelRoomFacility on HotelRoomFacility {
  type
  label
}
    `;
export const FOrderHotelRoomSummaryFragmentDoc = gql`
    fragment FOrderHotelRoomSummary on OrderHotelRoomSummary {
  roomThumbnailUrl
  roomName
  facilities {
    ...FHotelRoomFacility
  }
}
    ${FHotelRoomFacilityFragmentDoc}`;
export const FOrderHotelDetailFragmentDoc = gql`
    fragment FOrderHotelDetail on OrderHotelDetail {
  cocolocalaHotelId
  hotelName
  images {
    ...FHotelImage
  }
  summaryTitle
  rating
  hotelLocation
  googlePlaceReviews {
    ...FGooglePlaceReviews
  }
  summaryDescription
  description
  checkin {
    twentyFourHour
    beginTime
    endTime
    minAge
  }
  checkout {
    time
  }
  phoneNumber
  hotelAmenities {
    wifiCondition
    japaneseCondition
    amenities {
      ...FAmenity
    }
  }
  location {
    ...FHotelLocation
  }
  hotelExplanation {
    amenities
    dining
    access
  }
  hotelCautions {
    ...FHotelCautions
  }
  statics {
    roomsCount
  }
  websiteUrl
  hotelType {
    id
    name
  }
}
    ${FHotelImageFragmentDoc}
${FGooglePlaceReviewsFragmentDoc}
${FAmenityFragmentDoc}
${FHotelLocationFragmentDoc}
${FHotelCautionsFragmentDoc}`;
export const FOrderHotelRoomDetailFragmentDoc = gql`
    fragment FOrderHotelRoomDetail on OrderHotelRoomDetail {
  roomId
  images {
    ...FHotelImage
  }
  roomName
  view
  bedGroups {
    ...FRoomBedGroup
  }
  smokingCondition
  maxAllowedOccupancy {
    total
    adults
    children
  }
  hasWifi
  overview
}
    ${FHotelImageFragmentDoc}
${FRoomBedGroupFragmentDoc}`;
export const FdpCarFragmentDoc = gql`
    fragment FDPCar on DPCar {
  name
  thumbnailUrl
  options {
    ...FDPCarOption
  }
}
    ${FdpCarOptionFragmentDoc}`;
export const FOrderDpCarInfoFragmentDoc = gql`
    fragment FOrderDPCarInfo on OrderDPCarInfo {
  vendorInfo {
    ...FDPCarVendorInfo
  }
  car {
    ...FDPCar
  }
}
    ${FdpCarVendorInfoFragmentDoc}
${FdpCarFragmentDoc}`;
export const FFlightClassFragmentDoc = gql`
    fragment FFlightClass on FlightClass {
  id
  name
  code
}
    `;
export const FFlightSummaryFragmentDoc = gql`
    fragment FFlightSummary on FlightSummary {
  departureTime
  arrivalTime
  dayDiff
  totalTime
  totalTimeInMinutes
  priceDiff
  connectionsAirportNames
  numberOfConnections
  numberOfConnectingCarriers
  carrierIATA
  carrierName
  flightClass {
    ...FFlightClass
  }
  arrivalNote
  baggageAllowance
}
    ${FFlightClassFragmentDoc}`;
export const FOrderCarrierFragmentDoc = gql`
    fragment FOrderCarrier on OrderCarrier {
  id
  carrierIATACode
  name
  carrierType
}
    `;
export const FOrderAirportInfoFragmentDoc = gql`
    fragment FOrderAirportInfo on OrderAirportInfo {
  id
  airportIATACode
  airportName
  countryAndCityName
}
    `;
export const FFlightTransitFragmentDoc = gql`
    fragment FFlightTransit on FlightTransit {
  arrivalDate
  arrivalTime
  arrivalUtcDateTime
  departureDate
  departureTime
  departureUtcDateTime
  timeZoneOffset
  airport {
    ...FOrderAirportInfo
  }
  flightTime
  connectingTime
}
    ${FOrderAirportInfoFragmentDoc}`;
export const FFlightSectorFragmentDoc = gql`
    fragment FFlightSector on FlightSector {
  flightIndex
  carrier {
    ...FOrderCarrier
  }
  flightNumber
  flightClass {
    ...FFlightClass
  }
  fareClassCode
  departureDate
  departureTime
  departureUtcDateTime
  departureTimeZoneOffset
  departureAirport {
    ...FOrderAirportInfo
  }
  arrivalDate
  arrivalTime
  arrivalUtcDateTime
  arrivalTimeZoneOffset
  arrivalAirport {
    ...FOrderAirportInfo
  }
  flightTime
  connectingTime
  codeShareAirlines
  isConnectingToAnotherAirport
  flightTransits {
    ...FFlightTransit
  }
}
    ${FOrderCarrierFragmentDoc}
${FFlightClassFragmentDoc}
${FOrderAirportInfoFragmentDoc}
${FFlightTransitFragmentDoc}`;
export const FFlightTicketPriceInfoFragmentDoc = gql`
    fragment FFlightTicketPriceInfo on FlightTicketPriceInfo {
  originalExclusivePriceOfAdults
  originalExclusivePriceOfChildren
  originalExclusivePriceOfInfants
  originalExclusivePrice
  originalTaxOfAdults
  originalTaxOfChildren
  originalTaxOfInfants
  originalInclusivePrice
  originalTax
  currencyCode
  inclusivePrice
  inclusivePricePerPerson
}
    `;
export const FFlightDetailFragmentDoc = gql`
    fragment FFlightDetail on FlightDetail {
  flightSectors {
    ...FFlightSector
  }
  freeBaggageAllowance
  showDifferentAirportsAlertForDeparture
  showDifferentAirportsAlertForArrival
  price {
    ...FFlightTicketPriceInfo
  }
}
    ${FFlightSectorFragmentDoc}
${FFlightTicketPriceInfoFragmentDoc}`;
export const FReturningFlightFragmentDoc = gql`
    fragment FReturningFlight on Flight {
  summary {
    ...FFlightSummary
  }
  detail {
    ...FFlightDetail
  }
  gdsVendor
  carrierType
  additionalFlightInfo {
    externalFlightId
  }
}
    ${FFlightSummaryFragmentDoc}
${FFlightDetailFragmentDoc}`;
export const FAdditionalFlightInfoFragmentDoc = gql`
    fragment FAdditionalFlightInfo on AdditionalFlightInfo {
  externalFlightId
  recommendedReturningFlights {
    ...FReturningFlight
  }
}
    ${FReturningFlightFragmentDoc}`;
export const FFlightFragmentDoc = gql`
    fragment FFlight on Flight {
  summary {
    ...FFlightSummary
  }
  detail {
    ...FFlightDetail
  }
  gdsVendor
  passportRequirement
  carrierType
  additionalFlightInfo {
    ...FAdditionalFlightInfo
  }
}
    ${FFlightSummaryFragmentDoc}
${FFlightDetailFragmentDoc}
${FAdditionalFlightInfoFragmentDoc}`;
export const FCancelPolicyTableItemFragmentDoc = gql`
    fragment FCancelPolicyTableItem on CancelPolicyTableItem {
  beginDate {
    date
    time
  }
  endDate {
    date
    time
  }
  value
}
    `;
export const FFlightCancelPolicyFragmentDoc = gql`
    fragment FFlightCancelPolicy on FlightCancelPolicy {
  cocolocalaTicketingFeeText
  cocolocalaTicketingFeePerPersonText
  cocolocalaCancelFeeText
  cocolocalaCancelFeePerPersonText
  flightCarrierCancelPolicyTextList
}
    `;
export const FOrderCancelInfoFragmentDoc = gql`
    fragment FOrderCancelInfo on OrderCancelInfo {
  freeCancellation
  cancelPolicies {
    title
    policies {
      ...FCancelPolicyTableItem
    }
  }
  cocolocalaChangeFeePerPersonText
  flightCancelPolicy {
    ...FFlightCancelPolicy
  }
}
    ${FCancelPolicyTableItemFragmentDoc}
${FFlightCancelPolicyFragmentDoc}`;
export const FOrderPaymentInfoFragmentDoc = gql`
    fragment FOrderPaymentInfo on OrderPaymentInfo {
  paymentMethod
  paymentMethodName
  paymentDetailItems {
    ...FDetailsTableItem
  }
  paymentUserDetailItems {
    ...FDetailsTableItem
  }
  howToPaymentLink
  bankTransferDeadline
  convenienceStoreTransferDeadline
}
    ${FDetailsTableItemFragmentDoc}`;
export const FdpFlightSupportPlanFragmentDoc = gql`
    fragment FDPFlightSupportPlan on DPFlightSupportPlan {
  planType
  title
  description
  inclusivePrice
  iconUrl
  isRecommend
  planColor
  contents {
    title
    description
    iconUrl
  }
  zonePath
}
    `;
export const FOrderCancelForAnyReasonFragmentDoc = gql`
    fragment FOrderCancelForAnyReason on OrderCancelForAnyReason {
  hasCancelForAnyReason
  limitDateTimeText
  expireDateTimeText
}
    `;
export const FAdditionalOptionsInfoFragmentDoc = gql`
    fragment FAdditionalOptionsInfo on AdditionalOptionsInfo {
  isAvailableAirportTransfer
  localActivities {
    title
    description
    imageUrl
    linkUrl
  }
}
    `;
export const FOrderHistoryFragmentDoc = gql`
    fragment FOrderHistory on OrderHistory {
  id
  orderId
  status
  detailsTableItems {
    ...FDetailsTableItem
  }
  hotelInfo {
    id
    cocolocalaHotelId
    hotelSummary {
      ...FOrderHotelSummary
    }
    roomSummary {
      ...FOrderHotelRoomSummary
    }
    hotelDetail {
      ...FOrderHotelDetail
    }
    roomDetail {
      ...FOrderHotelRoomDetail
    }
    importantNotices
    numberOfPeople
    targetHotelZonePath
  }
  dPCarInfo {
    id
    ...FOrderDPCarInfo
  }
  flightInfo {
    goingFlight {
      ...FFlight
    }
    returningFlight {
      ...FFlight
    }
  }
  cancelInfo {
    ...FOrderCancelInfo
  }
  priceInfo {
    totalAmount
    strikethroughAmount
    hotelPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      propertyCollectionPriceInfo {
        ...FPropertyCollectionPriceInfo
      }
    }
    dPCarPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    flightPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    baggageOptionPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    supportPlanPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    cancelForAnyReasonInclusivePricePerPerson
    cancelForAnyReasonPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      cancelForAnyReasonInclusivePerPerson
    }
    cocolocalaTransactionFeePriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      cocolocalaTransactionFeeAndTaxText
    }
    discountSectionPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    discountAmount
    discountDetails {
      label
      value
    }
    totalPriceDetails {
      ...FOrderPriceDetail
    }
    discountLabel
  }
  paymentInfo {
    ...FOrderPaymentInfo
  }
  supportPlanInfo {
    ...FDPFlightSupportPlan
  }
  supportPlans {
    ...FDPFlightSupportPlan
  }
  cancelForAnyReasonInfo {
    ...FOrderCancelForAnyReason
  }
  isClosed
  IsNotAllPassportsCompleted
  additionalOptionsInfo {
    ...FAdditionalOptionsInfo
  }
}
    ${FDetailsTableItemFragmentDoc}
${FOrderHotelSummaryFragmentDoc}
${FOrderHotelRoomSummaryFragmentDoc}
${FOrderHotelDetailFragmentDoc}
${FOrderHotelRoomDetailFragmentDoc}
${FOrderDpCarInfoFragmentDoc}
${FFlightFragmentDoc}
${FOrderCancelInfoFragmentDoc}
${FOrderPriceDetailFragmentDoc}
${FPropertyCollectionPriceInfoFragmentDoc}
${FOrderPaymentInfoFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FOrderCancelForAnyReasonFragmentDoc}
${FAdditionalOptionsInfoFragmentDoc}`;
export const FLimitedTimeSaleInfoFragmentDoc = gql`
    fragment FLimitedTimeSaleInfo on LimitedTimeSaleInfo {
  limitedTimeSaleLabel
  isWithin30MinOfLimitedTimeSaleDiscount
  limitedTimeSaleEndTime
  limitedTimeSaleType
  limitedTimeSaleImageBannerPath
}
    `;
export const FSelectedProductsSummaryLabelFragmentDoc = gql`
    fragment FSelectedProductsSummaryLabel on SelectedProductsSummaryLabel {
  label
  dateTimeText
  dayDiff
  detail
}
    `;
export const FOrderPurchaseFragmentDoc = gql`
    fragment FOrderPurchase on OrderPurchase {
  id
  travelId
  priceInfo {
    totalAmount
    strikethroughAmount
    hotelPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      propertyCollectionPriceInfo {
        ...FPropertyCollectionPriceInfo
      }
    }
    dPCarPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    flightPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    baggageOptionPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    supportPlanPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    cancelForAnyReasonInclusivePricePerPerson
    cancelForAnyReasonPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      cancelForAnyReasonInclusivePerPerson
    }
    cocolocalaTransactionFeePriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
      cocolocalaTransactionFeeAndTaxText
    }
    discountSectionPriceInfo {
      label
      priceDetails {
        ...FOrderPriceDetail
      }
    }
    discountAmount
    limitedTimeSaleDiscount
    campaignDiscountAmount
    discountDetails {
      label
      value
    }
    totalPriceDetails {
      ...FOrderPriceDetail
    }
    discountLabel
    applyReservationPriceInfo {
      amountBeforeDiscount
      cocolocalaTransactionFee
      cocolocalaTransactionFeeTax
      currency
      cancelForAnyReasonPriceInfo {
        hasCancelForAnyReason
        amount
        tax
      }
    }
  }
  paymentInfo {
    convenienceStorePaymentDeadline
    bankTransferDeadline
  }
  cancelInfo {
    ...FOrderCancelInfo
    ...FOrderCancelInfo
  }
  reservationInfo {
    hotelReservationInfo {
      numberOfPeople
      numberOfAdults
      childAges
      numberOfStays
      expediaFreeCancelEndTime
      smoking
      bookingUrl
      referenceNo
      stayId
      externalHotelId
      roomId
      rateId
      bedGroupId
      salesChannel
      rateOptionMember
      numberOfRoomsRemaining
      importantNotices
      internationalOrDomestic
    }
    dPCarReservationInfo {
      reference {
        ...FDPCarReference
      }
      departureDateTime
      returnDateTime
      pickupLocationCode
      returnLocationCode
      passengers
    }
    flightReservationInfo {
      representativeFirstName
      representativeLastName
      representativePhoneNumber
      gdsVendor
      flightExternalReservationInfo {
        flightExternalReservationId
        expectedPrice
      }
    }
  }
  logInfo {
    productType
  }
  limitedTimeSaleInfo {
    ...FLimitedTimeSaleInfo
  }
  selectedProductsSummaryLabelInfo {
    labels {
      ...FSelectedProductsSummaryLabel
    }
  }
  cancelInfo {
    ...FOrderCancelInfo
  }
  productType
  dPFlightSupportPlan
  useAirportTransfer
  isHotspringMember
}
    ${FOrderPriceDetailFragmentDoc}
${FPropertyCollectionPriceInfoFragmentDoc}
${FOrderCancelInfoFragmentDoc}
${FdpCarReferenceFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}
${FSelectedProductsSummaryLabelFragmentDoc}`;
export const FiOrderSignOrPurchaseDpCarInfoFragmentDoc = gql`
    fragment FIOrderSignOrPurchaseDPCarInfo on IOrderSignOrPurchaseDPCarInfo {
  thumbnailUrl
  carName
  dPCarDetails {
    ...FDetailsTableItem
  }
}
    ${FDetailsTableItemFragmentDoc}`;
export const FOrderSupportPlanInfoFragmentDoc = gql`
    fragment FOrderSupportPlanInfo on OrderSupportPlanInfo {
  supportPlanType
}
    `;
export const FVacantHotelsForDpFlightHotelDetailFragmentDoc = gql`
    fragment FVacantHotelsForDPFlightHotelDetail on VacantHotelsForDPFlightHotelDetail {
  id
  cocolocalaHotelId
  name
  summaryTitle
  rating
  numberOfStays
  priceInfo {
    minimumPricePerPerson
    discountInfo {
      ...FDiscountInfoForDPFlight
    }
    priceDiff
  }
  popularScore
  images
}
    ${FDiscountInfoForDpFlightFragmentDoc}`;
export const FOverseasDpFlightTabZoneFragmentDoc = gql`
    fragment FOverseasDPFlightTabZone on OverseasDPFlightTabZone {
  countryName
  cityName
  zonePath
  zoneImageUrl
  numberOfStays
  minimumPricePerPerson
  goingDate
  returningDate
  goingCityOrAirportIATACode
  returningCityOrAirportIATACode
  numberOfAdults
  childAges
  minimumFlightPrice
  vacantHotels {
    ...FVacantHotelsForDPFlightHotelDetail
  }
}
    ${FVacantHotelsForDpFlightHotelDetailFragmentDoc}`;
export const FOverseasDpFlightTabsFragmentDoc = gql`
    fragment FOverseasDPFlightTabs on OverseasDPFlightTabs {
  label
  zones {
    ...FOverseasDPFlightTabZone
  }
}
    ${FOverseasDpFlightTabZoneFragmentDoc}`;
export const FPlanSummaryFragmentDoc = gql`
    fragment FPlanSummary on PlanSummary {
  id
  planId
  title
  areaName
  thumbnailUrl
}
    `;
export const FPlanImageFragmentDoc = gql`
    fragment FPlanImage on PlanImage {
  url
  width
  height
  creditText
  creditImageUrl
  creditLinkUrl
}
    `;
export const FReviewSummaryForReviewDetailFragmentDoc = gql`
    fragment FReviewSummaryForReviewDetail on Review {
  reviewId
  nickname
  iconUrl
  stayedAt
  numberOfPeople
  useScene {
    label
  }
}
    `;
export const FReviewItemImageFragmentDoc = gql`
    fragment FReviewItemImage on ReviewItemImage {
  id
  imageUrl
}
    `;
export const FReviewItemFragmentDoc = gql`
    fragment FReviewItem on ReviewItem {
  reviewItemId
  reviewItemImages {
    id
    imageUrl
  }
  comment
}
    `;
export const FReviewItemWithReviewUserFragmentDoc = gql`
    fragment FReviewItemWithReviewUser on ReviewItemWithReviewUser {
  reviewId
  reviewItemId
  nickname
  iconUrl
  reviewItemImageUrl
  comment
  cocolocalaHotelId
}
    `;
export const FReviewItemsPaginationResponseFragmentDoc = gql`
    fragment FReviewItemsPaginationResponse on ReviewItemsPaginationResponse {
  hasNext
  nextReviewOffset
  nextReviewItemOffset
}
    `;
export const FSelectedProductsSummaryFragmentDoc = gql`
    fragment FSelectedProductsSummary on SelectedProductsSummary {
  hotelInfo {
    id
    cocolocalaHotelId
    hotelSummary {
      ...FOrderHotelSummary
    }
    roomSummary {
      ...FOrderHotelRoomSummary
    }
    importantNotices
    numberOfPeople
  }
  dPCarInfo {
    id
    ...FOrderDPCarInfo
  }
  flightInfo {
    goingFlight {
      ...FFlight
    }
    returningFlight {
      ...FFlight
    }
  }
  supportPlan {
    ...FDPFlightSupportPlan
  }
  supportPlans {
    ...FDPFlightSupportPlan
  }
  cancelForAnyReason {
    ...FOrderCancelForAnyReason
  }
  cancelInfo {
    ...FOrderCancelInfo
  }
}
    ${FOrderHotelSummaryFragmentDoc}
${FOrderHotelRoomSummaryFragmentDoc}
${FOrderDpCarInfoFragmentDoc}
${FFlightFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FOrderCancelForAnyReasonFragmentDoc}
${FOrderCancelInfoFragmentDoc}`;
export const FPaginationFragmentDoc = gql`
    fragment FPagination on Pagination {
  hasNext
  nextOffset
}
    `;
export const FOcuppancyFragmentDoc = gql`
    fragment FOcuppancy on Occupancy {
  numberOfAdults
  childAges
}
    `;
export const FPaginationV2FragmentDoc = gql`
    fragment FPaginationV2 on PaginationV2 {
  hasNext
  nextPage
  nextIndex
}
    `;
export const FImageDataFragmentDoc = gql`
    fragment FImageData on ImageData {
  url
  height
  width
  creditText
  creditImageUrl
  creditLinkUrl
}
    `;
export const FReservationSummaryInfoFragmentDoc = gql`
    fragment FReservationSummaryInfo on ReservationSummaryInfo {
  goingDeparturePointDate
  returningDeparturePointDate
  numberOfPeople
}
    `;
export const FExpandableContentsSectionFragmentDoc = gql`
    fragment FExpandableContentsSection on ExpandableContentsSection {
  title
  contents {
    title
    iconUrl
    label {
      text
      labelColor
    }
    content
    status
  }
}
    `;
export const FExpandableContentFragmentDoc = gql`
    fragment FExpandableContent on ExpandableContent {
  title
  iconUrl
  label {
    text
    labelColor
  }
  content
  status
}
    `;
export const FInstagramImageFragmentDoc = gql`
    fragment FInstagramImage on InstagramImage {
  imageUrl
  accountName
}
    `;
export const FStaffCommentFragmentDoc = gql`
    fragment FStaffComment on StaffComment {
  status
  text
}
    `;
export const FCampaignInfoFragmentDoc = gql`
    fragment FCampaignInfo on CampaignInfo {
  campaignImageBannerPath
  campaignDiscountAmountPerPerson
}
    `;
export const FInclusivePriceInfoFragmentDoc = gql`
    fragment FInclusivePriceInfo on InclusivePriceInfo {
  total
  perPerson
  numberOfPeople
  numberOfStays
}
    `;
export const FSpotLocationFragmentDoc = gql`
    fragment FSpotLocation on SpotLocation {
  zipCode
  address
  description
  latitude
  longitude
}
    `;
export const FSpotCommentFragmentDoc = gql`
    fragment FSpotComment on SpotComment {
  id
  text
}
    `;
export const FSpotRelationalServiceIdsFragmentDoc = gql`
    fragment FSpotRelationalServiceIds on SpotRelationalServiceIds {
  foursquare
  googlePlace
}
    `;
export const FSpotFragmentDoc = gql`
    fragment FSpot on Spot {
  id
  areaId
  areaPath
  areaName
  districtId
  districtPath
  districtName
  prefectureId
  prefecturePath
  prefectureName
  regionId
  regionPath
  regionName
  countryCode
  countryName
  name
  rating
  phoneNumber
  summaryTitle
  summaryDescription
  websiteUrl
  businessHours
  location {
    ...FSpotLocation
  }
  comments {
    ...FSpotComment
  }
  relationalServiceIds {
    ...FSpotRelationalServiceIds
  }
  imageUrls
}
    ${FSpotLocationFragmentDoc}
${FSpotCommentFragmentDoc}
${FSpotRelationalServiceIdsFragmentDoc}`;
export const ZoneFragmentFragmentDoc = gql`
    fragment ZoneFragment on GqlZoneType {
  id
  zoneType
  zoneHotelCount
  countryId
  countryCode
  countryName
  regionId
  regionPath
  regionName
  prefectureId
  prefecturePath
  prefectureName
  districtId
  districtPath
  districtName
  areaId
  areaPath
  areaName
}
    `;
export const AddBookmarkHotelDocument = gql`
    mutation addBookmarkHotel($input: AddBookmarkHotelInput!) {
  addBookmarkHotel(input: $input) {
    ok
  }
}
    `;
export type AddBookmarkHotelMutationFn = Apollo.MutationFunction<AddBookmarkHotelMutation, AddBookmarkHotelMutationVariables>;

/**
 * __useAddBookmarkHotelMutation__
 *
 * To run a mutation, you first call `useAddBookmarkHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBookmarkHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBookmarkHotelMutation, { data, loading, error }] = useAddBookmarkHotelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBookmarkHotelMutation(baseOptions?: Apollo.MutationHookOptions<AddBookmarkHotelMutation, AddBookmarkHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBookmarkHotelMutation, AddBookmarkHotelMutationVariables>(AddBookmarkHotelDocument, options);
      }
export type AddBookmarkHotelMutationHookResult = ReturnType<typeof useAddBookmarkHotelMutation>;
export type AddBookmarkHotelMutationResult = Apollo.MutationResult<AddBookmarkHotelMutation>;
export type AddBookmarkHotelMutationOptions = Apollo.BaseMutationOptions<AddBookmarkHotelMutation, AddBookmarkHotelMutationVariables>;
export const AddDpCarToCartsForOrderPurchaseDocument = gql`
    mutation addDPCarToCartsForOrderPurchase($input: AddDPCarToCartsForOrderPurchaseInput!) {
  addDPCarToCartsForOrderPurchase(input: $input) {
    ok
  }
}
    `;
export type AddDpCarToCartsForOrderPurchaseMutationFn = Apollo.MutationFunction<AddDpCarToCartsForOrderPurchaseMutation, AddDpCarToCartsForOrderPurchaseMutationVariables>;

/**
 * __useAddDpCarToCartsForOrderPurchaseMutation__
 *
 * To run a mutation, you first call `useAddDpCarToCartsForOrderPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDpCarToCartsForOrderPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDpCarToCartsForOrderPurchaseMutation, { data, loading, error }] = useAddDpCarToCartsForOrderPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDpCarToCartsForOrderPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<AddDpCarToCartsForOrderPurchaseMutation, AddDpCarToCartsForOrderPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDpCarToCartsForOrderPurchaseMutation, AddDpCarToCartsForOrderPurchaseMutationVariables>(AddDpCarToCartsForOrderPurchaseDocument, options);
      }
export type AddDpCarToCartsForOrderPurchaseMutationHookResult = ReturnType<typeof useAddDpCarToCartsForOrderPurchaseMutation>;
export type AddDpCarToCartsForOrderPurchaseMutationResult = Apollo.MutationResult<AddDpCarToCartsForOrderPurchaseMutation>;
export type AddDpCarToCartsForOrderPurchaseMutationOptions = Apollo.BaseMutationOptions<AddDpCarToCartsForOrderPurchaseMutation, AddDpCarToCartsForOrderPurchaseMutationVariables>;
export const AddHotelToCartDocument = gql`
    mutation addHotelToCart($input: AddHotelToCartInput!) {
  addHotelToCart(input: $input) {
    ok
  }
}
    `;
export type AddHotelToCartMutationFn = Apollo.MutationFunction<AddHotelToCartMutation, AddHotelToCartMutationVariables>;

/**
 * __useAddHotelToCartMutation__
 *
 * To run a mutation, you first call `useAddHotelToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHotelToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHotelToCartMutation, { data, loading, error }] = useAddHotelToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHotelToCartMutation(baseOptions?: Apollo.MutationHookOptions<AddHotelToCartMutation, AddHotelToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHotelToCartMutation, AddHotelToCartMutationVariables>(AddHotelToCartDocument, options);
      }
export type AddHotelToCartMutationHookResult = ReturnType<typeof useAddHotelToCartMutation>;
export type AddHotelToCartMutationResult = Apollo.MutationResult<AddHotelToCartMutation>;
export type AddHotelToCartMutationOptions = Apollo.BaseMutationOptions<AddHotelToCartMutation, AddHotelToCartMutationVariables>;
export const AddHotelToCartsForOrderPurchaseDocument = gql`
    mutation addHotelToCartsForOrderPurchase($input: AddHotelToCartsForOrderPurchaseInput!) {
  addHotelToCartsForOrderPurchase(input: $input) {
    ok
  }
}
    `;
export type AddHotelToCartsForOrderPurchaseMutationFn = Apollo.MutationFunction<AddHotelToCartsForOrderPurchaseMutation, AddHotelToCartsForOrderPurchaseMutationVariables>;

/**
 * __useAddHotelToCartsForOrderPurchaseMutation__
 *
 * To run a mutation, you first call `useAddHotelToCartsForOrderPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHotelToCartsForOrderPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHotelToCartsForOrderPurchaseMutation, { data, loading, error }] = useAddHotelToCartsForOrderPurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHotelToCartsForOrderPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<AddHotelToCartsForOrderPurchaseMutation, AddHotelToCartsForOrderPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHotelToCartsForOrderPurchaseMutation, AddHotelToCartsForOrderPurchaseMutationVariables>(AddHotelToCartsForOrderPurchaseDocument, options);
      }
export type AddHotelToCartsForOrderPurchaseMutationHookResult = ReturnType<typeof useAddHotelToCartsForOrderPurchaseMutation>;
export type AddHotelToCartsForOrderPurchaseMutationResult = Apollo.MutationResult<AddHotelToCartsForOrderPurchaseMutation>;
export type AddHotelToCartsForOrderPurchaseMutationOptions = Apollo.BaseMutationOptions<AddHotelToCartsForOrderPurchaseMutation, AddHotelToCartsForOrderPurchaseMutationVariables>;
export const AddSelectedCancelForAnyReasonDocument = gql`
    mutation addSelectedCancelForAnyReason($input: AddSelectedCancelForAnyReasonInput!) {
  addSelectedCancelForAnyReason(input: $input) {
    cartSnapshotId
  }
}
    `;
export type AddSelectedCancelForAnyReasonMutationFn = Apollo.MutationFunction<AddSelectedCancelForAnyReasonMutation, AddSelectedCancelForAnyReasonMutationVariables>;

/**
 * __useAddSelectedCancelForAnyReasonMutation__
 *
 * To run a mutation, you first call `useAddSelectedCancelForAnyReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSelectedCancelForAnyReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSelectedCancelForAnyReasonMutation, { data, loading, error }] = useAddSelectedCancelForAnyReasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSelectedCancelForAnyReasonMutation(baseOptions?: Apollo.MutationHookOptions<AddSelectedCancelForAnyReasonMutation, AddSelectedCancelForAnyReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSelectedCancelForAnyReasonMutation, AddSelectedCancelForAnyReasonMutationVariables>(AddSelectedCancelForAnyReasonDocument, options);
      }
export type AddSelectedCancelForAnyReasonMutationHookResult = ReturnType<typeof useAddSelectedCancelForAnyReasonMutation>;
export type AddSelectedCancelForAnyReasonMutationResult = Apollo.MutationResult<AddSelectedCancelForAnyReasonMutation>;
export type AddSelectedCancelForAnyReasonMutationOptions = Apollo.BaseMutationOptions<AddSelectedCancelForAnyReasonMutation, AddSelectedCancelForAnyReasonMutationVariables>;
export const ApplyReservationDocument = gql`
    mutation applyReservation($input: ApplyReservationInput!) {
  applyReservation(input: $input) {
    id
    orderId
    travelId
    cocolocalaUserId
    firebaseUserId
    totalAmount
    hotelInfo {
      cocolocalaHotelId
      checkInDate
      checkOutDate
      nights
      numberOfPeople
      numberOfAdults
      numberOfChildren
      numberOfBabies
      hotelName
      mealLabel
    }
    flightInfo {
      flightReservationId
    }
    logInfo {
      email
    }
  }
}
    `;
export type ApplyReservationMutationFn = Apollo.MutationFunction<ApplyReservationMutation, ApplyReservationMutationVariables>;

/**
 * __useApplyReservationMutation__
 *
 * To run a mutation, you first call `useApplyReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyReservationMutation, { data, loading, error }] = useApplyReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyReservationMutation(baseOptions?: Apollo.MutationHookOptions<ApplyReservationMutation, ApplyReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyReservationMutation, ApplyReservationMutationVariables>(ApplyReservationDocument, options);
      }
export type ApplyReservationMutationHookResult = ReturnType<typeof useApplyReservationMutation>;
export type ApplyReservationMutationResult = Apollo.MutationResult<ApplyReservationMutation>;
export type ApplyReservationMutationOptions = Apollo.BaseMutationOptions<ApplyReservationMutation, ApplyReservationMutationVariables>;
export const ApplyReservationViaFincodeDocument = gql`
    mutation applyReservationViaFincode($input: ApplyReservationViaFincodeInput!) {
  applyReservationViaFincode(input: $input) {
    id
    orderId
    needChallengeInfo {
      challengeUrl
    }
    withoutChallengeInfo {
      id
      orderId
      travelId
      cocolocalaUserId
      firebaseUserId
      totalAmount
      hotelInfo {
        cocolocalaHotelId
        checkInDate
        checkOutDate
        nights
        numberOfPeople
        numberOfAdults
        numberOfChildren
        numberOfBabies
        hotelName
        mealLabel
      }
      flightInfo {
        flightReservationId
      }
      logInfo {
        email
      }
    }
  }
}
    `;
export type ApplyReservationViaFincodeMutationFn = Apollo.MutationFunction<ApplyReservationViaFincodeMutation, ApplyReservationViaFincodeMutationVariables>;

/**
 * __useApplyReservationViaFincodeMutation__
 *
 * To run a mutation, you first call `useApplyReservationViaFincodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyReservationViaFincodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyReservationViaFincodeMutation, { data, loading, error }] = useApplyReservationViaFincodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyReservationViaFincodeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyReservationViaFincodeMutation, ApplyReservationViaFincodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyReservationViaFincodeMutation, ApplyReservationViaFincodeMutationVariables>(ApplyReservationViaFincodeDocument, options);
      }
export type ApplyReservationViaFincodeMutationHookResult = ReturnType<typeof useApplyReservationViaFincodeMutation>;
export type ApplyReservationViaFincodeMutationResult = Apollo.MutationResult<ApplyReservationViaFincodeMutation>;
export type ApplyReservationViaFincodeMutationOptions = Apollo.BaseMutationOptions<ApplyReservationViaFincodeMutation, ApplyReservationViaFincodeMutationVariables>;
export const ApplyReservationViaStripeDocument = gql`
    mutation applyReservationViaStripe($input: ApplyReservationViaStripeInput!) {
  applyReservationViaStripe(input: $input) {
    id
    orderId
    travelId
    cocolocalaUserId
    firebaseUserId
    totalAmount
    hotelInfo {
      cocolocalaHotelId
      checkInDate
      checkOutDate
      nights
      numberOfPeople
      numberOfAdults
      numberOfChildren
      numberOfBabies
      hotelName
      mealLabel
    }
    flightInfo {
      flightReservationId
    }
    logInfo {
      email
    }
  }
}
    `;
export type ApplyReservationViaStripeMutationFn = Apollo.MutationFunction<ApplyReservationViaStripeMutation, ApplyReservationViaStripeMutationVariables>;

/**
 * __useApplyReservationViaStripeMutation__
 *
 * To run a mutation, you first call `useApplyReservationViaStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyReservationViaStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyReservationViaStripeMutation, { data, loading, error }] = useApplyReservationViaStripeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyReservationViaStripeMutation(baseOptions?: Apollo.MutationHookOptions<ApplyReservationViaStripeMutation, ApplyReservationViaStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyReservationViaStripeMutation, ApplyReservationViaStripeMutationVariables>(ApplyReservationViaStripeDocument, options);
      }
export type ApplyReservationViaStripeMutationHookResult = ReturnType<typeof useApplyReservationViaStripeMutation>;
export type ApplyReservationViaStripeMutationResult = Apollo.MutationResult<ApplyReservationViaStripeMutation>;
export type ApplyReservationViaStripeMutationOptions = Apollo.BaseMutationOptions<ApplyReservationViaStripeMutation, ApplyReservationViaStripeMutationVariables>;
export const ChangeDpFlightCancelForAnyReasonDocument = gql`
    mutation changeDPFlightCancelForAnyReason($input: ChangeDPFlightCancelForAnyReasonInput!) {
  changeDPFlightCancelForAnyReason(input: $input) {
    cartSnapshotId
    orderPriceInfo {
      ...FOrderPriceInfoForOrderConfirm
    }
  }
}
    ${FOrderPriceInfoForOrderConfirmFragmentDoc}`;
export type ChangeDpFlightCancelForAnyReasonMutationFn = Apollo.MutationFunction<ChangeDpFlightCancelForAnyReasonMutation, ChangeDpFlightCancelForAnyReasonMutationVariables>;

/**
 * __useChangeDpFlightCancelForAnyReasonMutation__
 *
 * To run a mutation, you first call `useChangeDpFlightCancelForAnyReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDpFlightCancelForAnyReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDpFlightCancelForAnyReasonMutation, { data, loading, error }] = useChangeDpFlightCancelForAnyReasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDpFlightCancelForAnyReasonMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDpFlightCancelForAnyReasonMutation, ChangeDpFlightCancelForAnyReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDpFlightCancelForAnyReasonMutation, ChangeDpFlightCancelForAnyReasonMutationVariables>(ChangeDpFlightCancelForAnyReasonDocument, options);
      }
export type ChangeDpFlightCancelForAnyReasonMutationHookResult = ReturnType<typeof useChangeDpFlightCancelForAnyReasonMutation>;
export type ChangeDpFlightCancelForAnyReasonMutationResult = Apollo.MutationResult<ChangeDpFlightCancelForAnyReasonMutation>;
export type ChangeDpFlightCancelForAnyReasonMutationOptions = Apollo.BaseMutationOptions<ChangeDpFlightCancelForAnyReasonMutation, ChangeDpFlightCancelForAnyReasonMutationVariables>;
export const ChangeDpFlightOptionsDocument = gql`
    mutation changeDPFlightOptions($input: ChangeDPFlightOptionsInput!) {
  changeDPFlightOptions(input: $input) {
    cartSnapshotId
    orderPriceInfo {
      ...FOrderPriceInfoForOrderConfirm
    }
  }
}
    ${FOrderPriceInfoForOrderConfirmFragmentDoc}`;
export type ChangeDpFlightOptionsMutationFn = Apollo.MutationFunction<ChangeDpFlightOptionsMutation, ChangeDpFlightOptionsMutationVariables>;

/**
 * __useChangeDpFlightOptionsMutation__
 *
 * To run a mutation, you first call `useChangeDpFlightOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDpFlightOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDpFlightOptionsMutation, { data, loading, error }] = useChangeDpFlightOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDpFlightOptionsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDpFlightOptionsMutation, ChangeDpFlightOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDpFlightOptionsMutation, ChangeDpFlightOptionsMutationVariables>(ChangeDpFlightOptionsDocument, options);
      }
export type ChangeDpFlightOptionsMutationHookResult = ReturnType<typeof useChangeDpFlightOptionsMutation>;
export type ChangeDpFlightOptionsMutationResult = Apollo.MutationResult<ChangeDpFlightOptionsMutation>;
export type ChangeDpFlightOptionsMutationOptions = Apollo.BaseMutationOptions<ChangeDpFlightOptionsMutation, ChangeDpFlightOptionsMutationVariables>;
export const ChangeDpFlightSupportPlanDocument = gql`
    mutation changeDPFlightSupportPlan($input: ChangeDPFlightSupportPlanInput!) {
  changeDPFlightSupportPlan(input: $input) {
    cartSnapshotId
    orderPriceInfo {
      ...FOrderPriceInfoForOrderConfirm
    }
  }
}
    ${FOrderPriceInfoForOrderConfirmFragmentDoc}`;
export type ChangeDpFlightSupportPlanMutationFn = Apollo.MutationFunction<ChangeDpFlightSupportPlanMutation, ChangeDpFlightSupportPlanMutationVariables>;

/**
 * __useChangeDpFlightSupportPlanMutation__
 *
 * To run a mutation, you first call `useChangeDpFlightSupportPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDpFlightSupportPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDpFlightSupportPlanMutation, { data, loading, error }] = useChangeDpFlightSupportPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeDpFlightSupportPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeDpFlightSupportPlanMutation, ChangeDpFlightSupportPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeDpFlightSupportPlanMutation, ChangeDpFlightSupportPlanMutationVariables>(ChangeDpFlightSupportPlanDocument, options);
      }
export type ChangeDpFlightSupportPlanMutationHookResult = ReturnType<typeof useChangeDpFlightSupportPlanMutation>;
export type ChangeDpFlightSupportPlanMutationResult = Apollo.MutationResult<ChangeDpFlightSupportPlanMutation>;
export type ChangeDpFlightSupportPlanMutationOptions = Apollo.BaseMutationOptions<ChangeDpFlightSupportPlanMutation, ChangeDpFlightSupportPlanMutationVariables>;
export const ChangeFlightDocument = gql`
    mutation changeFlight($input: ChangeFlightInput!) {
  changeFlight(input: $input) {
    cartSnapshotId
  }
}
    `;
export type ChangeFlightMutationFn = Apollo.MutationFunction<ChangeFlightMutation, ChangeFlightMutationVariables>;

/**
 * __useChangeFlightMutation__
 *
 * To run a mutation, you first call `useChangeFlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeFlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeFlightMutation, { data, loading, error }] = useChangeFlightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeFlightMutation(baseOptions?: Apollo.MutationHookOptions<ChangeFlightMutation, ChangeFlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeFlightMutation, ChangeFlightMutationVariables>(ChangeFlightDocument, options);
      }
export type ChangeFlightMutationHookResult = ReturnType<typeof useChangeFlightMutation>;
export type ChangeFlightMutationResult = Apollo.MutationResult<ChangeFlightMutation>;
export type ChangeFlightMutationOptions = Apollo.BaseMutationOptions<ChangeFlightMutation, ChangeFlightMutationVariables>;
export const ChangeHotelRoomDocument = gql`
    mutation changeHotelRoom($input: ChangeHotelRoomInput!) {
  changeHotelRoom(input: $input) {
    cartSnapshotId
  }
}
    `;
export type ChangeHotelRoomMutationFn = Apollo.MutationFunction<ChangeHotelRoomMutation, ChangeHotelRoomMutationVariables>;

/**
 * __useChangeHotelRoomMutation__
 *
 * To run a mutation, you first call `useChangeHotelRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeHotelRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeHotelRoomMutation, { data, loading, error }] = useChangeHotelRoomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeHotelRoomMutation(baseOptions?: Apollo.MutationHookOptions<ChangeHotelRoomMutation, ChangeHotelRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeHotelRoomMutation, ChangeHotelRoomMutationVariables>(ChangeHotelRoomDocument, options);
      }
export type ChangeHotelRoomMutationHookResult = ReturnType<typeof useChangeHotelRoomMutation>;
export type ChangeHotelRoomMutationResult = Apollo.MutationResult<ChangeHotelRoomMutation>;
export type ChangeHotelRoomMutationOptions = Apollo.BaseMutationOptions<ChangeHotelRoomMutation, ChangeHotelRoomMutationVariables>;
export const ChangeSelectedBaggageOptionDocument = gql`
    mutation changeSelectedBaggageOption($input: ChangeSelectedBaggageOptionInput!) {
  changeSelectedBaggageOption(input: $input) {
    cartSnapshotId
    orderPriceInfo {
      ...FOrderPriceInfoForOrderConfirm
    }
  }
}
    ${FOrderPriceInfoForOrderConfirmFragmentDoc}`;
export type ChangeSelectedBaggageOptionMutationFn = Apollo.MutationFunction<ChangeSelectedBaggageOptionMutation, ChangeSelectedBaggageOptionMutationVariables>;

/**
 * __useChangeSelectedBaggageOptionMutation__
 *
 * To run a mutation, you first call `useChangeSelectedBaggageOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSelectedBaggageOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSelectedBaggageOptionMutation, { data, loading, error }] = useChangeSelectedBaggageOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSelectedBaggageOptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSelectedBaggageOptionMutation, ChangeSelectedBaggageOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSelectedBaggageOptionMutation, ChangeSelectedBaggageOptionMutationVariables>(ChangeSelectedBaggageOptionDocument, options);
      }
export type ChangeSelectedBaggageOptionMutationHookResult = ReturnType<typeof useChangeSelectedBaggageOptionMutation>;
export type ChangeSelectedBaggageOptionMutationResult = Apollo.MutationResult<ChangeSelectedBaggageOptionMutation>;
export type ChangeSelectedBaggageOptionMutationOptions = Apollo.BaseMutationOptions<ChangeSelectedBaggageOptionMutation, ChangeSelectedBaggageOptionMutationVariables>;
export const ChangeUseAirportTransferDocument = gql`
    mutation changeUseAirportTransfer($input: ChangeUseAirportTransferInput!) {
  changeUseAirportTransfer(input: $input) {
    cartSnapshotId
  }
}
    `;
export type ChangeUseAirportTransferMutationFn = Apollo.MutationFunction<ChangeUseAirportTransferMutation, ChangeUseAirportTransferMutationVariables>;

/**
 * __useChangeUseAirportTransferMutation__
 *
 * To run a mutation, you first call `useChangeUseAirportTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUseAirportTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUseAirportTransferMutation, { data, loading, error }] = useChangeUseAirportTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUseAirportTransferMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUseAirportTransferMutation, ChangeUseAirportTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUseAirportTransferMutation, ChangeUseAirportTransferMutationVariables>(ChangeUseAirportTransferDocument, options);
      }
export type ChangeUseAirportTransferMutationHookResult = ReturnType<typeof useChangeUseAirportTransferMutation>;
export type ChangeUseAirportTransferMutationResult = Apollo.MutationResult<ChangeUseAirportTransferMutation>;
export type ChangeUseAirportTransferMutationOptions = Apollo.BaseMutationOptions<ChangeUseAirportTransferMutation, ChangeUseAirportTransferMutationVariables>;
export const ConfirmReservationViaFincodeDocument = gql`
    mutation confirmReservationViaFincode($input: ConfirmReservationViaFincodeInput!) {
  confirmReservationViaFincode(input: $input) {
    id
    orderId
    travelId
    cocolocalaUserId
    firebaseUserId
    totalAmount
    hotelInfo {
      cocolocalaHotelId
      checkInDate
      checkOutDate
      nights
      numberOfPeople
      numberOfAdults
      numberOfChildren
      numberOfBabies
      hotelName
      mealLabel
    }
    flightInfo {
      flightReservationId
    }
    logInfo {
      email
    }
  }
}
    `;
export type ConfirmReservationViaFincodeMutationFn = Apollo.MutationFunction<ConfirmReservationViaFincodeMutation, ConfirmReservationViaFincodeMutationVariables>;

/**
 * __useConfirmReservationViaFincodeMutation__
 *
 * To run a mutation, you first call `useConfirmReservationViaFincodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmReservationViaFincodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmReservationViaFincodeMutation, { data, loading, error }] = useConfirmReservationViaFincodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmReservationViaFincodeMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmReservationViaFincodeMutation, ConfirmReservationViaFincodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmReservationViaFincodeMutation, ConfirmReservationViaFincodeMutationVariables>(ConfirmReservationViaFincodeDocument, options);
      }
export type ConfirmReservationViaFincodeMutationHookResult = ReturnType<typeof useConfirmReservationViaFincodeMutation>;
export type ConfirmReservationViaFincodeMutationResult = Apollo.MutationResult<ConfirmReservationViaFincodeMutation>;
export type ConfirmReservationViaFincodeMutationOptions = Apollo.BaseMutationOptions<ConfirmReservationViaFincodeMutation, ConfirmReservationViaFincodeMutationVariables>;
export const MigrateAnonymouseUserToAuthenticatedUserDocument = gql`
    mutation migrateAnonymouseUserToAuthenticatedUser($input: MigrateAnonymouseUserToAuthenticatedUserInput!) {
  migrateAnonymouseUserToAuthenticatedUser(input: $input) {
    anonymouseUid
    authenticatedUid
  }
}
    `;
export type MigrateAnonymouseUserToAuthenticatedUserMutationFn = Apollo.MutationFunction<MigrateAnonymouseUserToAuthenticatedUserMutation, MigrateAnonymouseUserToAuthenticatedUserMutationVariables>;

/**
 * __useMigrateAnonymouseUserToAuthenticatedUserMutation__
 *
 * To run a mutation, you first call `useMigrateAnonymouseUserToAuthenticatedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateAnonymouseUserToAuthenticatedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateAnonymouseUserToAuthenticatedUserMutation, { data, loading, error }] = useMigrateAnonymouseUserToAuthenticatedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMigrateAnonymouseUserToAuthenticatedUserMutation(baseOptions?: Apollo.MutationHookOptions<MigrateAnonymouseUserToAuthenticatedUserMutation, MigrateAnonymouseUserToAuthenticatedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateAnonymouseUserToAuthenticatedUserMutation, MigrateAnonymouseUserToAuthenticatedUserMutationVariables>(MigrateAnonymouseUserToAuthenticatedUserDocument, options);
      }
export type MigrateAnonymouseUserToAuthenticatedUserMutationHookResult = ReturnType<typeof useMigrateAnonymouseUserToAuthenticatedUserMutation>;
export type MigrateAnonymouseUserToAuthenticatedUserMutationResult = Apollo.MutationResult<MigrateAnonymouseUserToAuthenticatedUserMutation>;
export type MigrateAnonymouseUserToAuthenticatedUserMutationOptions = Apollo.BaseMutationOptions<MigrateAnonymouseUserToAuthenticatedUserMutation, MigrateAnonymouseUserToAuthenticatedUserMutationVariables>;
export const PrepareReservationViaFincodeDocument = gql`
    mutation prepareReservationViaFincode($input: PrepareReservationViaFincodeInput!) {
  prepareReservationViaFincode(input: $input) {
    id
    orderId
    acsUrl
  }
}
    `;
export type PrepareReservationViaFincodeMutationFn = Apollo.MutationFunction<PrepareReservationViaFincodeMutation, PrepareReservationViaFincodeMutationVariables>;

/**
 * __usePrepareReservationViaFincodeMutation__
 *
 * To run a mutation, you first call `usePrepareReservationViaFincodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareReservationViaFincodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareReservationViaFincodeMutation, { data, loading, error }] = usePrepareReservationViaFincodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareReservationViaFincodeMutation(baseOptions?: Apollo.MutationHookOptions<PrepareReservationViaFincodeMutation, PrepareReservationViaFincodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareReservationViaFincodeMutation, PrepareReservationViaFincodeMutationVariables>(PrepareReservationViaFincodeDocument, options);
      }
export type PrepareReservationViaFincodeMutationHookResult = ReturnType<typeof usePrepareReservationViaFincodeMutation>;
export type PrepareReservationViaFincodeMutationResult = Apollo.MutationResult<PrepareReservationViaFincodeMutation>;
export type PrepareReservationViaFincodeMutationOptions = Apollo.BaseMutationOptions<PrepareReservationViaFincodeMutation, PrepareReservationViaFincodeMutationVariables>;
export const PrepareReservationViaStripeDocument = gql`
    mutation prepareReservationViaStripe($input: PrepareReservationViaStripeInput!) {
  prepareReservationViaStripe(input: $input) {
    id
    orderId
    need3DSecure {
      clientSecretKey
    }
    without3DSecure {
      id
      orderId
      travelId
      cocolocalaUserId
      firebaseUserId
      totalAmount
      hotelInfo {
        cocolocalaHotelId
        checkInDate
        checkOutDate
        nights
        numberOfPeople
        numberOfAdults
        numberOfChildren
        numberOfBabies
        hotelName
        mealLabel
      }
      flightInfo {
        flightReservationId
      }
      logInfo {
        email
      }
    }
  }
}
    `;
export type PrepareReservationViaStripeMutationFn = Apollo.MutationFunction<PrepareReservationViaStripeMutation, PrepareReservationViaStripeMutationVariables>;

/**
 * __usePrepareReservationViaStripeMutation__
 *
 * To run a mutation, you first call `usePrepareReservationViaStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareReservationViaStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareReservationViaStripeMutation, { data, loading, error }] = usePrepareReservationViaStripeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareReservationViaStripeMutation(baseOptions?: Apollo.MutationHookOptions<PrepareReservationViaStripeMutation, PrepareReservationViaStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareReservationViaStripeMutation, PrepareReservationViaStripeMutationVariables>(PrepareReservationViaStripeDocument, options);
      }
export type PrepareReservationViaStripeMutationHookResult = ReturnType<typeof usePrepareReservationViaStripeMutation>;
export type PrepareReservationViaStripeMutationResult = Apollo.MutationResult<PrepareReservationViaStripeMutation>;
export type PrepareReservationViaStripeMutationOptions = Apollo.BaseMutationOptions<PrepareReservationViaStripeMutation, PrepareReservationViaStripeMutationVariables>;
export const RemoveBookmarkHotelDocument = gql`
    mutation removeBookmarkHotel($input: RemoveBookmarkHotelInput!) {
  removeBookmarkHotel(input: $input) {
    ok
  }
}
    `;
export type RemoveBookmarkHotelMutationFn = Apollo.MutationFunction<RemoveBookmarkHotelMutation, RemoveBookmarkHotelMutationVariables>;

/**
 * __useRemoveBookmarkHotelMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkHotelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkHotelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkHotelMutation, { data, loading, error }] = useRemoveBookmarkHotelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveBookmarkHotelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBookmarkHotelMutation, RemoveBookmarkHotelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBookmarkHotelMutation, RemoveBookmarkHotelMutationVariables>(RemoveBookmarkHotelDocument, options);
      }
export type RemoveBookmarkHotelMutationHookResult = ReturnType<typeof useRemoveBookmarkHotelMutation>;
export type RemoveBookmarkHotelMutationResult = Apollo.MutationResult<RemoveBookmarkHotelMutation>;
export type RemoveBookmarkHotelMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkHotelMutation, RemoveBookmarkHotelMutationVariables>;
export const SaveOrderReservationInformationDocument = gql`
    mutation saveOrderReservationInformation($input: SaveOrderReservationInformationInput!) {
  saveOrderReservationInformation(input: $input) {
    ok
  }
}
    `;
export type SaveOrderReservationInformationMutationFn = Apollo.MutationFunction<SaveOrderReservationInformationMutation, SaveOrderReservationInformationMutationVariables>;

/**
 * __useSaveOrderReservationInformationMutation__
 *
 * To run a mutation, you first call `useSaveOrderReservationInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrderReservationInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrderReservationInformationMutation, { data, loading, error }] = useSaveOrderReservationInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOrderReservationInformationMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrderReservationInformationMutation, SaveOrderReservationInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrderReservationInformationMutation, SaveOrderReservationInformationMutationVariables>(SaveOrderReservationInformationDocument, options);
      }
export type SaveOrderReservationInformationMutationHookResult = ReturnType<typeof useSaveOrderReservationInformationMutation>;
export type SaveOrderReservationInformationMutationResult = Apollo.MutationResult<SaveOrderReservationInformationMutation>;
export type SaveOrderReservationInformationMutationOptions = Apollo.BaseMutationOptions<SaveOrderReservationInformationMutation, SaveOrderReservationInformationMutationVariables>;
export const SavePassportDocument = gql`
    mutation savePassport($input: SavePassportInput!) {
  savePassport(input: $input) {
    ok
  }
}
    `;
export type SavePassportMutationFn = Apollo.MutationFunction<SavePassportMutation, SavePassportMutationVariables>;

/**
 * __useSavePassportMutation__
 *
 * To run a mutation, you first call `useSavePassportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePassportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePassportMutation, { data, loading, error }] = useSavePassportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePassportMutation(baseOptions?: Apollo.MutationHookOptions<SavePassportMutation, SavePassportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePassportMutation, SavePassportMutationVariables>(SavePassportDocument, options);
      }
export type SavePassportMutationHookResult = ReturnType<typeof useSavePassportMutation>;
export type SavePassportMutationResult = Apollo.MutationResult<SavePassportMutation>;
export type SavePassportMutationOptions = Apollo.BaseMutationOptions<SavePassportMutation, SavePassportMutationVariables>;
export const SendEmergencyContactDocument = gql`
    mutation sendEmergencyContact($input: SendEmergencyContactInput!) {
  sendEmergencyContact(input: $input) {
    ok
  }
}
    `;
export type SendEmergencyContactMutationFn = Apollo.MutationFunction<SendEmergencyContactMutation, SendEmergencyContactMutationVariables>;

/**
 * __useSendEmergencyContactMutation__
 *
 * To run a mutation, you first call `useSendEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmergencyContactMutation, { data, loading, error }] = useSendEmergencyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<SendEmergencyContactMutation, SendEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmergencyContactMutation, SendEmergencyContactMutationVariables>(SendEmergencyContactDocument, options);
      }
export type SendEmergencyContactMutationHookResult = ReturnType<typeof useSendEmergencyContactMutation>;
export type SendEmergencyContactMutationResult = Apollo.MutationResult<SendEmergencyContactMutation>;
export type SendEmergencyContactMutationOptions = Apollo.BaseMutationOptions<SendEmergencyContactMutation, SendEmergencyContactMutationVariables>;
export const SendSelectedProductsDocument = gql`
    mutation sendSelectedProducts($input: SendSelectedProductsInput!) {
  sendSelectedProducts(input: $input) {
    ok
  }
}
    `;
export type SendSelectedProductsMutationFn = Apollo.MutationFunction<SendSelectedProductsMutation, SendSelectedProductsMutationVariables>;

/**
 * __useSendSelectedProductsMutation__
 *
 * To run a mutation, you first call `useSendSelectedProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSelectedProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSelectedProductsMutation, { data, loading, error }] = useSendSelectedProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSelectedProductsMutation(baseOptions?: Apollo.MutationHookOptions<SendSelectedProductsMutation, SendSelectedProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSelectedProductsMutation, SendSelectedProductsMutationVariables>(SendSelectedProductsDocument, options);
      }
export type SendSelectedProductsMutationHookResult = ReturnType<typeof useSendSelectedProductsMutation>;
export type SendSelectedProductsMutationResult = Apollo.MutationResult<SendSelectedProductsMutation>;
export type SendSelectedProductsMutationOptions = Apollo.BaseMutationOptions<SendSelectedProductsMutation, SendSelectedProductsMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation updateEmail($input: UpdateEmailInput!) {
  updateEmail(input: $input) {
    email
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateOrderTodoListDocument = gql`
    mutation updateOrderTodoList($input: UpdateOrderTodoListInput!) {
  updateOrderTodoList(input: $input) {
    ok
  }
}
    `;
export type UpdateOrderTodoListMutationFn = Apollo.MutationFunction<UpdateOrderTodoListMutation, UpdateOrderTodoListMutationVariables>;

/**
 * __useUpdateOrderTodoListMutation__
 *
 * To run a mutation, you first call `useUpdateOrderTodoListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderTodoListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderTodoListMutation, { data, loading, error }] = useUpdateOrderTodoListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderTodoListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderTodoListMutation, UpdateOrderTodoListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderTodoListMutation, UpdateOrderTodoListMutationVariables>(UpdateOrderTodoListDocument, options);
      }
export type UpdateOrderTodoListMutationHookResult = ReturnType<typeof useUpdateOrderTodoListMutation>;
export type UpdateOrderTodoListMutationResult = Apollo.MutationResult<UpdateOrderTodoListMutation>;
export type UpdateOrderTodoListMutationOptions = Apollo.BaseMutationOptions<UpdateOrderTodoListMutation, UpdateOrderTodoListMutationVariables>;
export const ChildZonesDocument = gql`
    query childZones($input: GetChildZonesInput!) {
  childZones(input: $input) {
    ...ZoneFragment
  }
}
    ${ZoneFragmentFragmentDoc}`;

/**
 * __useChildZonesQuery__
 *
 * To run a query within a React component, call `useChildZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildZonesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChildZonesQuery(baseOptions: Apollo.QueryHookOptions<ChildZonesQuery, ChildZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildZonesQuery, ChildZonesQueryVariables>(ChildZonesDocument, options);
      }
export function useChildZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildZonesQuery, ChildZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildZonesQuery, ChildZonesQueryVariables>(ChildZonesDocument, options);
        }
export type ChildZonesQueryHookResult = ReturnType<typeof useChildZonesQuery>;
export type ChildZonesLazyQueryHookResult = ReturnType<typeof useChildZonesLazyQuery>;
export type ChildZonesQueryResult = Apollo.QueryResult<ChildZonesQuery, ChildZonesQueryVariables>;
export const FetchAroundVacantHotelsDocument = gql`
    query fetchAroundVacantHotels($aroundVacantHotelsInput: AroundVacantHotelsInput!) {
  aroundVacantHotels(input: $aroundVacantHotelsInput) {
    result {
      id
      name
      rating
      areaId
      areaName
      districtId
      prefectureId
      prefectureName
      regionId
      relationalServiceIds {
        agoda
        expedia
        googlePlace
        rakuten
      }
      distance
      imageUrls
      rates {
        ...FRate
      }
      minimumRate {
        ...FRate
      }
      minimumPricingPerOne {
        ...FMinimumPricing
      }
      minimumPricingPerTwo {
        ...FMinimumPricing
      }
      conditions {
        priceRangeConditions
        bedTypeConditions
        smokingConditions
        wifiConditions
        japaneseConditions
      }
    }
    pagination {
      total
      resultCount
      paginationSize
      page
    }
  }
}
    ${FRateFragmentDoc}
${FMinimumPricingFragmentDoc}`;

/**
 * __useFetchAroundVacantHotelsQuery__
 *
 * To run a query within a React component, call `useFetchAroundVacantHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAroundVacantHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAroundVacantHotelsQuery({
 *   variables: {
 *      aroundVacantHotelsInput: // value for 'aroundVacantHotelsInput'
 *   },
 * });
 */
export function useFetchAroundVacantHotelsQuery(baseOptions: Apollo.QueryHookOptions<FetchAroundVacantHotelsQuery, FetchAroundVacantHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAroundVacantHotelsQuery, FetchAroundVacantHotelsQueryVariables>(FetchAroundVacantHotelsDocument, options);
      }
export function useFetchAroundVacantHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAroundVacantHotelsQuery, FetchAroundVacantHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAroundVacantHotelsQuery, FetchAroundVacantHotelsQueryVariables>(FetchAroundVacantHotelsDocument, options);
        }
export type FetchAroundVacantHotelsQueryHookResult = ReturnType<typeof useFetchAroundVacantHotelsQuery>;
export type FetchAroundVacantHotelsLazyQueryHookResult = ReturnType<typeof useFetchAroundVacantHotelsLazyQuery>;
export type FetchAroundVacantHotelsQueryResult = Apollo.QueryResult<FetchAroundVacantHotelsQuery, FetchAroundVacantHotelsQueryVariables>;
export const FetchFlightTicketStatusDocument = gql`
    query fetchFlightTicketStatus($input: FlightTicketStatusInput!) {
  flightTicketStatus(input: $input) {
    status
    redirectInfo {
      cocolocalaHotelId
      queryParameterForSelectGoingFlight
      queryParameterForHotel
    }
  }
}
    `;

/**
 * __useFetchFlightTicketStatusQuery__
 *
 * To run a query within a React component, call `useFetchFlightTicketStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFlightTicketStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFlightTicketStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchFlightTicketStatusQuery(baseOptions: Apollo.QueryHookOptions<FetchFlightTicketStatusQuery, FetchFlightTicketStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFlightTicketStatusQuery, FetchFlightTicketStatusQueryVariables>(FetchFlightTicketStatusDocument, options);
      }
export function useFetchFlightTicketStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFlightTicketStatusQuery, FetchFlightTicketStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFlightTicketStatusQuery, FetchFlightTicketStatusQueryVariables>(FetchFlightTicketStatusDocument, options);
        }
export type FetchFlightTicketStatusQueryHookResult = ReturnType<typeof useFetchFlightTicketStatusQuery>;
export type FetchFlightTicketStatusLazyQueryHookResult = ReturnType<typeof useFetchFlightTicketStatusLazyQuery>;
export type FetchFlightTicketStatusQueryResult = Apollo.QueryResult<FetchFlightTicketStatusQuery, FetchFlightTicketStatusQueryVariables>;
export const FetchJpTopPageDocument = gql`
    query fetchJpTopPage {
  jpTopPage {
    campaignBanners {
      description
      imageData {
        ...FImageData
      }
      linkUrl
    }
    popularAreaDescription {
      description
      thumbnailUrl
    }
    areas {
      name
      thumbnailUrl
      path
      type
      count
    }
    popularHotels {
      id
      name
      rating
      areaName
      prefectureName
      date
      inclusivePrice
      exclusivePrice
      strikeThroughPrice
      numberOfAdults
      imageUrl
    }
    saleHotels {
      id
      name
      rating
      areaName
      prefectureName
      date
      inclusivePrice
      exclusivePrice
      strikeThroughPrice
      numberOfAdults
      imageUrl
    }
    popularPlans {
      planId
      title
      areaName
      thumbnail {
        ...FImageData
      }
    }
    popularDestinations {
      label
      path
    }
  }
}
    ${FImageDataFragmentDoc}`;

/**
 * __useFetchJpTopPageQuery__
 *
 * To run a query within a React component, call `useFetchJpTopPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJpTopPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJpTopPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchJpTopPageQuery(baseOptions?: Apollo.QueryHookOptions<FetchJpTopPageQuery, FetchJpTopPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchJpTopPageQuery, FetchJpTopPageQueryVariables>(FetchJpTopPageDocument, options);
      }
export function useFetchJpTopPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchJpTopPageQuery, FetchJpTopPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchJpTopPageQuery, FetchJpTopPageQueryVariables>(FetchJpTopPageDocument, options);
        }
export type FetchJpTopPageQueryHookResult = ReturnType<typeof useFetchJpTopPageQuery>;
export type FetchJpTopPageLazyQueryHookResult = ReturnType<typeof useFetchJpTopPageLazyQuery>;
export type FetchJpTopPageQueryResult = Apollo.QueryResult<FetchJpTopPageQuery, FetchJpTopPageQueryVariables>;
export const FetchOverseasTopPageDocument = gql`
    query fetchOverseasTopPage {
  overseasTop {
    campaignBanners {
      description
      linkUrl
      imageData {
        ...FImageData
      }
    }
    popularAreaDescription {
      description
      thumbnailUrl
    }
    popularAreas {
      name
      thumbnailUrl
      path
    }
    popularDestinations {
      label
      path
    }
  }
}
    ${FImageDataFragmentDoc}`;

/**
 * __useFetchOverseasTopPageQuery__
 *
 * To run a query within a React component, call `useFetchOverseasTopPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOverseasTopPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOverseasTopPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchOverseasTopPageQuery(baseOptions?: Apollo.QueryHookOptions<FetchOverseasTopPageQuery, FetchOverseasTopPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOverseasTopPageQuery, FetchOverseasTopPageQueryVariables>(FetchOverseasTopPageDocument, options);
      }
export function useFetchOverseasTopPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOverseasTopPageQuery, FetchOverseasTopPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOverseasTopPageQuery, FetchOverseasTopPageQueryVariables>(FetchOverseasTopPageDocument, options);
        }
export type FetchOverseasTopPageQueryHookResult = ReturnType<typeof useFetchOverseasTopPageQuery>;
export type FetchOverseasTopPageLazyQueryHookResult = ReturnType<typeof useFetchOverseasTopPageLazyQuery>;
export type FetchOverseasTopPageQueryResult = Apollo.QueryResult<FetchOverseasTopPageQuery, FetchOverseasTopPageQueryVariables>;
export const FetchTopPageDocument = gql`
    query fetchTopPage {
  topPage {
    campaignBanners {
      description
      imageData {
        ...FImageData
      }
      linkUrl
    }
    overseasPopularAreaDescription {
      description
      thumbnailUrl
    }
    overseasPopularAreas {
      name
      thumbnailUrl
      path
    }
    overseasPopularDestinations {
      label
      path
    }
    jpPopularAreaDescription {
      description
      thumbnailUrl
    }
    jpPopularDestinations {
      label
      path
    }
    jpPopularAreas {
      name
      thumbnailUrl
      path
      type
      count
    }
    saleHotels {
      id
      name
      rating
      areaName
      prefectureName
      date
      inclusivePrice
      exclusivePrice
      strikeThroughPrice
      numberOfAdults
      imageUrl
    }
  }
}
    ${FImageDataFragmentDoc}`;

/**
 * __useFetchTopPageQuery__
 *
 * To run a query within a React component, call `useFetchTopPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTopPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTopPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchTopPageQuery(baseOptions?: Apollo.QueryHookOptions<FetchTopPageQuery, FetchTopPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTopPageQuery, FetchTopPageQueryVariables>(FetchTopPageDocument, options);
      }
export function useFetchTopPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTopPageQuery, FetchTopPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTopPageQuery, FetchTopPageQueryVariables>(FetchTopPageDocument, options);
        }
export type FetchTopPageQueryHookResult = ReturnType<typeof useFetchTopPageQuery>;
export type FetchTopPageLazyQueryHookResult = ReturnType<typeof useFetchTopPageLazyQuery>;
export type FetchTopPageQueryResult = Apollo.QueryResult<FetchTopPageQuery, FetchTopPageQueryVariables>;
export const FilterAvailableDpCarVendorsDocument = gql`
    query filterAvailableDPCarVendors($filterAvailableDPCarVendorsInput: FilterAvailableDPCarVendorsInput!) {
  dPCarVendors(input: $filterAvailableDPCarVendorsInput) {
    ...FDPCarVendor
  }
}
    ${FdpCarVendorFragmentDoc}`;

/**
 * __useFilterAvailableDpCarVendorsQuery__
 *
 * To run a query within a React component, call `useFilterAvailableDpCarVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterAvailableDpCarVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterAvailableDpCarVendorsQuery({
 *   variables: {
 *      filterAvailableDPCarVendorsInput: // value for 'filterAvailableDPCarVendorsInput'
 *   },
 * });
 */
export function useFilterAvailableDpCarVendorsQuery(baseOptions: Apollo.QueryHookOptions<FilterAvailableDpCarVendorsQuery, FilterAvailableDpCarVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterAvailableDpCarVendorsQuery, FilterAvailableDpCarVendorsQueryVariables>(FilterAvailableDpCarVendorsDocument, options);
      }
export function useFilterAvailableDpCarVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterAvailableDpCarVendorsQuery, FilterAvailableDpCarVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterAvailableDpCarVendorsQuery, FilterAvailableDpCarVendorsQueryVariables>(FilterAvailableDpCarVendorsDocument, options);
        }
export type FilterAvailableDpCarVendorsQueryHookResult = ReturnType<typeof useFilterAvailableDpCarVendorsQuery>;
export type FilterAvailableDpCarVendorsLazyQueryHookResult = ReturnType<typeof useFilterAvailableDpCarVendorsLazyQuery>;
export type FilterAvailableDpCarVendorsQueryResult = Apollo.QueryResult<FilterAvailableDpCarVendorsQuery, FilterAvailableDpCarVendorsQueryVariables>;
export const FindFlightsForDpFlightDocument = gql`
    query findFlightsForDPFlight($input: FlightsForDPFlightInput!) {
  flightsForDPFlight(input: $input) {
    flights {
      ...FFlight
    }
    inclusivePriceInfo {
      numberOfStays
      numberOfPeople
      total
      perPerson
    }
    routingId
    isPollingRequired
    logInfo {
      going {
        originalCarrierIATACode
        originalFlightNumber
      }
      returning {
        originalCarrierIATACode
        originalFlightNumber
      }
    }
  }
}
    ${FFlightFragmentDoc}`;

/**
 * __useFindFlightsForDpFlightQuery__
 *
 * To run a query within a React component, call `useFindFlightsForDpFlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFlightsForDpFlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFlightsForDpFlightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindFlightsForDpFlightQuery(baseOptions: Apollo.QueryHookOptions<FindFlightsForDpFlightQuery, FindFlightsForDpFlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFlightsForDpFlightQuery, FindFlightsForDpFlightQueryVariables>(FindFlightsForDpFlightDocument, options);
      }
export function useFindFlightsForDpFlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFlightsForDpFlightQuery, FindFlightsForDpFlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFlightsForDpFlightQuery, FindFlightsForDpFlightQueryVariables>(FindFlightsForDpFlightDocument, options);
        }
export type FindFlightsForDpFlightQueryHookResult = ReturnType<typeof useFindFlightsForDpFlightQuery>;
export type FindFlightsForDpFlightLazyQueryHookResult = ReturnType<typeof useFindFlightsForDpFlightLazyQuery>;
export type FindFlightsForDpFlightQueryResult = Apollo.QueryResult<FindFlightsForDpFlightQuery, FindFlightsForDpFlightQueryVariables>;
export const FilterHotelReviewsDocument = gql`
    query filterHotelReviews($hotelReviewsInput: HotelReviewsInput!) {
  hotelReviews(input: $hotelReviewsInput) {
    pagination {
      ...FPagination
    }
    reviewItems {
      ...FReviewItemWithReviewUser
    }
  }
}
    ${FPaginationFragmentDoc}
${FReviewItemWithReviewUserFragmentDoc}`;

/**
 * __useFilterHotelReviewsQuery__
 *
 * To run a query within a React component, call `useFilterHotelReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterHotelReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterHotelReviewsQuery({
 *   variables: {
 *      hotelReviewsInput: // value for 'hotelReviewsInput'
 *   },
 * });
 */
export function useFilterHotelReviewsQuery(baseOptions: Apollo.QueryHookOptions<FilterHotelReviewsQuery, FilterHotelReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterHotelReviewsQuery, FilterHotelReviewsQueryVariables>(FilterHotelReviewsDocument, options);
      }
export function useFilterHotelReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterHotelReviewsQuery, FilterHotelReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterHotelReviewsQuery, FilterHotelReviewsQueryVariables>(FilterHotelReviewsDocument, options);
        }
export type FilterHotelReviewsQueryHookResult = ReturnType<typeof useFilterHotelReviewsQuery>;
export type FilterHotelReviewsLazyQueryHookResult = ReturnType<typeof useFilterHotelReviewsLazyQuery>;
export type FilterHotelReviewsQueryResult = Apollo.QueryResult<FilterHotelReviewsQuery, FilterHotelReviewsQueryVariables>;
export const FilterHotelsDocument = gql`
    query filterHotels($input: HotelsInput!) {
  hotels(input: $input) {
    hotels {
      ...FHotelSummary
    }
    pagination {
      hasNext
      nextOffset
      total
      paginationSize
    }
  }
}
    ${FHotelSummaryFragmentDoc}`;

/**
 * __useFilterHotelsQuery__
 *
 * To run a query within a React component, call `useFilterHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterHotelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterHotelsQuery(baseOptions: Apollo.QueryHookOptions<FilterHotelsQuery, FilterHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterHotelsQuery, FilterHotelsQueryVariables>(FilterHotelsDocument, options);
      }
export function useFilterHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterHotelsQuery, FilterHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterHotelsQuery, FilterHotelsQueryVariables>(FilterHotelsDocument, options);
        }
export type FilterHotelsQueryHookResult = ReturnType<typeof useFilterHotelsQuery>;
export type FilterHotelsLazyQueryHookResult = ReturnType<typeof useFilterHotelsLazyQuery>;
export type FilterHotelsQueryResult = Apollo.QueryResult<FilterHotelsQuery, FilterHotelsQueryVariables>;
export const FilterHotelsForDpFlightThemesDocument = gql`
    query filterHotelsForDPFlightThemes($input: HotelsForDPFlightThemesInput!) {
  hotelsForDPFlightThemes(input: $input) {
    staffComment
    hotels {
      id
      cocolocalaHotelId
      name
      summaryTitle
      rating
      numberOfStays
      priceInfo {
        minimumPricePerPerson
        discountInfo {
          ...FDiscountInfoForDPFlight
        }
      }
      imageUrl
    }
    minimumFlightPrice
    limitedTimeSaleInfo {
      ...FLimitedTimeSaleInfo
    }
  }
}
    ${FDiscountInfoForDpFlightFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}`;

/**
 * __useFilterHotelsForDpFlightThemesQuery__
 *
 * To run a query within a React component, call `useFilterHotelsForDpFlightThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterHotelsForDpFlightThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterHotelsForDpFlightThemesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterHotelsForDpFlightThemesQuery(baseOptions: Apollo.QueryHookOptions<FilterHotelsForDpFlightThemesQuery, FilterHotelsForDpFlightThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterHotelsForDpFlightThemesQuery, FilterHotelsForDpFlightThemesQueryVariables>(FilterHotelsForDpFlightThemesDocument, options);
      }
export function useFilterHotelsForDpFlightThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterHotelsForDpFlightThemesQuery, FilterHotelsForDpFlightThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterHotelsForDpFlightThemesQuery, FilterHotelsForDpFlightThemesQueryVariables>(FilterHotelsForDpFlightThemesDocument, options);
        }
export type FilterHotelsForDpFlightThemesQueryHookResult = ReturnType<typeof useFilterHotelsForDpFlightThemesQuery>;
export type FilterHotelsForDpFlightThemesLazyQueryHookResult = ReturnType<typeof useFilterHotelsForDpFlightThemesLazyQuery>;
export type FilterHotelsForDpFlightThemesQueryResult = Apollo.QueryResult<FilterHotelsForDpFlightThemesQuery, FilterHotelsForDpFlightThemesQueryVariables>;
export const FilterOrderHistorySummariesDocument = gql`
    query filterOrderHistorySummaries {
  orderHistorySummaries {
    id
    orderId
    labels {
      label
      orderStatus
    }
    detailsTableItems {
      title
      content
    }
    hotelInfo {
      hotelName
      hotelThumbnailUrl
      roomName
      checkInDate
      checkOutDate
      availableCheckInTimeRange
      checkOutTime
    }
    flightInfo {
      flightInfoText
      goingFlightFirstAirportIata
      goingFlightDepartureDate
      goingFlightDepartureTime
      goingFlightArrivalDate
      goingFlightArrivalTime
      returningFlightFirstAirportIata
      returningFlightDepartureDate
      returningFlightDepartureTime
      returningFlightArrivalDate
      returningFlightArrivalTime
    }
  }
}
    `;

/**
 * __useFilterOrderHistorySummariesQuery__
 *
 * To run a query within a React component, call `useFilterOrderHistorySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterOrderHistorySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterOrderHistorySummariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterOrderHistorySummariesQuery(baseOptions?: Apollo.QueryHookOptions<FilterOrderHistorySummariesQuery, FilterOrderHistorySummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterOrderHistorySummariesQuery, FilterOrderHistorySummariesQueryVariables>(FilterOrderHistorySummariesDocument, options);
      }
export function useFilterOrderHistorySummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterOrderHistorySummariesQuery, FilterOrderHistorySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterOrderHistorySummariesQuery, FilterOrderHistorySummariesQueryVariables>(FilterOrderHistorySummariesDocument, options);
        }
export type FilterOrderHistorySummariesQueryHookResult = ReturnType<typeof useFilterOrderHistorySummariesQuery>;
export type FilterOrderHistorySummariesLazyQueryHookResult = ReturnType<typeof useFilterOrderHistorySummariesLazyQuery>;
export type FilterOrderHistorySummariesQueryResult = Apollo.QueryResult<FilterOrderHistorySummariesQuery, FilterOrderHistorySummariesQueryVariables>;
export const FilterReviewItemsDocument = gql`
    query filterReviewItems($reviewItemsInput: ReviewItemsInput!) {
  reviewItems(input: $reviewItemsInput) {
    pagination {
      ...FReviewItemsPaginationResponse
    }
    reviewItems {
      ...FReviewItemWithReviewUser
    }
  }
}
    ${FReviewItemsPaginationResponseFragmentDoc}
${FReviewItemWithReviewUserFragmentDoc}`;

/**
 * __useFilterReviewItemsQuery__
 *
 * To run a query within a React component, call `useFilterReviewItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterReviewItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterReviewItemsQuery({
 *   variables: {
 *      reviewItemsInput: // value for 'reviewItemsInput'
 *   },
 * });
 */
export function useFilterReviewItemsQuery(baseOptions: Apollo.QueryHookOptions<FilterReviewItemsQuery, FilterReviewItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterReviewItemsQuery, FilterReviewItemsQueryVariables>(FilterReviewItemsDocument, options);
      }
export function useFilterReviewItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterReviewItemsQuery, FilterReviewItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterReviewItemsQuery, FilterReviewItemsQueryVariables>(FilterReviewItemsDocument, options);
        }
export type FilterReviewItemsQueryHookResult = ReturnType<typeof useFilterReviewItemsQuery>;
export type FilterReviewItemsLazyQueryHookResult = ReturnType<typeof useFilterReviewItemsLazyQuery>;
export type FilterReviewItemsQueryResult = Apollo.QueryResult<FilterReviewItemsQuery, FilterReviewItemsQueryVariables>;
export const FilterSpotsDocument = gql`
    query filterSpots($input: SpotsInput!) {
  spots(input: $input) {
    hits {
      ...FSpot
    }
  }
}
    ${FSpotFragmentDoc}`;

/**
 * __useFilterSpotsQuery__
 *
 * To run a query within a React component, call `useFilterSpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterSpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterSpotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterSpotsQuery(baseOptions: Apollo.QueryHookOptions<FilterSpotsQuery, FilterSpotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterSpotsQuery, FilterSpotsQueryVariables>(FilterSpotsDocument, options);
      }
export function useFilterSpotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterSpotsQuery, FilterSpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterSpotsQuery, FilterSpotsQueryVariables>(FilterSpotsDocument, options);
        }
export type FilterSpotsQueryHookResult = ReturnType<typeof useFilterSpotsQuery>;
export type FilterSpotsLazyQueryHookResult = ReturnType<typeof useFilterSpotsLazyQuery>;
export type FilterSpotsQueryResult = Apollo.QueryResult<FilterSpotsQuery, FilterSpotsQueryVariables>;
export const FilterVacantHotelsDocument = gql`
    query filterVacantHotels($vacantHotelsInput: VacantHotelsInput!) {
  vacantHotels(input: $vacantHotelsInput) {
    vacantHotels {
      ...FVacantHotelSummary
    }
    pagination {
      ...FPagination
    }
  }
}
    ${FVacantHotelSummaryFragmentDoc}
${FPaginationFragmentDoc}`;

/**
 * __useFilterVacantHotelsQuery__
 *
 * To run a query within a React component, call `useFilterVacantHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterVacantHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterVacantHotelsQuery({
 *   variables: {
 *      vacantHotelsInput: // value for 'vacantHotelsInput'
 *   },
 * });
 */
export function useFilterVacantHotelsQuery(baseOptions: Apollo.QueryHookOptions<FilterVacantHotelsQuery, FilterVacantHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterVacantHotelsQuery, FilterVacantHotelsQueryVariables>(FilterVacantHotelsDocument, options);
      }
export function useFilterVacantHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterVacantHotelsQuery, FilterVacantHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterVacantHotelsQuery, FilterVacantHotelsQueryVariables>(FilterVacantHotelsDocument, options);
        }
export type FilterVacantHotelsQueryHookResult = ReturnType<typeof useFilterVacantHotelsQuery>;
export type FilterVacantHotelsLazyQueryHookResult = ReturnType<typeof useFilterVacantHotelsLazyQuery>;
export type FilterVacantHotelsQueryResult = Apollo.QueryResult<FilterVacantHotelsQuery, FilterVacantHotelsQueryVariables>;
export const FilterVacantHotelsForDpFlightDocument = gql`
    query filterVacantHotelsForDPFlight($input: VacantHotelsForDPFlightInput!) {
  vacantHotelsForDPFlight(input: $input) {
    vacantHotels {
      ...FVacantHotelsForDPFlightHotelDetail
    }
    minimumFlightPrice
    inclusivePriceInfo {
      ...FInclusivePriceInfo
    }
  }
}
    ${FVacantHotelsForDpFlightHotelDetailFragmentDoc}
${FInclusivePriceInfoFragmentDoc}`;

/**
 * __useFilterVacantHotelsForDpFlightQuery__
 *
 * To run a query within a React component, call `useFilterVacantHotelsForDpFlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterVacantHotelsForDpFlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterVacantHotelsForDpFlightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilterVacantHotelsForDpFlightQuery(baseOptions: Apollo.QueryHookOptions<FilterVacantHotelsForDpFlightQuery, FilterVacantHotelsForDpFlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterVacantHotelsForDpFlightQuery, FilterVacantHotelsForDpFlightQueryVariables>(FilterVacantHotelsForDpFlightDocument, options);
      }
export function useFilterVacantHotelsForDpFlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterVacantHotelsForDpFlightQuery, FilterVacantHotelsForDpFlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterVacantHotelsForDpFlightQuery, FilterVacantHotelsForDpFlightQueryVariables>(FilterVacantHotelsForDpFlightDocument, options);
        }
export type FilterVacantHotelsForDpFlightQueryHookResult = ReturnType<typeof useFilterVacantHotelsForDpFlightQuery>;
export type FilterVacantHotelsForDpFlightLazyQueryHookResult = ReturnType<typeof useFilterVacantHotelsForDpFlightLazyQuery>;
export type FilterVacantHotelsForDpFlightQueryResult = Apollo.QueryResult<FilterVacantHotelsForDpFlightQuery, FilterVacantHotelsForDpFlightQueryVariables>;
export const FindAirportDocument = gql`
    query findAirport($input: AirportInput!) {
  airport(input: $input) {
    ...FAirport
  }
}
    ${FAirportFragmentDoc}`;

/**
 * __useFindAirportQuery__
 *
 * To run a query within a React component, call `useFindAirportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAirportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAirportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAirportQuery(baseOptions: Apollo.QueryHookOptions<FindAirportQuery, FindAirportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAirportQuery, FindAirportQueryVariables>(FindAirportDocument, options);
      }
export function useFindAirportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAirportQuery, FindAirportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAirportQuery, FindAirportQueryVariables>(FindAirportDocument, options);
        }
export type FindAirportQueryHookResult = ReturnType<typeof useFindAirportQuery>;
export type FindAirportLazyQueryHookResult = ReturnType<typeof useFindAirportLazyQuery>;
export type FindAirportQueryResult = Apollo.QueryResult<FindAirportQuery, FindAirportQueryVariables>;
export const FindAirportsForDpFlightThemesDocument = gql`
    query findAirportsForDPFlightThemes($input: AirportsForDPFlightThemesInput!) {
  airportsForDPFlightThemes(input: $input) {
    imageUrl
    returningCityOrAirportIATACode
    zonePath
    departureAirports {
      ...FAirportSection
    }
    arrivalAirports {
      ...FAirportSection
    }
  }
}
    ${FAirportSectionFragmentDoc}`;

/**
 * __useFindAirportsForDpFlightThemesQuery__
 *
 * To run a query within a React component, call `useFindAirportsForDpFlightThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAirportsForDpFlightThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAirportsForDpFlightThemesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAirportsForDpFlightThemesQuery(baseOptions: Apollo.QueryHookOptions<FindAirportsForDpFlightThemesQuery, FindAirportsForDpFlightThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAirportsForDpFlightThemesQuery, FindAirportsForDpFlightThemesQueryVariables>(FindAirportsForDpFlightThemesDocument, options);
      }
export function useFindAirportsForDpFlightThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAirportsForDpFlightThemesQuery, FindAirportsForDpFlightThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAirportsForDpFlightThemesQuery, FindAirportsForDpFlightThemesQueryVariables>(FindAirportsForDpFlightThemesDocument, options);
        }
export type FindAirportsForDpFlightThemesQueryHookResult = ReturnType<typeof useFindAirportsForDpFlightThemesQuery>;
export type FindAirportsForDpFlightThemesLazyQueryHookResult = ReturnType<typeof useFindAirportsForDpFlightThemesLazyQuery>;
export type FindAirportsForDpFlightThemesQueryResult = Apollo.QueryResult<FindAirportsForDpFlightThemesQuery, FindAirportsForDpFlightThemesQueryVariables>;
export const FindCouponCodeDocument = gql`
    query findCouponCode($input: CouponCodeInput!) {
  couponCode(input: $input) {
    isAvailableDiscount
    isAvailableFifteenPercentDiscount
    isAvailablePerPersonDiscount
    couponCode
    isDPFlight
  }
}
    `;

/**
 * __useFindCouponCodeQuery__
 *
 * To run a query within a React component, call `useFindCouponCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCouponCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCouponCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindCouponCodeQuery(baseOptions: Apollo.QueryHookOptions<FindCouponCodeQuery, FindCouponCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCouponCodeQuery, FindCouponCodeQueryVariables>(FindCouponCodeDocument, options);
      }
export function useFindCouponCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCouponCodeQuery, FindCouponCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCouponCodeQuery, FindCouponCodeQueryVariables>(FindCouponCodeDocument, options);
        }
export type FindCouponCodeQueryHookResult = ReturnType<typeof useFindCouponCodeQuery>;
export type FindCouponCodeLazyQueryHookResult = ReturnType<typeof useFindCouponCodeLazyQuery>;
export type FindCouponCodeQueryResult = Apollo.QueryResult<FindCouponCodeQuery, FindCouponCodeQueryVariables>;
export const FindDpFlightCancelForAnyReasonDocument = gql`
    query findDPFlightCancelForAnyReason {
  dPFlightCancelForAnyReason {
    cancelForAnyReasonPrice {
      totalPrice
      totalPricePerPerson
      inclusivePricePerPerson
    }
    defaultPrice {
      totalPrice
      totalPricePerPerson
      inclusivePricePerPerson
    }
    numberOfStays
    numberOfPeople
    limitDateTimeText
  }
}
    `;

/**
 * __useFindDpFlightCancelForAnyReasonQuery__
 *
 * To run a query within a React component, call `useFindDpFlightCancelForAnyReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDpFlightCancelForAnyReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDpFlightCancelForAnyReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindDpFlightCancelForAnyReasonQuery(baseOptions?: Apollo.QueryHookOptions<FindDpFlightCancelForAnyReasonQuery, FindDpFlightCancelForAnyReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDpFlightCancelForAnyReasonQuery, FindDpFlightCancelForAnyReasonQueryVariables>(FindDpFlightCancelForAnyReasonDocument, options);
      }
export function useFindDpFlightCancelForAnyReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDpFlightCancelForAnyReasonQuery, FindDpFlightCancelForAnyReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDpFlightCancelForAnyReasonQuery, FindDpFlightCancelForAnyReasonQueryVariables>(FindDpFlightCancelForAnyReasonDocument, options);
        }
export type FindDpFlightCancelForAnyReasonQueryHookResult = ReturnType<typeof useFindDpFlightCancelForAnyReasonQuery>;
export type FindDpFlightCancelForAnyReasonLazyQueryHookResult = ReturnType<typeof useFindDpFlightCancelForAnyReasonLazyQuery>;
export type FindDpFlightCancelForAnyReasonQueryResult = Apollo.QueryResult<FindDpFlightCancelForAnyReasonQuery, FindDpFlightCancelForAnyReasonQueryVariables>;
export const FindDpFlightCancelForAnyReasonForOrderConfirmDocument = gql`
    query findDPFlightCancelForAnyReasonForOrderConfirm($input: DPFlightCancelForAnyReasonForOrderConfirmInput!) {
  dPFlightCancelForAnyReasonForOrderConfirm(input: $input) {
    cancelForAnyReasonPrice {
      totalPrice
      totalPricePerPerson
      priceDiff
    }
    defaultPrice {
      totalPrice
      totalPricePerPerson
      priceDiff
    }
    numberOfStays
    numberOfPeople
    limitDateTimeText
    hasCancelForAnyReason
  }
}
    `;

/**
 * __useFindDpFlightCancelForAnyReasonForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindDpFlightCancelForAnyReasonForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDpFlightCancelForAnyReasonForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDpFlightCancelForAnyReasonForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDpFlightCancelForAnyReasonForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindDpFlightCancelForAnyReasonForOrderConfirmQuery, FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDpFlightCancelForAnyReasonForOrderConfirmQuery, FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables>(FindDpFlightCancelForAnyReasonForOrderConfirmDocument, options);
      }
export function useFindDpFlightCancelForAnyReasonForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDpFlightCancelForAnyReasonForOrderConfirmQuery, FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDpFlightCancelForAnyReasonForOrderConfirmQuery, FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables>(FindDpFlightCancelForAnyReasonForOrderConfirmDocument, options);
        }
export type FindDpFlightCancelForAnyReasonForOrderConfirmQueryHookResult = ReturnType<typeof useFindDpFlightCancelForAnyReasonForOrderConfirmQuery>;
export type FindDpFlightCancelForAnyReasonForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindDpFlightCancelForAnyReasonForOrderConfirmLazyQuery>;
export type FindDpFlightCancelForAnyReasonForOrderConfirmQueryResult = Apollo.QueryResult<FindDpFlightCancelForAnyReasonForOrderConfirmQuery, FindDpFlightCancelForAnyReasonForOrderConfirmQueryVariables>;
export const FindDpFlightSupportPlanForOrderConfirmDocument = gql`
    query findDPFlightSupportPlanForOrderConfirm($input: DPFlightSupportPlanForOrderConfirmInput!) {
  dPFlightSupportPlanForOrderConfirm(input: $input) {
    basicPlanPrice {
      planType
      totalPricePerPerson
      totalPrice
      priceDiff
    }
    allPlanPrice {
      planType
      totalPricePerPerson
      totalPrice
      priceDiff
    }
    overseasDPFlightPlans {
      ...FDPFlightSupportPlan
    }
    numberOfStays
    numberOfPeople
    selectedPlanType
  }
}
    ${FdpFlightSupportPlanFragmentDoc}`;

/**
 * __useFindDpFlightSupportPlanForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindDpFlightSupportPlanForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDpFlightSupportPlanForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDpFlightSupportPlanForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDpFlightSupportPlanForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindDpFlightSupportPlanForOrderConfirmQuery, FindDpFlightSupportPlanForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDpFlightSupportPlanForOrderConfirmQuery, FindDpFlightSupportPlanForOrderConfirmQueryVariables>(FindDpFlightSupportPlanForOrderConfirmDocument, options);
      }
export function useFindDpFlightSupportPlanForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDpFlightSupportPlanForOrderConfirmQuery, FindDpFlightSupportPlanForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDpFlightSupportPlanForOrderConfirmQuery, FindDpFlightSupportPlanForOrderConfirmQueryVariables>(FindDpFlightSupportPlanForOrderConfirmDocument, options);
        }
export type FindDpFlightSupportPlanForOrderConfirmQueryHookResult = ReturnType<typeof useFindDpFlightSupportPlanForOrderConfirmQuery>;
export type FindDpFlightSupportPlanForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindDpFlightSupportPlanForOrderConfirmLazyQuery>;
export type FindDpFlightSupportPlanForOrderConfirmQueryResult = Apollo.QueryResult<FindDpFlightSupportPlanForOrderConfirmQuery, FindDpFlightSupportPlanForOrderConfirmQueryVariables>;
export const FindDpFlightThemeDocument = gql`
    query findDPFlightTheme($input: DPFlightThemeInput!) {
  dPFlightTheme(input: $input) {
    zoneName
    zoneNameEn
    zonePath
    parentZoneInfo {
      ...FZoneInfo
    }
    staffComment
    travelTheme {
      ...FTravelTheme
    }
    hotels {
      id
      cocolocalaHotelId
      name
      summaryTitle
      rating
      numberOfStays
      priceInfo {
        minimumPricePerPerson
        discountInfo {
          ...FDiscountInfoForDPFlight
        }
      }
      imageUrl
    }
    supportPlans {
      ...FDPFlightSupportPlan
    }
    departureAirports {
      ...FAirportSection
    }
    returningCityOrAirportIATACode
    arrivalAirportName
    arrivalAirportCityName
    recommendedThemes {
      ...FTravelTheme
    }
    lowestPriceSchedule {
      goingDate
      returningDate
    }
  }
}
    ${FZoneInfoFragmentDoc}
${FTravelThemeFragmentDoc}
${FDiscountInfoForDpFlightFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FAirportSectionFragmentDoc}`;

/**
 * __useFindDpFlightThemeQuery__
 *
 * To run a query within a React component, call `useFindDpFlightThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDpFlightThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDpFlightThemeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDpFlightThemeQuery(baseOptions: Apollo.QueryHookOptions<FindDpFlightThemeQuery, FindDpFlightThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDpFlightThemeQuery, FindDpFlightThemeQueryVariables>(FindDpFlightThemeDocument, options);
      }
export function useFindDpFlightThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDpFlightThemeQuery, FindDpFlightThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDpFlightThemeQuery, FindDpFlightThemeQueryVariables>(FindDpFlightThemeDocument, options);
        }
export type FindDpFlightThemeQueryHookResult = ReturnType<typeof useFindDpFlightThemeQuery>;
export type FindDpFlightThemeLazyQueryHookResult = ReturnType<typeof useFindDpFlightThemeLazyQuery>;
export type FindDpFlightThemeQueryResult = Apollo.QueryResult<FindDpFlightThemeQuery, FindDpFlightThemeQueryVariables>;
export const FindDpFlightThemesDocument = gql`
    query findDPFlightThemes($input: DPFlightThemesInput!) {
  dPFlightThemes(input: $input) {
    zoneName
    zonePath
    parentZoneInfo {
      ...FZoneInfo
    }
    cities {
      ...FTravelDestination
    }
    headerImageUrl
    supportPlans {
      ...FDPFlightSupportPlan
    }
    recommendedTravelDestinations {
      ...FTravelDestination
    }
    travelThemes {
      ...FTravelTheme
    }
    travelThemesFilter {
      ...FDPFlightTravelThemesFilter
    }
    priorConfirmation
    limitedTimeSaleInfo {
      ...FLimitedTimeSaleInfo
    }
    campaignInfo {
      ...FCampaignInfo
    }
  }
}
    ${FZoneInfoFragmentDoc}
${FTravelDestinationFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FTravelThemeFragmentDoc}
${FdpFlightTravelThemesFilterFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}
${FCampaignInfoFragmentDoc}`;

/**
 * __useFindDpFlightThemesQuery__
 *
 * To run a query within a React component, call `useFindDpFlightThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDpFlightThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDpFlightThemesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDpFlightThemesQuery(baseOptions: Apollo.QueryHookOptions<FindDpFlightThemesQuery, FindDpFlightThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDpFlightThemesQuery, FindDpFlightThemesQueryVariables>(FindDpFlightThemesDocument, options);
      }
export function useFindDpFlightThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDpFlightThemesQuery, FindDpFlightThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDpFlightThemesQuery, FindDpFlightThemesQueryVariables>(FindDpFlightThemesDocument, options);
        }
export type FindDpFlightThemesQueryHookResult = ReturnType<typeof useFindDpFlightThemesQuery>;
export type FindDpFlightThemesLazyQueryHookResult = ReturnType<typeof useFindDpFlightThemesLazyQuery>;
export type FindDpFlightThemesQueryResult = Apollo.QueryResult<FindDpFlightThemesQuery, FindDpFlightThemesQueryVariables>;
export const FindFlightOptionsDocument = gql`
    query findFlightOptions($input: FlightOptionsInput!) {
  flightOptions(input: $input) {
    goingFlight {
      freeBaggageAllowance
      fareClassCodes
    }
    returningFlight {
      freeBaggageAllowance
      fareClassCodes
    }
    isPassportRequired
    baggageOptionInfo {
      round {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      going {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      returning {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
    }
  }
}
    `;

/**
 * __useFindFlightOptionsQuery__
 *
 * To run a query within a React component, call `useFindFlightOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFlightOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFlightOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindFlightOptionsQuery(baseOptions: Apollo.QueryHookOptions<FindFlightOptionsQuery, FindFlightOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFlightOptionsQuery, FindFlightOptionsQueryVariables>(FindFlightOptionsDocument, options);
      }
export function useFindFlightOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFlightOptionsQuery, FindFlightOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFlightOptionsQuery, FindFlightOptionsQueryVariables>(FindFlightOptionsDocument, options);
        }
export type FindFlightOptionsQueryHookResult = ReturnType<typeof useFindFlightOptionsQuery>;
export type FindFlightOptionsLazyQueryHookResult = ReturnType<typeof useFindFlightOptionsLazyQuery>;
export type FindFlightOptionsQueryResult = Apollo.QueryResult<FindFlightOptionsQuery, FindFlightOptionsQueryVariables>;
export const FindHotelForAroundHotelsDocument = gql`
    query findHotelForAroundHotels($hotelInput: HotelInput!) {
  hotel(input: $hotelInput) {
    cocolocalaHotelId
    name
    aroundHotels {
      ...FHotelSummaryForHotel
    }
  }
}
    ${FHotelSummaryForHotelFragmentDoc}`;

/**
 * __useFindHotelForAroundHotelsQuery__
 *
 * To run a query within a React component, call `useFindHotelForAroundHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelForAroundHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelForAroundHotelsQuery({
 *   variables: {
 *      hotelInput: // value for 'hotelInput'
 *   },
 * });
 */
export function useFindHotelForAroundHotelsQuery(baseOptions: Apollo.QueryHookOptions<FindHotelForAroundHotelsQuery, FindHotelForAroundHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelForAroundHotelsQuery, FindHotelForAroundHotelsQueryVariables>(FindHotelForAroundHotelsDocument, options);
      }
export function useFindHotelForAroundHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelForAroundHotelsQuery, FindHotelForAroundHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelForAroundHotelsQuery, FindHotelForAroundHotelsQueryVariables>(FindHotelForAroundHotelsDocument, options);
        }
export type FindHotelForAroundHotelsQueryHookResult = ReturnType<typeof useFindHotelForAroundHotelsQuery>;
export type FindHotelForAroundHotelsLazyQueryHookResult = ReturnType<typeof useFindHotelForAroundHotelsLazyQuery>;
export type FindHotelForAroundHotelsQueryResult = Apollo.QueryResult<FindHotelForAroundHotelsQuery, FindHotelForAroundHotelsQueryVariables>;
export const FindHotelForHotelDetailDocument = gql`
    query findHotelForHotelDetail($hotelInput: HotelInput!) {
  hotel(input: $hotelInput) {
    ...FFullHotel
  }
}
    ${FFullHotelFragmentDoc}`;

/**
 * __useFindHotelForHotelDetailQuery__
 *
 * To run a query within a React component, call `useFindHotelForHotelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelForHotelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelForHotelDetailQuery({
 *   variables: {
 *      hotelInput: // value for 'hotelInput'
 *   },
 * });
 */
export function useFindHotelForHotelDetailQuery(baseOptions: Apollo.QueryHookOptions<FindHotelForHotelDetailQuery, FindHotelForHotelDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelForHotelDetailQuery, FindHotelForHotelDetailQueryVariables>(FindHotelForHotelDetailDocument, options);
      }
export function useFindHotelForHotelDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelForHotelDetailQuery, FindHotelForHotelDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelForHotelDetailQuery, FindHotelForHotelDetailQueryVariables>(FindHotelForHotelDetailDocument, options);
        }
export type FindHotelForHotelDetailQueryHookResult = ReturnType<typeof useFindHotelForHotelDetailQuery>;
export type FindHotelForHotelDetailLazyQueryHookResult = ReturnType<typeof useFindHotelForHotelDetailLazyQuery>;
export type FindHotelForHotelDetailQueryResult = Apollo.QueryResult<FindHotelForHotelDetailQuery, FindHotelForHotelDetailQueryVariables>;
export const FindHotelForHotelImagesDocument = gql`
    query findHotelForHotelImages($hotelInput: HotelInput!) {
  hotel(input: $hotelInput) {
    cocolocalaHotelId
    name
    location {
      ...FHotelLocation
    }
    minimumPrices {
      ...FHotelMinimumPrices
    }
    images {
      ...FHotelImage
    }
  }
}
    ${FHotelLocationFragmentDoc}
${FHotelMinimumPricesFragmentDoc}
${FHotelImageFragmentDoc}`;

/**
 * __useFindHotelForHotelImagesQuery__
 *
 * To run a query within a React component, call `useFindHotelForHotelImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelForHotelImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelForHotelImagesQuery({
 *   variables: {
 *      hotelInput: // value for 'hotelInput'
 *   },
 * });
 */
export function useFindHotelForHotelImagesQuery(baseOptions: Apollo.QueryHookOptions<FindHotelForHotelImagesQuery, FindHotelForHotelImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelForHotelImagesQuery, FindHotelForHotelImagesQueryVariables>(FindHotelForHotelImagesDocument, options);
      }
export function useFindHotelForHotelImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelForHotelImagesQuery, FindHotelForHotelImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelForHotelImagesQuery, FindHotelForHotelImagesQueryVariables>(FindHotelForHotelImagesDocument, options);
        }
export type FindHotelForHotelImagesQueryHookResult = ReturnType<typeof useFindHotelForHotelImagesQuery>;
export type FindHotelForHotelImagesLazyQueryHookResult = ReturnType<typeof useFindHotelForHotelImagesLazyQuery>;
export type FindHotelForHotelImagesQueryResult = Apollo.QueryResult<FindHotelForHotelImagesQuery, FindHotelForHotelImagesQueryVariables>;
export const FindHotelForOrderConfirmDocument = gql`
    query findHotelForOrderConfirm($input: HotelForOrderConfirmInput!) {
  hotelForOrderConfirm(input: $input) {
    id
    cocolocalaHotelId
    hotelName
    summaryTitle
    rating
    hotelLocation
    relationalServiceIds {
      expedia
      googlePlace
    }
    imageUrls
    hotelDetailInfo {
      summaryDescription
      description
      checkin {
        beginTime
        endTime
        twentyFourHour
      }
      checkout {
        time
      }
      phoneNumber
      hotelAmenities {
        wifiCondition
        japaneseCondition
        amenities {
          ...FAmenity
        }
      }
      location {
        ...FHotelLocation
      }
      hotelExplanation {
        amenities
        dining
        access
      }
      hotelCautions {
        ...FHotelCautions
      }
      statics {
        roomsCount
      }
      websiteUrl
      hotelType {
        id
        name
      }
    }
    googlePlaceReviews {
      ...FGooglePlaceReviews
    }
    contents {
      ...FHotelContentItem
    }
    inclusivePriceInfo {
      ...FInclusivePriceInfo
    }
  }
}
    ${FAmenityFragmentDoc}
${FHotelLocationFragmentDoc}
${FHotelCautionsFragmentDoc}
${FGooglePlaceReviewsFragmentDoc}
${FHotelContentItemFragmentDoc}
${FInclusivePriceInfoFragmentDoc}`;

/**
 * __useFindHotelForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindHotelForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindHotelForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindHotelForOrderConfirmQuery, FindHotelForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelForOrderConfirmQuery, FindHotelForOrderConfirmQueryVariables>(FindHotelForOrderConfirmDocument, options);
      }
export function useFindHotelForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelForOrderConfirmQuery, FindHotelForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelForOrderConfirmQuery, FindHotelForOrderConfirmQueryVariables>(FindHotelForOrderConfirmDocument, options);
        }
export type FindHotelForOrderConfirmQueryHookResult = ReturnType<typeof useFindHotelForOrderConfirmQuery>;
export type FindHotelForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindHotelForOrderConfirmLazyQuery>;
export type FindHotelForOrderConfirmQueryResult = Apollo.QueryResult<FindHotelForOrderConfirmQuery, FindHotelForOrderConfirmQueryVariables>;
export const FindHotelMinimumPriceCalendarDocument = gql`
    query findHotelMinimumPriceCalendar($input: HotelMinimumPriceCalendarInput!) {
  hotelMinimumPriceCalendar(input: $input) {
    minimumPriceCalendarByNumberOfPeople {
      id
      perOne {
        ...FHotelDayMinimumPrice
      }
      perTwo {
        ...FHotelDayMinimumPrice
      }
    }
    lowestMinimumPrices {
      id
      perOne {
        inclusive
        strikeThrough
      }
      perTwo {
        inclusive
        strikeThrough
      }
    }
  }
}
    ${FHotelDayMinimumPriceFragmentDoc}`;

/**
 * __useFindHotelMinimumPriceCalendarQuery__
 *
 * To run a query within a React component, call `useFindHotelMinimumPriceCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelMinimumPriceCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelMinimumPriceCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindHotelMinimumPriceCalendarQuery(baseOptions: Apollo.QueryHookOptions<FindHotelMinimumPriceCalendarQuery, FindHotelMinimumPriceCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelMinimumPriceCalendarQuery, FindHotelMinimumPriceCalendarQueryVariables>(FindHotelMinimumPriceCalendarDocument, options);
      }
export function useFindHotelMinimumPriceCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelMinimumPriceCalendarQuery, FindHotelMinimumPriceCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelMinimumPriceCalendarQuery, FindHotelMinimumPriceCalendarQueryVariables>(FindHotelMinimumPriceCalendarDocument, options);
        }
export type FindHotelMinimumPriceCalendarQueryHookResult = ReturnType<typeof useFindHotelMinimumPriceCalendarQuery>;
export type FindHotelMinimumPriceCalendarLazyQueryHookResult = ReturnType<typeof useFindHotelMinimumPriceCalendarLazyQuery>;
export type FindHotelMinimumPriceCalendarQueryResult = Apollo.QueryResult<FindHotelMinimumPriceCalendarQuery, FindHotelMinimumPriceCalendarQueryVariables>;
export const FindHotelSummaryForReviewDocument = gql`
    query findHotelSummaryForReview($hotelInput: HotelInput!) {
  hotel(input: $hotelInput) {
    ...FHotelSummaryForReview
  }
}
    ${FHotelSummaryForReviewFragmentDoc}`;

/**
 * __useFindHotelSummaryForReviewQuery__
 *
 * To run a query within a React component, call `useFindHotelSummaryForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelSummaryForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelSummaryForReviewQuery({
 *   variables: {
 *      hotelInput: // value for 'hotelInput'
 *   },
 * });
 */
export function useFindHotelSummaryForReviewQuery(baseOptions: Apollo.QueryHookOptions<FindHotelSummaryForReviewQuery, FindHotelSummaryForReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelSummaryForReviewQuery, FindHotelSummaryForReviewQueryVariables>(FindHotelSummaryForReviewDocument, options);
      }
export function useFindHotelSummaryForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelSummaryForReviewQuery, FindHotelSummaryForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelSummaryForReviewQuery, FindHotelSummaryForReviewQueryVariables>(FindHotelSummaryForReviewDocument, options);
        }
export type FindHotelSummaryForReviewQueryHookResult = ReturnType<typeof useFindHotelSummaryForReviewQuery>;
export type FindHotelSummaryForReviewLazyQueryHookResult = ReturnType<typeof useFindHotelSummaryForReviewLazyQuery>;
export type FindHotelSummaryForReviewQueryResult = Apollo.QueryResult<FindHotelSummaryForReviewQuery, FindHotelSummaryForReviewQueryVariables>;
export const FindHotelTabsForOrderConfirmDocument = gql`
    query findHotelTabsForOrderConfirm($input: HotelTabsForOrderConfirmInput!) {
  hotelTabsForOrderConfirm(input: $input) {
    hotelTabs {
      label
      hotelIds
    }
  }
}
    `;

/**
 * __useFindHotelTabsForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindHotelTabsForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHotelTabsForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHotelTabsForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindHotelTabsForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindHotelTabsForOrderConfirmQuery, FindHotelTabsForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHotelTabsForOrderConfirmQuery, FindHotelTabsForOrderConfirmQueryVariables>(FindHotelTabsForOrderConfirmDocument, options);
      }
export function useFindHotelTabsForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHotelTabsForOrderConfirmQuery, FindHotelTabsForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHotelTabsForOrderConfirmQuery, FindHotelTabsForOrderConfirmQueryVariables>(FindHotelTabsForOrderConfirmDocument, options);
        }
export type FindHotelTabsForOrderConfirmQueryHookResult = ReturnType<typeof useFindHotelTabsForOrderConfirmQuery>;
export type FindHotelTabsForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindHotelTabsForOrderConfirmLazyQuery>;
export type FindHotelTabsForOrderConfirmQueryResult = Apollo.QueryResult<FindHotelTabsForOrderConfirmQuery, FindHotelTabsForOrderConfirmQueryVariables>;
export const FindLatestReservedReservationInfoDocument = gql`
    query findLatestReservedReservationInfo {
  latestReservedReservationInfo {
    isDPFlightReservedWithin30Days
  }
}
    `;

/**
 * __useFindLatestReservedReservationInfoQuery__
 *
 * To run a query within a React component, call `useFindLatestReservedReservationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLatestReservedReservationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLatestReservedReservationInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindLatestReservedReservationInfoQuery(baseOptions?: Apollo.QueryHookOptions<FindLatestReservedReservationInfoQuery, FindLatestReservedReservationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLatestReservedReservationInfoQuery, FindLatestReservedReservationInfoQueryVariables>(FindLatestReservedReservationInfoDocument, options);
      }
export function useFindLatestReservedReservationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLatestReservedReservationInfoQuery, FindLatestReservedReservationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLatestReservedReservationInfoQuery, FindLatestReservedReservationInfoQueryVariables>(FindLatestReservedReservationInfoDocument, options);
        }
export type FindLatestReservedReservationInfoQueryHookResult = ReturnType<typeof useFindLatestReservedReservationInfoQuery>;
export type FindLatestReservedReservationInfoLazyQueryHookResult = ReturnType<typeof useFindLatestReservedReservationInfoLazyQuery>;
export type FindLatestReservedReservationInfoQueryResult = Apollo.QueryResult<FindLatestReservedReservationInfoQuery, FindLatestReservedReservationInfoQueryVariables>;
export const FindOverseasLineSupportDocument = gql`
    query findOverseasLINESupport($input: OverseasDPFlightInput!) {
  overseasDPFlight(input: $input) {
    overseasDPFlightInfo {
      recommendedTravelDestinations {
        ...FTravelDestination
      }
    }
  }
}
    ${FTravelDestinationFragmentDoc}`;

/**
 * __useFindOverseasLineSupportQuery__
 *
 * To run a query within a React component, call `useFindOverseasLineSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverseasLineSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverseasLineSupportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOverseasLineSupportQuery(baseOptions: Apollo.QueryHookOptions<FindOverseasLineSupportQuery, FindOverseasLineSupportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOverseasLineSupportQuery, FindOverseasLineSupportQueryVariables>(FindOverseasLineSupportDocument, options);
      }
export function useFindOverseasLineSupportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOverseasLineSupportQuery, FindOverseasLineSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOverseasLineSupportQuery, FindOverseasLineSupportQueryVariables>(FindOverseasLineSupportDocument, options);
        }
export type FindOverseasLineSupportQueryHookResult = ReturnType<typeof useFindOverseasLineSupportQuery>;
export type FindOverseasLineSupportLazyQueryHookResult = ReturnType<typeof useFindOverseasLineSupportLazyQuery>;
export type FindOverseasLineSupportQueryResult = Apollo.QueryResult<FindOverseasLineSupportQuery, FindOverseasLineSupportQueryVariables>;
export const FindMinimumDpCarPriceInfoDocument = gql`
    query findMinimumDPCarPriceInfo($input: MinimumDPCarPriceInfoInput!) {
  minimumDPCarPriceInfo(input: $input) {
    inclusivePrice
  }
}
    `;

/**
 * __useFindMinimumDpCarPriceInfoQuery__
 *
 * To run a query within a React component, call `useFindMinimumDpCarPriceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMinimumDpCarPriceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMinimumDpCarPriceInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMinimumDpCarPriceInfoQuery(baseOptions: Apollo.QueryHookOptions<FindMinimumDpCarPriceInfoQuery, FindMinimumDpCarPriceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMinimumDpCarPriceInfoQuery, FindMinimumDpCarPriceInfoQueryVariables>(FindMinimumDpCarPriceInfoDocument, options);
      }
export function useFindMinimumDpCarPriceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMinimumDpCarPriceInfoQuery, FindMinimumDpCarPriceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMinimumDpCarPriceInfoQuery, FindMinimumDpCarPriceInfoQueryVariables>(FindMinimumDpCarPriceInfoDocument, options);
        }
export type FindMinimumDpCarPriceInfoQueryHookResult = ReturnType<typeof useFindMinimumDpCarPriceInfoQuery>;
export type FindMinimumDpCarPriceInfoLazyQueryHookResult = ReturnType<typeof useFindMinimumDpCarPriceInfoLazyQuery>;
export type FindMinimumDpCarPriceInfoQueryResult = Apollo.QueryResult<FindMinimumDpCarPriceInfoQuery, FindMinimumDpCarPriceInfoQueryVariables>;
export const FindMobileHotelDetailWithAreaHotelsDocument = gql`
    query findMobileHotelDetailWithAreaHotels($input: HotelInput!) {
  hotel(input: $input) {
    id
    ...FCocoolocalaHotel
    ...FExpediaHotel
    googlePlaceReviews {
      ...FGooglePlaceReviews
    }
  }
}
    ${FCocoolocalaHotelFragmentDoc}
${FExpediaHotelFragmentDoc}
${FGooglePlaceReviewsFragmentDoc}`;

/**
 * __useFindMobileHotelDetailWithAreaHotelsQuery__
 *
 * To run a query within a React component, call `useFindMobileHotelDetailWithAreaHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMobileHotelDetailWithAreaHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMobileHotelDetailWithAreaHotelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMobileHotelDetailWithAreaHotelsQuery(baseOptions: Apollo.QueryHookOptions<FindMobileHotelDetailWithAreaHotelsQuery, FindMobileHotelDetailWithAreaHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMobileHotelDetailWithAreaHotelsQuery, FindMobileHotelDetailWithAreaHotelsQueryVariables>(FindMobileHotelDetailWithAreaHotelsDocument, options);
      }
export function useFindMobileHotelDetailWithAreaHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMobileHotelDetailWithAreaHotelsQuery, FindMobileHotelDetailWithAreaHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMobileHotelDetailWithAreaHotelsQuery, FindMobileHotelDetailWithAreaHotelsQueryVariables>(FindMobileHotelDetailWithAreaHotelsDocument, options);
        }
export type FindMobileHotelDetailWithAreaHotelsQueryHookResult = ReturnType<typeof useFindMobileHotelDetailWithAreaHotelsQuery>;
export type FindMobileHotelDetailWithAreaHotelsLazyQueryHookResult = ReturnType<typeof useFindMobileHotelDetailWithAreaHotelsLazyQuery>;
export type FindMobileHotelDetailWithAreaHotelsQueryResult = Apollo.QueryResult<FindMobileHotelDetailWithAreaHotelsQuery, FindMobileHotelDetailWithAreaHotelsQueryVariables>;
export const FindMyHotelBookmarkDocument = gql`
    query findMyHotelBookmark($input: MyHotelBookmarkInput!) {
  myHotelBookmark(input: $input) {
    cocolocalaHotelId
    bookmarked
  }
}
    `;

/**
 * __useFindMyHotelBookmarkQuery__
 *
 * To run a query within a React component, call `useFindMyHotelBookmarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyHotelBookmarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyHotelBookmarkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMyHotelBookmarkQuery(baseOptions: Apollo.QueryHookOptions<FindMyHotelBookmarkQuery, FindMyHotelBookmarkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyHotelBookmarkQuery, FindMyHotelBookmarkQueryVariables>(FindMyHotelBookmarkDocument, options);
      }
export function useFindMyHotelBookmarkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyHotelBookmarkQuery, FindMyHotelBookmarkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyHotelBookmarkQuery, FindMyHotelBookmarkQueryVariables>(FindMyHotelBookmarkDocument, options);
        }
export type FindMyHotelBookmarkQueryHookResult = ReturnType<typeof useFindMyHotelBookmarkQuery>;
export type FindMyHotelBookmarkLazyQueryHookResult = ReturnType<typeof useFindMyHotelBookmarkLazyQuery>;
export type FindMyHotelBookmarkQueryResult = Apollo.QueryResult<FindMyHotelBookmarkQuery, FindMyHotelBookmarkQueryVariables>;
export const FindOgpImageForOrderConfirmDocument = gql`
    query findOGPImageForOrderConfirm($input: OGPImageForOrderConfirmInput!) {
  ogpImageForOrderConfirm(input: $input) {
    id
    ogpImage {
      imageUrl
    }
  }
}
    `;

/**
 * __useFindOgpImageForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindOgpImageForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOgpImageForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOgpImageForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOgpImageForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindOgpImageForOrderConfirmQuery, FindOgpImageForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOgpImageForOrderConfirmQuery, FindOgpImageForOrderConfirmQueryVariables>(FindOgpImageForOrderConfirmDocument, options);
      }
export function useFindOgpImageForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOgpImageForOrderConfirmQuery, FindOgpImageForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOgpImageForOrderConfirmQuery, FindOgpImageForOrderConfirmQueryVariables>(FindOgpImageForOrderConfirmDocument, options);
        }
export type FindOgpImageForOrderConfirmQueryHookResult = ReturnType<typeof useFindOgpImageForOrderConfirmQuery>;
export type FindOgpImageForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindOgpImageForOrderConfirmLazyQuery>;
export type FindOgpImageForOrderConfirmQueryResult = Apollo.QueryResult<FindOgpImageForOrderConfirmQuery, FindOgpImageForOrderConfirmQueryVariables>;
export const FindOrderCompleteDocument = gql`
    query findOrderComplete($input: OrderCompleteInput!) {
  orderComplete(input: $input) {
    orderId
    status
    isDPFlight
    affiliateCVPrice
    email
    paymentMethod
  }
}
    `;

/**
 * __useFindOrderCompleteQuery__
 *
 * To run a query within a React component, call `useFindOrderCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderCompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderCompleteQuery(baseOptions: Apollo.QueryHookOptions<FindOrderCompleteQuery, FindOrderCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderCompleteQuery, FindOrderCompleteQueryVariables>(FindOrderCompleteDocument, options);
      }
export function useFindOrderCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderCompleteQuery, FindOrderCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderCompleteQuery, FindOrderCompleteQueryVariables>(FindOrderCompleteDocument, options);
        }
export type FindOrderCompleteQueryHookResult = ReturnType<typeof useFindOrderCompleteQuery>;
export type FindOrderCompleteLazyQueryHookResult = ReturnType<typeof useFindOrderCompleteLazyQuery>;
export type FindOrderCompleteQueryResult = Apollo.QueryResult<FindOrderCompleteQuery, FindOrderCompleteQueryVariables>;
export const FindOrderConfirmDocument = gql`
    query findOrderConfirm($input: OrderConfirmInput!) {
  orderConfirm(input: $input) {
    id
    hotelInfo {
      id
      cocolocalaHotelId
      hotelSummary {
        ...FOrderHotelSummary
      }
      roomSummary {
        ...FOrderHotelRoomSummary
      }
      hotelDetail {
        ...FOrderHotelDetail
      }
      roomDetail {
        ...FOrderHotelRoomDetail
      }
      selectedRateId
      importantNotices
      numberOfPeople
      targetHotelZonePath
      numberOfRoomsRemaining
      isSoldOut
    }
    reservationSummaryInfo {
      goingDeparturePointDate
      returningDeparturePointDate
      numberOfPeople
    }
    flightDetail {
      goingFlight {
        ...FFlight
      }
      returningFlight {
        ...FFlight
      }
    }
    supportPlan {
      ...FDPFlightSupportPlan
    }
    supportPlans {
      ...FDPFlightSupportPlan
    }
    cancelForAnyReason {
      ...FOrderCancelForAnyReason
    }
    priceInfo {
      ...FOrderPriceInfoForOrderConfirm
    }
    cancelInfo {
      ...FOrderCancelInfo
    }
    searchCondition {
      goingCityOrAirportIATACode
      returningCityOrAirportIATACode
      goingDate
      returningDate
      numberOfAdults
      childAges
      zonePath
    }
    isPartialStayDaysOfEntireItinerary
    orderConfirmRevisitInfo {
      zoneName
      hotelName
      thumbnailUrl
      departureDate
      numberOfPeople
      flightCarrierNames
    }
    additionalOptionsInfo {
      ...FAdditionalOptionsInfo
    }
    limitedTimeSaleInfo {
      ...FLimitedTimeSaleInfo
    }
    useAirportTransfer
    passportRequirement
    adjustedCheckInDateNote
    baggageOptionInfo {
      round {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      going {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      returning {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
    }
    selectedBaggageOptionInfo {
      perFlight {
        round {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
        going {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
        returning {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
      }
      perPassengers {
        selectedBaggageOption {
          round {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
          going {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
          returning {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
        }
      }
    }
  }
}
    ${FOrderHotelSummaryFragmentDoc}
${FOrderHotelRoomSummaryFragmentDoc}
${FOrderHotelDetailFragmentDoc}
${FOrderHotelRoomDetailFragmentDoc}
${FFlightFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FOrderCancelForAnyReasonFragmentDoc}
${FOrderPriceInfoForOrderConfirmFragmentDoc}
${FOrderCancelInfoFragmentDoc}
${FAdditionalOptionsInfoFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}`;

/**
 * __useFindOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindOrderConfirmQuery, FindOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderConfirmQuery, FindOrderConfirmQueryVariables>(FindOrderConfirmDocument, options);
      }
export function useFindOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderConfirmQuery, FindOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderConfirmQuery, FindOrderConfirmQueryVariables>(FindOrderConfirmDocument, options);
        }
export type FindOrderConfirmQueryHookResult = ReturnType<typeof useFindOrderConfirmQuery>;
export type FindOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindOrderConfirmLazyQuery>;
export type FindOrderConfirmQueryResult = Apollo.QueryResult<FindOrderConfirmQuery, FindOrderConfirmQueryVariables>;
export const FindOrderHistoryDocument = gql`
    query findOrderHistory($input: OrderHistoryInput!) {
  orderHistory(input: $input) {
    ...FOrderHistory
  }
}
    ${FOrderHistoryFragmentDoc}`;

/**
 * __useFindOrderHistoryQuery__
 *
 * To run a query within a React component, call `useFindOrderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderHistoryQuery(baseOptions: Apollo.QueryHookOptions<FindOrderHistoryQuery, FindOrderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderHistoryQuery, FindOrderHistoryQueryVariables>(FindOrderHistoryDocument, options);
      }
export function useFindOrderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderHistoryQuery, FindOrderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderHistoryQuery, FindOrderHistoryQueryVariables>(FindOrderHistoryDocument, options);
        }
export type FindOrderHistoryQueryHookResult = ReturnType<typeof useFindOrderHistoryQuery>;
export type FindOrderHistoryLazyQueryHookResult = ReturnType<typeof useFindOrderHistoryLazyQuery>;
export type FindOrderHistoryQueryResult = Apollo.QueryResult<FindOrderHistoryQuery, FindOrderHistoryQueryVariables>;
export const FindOrderHistoryConvenienceStorePaymentDocument = gql`
    query findOrderHistoryConvenienceStorePayment($input: OrderHistoryConvenienceStorePaymentInput!) {
  orderHistoryConvenienceStorePayment(input: $input) {
    barcode
    inclusivePrice
    convenienceStoreTransferDeadline
  }
}
    `;

/**
 * __useFindOrderHistoryConvenienceStorePaymentQuery__
 *
 * To run a query within a React component, call `useFindOrderHistoryConvenienceStorePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderHistoryConvenienceStorePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderHistoryConvenienceStorePaymentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderHistoryConvenienceStorePaymentQuery(baseOptions: Apollo.QueryHookOptions<FindOrderHistoryConvenienceStorePaymentQuery, FindOrderHistoryConvenienceStorePaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderHistoryConvenienceStorePaymentQuery, FindOrderHistoryConvenienceStorePaymentQueryVariables>(FindOrderHistoryConvenienceStorePaymentDocument, options);
      }
export function useFindOrderHistoryConvenienceStorePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderHistoryConvenienceStorePaymentQuery, FindOrderHistoryConvenienceStorePaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderHistoryConvenienceStorePaymentQuery, FindOrderHistoryConvenienceStorePaymentQueryVariables>(FindOrderHistoryConvenienceStorePaymentDocument, options);
        }
export type FindOrderHistoryConvenienceStorePaymentQueryHookResult = ReturnType<typeof useFindOrderHistoryConvenienceStorePaymentQuery>;
export type FindOrderHistoryConvenienceStorePaymentLazyQueryHookResult = ReturnType<typeof useFindOrderHistoryConvenienceStorePaymentLazyQuery>;
export type FindOrderHistoryConvenienceStorePaymentQueryResult = Apollo.QueryResult<FindOrderHistoryConvenienceStorePaymentQuery, FindOrderHistoryConvenienceStorePaymentQueryVariables>;
export const FindOrderPurchaseDocument = gql`
    query findOrderPurchase {
  orderPurchase {
    ...FOrderPurchase
  }
}
    ${FOrderPurchaseFragmentDoc}`;

/**
 * __useFindOrderPurchaseQuery__
 *
 * To run a query within a React component, call `useFindOrderPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderPurchaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindOrderPurchaseQuery(baseOptions?: Apollo.QueryHookOptions<FindOrderPurchaseQuery, FindOrderPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderPurchaseQuery, FindOrderPurchaseQueryVariables>(FindOrderPurchaseDocument, options);
      }
export function useFindOrderPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderPurchaseQuery, FindOrderPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderPurchaseQuery, FindOrderPurchaseQueryVariables>(FindOrderPurchaseDocument, options);
        }
export type FindOrderPurchaseQueryHookResult = ReturnType<typeof useFindOrderPurchaseQuery>;
export type FindOrderPurchaseLazyQueryHookResult = ReturnType<typeof useFindOrderPurchaseLazyQuery>;
export type FindOrderPurchaseQueryResult = Apollo.QueryResult<FindOrderPurchaseQuery, FindOrderPurchaseQueryVariables>;
export const FindOrderReservationInformationDocument = gql`
    query findOrderReservationInformation($input: OrderReservationInformationInput!) {
  orderReservationInformation(input: $input) {
    numberOfPeople
    isDP
    passportRequirement
    selectedProductsSummaryLabelInfo {
      labels {
        ...FSelectedProductsSummaryLabel
      }
    }
    cancelForAnyReasonInclusivePricePerPerson
    supportPlan {
      ...FDPFlightSupportPlan
    }
    supportPlans {
      ...FDPFlightSupportPlan
    }
    hasCancelForAnyReason
    priceInfo {
      totalAmount
      totalAmountPerPerson
      flightBaggageOptionInclusivePrice
      cocolocalaTransactionFeeAndTaxText
    }
    baggageOptionInfo {
      round {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      going {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
      returning {
        perPassenger
        baggageOptions {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
    }
    selectedBaggageOptionInfo {
      perFlight {
        round {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
        going {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
        returning {
          value
          allowance
          price
          maxQuantity
          maxWeight
        }
      }
      perPassengers {
        selectedBaggageOption {
          round {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
          going {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
          returning {
            value
            allowance
            price
            maxQuantity
            maxWeight
          }
        }
      }
    }
    numberOfStays
    nationalityOptions {
      value
      label
    }
    departureDateText
    presetFormOrderReservationInformation {
      passengers {
        firstName
        lastName
        gender
        birthday {
          year
          month
          day
        }
        nationality
        selectedBaggageOption {
          goingBaggageOptionValue
          returningBaggageOptionValue
          roundBaggageOptionValue
        }
        passport {
          passportNumber
          passportExpiry {
            year
            month
            day
          }
          passportIssuingCountry
        }
      }
      selectedBaggageOption {
        goingBaggageOptionValue
        returningBaggageOptionValue
        roundBaggageOptionValue
      }
    }
    isHotspringMember
  }
}
    ${FSelectedProductsSummaryLabelFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}`;

/**
 * __useFindOrderReservationInformationQuery__
 *
 * To run a query within a React component, call `useFindOrderReservationInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderReservationInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderReservationInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderReservationInformationQuery(baseOptions: Apollo.QueryHookOptions<FindOrderReservationInformationQuery, FindOrderReservationInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderReservationInformationQuery, FindOrderReservationInformationQueryVariables>(FindOrderReservationInformationDocument, options);
      }
export function useFindOrderReservationInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderReservationInformationQuery, FindOrderReservationInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderReservationInformationQuery, FindOrderReservationInformationQueryVariables>(FindOrderReservationInformationDocument, options);
        }
export type FindOrderReservationInformationQueryHookResult = ReturnType<typeof useFindOrderReservationInformationQuery>;
export type FindOrderReservationInformationLazyQueryHookResult = ReturnType<typeof useFindOrderReservationInformationLazyQuery>;
export type FindOrderReservationInformationQueryResult = Apollo.QueryResult<FindOrderReservationInformationQuery, FindOrderReservationInformationQueryVariables>;
export const FindOrderSignDocument = gql`
    query findOrderSign($input: OrderSignInput!) {
  orderSign(input: $input) {
    id
    logInfo {
      productType
    }
  }
}
    `;

/**
 * __useFindOrderSignQuery__
 *
 * To run a query within a React component, call `useFindOrderSignQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderSignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderSignQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderSignQuery(baseOptions: Apollo.QueryHookOptions<FindOrderSignQuery, FindOrderSignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderSignQuery, FindOrderSignQueryVariables>(FindOrderSignDocument, options);
      }
export function useFindOrderSignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderSignQuery, FindOrderSignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderSignQuery, FindOrderSignQueryVariables>(FindOrderSignDocument, options);
        }
export type FindOrderSignQueryHookResult = ReturnType<typeof useFindOrderSignQuery>;
export type FindOrderSignLazyQueryHookResult = ReturnType<typeof useFindOrderSignLazyQuery>;
export type FindOrderSignQueryResult = Apollo.QueryResult<FindOrderSignQuery, FindOrderSignQueryVariables>;
export const FindOrderTodoListDocument = gql`
    query findOrderTodoList($input: OrderTodoListInput!) {
  orderTodoList(input: $input) {
    todoList {
      sectionTitle
      sortIndex
      items {
        id
        isRequired
        title
        content
        sortIndex
        isChecked
      }
    }
  }
}
    `;

/**
 * __useFindOrderTodoListQuery__
 *
 * To run a query within a React component, call `useFindOrderTodoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrderTodoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrderTodoListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrderTodoListQuery(baseOptions: Apollo.QueryHookOptions<FindOrderTodoListQuery, FindOrderTodoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrderTodoListQuery, FindOrderTodoListQueryVariables>(FindOrderTodoListDocument, options);
      }
export function useFindOrderTodoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrderTodoListQuery, FindOrderTodoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrderTodoListQuery, FindOrderTodoListQueryVariables>(FindOrderTodoListDocument, options);
        }
export type FindOrderTodoListQueryHookResult = ReturnType<typeof useFindOrderTodoListQuery>;
export type FindOrderTodoListLazyQueryHookResult = ReturnType<typeof useFindOrderTodoListLazyQuery>;
export type FindOrderTodoListQueryResult = Apollo.QueryResult<FindOrderTodoListQuery, FindOrderTodoListQueryVariables>;
export const FindOverseasDpFlightDocument = gql`
    query findOverseasDPFlight($input: OverseasDPFlightInput!) {
  overseasDPFlight(input: $input) {
    id
    overseasDPFlightInfo {
      departureAirports {
        ...FAirportSection
      }
      arrivalAirports {
        ...FAirportSection
      }
      dPFlightSupportPlans {
        ...FDPFlightSupportPlan
      }
      recommendedTravelDestinations {
        ...FTravelDestination
      }
      groupedTravelDestination {
        name
        travelDestinations {
          ...FTravelDestination
        }
      }
      parentsOfEachTravelDestination {
        ...FTravelDestination
      }
      limitedTimeSaleInfo {
        ...FLimitedTimeSaleInfo
      }
    }
    overseasDPFlightTabs {
      ...FOverseasDPFlightTabs
    }
  }
}
    ${FAirportSectionFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FTravelDestinationFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}
${FOverseasDpFlightTabsFragmentDoc}`;

/**
 * __useFindOverseasDpFlightQuery__
 *
 * To run a query within a React component, call `useFindOverseasDpFlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverseasDpFlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverseasDpFlightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOverseasDpFlightQuery(baseOptions: Apollo.QueryHookOptions<FindOverseasDpFlightQuery, FindOverseasDpFlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOverseasDpFlightQuery, FindOverseasDpFlightQueryVariables>(FindOverseasDpFlightDocument, options);
      }
export function useFindOverseasDpFlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOverseasDpFlightQuery, FindOverseasDpFlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOverseasDpFlightQuery, FindOverseasDpFlightQueryVariables>(FindOverseasDpFlightDocument, options);
        }
export type FindOverseasDpFlightQueryHookResult = ReturnType<typeof useFindOverseasDpFlightQuery>;
export type FindOverseasDpFlightLazyQueryHookResult = ReturnType<typeof useFindOverseasDpFlightLazyQuery>;
export type FindOverseasDpFlightQueryResult = Apollo.QueryResult<FindOverseasDpFlightQuery, FindOverseasDpFlightQueryVariables>;
export const FindOverseasDpFlightPlansDocument = gql`
    query findOverseasDPFlightPlans {
  overseasDPFlightPlans {
    ...FDPFlightSupportPlan
  }
}
    ${FdpFlightSupportPlanFragmentDoc}`;

/**
 * __useFindOverseasDpFlightPlansQuery__
 *
 * To run a query within a React component, call `useFindOverseasDpFlightPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverseasDpFlightPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverseasDpFlightPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindOverseasDpFlightPlansQuery(baseOptions?: Apollo.QueryHookOptions<FindOverseasDpFlightPlansQuery, FindOverseasDpFlightPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOverseasDpFlightPlansQuery, FindOverseasDpFlightPlansQueryVariables>(FindOverseasDpFlightPlansDocument, options);
      }
export function useFindOverseasDpFlightPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOverseasDpFlightPlansQuery, FindOverseasDpFlightPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOverseasDpFlightPlansQuery, FindOverseasDpFlightPlansQueryVariables>(FindOverseasDpFlightPlansDocument, options);
        }
export type FindOverseasDpFlightPlansQueryHookResult = ReturnType<typeof useFindOverseasDpFlightPlansQuery>;
export type FindOverseasDpFlightPlansLazyQueryHookResult = ReturnType<typeof useFindOverseasDpFlightPlansLazyQuery>;
export type FindOverseasDpFlightPlansQueryResult = Apollo.QueryResult<FindOverseasDpFlightPlansQuery, FindOverseasDpFlightPlansQueryVariables>;
export const FindOverseasHotelDocument = gql`
    query findOverseasHotel($input: OverseasDPFlightInput!) {
  overseasDPFlight(input: $input) {
    id
    overseasDPFlightInfo {
      departureAirports {
        ...FAirportSection
      }
      arrivalAirports {
        ...FAirportSection
      }
      dPFlightSupportPlans {
        ...FDPFlightSupportPlan
      }
      recommendedTravelDestinations {
        name
        path
        imageUrl
      }
      groupedTravelDestination {
        name
        travelDestinations {
          name
          path
          imageUrl
        }
      }
      parentsOfEachTravelDestination {
        ...FTravelDestination
      }
    }
    overseasDPFlightTabs {
      ...FOverseasDPFlightTabs
    }
  }
}
    ${FAirportSectionFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FTravelDestinationFragmentDoc}
${FOverseasDpFlightTabsFragmentDoc}`;

/**
 * __useFindOverseasHotelQuery__
 *
 * To run a query within a React component, call `useFindOverseasHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverseasHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverseasHotelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOverseasHotelQuery(baseOptions: Apollo.QueryHookOptions<FindOverseasHotelQuery, FindOverseasHotelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOverseasHotelQuery, FindOverseasHotelQueryVariables>(FindOverseasHotelDocument, options);
      }
export function useFindOverseasHotelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOverseasHotelQuery, FindOverseasHotelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOverseasHotelQuery, FindOverseasHotelQueryVariables>(FindOverseasHotelDocument, options);
        }
export type FindOverseasHotelQueryHookResult = ReturnType<typeof useFindOverseasHotelQuery>;
export type FindOverseasHotelLazyQueryHookResult = ReturnType<typeof useFindOverseasHotelLazyQuery>;
export type FindOverseasHotelQueryResult = Apollo.QueryResult<FindOverseasHotelQuery, FindOverseasHotelQueryVariables>;
export const FindOverseasZoneDpFlightDocument = gql`
    query findOverseasZoneDPFlight($input: OverseasZoneDPFlightInput!) {
  overseasZoneDPFlight(input: $input) {
    id
    imageUrl
    referenceMinimumPrice
    travelStatus
    departureAirports {
      ...FAirportSection
    }
    arrivalAirports {
      ...FAirportSection
    }
    zoneName
    zonePath
    parentZoneInfo {
      ...FZoneInfo
    }
    returningCityOrAirportIATACode
    dPFlightSupportPlans {
      ...FDPFlightSupportPlan
    }
    cities {
      ...FTravelDestination
    }
    recommendedTravelDestinations {
      ...FTravelDestination
    }
    existsDPFlightThemes
    priorConfirmation
    travelPreparationForDeparture
    travelPreparationForReturn
    recommendedStayDays
    lowestPriceSchedule {
      goingDate
      returningDate
    }
    hotels {
      id
      name
      rating
      areaName
      prefectureName
      imageUrl
    }
    hotelTabs {
      label
      hotelIds
    }
    travelThemes {
      ...FTravelTheme
    }
    basicInformation {
      ...FZoneBasicInfomration
    }
    limitedTimeSaleInfo {
      ...FLimitedTimeSaleInfo
    }
    campaignInfo {
      ...FCampaignInfo
    }
  }
}
    ${FAirportSectionFragmentDoc}
${FZoneInfoFragmentDoc}
${FdpFlightSupportPlanFragmentDoc}
${FTravelDestinationFragmentDoc}
${FTravelThemeFragmentDoc}
${FZoneBasicInfomrationFragmentDoc}
${FLimitedTimeSaleInfoFragmentDoc}
${FCampaignInfoFragmentDoc}`;

/**
 * __useFindOverseasZoneDpFlightQuery__
 *
 * To run a query within a React component, call `useFindOverseasZoneDpFlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOverseasZoneDpFlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOverseasZoneDpFlightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOverseasZoneDpFlightQuery(baseOptions: Apollo.QueryHookOptions<FindOverseasZoneDpFlightQuery, FindOverseasZoneDpFlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOverseasZoneDpFlightQuery, FindOverseasZoneDpFlightQueryVariables>(FindOverseasZoneDpFlightDocument, options);
      }
export function useFindOverseasZoneDpFlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOverseasZoneDpFlightQuery, FindOverseasZoneDpFlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOverseasZoneDpFlightQuery, FindOverseasZoneDpFlightQueryVariables>(FindOverseasZoneDpFlightDocument, options);
        }
export type FindOverseasZoneDpFlightQueryHookResult = ReturnType<typeof useFindOverseasZoneDpFlightQuery>;
export type FindOverseasZoneDpFlightLazyQueryHookResult = ReturnType<typeof useFindOverseasZoneDpFlightLazyQuery>;
export type FindOverseasZoneDpFlightQueryResult = Apollo.QueryResult<FindOverseasZoneDpFlightQuery, FindOverseasZoneDpFlightQueryVariables>;
export const FindPassportInformationDocument = gql`
    query findPassportInformation($input: PassportInformationInput!) {
  passportInformation(input: $input) {
    id
    vendor
    selectedBaggageOption {
      round {
        value
        allowance
        price
        inclusivePrice
        maxQuantity
        maxWeight
      }
      going {
        value
        allowance
        price
        inclusivePrice
        maxQuantity
        maxWeight
      }
      returning {
        value
        allowance
        price
        inclusivePrice
        maxQuantity
        maxWeight
      }
    }
    passengers {
      flightPassengerId
      firstName
      lastName
      nationality
      gender
      birthday {
        year
        month
        day
      }
      isNeedPassport
      passport {
        passportNumber
        passportIssuingCountry
        passportExpiry {
          year
          month
          day
        }
      }
      isRepresentative
      selectedBaggageOption {
        round {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
        going {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
        returning {
          value
          allowance
          price
          inclusivePrice
          maxQuantity
          maxWeight
        }
      }
    }
    nationalityOptions {
      value
      label
    }
    departureDateText
  }
}
    `;

/**
 * __useFindPassportInformationQuery__
 *
 * To run a query within a React component, call `useFindPassportInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPassportInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPassportInformationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPassportInformationQuery(baseOptions: Apollo.QueryHookOptions<FindPassportInformationQuery, FindPassportInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPassportInformationQuery, FindPassportInformationQueryVariables>(FindPassportInformationDocument, options);
      }
export function useFindPassportInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPassportInformationQuery, FindPassportInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPassportInformationQuery, FindPassportInformationQueryVariables>(FindPassportInformationDocument, options);
        }
export type FindPassportInformationQueryHookResult = ReturnType<typeof useFindPassportInformationQuery>;
export type FindPassportInformationLazyQueryHookResult = ReturnType<typeof useFindPassportInformationLazyQuery>;
export type FindPassportInformationQueryResult = Apollo.QueryResult<FindPassportInformationQuery, FindPassportInformationQueryVariables>;
export const FindPcHotelDetailWithAreaHotelsDocument = gql`
    query findPcHotelDetailWithAreaHotels($input: HotelInput!) {
  hotel(input: $input) {
    id
    ...FCocoolocalaHotel
    ...FExpediaHotel
  }
}
    ${FCocoolocalaHotelFragmentDoc}
${FExpediaHotelFragmentDoc}`;

/**
 * __useFindPcHotelDetailWithAreaHotelsQuery__
 *
 * To run a query within a React component, call `useFindPcHotelDetailWithAreaHotelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPcHotelDetailWithAreaHotelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPcHotelDetailWithAreaHotelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPcHotelDetailWithAreaHotelsQuery(baseOptions: Apollo.QueryHookOptions<FindPcHotelDetailWithAreaHotelsQuery, FindPcHotelDetailWithAreaHotelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPcHotelDetailWithAreaHotelsQuery, FindPcHotelDetailWithAreaHotelsQueryVariables>(FindPcHotelDetailWithAreaHotelsDocument, options);
      }
export function useFindPcHotelDetailWithAreaHotelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPcHotelDetailWithAreaHotelsQuery, FindPcHotelDetailWithAreaHotelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPcHotelDetailWithAreaHotelsQuery, FindPcHotelDetailWithAreaHotelsQueryVariables>(FindPcHotelDetailWithAreaHotelsDocument, options);
        }
export type FindPcHotelDetailWithAreaHotelsQueryHookResult = ReturnType<typeof useFindPcHotelDetailWithAreaHotelsQuery>;
export type FindPcHotelDetailWithAreaHotelsLazyQueryHookResult = ReturnType<typeof useFindPcHotelDetailWithAreaHotelsLazyQuery>;
export type FindPcHotelDetailWithAreaHotelsQueryResult = Apollo.QueryResult<FindPcHotelDetailWithAreaHotelsQuery, FindPcHotelDetailWithAreaHotelsQueryVariables>;
export const FindPlanDocument = gql`
    query findPlan($input: PlanInput!) {
  plan(input: $input) {
    id
    planId
    title
    areaName
    regions {
      name
      nameAlphabet
    }
    districts {
      id
      name
    }
    prefectures {
      name
      nameAlphabet
    }
    summaryImages {
      ...FPlanImage
    }
    noIndex
    producedBy
    modelCourseItemsPerDays {
      day
      modelCourseItems {
        ... on SpotModelCourseItem {
          itemType
          time
          spotId
          name
          summaryDescription
          summaryTitle
          images {
            ...FPlanImage
          }
        }
        ... on NormalModelCourseItem {
          itemType
          time
          name
          description
          images {
            ...FPlanImage
          }
        }
      }
    }
    comments
    numberOfStays
    hotels {
      hotelId
      name
      speciality
      popText
      images {
        ...FPlanImage
      }
      comments
      summaryTitle
      minimumPrice
    }
    nearDistrictPlans {
      ...FPlanSummary
    }
    prefectureHotels {
      ...FHotelSummaryForHotel
    }
  }
  popularPlans {
    ...FPlanSummary
  }
}
    ${FPlanImageFragmentDoc}
${FPlanSummaryFragmentDoc}
${FHotelSummaryForHotelFragmentDoc}`;

/**
 * __useFindPlanQuery__
 *
 * To run a query within a React component, call `useFindPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPlanQuery(baseOptions: Apollo.QueryHookOptions<FindPlanQuery, FindPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlanQuery, FindPlanQueryVariables>(FindPlanDocument, options);
      }
export function useFindPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlanQuery, FindPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlanQuery, FindPlanQueryVariables>(FindPlanDocument, options);
        }
export type FindPlanQueryHookResult = ReturnType<typeof useFindPlanQuery>;
export type FindPlanLazyQueryHookResult = ReturnType<typeof useFindPlanLazyQuery>;
export type FindPlanQueryResult = Apollo.QueryResult<FindPlanQuery, FindPlanQueryVariables>;
export const FindReturningFlightsForOrderConfirmDocument = gql`
    query findReturningFlightsForOrderConfirm($input: ReturningFlightsForOrderConfirmInput!) {
  returningFlightsForOrderConfirm(input: $input) {
    flights {
      ...FFlight
    }
    inclusivePriceInfo {
      total
      perPerson
      numberOfPeople
      numberOfStays
    }
  }
}
    ${FFlightFragmentDoc}`;

/**
 * __useFindReturningFlightsForOrderConfirmQuery__
 *
 * To run a query within a React component, call `useFindReturningFlightsForOrderConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReturningFlightsForOrderConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReturningFlightsForOrderConfirmQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindReturningFlightsForOrderConfirmQuery(baseOptions: Apollo.QueryHookOptions<FindReturningFlightsForOrderConfirmQuery, FindReturningFlightsForOrderConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindReturningFlightsForOrderConfirmQuery, FindReturningFlightsForOrderConfirmQueryVariables>(FindReturningFlightsForOrderConfirmDocument, options);
      }
export function useFindReturningFlightsForOrderConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindReturningFlightsForOrderConfirmQuery, FindReturningFlightsForOrderConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindReturningFlightsForOrderConfirmQuery, FindReturningFlightsForOrderConfirmQueryVariables>(FindReturningFlightsForOrderConfirmDocument, options);
        }
export type FindReturningFlightsForOrderConfirmQueryHookResult = ReturnType<typeof useFindReturningFlightsForOrderConfirmQuery>;
export type FindReturningFlightsForOrderConfirmLazyQueryHookResult = ReturnType<typeof useFindReturningFlightsForOrderConfirmLazyQuery>;
export type FindReturningFlightsForOrderConfirmQueryResult = Apollo.QueryResult<FindReturningFlightsForOrderConfirmQuery, FindReturningFlightsForOrderConfirmQueryVariables>;
export const FindReviewDetailDocument = gql`
    query findReviewDetail($reviewInput: ReviewInput!) {
  review(input: $reviewInput) {
    ...FReviewSummaryForReviewDetail
    reviewItems {
      ...FReviewItem
    }
    reviewItemImages {
      ...FReviewItemImage
    }
  }
}
    ${FReviewSummaryForReviewDetailFragmentDoc}
${FReviewItemFragmentDoc}
${FReviewItemImageFragmentDoc}`;

/**
 * __useFindReviewDetailQuery__
 *
 * To run a query within a React component, call `useFindReviewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReviewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReviewDetailQuery({
 *   variables: {
 *      reviewInput: // value for 'reviewInput'
 *   },
 * });
 */
export function useFindReviewDetailQuery(baseOptions: Apollo.QueryHookOptions<FindReviewDetailQuery, FindReviewDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindReviewDetailQuery, FindReviewDetailQueryVariables>(FindReviewDetailDocument, options);
      }
export function useFindReviewDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindReviewDetailQuery, FindReviewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindReviewDetailQuery, FindReviewDetailQueryVariables>(FindReviewDetailDocument, options);
        }
export type FindReviewDetailQueryHookResult = ReturnType<typeof useFindReviewDetailQuery>;
export type FindReviewDetailLazyQueryHookResult = ReturnType<typeof useFindReviewDetailLazyQuery>;
export type FindReviewDetailQueryResult = Apollo.QueryResult<FindReviewDetailQuery, FindReviewDetailQueryVariables>;
export const FindSelectedProductsSummaryDocument = gql`
    query findSelectedProductsSummary($input: SelectedProductsSummaryInput!) {
  selectedProductsSummary(input: $input) {
    ...FSelectedProductsSummary
  }
}
    ${FSelectedProductsSummaryFragmentDoc}`;

/**
 * __useFindSelectedProductsSummaryQuery__
 *
 * To run a query within a React component, call `useFindSelectedProductsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSelectedProductsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSelectedProductsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindSelectedProductsSummaryQuery(baseOptions: Apollo.QueryHookOptions<FindSelectedProductsSummaryQuery, FindSelectedProductsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSelectedProductsSummaryQuery, FindSelectedProductsSummaryQueryVariables>(FindSelectedProductsSummaryDocument, options);
      }
export function useFindSelectedProductsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSelectedProductsSummaryQuery, FindSelectedProductsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSelectedProductsSummaryQuery, FindSelectedProductsSummaryQueryVariables>(FindSelectedProductsSummaryDocument, options);
        }
export type FindSelectedProductsSummaryQueryHookResult = ReturnType<typeof useFindSelectedProductsSummaryQuery>;
export type FindSelectedProductsSummaryLazyQueryHookResult = ReturnType<typeof useFindSelectedProductsSummaryLazyQuery>;
export type FindSelectedProductsSummaryQueryResult = Apollo.QueryResult<FindSelectedProductsSummaryQuery, FindSelectedProductsSummaryQueryVariables>;
export const FindSpotDocument = gql`
    query findSpot($input: SpotInput!) {
  spot(input: $input) {
    ...FSpot
  }
}
    ${FSpotFragmentDoc}`;

/**
 * __useFindSpotQuery__
 *
 * To run a query within a React component, call `useFindSpotQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSpotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSpotQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindSpotQuery(baseOptions: Apollo.QueryHookOptions<FindSpotQuery, FindSpotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSpotQuery, FindSpotQueryVariables>(FindSpotDocument, options);
      }
export function useFindSpotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSpotQuery, FindSpotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSpotQuery, FindSpotQueryVariables>(FindSpotDocument, options);
        }
export type FindSpotQueryHookResult = ReturnType<typeof useFindSpotQuery>;
export type FindSpotLazyQueryHookResult = ReturnType<typeof useFindSpotLazyQuery>;
export type FindSpotQueryResult = Apollo.QueryResult<FindSpotQuery, FindSpotQueryVariables>;
export const FindVacantHotelDocument = gql`
    query findVacantHotel($vacantHotelInput: VacantHotelInput!) {
  vacantHotel(input: $vacantHotelInput) {
    ...FVacantHotelForDPCar
  }
}
    ${FVacantHotelForDpCarFragmentDoc}`;

/**
 * __useFindVacantHotelQuery__
 *
 * To run a query within a React component, call `useFindVacantHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVacantHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVacantHotelQuery({
 *   variables: {
 *      vacantHotelInput: // value for 'vacantHotelInput'
 *   },
 * });
 */
export function useFindVacantHotelQuery(baseOptions: Apollo.QueryHookOptions<FindVacantHotelQuery, FindVacantHotelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVacantHotelQuery, FindVacantHotelQueryVariables>(FindVacantHotelDocument, options);
      }
export function useFindVacantHotelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVacantHotelQuery, FindVacantHotelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVacantHotelQuery, FindVacantHotelQueryVariables>(FindVacantHotelDocument, options);
        }
export type FindVacantHotelQueryHookResult = ReturnType<typeof useFindVacantHotelQuery>;
export type FindVacantHotelLazyQueryHookResult = ReturnType<typeof useFindVacantHotelLazyQuery>;
export type FindVacantHotelQueryResult = Apollo.QueryResult<FindVacantHotelQuery, FindVacantHotelQueryVariables>;
export const FindVacantHotelForDpFlightDocument = gql`
    query findVacantHotelForDPFlight($input: VacantHotelForDPFlightInput!) {
  vacantHotelForDPFlight(input: $input) {
    ...FVacantHotelForDPFlight
  }
}
    ${FVacantHotelForDpFlightFragmentDoc}`;

/**
 * __useFindVacantHotelForDpFlightQuery__
 *
 * To run a query within a React component, call `useFindVacantHotelForDpFlightQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVacantHotelForDpFlightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVacantHotelForDpFlightQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindVacantHotelForDpFlightQuery(baseOptions: Apollo.QueryHookOptions<FindVacantHotelForDpFlightQuery, FindVacantHotelForDpFlightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVacantHotelForDpFlightQuery, FindVacantHotelForDpFlightQueryVariables>(FindVacantHotelForDpFlightDocument, options);
      }
export function useFindVacantHotelForDpFlightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVacantHotelForDpFlightQuery, FindVacantHotelForDpFlightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVacantHotelForDpFlightQuery, FindVacantHotelForDpFlightQueryVariables>(FindVacantHotelForDpFlightDocument, options);
        }
export type FindVacantHotelForDpFlightQueryHookResult = ReturnType<typeof useFindVacantHotelForDpFlightQuery>;
export type FindVacantHotelForDpFlightLazyQueryHookResult = ReturnType<typeof useFindVacantHotelForDpFlightLazyQuery>;
export type FindVacantHotelForDpFlightQueryResult = Apollo.QueryResult<FindVacantHotelForDpFlightQuery, FindVacantHotelForDpFlightQueryVariables>;
export const FindVacantHotelRoomsDocument = gql`
    query findVacantHotelRooms($input: VacantHotelRoomsInput!) {
  vacantHotelRooms(input: $input) {
    rooms {
      id
      roomName
      overview
      isNoSmoking
      images {
        caption
        links {
          large {
            href
          }
          medium {
            href
          }
          small {
            href
          }
        }
      }
      rates {
        id
        availableRooms
        refundable
        fencedDeal
        fencedDealAvailable
        depositRequired
        merchantOfRecord
        promotions {
          deal {
            id
            description
          }
          valueAdds
        }
        occupancyPricing {
          fees {
            mandatoryFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
            resortFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
            mandatoryTax {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
          }
          totals {
            inclusive {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            strikethrough {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            marketingFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            grossProfit {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            exclusive {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            discountRate
          }
        }
        occupancyPricingWithoutCocolocalaTransactionFee {
          fees {
            mandatoryFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
            resortFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
            mandatoryTax {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
              scope
              frequency
            }
          }
          totals {
            inclusive {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            strikethrough {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            marketingFee {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            grossProfit {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            exclusive {
              billableCurrency {
                value
                currency
              }
              requestCurrency {
                value
                currency
              }
            }
            discountRate
          }
        }
        cancelPenalties {
          currency
          start
          end
          amount
          nights
          percent
        }
        bedGroups {
          id
          description
          configuration {
            type
            size
            quantity
          }
          links {
            priceCheck {
              method
              href
              expires
            }
          }
        }
        amenities {
          id
          name
          value
        }
        meal
        priceRange
      }
      occupancy {
        maxAllowed {
          total
          adults
          children
        }
      }
      bedGroups {
        id
        description
        configuration {
          type
          size
          quantity
        }
      }
      view {
        id
        name
      }
      amenities {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useFindVacantHotelRoomsQuery__
 *
 * To run a query within a React component, call `useFindVacantHotelRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVacantHotelRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVacantHotelRoomsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindVacantHotelRoomsQuery(baseOptions: Apollo.QueryHookOptions<FindVacantHotelRoomsQuery, FindVacantHotelRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVacantHotelRoomsQuery, FindVacantHotelRoomsQueryVariables>(FindVacantHotelRoomsDocument, options);
      }
export function useFindVacantHotelRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVacantHotelRoomsQuery, FindVacantHotelRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVacantHotelRoomsQuery, FindVacantHotelRoomsQueryVariables>(FindVacantHotelRoomsDocument, options);
        }
export type FindVacantHotelRoomsQueryHookResult = ReturnType<typeof useFindVacantHotelRoomsQuery>;
export type FindVacantHotelRoomsLazyQueryHookResult = ReturnType<typeof useFindVacantHotelRoomsLazyQuery>;
export type FindVacantHotelRoomsQueryResult = Apollo.QueryResult<FindVacantHotelRoomsQuery, FindVacantHotelRoomsQueryVariables>;
export const IncrementalSearchDocument = gql`
    query incrementalSearch($input: IncrementalSearchInput!) {
  incrementalSearch(input: $input) {
    zones {
      ...FIncrementalSearchZoneItem
    }
    hotels {
      ...FIncrementalSearchHotelItem
    }
  }
}
    ${FIncrementalSearchZoneItemFragmentDoc}
${FIncrementalSearchHotelItemFragmentDoc}`;

/**
 * __useIncrementalSearchQuery__
 *
 * To run a query within a React component, call `useIncrementalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncrementalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncrementalSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIncrementalSearchQuery(baseOptions: Apollo.QueryHookOptions<IncrementalSearchQuery, IncrementalSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncrementalSearchQuery, IncrementalSearchQueryVariables>(IncrementalSearchDocument, options);
      }
export function useIncrementalSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncrementalSearchQuery, IncrementalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncrementalSearchQuery, IncrementalSearchQueryVariables>(IncrementalSearchDocument, options);
        }
export type IncrementalSearchQueryHookResult = ReturnType<typeof useIncrementalSearchQuery>;
export type IncrementalSearchLazyQueryHookResult = ReturnType<typeof useIncrementalSearchLazyQuery>;
export type IncrementalSearchQueryResult = Apollo.QueryResult<IncrementalSearchQuery, IncrementalSearchQueryVariables>;
export const ListUserCouponsDocument = gql`
    query listUserCoupons {
  userCoupons {
    id
    couponId
    title
    label
    description
    discountAmount
    discountType
    condition
    startTime
    expireTime
    departureStartTime
    arrivalEndTime
    isUsed
    minimumAvailableAmount
    discountUnit
    usageCountLimit
    currentUsageCount
    maximumDiscountAmount
  }
}
    `;

/**
 * __useListUserCouponsQuery__
 *
 * To run a query within a React component, call `useListUserCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUserCouponsQuery(baseOptions?: Apollo.QueryHookOptions<ListUserCouponsQuery, ListUserCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserCouponsQuery, ListUserCouponsQueryVariables>(ListUserCouponsDocument, options);
      }
export function useListUserCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserCouponsQuery, ListUserCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserCouponsQuery, ListUserCouponsQueryVariables>(ListUserCouponsDocument, options);
        }
export type ListUserCouponsQueryHookResult = ReturnType<typeof useListUserCouponsQuery>;
export type ListUserCouponsLazyQueryHookResult = ReturnType<typeof useListUserCouponsLazyQuery>;
export type ListUserCouponsQueryResult = Apollo.QueryResult<ListUserCouponsQuery, ListUserCouponsQueryVariables>;